// Generated by scripts/build-canonical.ts from src/data/source/*.json.
// Do not edit by hand — re-run the script to refresh. This is schema v2 (canonical items
// catalog) — it coexists with the legacy per-category files, it does not replace them yet.

import type { CanonicalItem } from "../schema/types";

export const CANONICAL_ITEMS: CanonicalItem[] = [
  {
    "id": "anglerfish",
    "slug": "anglerfish",
    "name": "Anglerfish",
    "kind": "fish",
    "eventKey": "sea-fishing",
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/anglerfish.webp",
    "imageStatus": "verified",
    "sellPrice": 320,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "The female Anglerfish effectively carries its own fishing lure: a glowing appendage above the face attracts prey close enough to be caught. Heartopia spotlights this built-in hunting trick as the species' signature feature."
  },
  {
    "id": "arctic-char",
    "slug": "arctic-char",
    "name": "Arctic Char",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/arctic-char.webp",
    "imageStatus": "verified",
    "sellPrice": 610,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Cold water is where Arctic Char earns its reputation. Even in harsh conditions it is portrayed as fearless, while scattered red markings give the fish an easy visual identifier."
  },
  {
    "id": "atlantic-mackerel",
    "slug": "atlantic-mackerel",
    "name": "Atlantic Mackerel",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/atlantic-mackerel.webp",
    "imageStatus": "verified",
    "sellPrice": 150,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Rather than behaving like an energetic open-water fish, Atlantic Mackerel gets a dry personality joke in Heartopia: it looks composed and beautiful, yet is notable for spending an excessive amount of time asleep."
  },
  {
    "id": "atlantic-pygmy-octopus",
    "slug": "atlantic-pygmy-octopus",
    "name": "Atlantic Pygmy Octopus",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/atlantic-pygmy-octopus.webp",
    "imageStatus": "verified",
    "sellPrice": 150,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Heartopia builds the joke around scale: this octopus is so exceptionally tiny that even labeling it “pygmy” is treated as almost unnecessary."
  },
  {
    "id": "atlantic-salmon",
    "slug": "atlantic-salmon",
    "name": "Atlantic Salmon",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/atlantic-salmon.webp",
    "imageStatus": "verified",
    "sellPrice": 155,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Heartopia frames Atlantic Salmon through its flesh rather than its behavior: the orange meat is considered nutritious and works as food either uncooked or after cooking."
  },
  {
    "id": "barbel",
    "slug": "barbel",
    "name": "Barbel",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/barbel.webp",
    "imageStatus": "verified",
    "sellPrice": 75,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "This fish doubles as a vocabulary lesson. “Barbel” also names the whisker-like sensory structures near a fish's mouth, so the species and the anatomical feature share the same term."
  },
  {
    "id": "beltfish",
    "slug": "beltfish",
    "name": "Beltfish",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/beltfish.webp",
    "imageStatus": "verified",
    "sellPrice": 105,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Its shape explains the Beltfish's visual metaphor: the body is extremely narrow and elongated, and when it rides the current Heartopia likens the motion to pale fabric streaming through water."
  },
  {
    "id": "blackspot-seabream",
    "slug": "blackspot-seabream",
    "name": "Blackspot Seabream",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/blackspot-seabream.webp",
    "imageStatus": "verified",
    "sellPrice": 230,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Depth is what defines Blackspot Seabream in Heartopia's flavor text. It is portrayed as completely at ease farther below the surface, moving through deep marine water without difficulty."
  },
  {
    "id": "blue-european-crayfish",
    "slug": "blue-european-crayfish",
    "name": "Blue European Crayfish",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/blue-european-crayfish.webp",
    "imageStatus": "verified",
    "sellPrice": 250,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "The unusual shell color is a mutation rather than a different lifestyle: Blue European Crayfish keeps the freshwater identity of European Crayfish, but its carapace appears pale blue."
  },
  {
    "id": "bluefin-tuna",
    "slug": "bluefin-tuna",
    "name": "Bluefin Tuna",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/bluefin-tuna.webp",
    "imageStatus": "verified",
    "sellPrice": 850,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Heartopia gives Bluefin Tuna a near-constant sense of motion. The fish is depicted as energetic and difficult to keep still, built around fast swimming in deeper parts of the ocean."
  },
  {
    "id": "bluegill",
    "slug": "bluegill",
    "name": "Bluegill",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/bluegill.webp",
    "imageStatus": "verified",
    "sellPrice": 395,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Warm freshwater suits Bluegill unusually well, despite the species being presented as uncommon. Heartopia also slips in a food-related joke, treating it as both an interesting catch and something people might eat."
  },
  {
    "id": "burbot",
    "slug": "burbot",
    "name": "Burbot",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/burbot.webp",
    "imageStatus": "verified",
    "sellPrice": 230,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "A Burbot can “smell” with the short feeler under its jaw. Heartopia calls attention to that chin barbel as a sensory tool used for detecting odors rather than a decorative feature."
  },
  {
    "id": "butterfly-koi",
    "slug": "butterfly-koi",
    "name": "Butterfly Koi",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/butterfly-koi.webp",
    "imageStatus": "verified",
    "sellPrice": 320,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Butterfly Koi gets an almost fairy-like presentation because of its elegant movement and delicate appearance. That beauty comes with fragility: Heartopia describes the fish as sensitive and requiring careful treatment."
  },
  {
    "id": "chum-salmon",
    "slug": "chum-salmon",
    "name": "Chum Salmon",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/chum-salmon.webp",
    "imageStatus": "verified",
    "sellPrice": 150,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "The Chum Salmon does not keep the same look throughout life. As it reaches maturity, its colors shift, and Heartopia turns that change into a fashion joke about the adult fish updating its style."
  },
  {
    "id": "clownfish",
    "slug": "clownfish",
    "name": "Clownfish",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/clownfish.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Heartopia's Clownfish entry winks at pop culture instead of naming it directly: the cheerful little fish is said to owe much of its fame to a hugely successful movie set in the ocean."
  },
  {
    "id": "common-barbel",
    "slug": "common-barbel",
    "name": "Common Barbel",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/common-barbel.webp",
    "imageStatus": "verified",
    "sellPrice": 75,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "The name Common Barbel comes with an anatomical wordplay: a barbel is also one of the whisker-like sensory structures around a fish's mouth. Heartopia uses the shared term as the item's main bit of trivia."
  },
  {
    "id": "common-bleak",
    "slug": "common-bleak",
    "name": "Common Bleak",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/common-bleak.webp",
    "imageStatus": "verified",
    "sellPrice": 50,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "The Common Bleak's mouth angles upward, creating an expression Heartopia reads as a permanent scowl. The joke is that it seems irritated even when nothing has happened."
  },
  {
    "id": "common-carp",
    "slug": "common-carp",
    "name": "Common Carp",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/common-carp.webp",
    "imageStatus": "verified",
    "sellPrice": 230,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Getting hooked does not make Common Carp passive. Heartopia describes it as a powerful, lively fish that can throw itself out of the water while trying to break free."
  },
  {
    "id": "common-chub",
    "slug": "common-chub",
    "name": "Common Chub",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/common-chub.webp",
    "imageStatus": "verified",
    "sellPrice": 75,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Still water seems to match the Common Chub's temperament: it favors places with little current, and Heartopia mirrors that preference by characterizing the fish as relaxed and unhurried."
  },
  {
    "id": "common-octopus",
    "slug": "common-octopus",
    "name": "Common Octopus",
    "kind": "fish",
    "eventKey": "sea-fishing",
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/common-octopus.webp",
    "imageStatus": "verified",
    "sellPrice": 320,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Light, rather than prey or speed, is the behavioral detail Heartopia emphasizes for Common Octopus. This medium-sized octopus is depicted as actively following bright sources underwater."
  },
  {
    "id": "common-prawn",
    "slug": "common-prawn",
    "name": "Common Prawn",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/common-prawn.webp",
    "imageStatus": "verified",
    "sellPrice": 50,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Common Prawn is treated as familiar food rather than an exotic discovery. Heartopia places this marine crustacean in the everyday-seafood category, something routinely seen at meals."
  },
  {
    "id": "common-rudd",
    "slug": "common-rudd",
    "name": "Common Rudd",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/common-rudd.webp",
    "imageStatus": "verified",
    "sellPrice": 150,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Those red eyes give Common Rudd an unexpectedly emotional look. Heartopia plays with the feature by pretending the fish may have been crying."
  },
  {
    "id": "common-shrimp",
    "slug": "common-shrimp",
    "name": "Common Shrimp",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/common-shrimp.webp",
    "imageStatus": "verified",
    "sellPrice": 50,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "For Common Shrimp, the notable context is cultural rather than biological: Heartopia treats it as ordinary marine seafood, the kind of ingredient diners would recognize from routine meals."
  },
  {
    "id": "common-whitefish",
    "slug": "common-whitefish",
    "name": "Common Whitefish",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/common-whitefish.webp",
    "imageStatus": "verified",
    "sellPrice": 105,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Once Common Whitefish settles into a spot it likes, it is reluctant to leave. Heartopia pairs that stay-put behavior with the species' narrow, streamlined body."
  },
  {
    "id": "crucian-carp",
    "slug": "crucian-carp",
    "name": "Crucian Carp",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/crucian-carp.webp",
    "imageStatus": "verified",
    "sellPrice": 75,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Crucian Carp changes visually with age. Juveniles begin with a much brighter golden cast, but that shine becomes less vivid as the fish grows older."
  },
  {
    "id": "director-common-octopus-w-cinnamon-hat",
    "slug": "director-common-octopus-w-cinnamon-hat",
    "name": "Director Common Octopus w/ Cinnamon Hat",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/director-common-octopus-w-cinnamon-hat.webp",
    "imageStatus": "verified",
    "sellPrice": 215,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Eight arms become a film-set advantage for this cinnamon-hatted toy director. Heartopia imagines the Common Octopus juggling a minimum of eight production jobs simultaneously."
  },
  {
    "id": "director-pygmy-octopus-w-brown-hat",
    "slug": "director-pygmy-octopus-w-brown-hat",
    "name": "Director Pygmy Octopus w/ Brown Hat",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/director-pygmy-octopus-w-brown-hat.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Thrillers are a rough assignment for the brown-hatted Pygmy Octopus. Heartopia casts this toy director as naturally timid, so shooting a suspenseful production becomes an especially intimidating job."
  },
  {
    "id": "director-pygmy-octopus-w-cyan-hat",
    "slug": "director-pygmy-octopus-w-cyan-hat",
    "name": "Director Pygmy Octopus w/ Cyan Hat",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/director-pygmy-octopus-w-cyan-hat.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Hiding inside its shell becomes a creative asset for the cyan-hatted Pygmy Octopus. Heartopia turns that shy habit into a joke that the toy director sees filmmaking from an unusual point of view."
  },
  {
    "id": "director-pygmy-octopus-w-navy-hat",
    "slug": "director-pygmy-octopus-w-navy-hat",
    "name": "Director Pygmy Octopus w/ Navy Hat",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/director-pygmy-octopus-w-navy-hat.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Confidence is not a problem for the navy-hatted Pygmy Octopus. This toy filmmaker considers ocean adventures its specialty and believes that genre is where its directing skills shine."
  },
  {
    "id": "edible-frog",
    "slug": "edible-frog",
    "name": "Edible Frog",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/edible-frog.webp",
    "imageStatus": "verified",
    "sellPrice": 320,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "One Edible Frog restriction is tied to ownership of the lure: the blue target can be taken only by whoever deployed Mermaid Fish Attractor. Its lineage combines ancestry associated with pond frogs and marsh frogs."
  },
  {
    "id": "european-crayfish",
    "slug": "european-crayfish",
    "name": "European Crayfish",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/european-crayfish.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "European Crayfish is built like a small armored fighter. A hard outer shell and oversized pincers support the aggressive personality Heartopia gives it, with the animal portrayed as unwilling to retreat from danger."
  },
  {
    "id": "european-eel",
    "slug": "european-eel",
    "name": "European Eel",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/european-eel.webp",
    "imageStatus": "verified",
    "sellPrice": 380,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "The European Eel's standout feat is endurance, not speed. Heartopia describes journeys spanning several thousand miles on an empty stomach."
  },
  {
    "id": "european-flying-squid",
    "slug": "european-flying-squid",
    "name": "European Flying Squid",
    "kind": "fish",
    "eventKey": "sea-fishing",
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/european-flying-squid.webp",
    "imageStatus": "verified",
    "sellPrice": 320,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Its “flying” name comes from movement above the surface: European Flying Squid can launch itself out of the sea, combining water-jet thrust with rapid fin motion for brief airborne travel."
  },
  {
    "id": "european-lobster",
    "slug": "european-lobster",
    "name": "European Lobster",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/european-lobster.webp",
    "imageStatus": "verified",
    "sellPrice": 230,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "European Lobster gets its intimidating look from scale and weaponry. Heartopia emphasizes that it is a comparatively large lobster whose pair of oversized claws dominates its appearance."
  },
  {
    "id": "european-mudminnow",
    "slug": "european-mudminnow",
    "name": "European Mudminnow",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/european-mudminnow.webp",
    "imageStatus": "verified",
    "sellPrice": 250,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Dark mottling gives European Mudminnow an effective disguise along the lake floor. The fish stays low, where its brown speckles help it disappear against the bottom."
  },
  {
    "id": "european-perch",
    "slug": "european-perch",
    "name": "European Perch",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/european-perch.webp",
    "imageStatus": "verified",
    "sellPrice": 75,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Heartopia treats European Perch as proof that ordinary does not mean undesirable: it is widespread in freshwater and familiar to many diners, yet still has a reputation for good flavor."
  },
  {
    "id": "european-plaice",
    "slug": "european-plaice",
    "name": "European Plaice",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/european-plaice.webp",
    "imageStatus": "verified",
    "sellPrice": 230,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "European Plaice does most of its feeding after dark. The joke in Heartopia is that the flatfish's vision seems barely adequate for its nocturnal routine, but apparently gets the job done."
  },
  {
    "id": "european-smelt",
    "slug": "european-smelt",
    "name": "European Smelt",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/european-smelt.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "European Smelt carries two odd facts in one small fish: its flavor is compared with fresh cucumber, and females are capable of producing eggs in quantities reaching the tens of thousands."
  },
  {
    "id": "false-scad",
    "slug": "false-scad",
    "name": "False Scad",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/false-scad.webp",
    "imageStatus": "verified",
    "sellPrice": 232,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Looks are misleading with False Scad. It resembles true scad closely enough to cause confusion, but Heartopia points out that the visual similarity does not indicate a real family relationship."
  },
  {
    "id": "freshwater-blenny",
    "slug": "freshwater-blenny",
    "name": "Freshwater Blenny",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/freshwater-blenny.webp",
    "imageStatus": "verified",
    "sellPrice": 150,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Two tiny growths on the Freshwater Blenny's head resemble flowers and move with the current. Heartopia uses that detail to give the fish an unexpectedly ornamental look."
  },
  {
    "id": "frostspore-king-crab",
    "slug": "frostspore-king-crab",
    "name": "Frostspore King Crab",
    "kind": "fish",
    "eventKey": "frostspore-fish",
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/frostspore-king-crab.webp",
    "imageStatus": "verified",
    "sellPrice": 430,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Frostspore changes the King Crab's body language as much as its look. The infected crab appears sharper and more distant, which Heartopia interprets as making its already imposing presence feel more royal."
  },
  {
    "id": "frostspore-ocean-sunfish",
    "slug": "frostspore-ocean-sunfish",
    "name": "Frostspore Ocean Sunfish",
    "kind": "fish",
    "eventKey": "frostspore-fish",
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/frostspore-ocean-sunfish.webp",
    "imageStatus": "verified",
    "sellPrice": 215,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "The infection leaves Frostspore Ocean Sunfish looking comically top-heavy. Heartopia focuses on the oversized head and jokes that so much apparent weight ought to send the fish sinking."
  },
  {
    "id": "frostspore-puffer-fish",
    "slug": "frostspore-puffer-fish",
    "name": "Frostspore Puffer Fish",
    "kind": "fish",
    "eventKey": "frostspore-fish",
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/frostspore-puffer-fish.webp",
    "imageStatus": "verified",
    "sellPrice": 155,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Frostspore infection has the opposite visual effect you might expect from a puffer: this variant looks thinner. Heartopia explains the change with a tongue-in-cheek cold-shrinkage joke."
  },
  {
    "id": "frostspore-seahorse",
    "slug": "frostspore-seahorse",
    "name": "Frostspore Seahorse",
    "kind": "fish",
    "eventKey": "frostspore-fish",
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/frostspore-seahorse.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "As Frostspore Seahorse drifts along, the altered body looks less like an ordinary animal and more like carved ice. Heartopia leans into that frozen, sculpture-like appearance."
  },
  {
    "id": "frostspore-whale-shark",
    "slug": "frostspore-whale-shark",
    "name": "Frostspore Whale Shark",
    "kind": "fish",
    "eventKey": "frostspore-fish",
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/frostspore-whale-shark.webp",
    "imageStatus": "verified",
    "sellPrice": 320,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "This infected Whale Shark was tied to the Frostspore Fish Event's extra phase. The darker joke in its lore concerns the small hitchhiking fish that normally accompany a whale shark, which become miserable after infection."
  },
  {
    "id": "giant-oarfish",
    "slug": "giant-oarfish",
    "name": "Giant Oarfish",
    "kind": "fish",
    "eventKey": "sea-fishing",
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/giant-oarfish.webp",
    "imageStatus": "verified",
    "sellPrice": 802,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Nobody in Heartopia seems entirely sure what to make of Giant Oarfish. Stories cast it either as a Dragon Palace messenger or as a deep-sea monster, while its real habits remain mysterious."
  },
  {
    "id": "goby",
    "slug": "goby",
    "name": "Goby",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/goby.webp",
    "imageStatus": "verified",
    "sellPrice": 150,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Goby turns its pelvic fins into an anchor. They form a suction-like disc that grips rock surfaces, helping the fish stay put when water is pushing past it."
  },
  {
    "id": "golden-king-crab",
    "slug": "golden-king-crab",
    "name": "Golden King Crab",
    "kind": "fish",
    "eventKey": "sea-fishing",
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/golden-king-crab.webp",
    "imageStatus": "verified",
    "sellPrice": 850,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Heartopia presents the Golden King Crab almost like a monster-movie creature: a huge body and spiny armor create such a menacing silhouette that its lore jokes about horror-film inspiration."
  },
  {
    "id": "goldfish",
    "slug": "goldfish",
    "name": "Goldfish",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/goldfish.webp",
    "imageStatus": "verified",
    "sellPrice": 250,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Heartopia treats Goldfish as the showpiece of the aquarium world. Its appeal comes from vivid coloration paired with elegant posture, earning it a tongue-in-cheek reputation as a pageant winner."
  },
  {
    "id": "grayling",
    "slug": "grayling",
    "name": "Grayling",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/grayling.webp",
    "imageStatus": "verified",
    "sellPrice": 230,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Grayling's display value comes from the way its scales catch light, producing a soft purple shimmer. Heartopia specifically notes that this effect makes the species appealing for aquariums."
  },
  {
    "id": "haddock",
    "slug": "haddock",
    "name": "Haddock",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/haddock.webp",
    "imageStatus": "verified",
    "sellPrice": 230,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Most Haddock activity happens when food is involved. The fish otherwise keeps close to the seabed with little movement, then becomes noticeably livelier once it starts searching for something to eat."
  },
  {
    "id": "hermit-crab",
    "slug": "hermit-crab",
    "name": "Hermit Crab",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/hermit-crab.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "A Hermit Crab never treats one shell as a permanent address. Heartopia turns its habit of moving into borrowed shells into a housing joke, as if the crustacean had discovered a way to live without paying rent."
  },
  {
    "id": "horse-mackerel",
    "slug": "horse-mackerel",
    "name": "Horse Mackerel",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": null,
    "imageStatus": "missing",
    "sellPrice": 50,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Horse Mackerel appears to be a legacy name rather than a separate current species. Player reports say the entry was renamed to Scad, and the modern collection no longer lists Horse Mackerel on its own."
  },
  {
    "id": "huchen",
    "slug": "huchen",
    "name": "Huchen",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/huchen.webp",
    "imageStatus": "verified",
    "sellPrice": 380,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Diet is tied directly to the Huchen's strength: it is presented as a dedicated carnivore. That physical power comes with a solitary streak, giving the fish a distinctly lone-wanderer personality."
  },
  {
    "id": "king-crab",
    "slug": "king-crab",
    "name": "King Crab",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/king-crab.webp",
    "imageStatus": "verified",
    "sellPrice": 535,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "The King Crab's appeal is not limited to its size. Heartopia gives it a strong culinary reputation, emphasizing tender meat together with protein and beneficial fats."
  },
  {
    "id": "large-pearl-mussel",
    "slug": "large-pearl-mussel",
    "name": "Large Pearl Mussel",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/large-pearl-mussel.webp",
    "imageStatus": "verified",
    "sellPrice": 380,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "A trapped foreign object can become the starting point for a pearl in the Large Pearl Mussel. When the material cannot be expelled, the shellfish forms a pearl around it instead."
  },
  {
    "id": "largemouth-bass",
    "slug": "largemouth-bass",
    "name": "Largemouth Bass",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/largemouth-bass.webp",
    "imageStatus": "verified",
    "sellPrice": 230,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Aquatic plants serve as cover for the Largemouth Bass. Rather than chasing constantly, it waits in concealment and attacks once prey moves within striking distance."
  },
  {
    "id": "mediterranean-killifish",
    "slug": "mediterranean-killifish",
    "name": "Mediterranean Killifish",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/mediterranean-killifish.webp",
    "imageStatus": "verified",
    "sellPrice": 150,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "The Mediterranean Killifish looks more severe than it behaves. Dark striping gives it a bold appearance, yet its Heartopia characterization is peaceful enough that its supposed ambition is simply a quiet life."
  },
  {
    "id": "minnow",
    "slug": "minnow",
    "name": "Minnow",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/minnow.webp",
    "imageStatus": "verified",
    "sellPrice": 50,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Delicacy is the Minnow's defining impression. Its narrow body is paired with especially fragile scales, making this small fish seem light and easily damaged."
  },
  {
    "id": "moonfish",
    "slug": "moonfish",
    "name": "Moonfish",
    "kind": "fish",
    "eventKey": "sea-fishing",
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/moonfish.webp",
    "imageStatus": "verified",
    "sellPrice": 850,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Nightfall changes the Moonfish's position in the water: it moves upward after spending daylight at greater depth. Its nearly round outline also inspires a comparison with the full moon of Mid-Autumn celebrations."
  },
  {
    "id": "mottled-sculpin",
    "slug": "mottled-sculpin",
    "name": "Mottled Sculpin",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/mottled-sculpin.webp",
    "imageStatus": "verified",
    "sellPrice": 150,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "The Mottled Sculpin is far more inclined to sit on the bottom than cruise around. Heartopia turns that low-energy routine into a personality gag, essentially branding the fish as lazy."
  },
  {
    "id": "mud-sunfish",
    "slug": "mud-sunfish",
    "name": "Mud Sunfish",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/mud-sunfish.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Mud Sunfish leans heavily into its name: the fish's muted coloration suits murky surroundings, while the flavor text doubles down on the theme with a deliberately awkward mud-based tongue twister."
  },
  {
    "id": "mussel",
    "slug": "mussel",
    "name": "Mussel",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/mussel.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "The Mussel hides something valuable behind a hard exterior. Its shell carries green-and-yellow banding, while the edible flesh inside is specifically noted for its nutritional value."
  },
  {
    "id": "northern-pike",
    "slug": "northern-pike",
    "name": "Northern Pike",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/northern-pike.webp",
    "imageStatus": "verified",
    "sellPrice": 610,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Heartopia pushes the Northern Pike's appetite into an intentionally gross detail: scraps caught around its teeth can become food for later. The joke fits a fish already portrayed as a very enthusiastic eater."
  },
  {
    "id": "nursehound",
    "slug": "nursehound",
    "name": "Nursehound",
    "kind": "fish",
    "eventKey": "sea-fishing",
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/nursehound.webp",
    "imageStatus": "verified",
    "sellPrice": 535,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "A Nursehound's eyes can shine in darkness without producing their own light. They bounce incoming light back toward the viewer, creating the same kind of nighttime gleam commonly noticed in cats."
  },
  {
    "id": "ocean-sunfish",
    "slug": "ocean-sunfish",
    "name": "Ocean Sunfish",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/ocean-sunfish.webp",
    "imageStatus": "verified",
    "sellPrice": 850,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Its proportions make the Ocean Sunfish look almost like a head that learned to swim. Heartopia builds the nickname around the enormous front of the body and a tail that appears tiny by comparison."
  },
  {
    "id": "oriental-shrimp",
    "slug": "oriental-shrimp",
    "name": "Oriental Shrimp",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/oriental-shrimp.webp",
    "imageStatus": "verified",
    "sellPrice": 50,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Direct sun is something the Oriental Shrimp actively avoids. It works its way between aquatic plants, using the vegetation as shade and cover from strong light."
  },
  {
    "id": "puffer-fish",
    "slug": "puffer-fish",
    "name": "Puffer Fish",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/puffer-fish.webp",
    "imageStatus": "verified",
    "sellPrice": 230,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "The Puffer Fish is not confined to a single kind of water. Heartopia identifies it as diadromous, although the species spends the greater part of its life on the saltwater side of that migration."
  },
  {
    "id": "pumpkinseed",
    "slug": "pumpkinseed",
    "name": "Pumpkinseed",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/pumpkinseed.webp",
    "imageStatus": "verified",
    "sellPrice": 250,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Green and blue flecks scatter across the Pumpkinseed's body. Instead of treating them as plain markings, Heartopia imagines the pattern as clothing sprinkled with tiny points of light."
  },
  {
    "id": "rabbit-fish",
    "slug": "rabbit-fish",
    "name": "Rabbit Fish",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/rabbit-fish.webp",
    "imageStatus": "verified",
    "sellPrice": 320,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Beauty and defense sit side by side in the Rabbit Fish. From above its outline is likened to a tailed butterfly, but the graceful shape includes a dorsal spine capable of delivering mild venom."
  },
  {
    "id": "red-bellied-piranha",
    "slug": "red-bellied-piranha",
    "name": "Red-Bellied Piranha",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/red-bellied-piranha.webp",
    "imageStatus": "verified",
    "sellPrice": 230,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "The red underside of the Red-Bellied Piranha is simply part of the fish's normal coloring. Heartopia turns the dramatic hue into a joke by dismissing the idea that its belly somehow got scorched."
  },
  {
    "id": "river-crab",
    "slug": "river-crab",
    "name": "River Crab",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/river-crab.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "River Crab handles a meaty meal almost like table preparation: its claws divide the food into manageable pieces before it eats them individually. Heartopia treats that methodical feeding style as unexpectedly refined."
  },
  {
    "id": "ruffe",
    "slug": "ruffe",
    "name": "Ruffe",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/ruffe.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Two preferences define Ruffe more than its looks: meat for food and warmer conditions in lake water. Heartopia's description centers on those habits instead of giving the fish elaborate visual lore."
  },
  {
    "id": "sardine",
    "slug": "sardine",
    "name": "Sardine",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/sardine.webp",
    "imageStatus": "verified",
    "sellPrice": 50,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Sardine receives a deliberately simple treatment in Heartopia. The entry focuses on its tiny size and light coloration, leaving this familiar fish with a plain, recognizable identity."
  },
  {
    "id": "scad",
    "slug": "scad",
    "name": "Scad",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/scad.webp",
    "imageStatus": "verified",
    "sellPrice": 50,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Small size does not stop Scad from being a nimble swimmer. Heartopia also singles out an unusual bit of ecological company, noting that the fish shares its marine surroundings with jellyfish."
  },
  {
    "id": "schneider",
    "slug": "schneider",
    "name": "Schneider",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/schneider.webp",
    "imageStatus": "verified",
    "sellPrice": 50,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Schneider avoids the usual scramble for food. It neither picks fights nor competes aggressively, instead waiting until something edible happens to come within easy reach."
  },
  {
    "id": "sea-bass",
    "slug": "sea-bass",
    "name": "Sea Bass",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/sea-bass.webp",
    "imageStatus": "verified",
    "sellPrice": 75,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Food quality is the main distinction Heartopia gives Sea Bass. The flesh is described as both tender and juicy, framing the species primarily as a desirable fish to eat."
  },
  {
    "id": "sea-stickleback",
    "slug": "sea-stickleback",
    "name": "Sea Stickleback",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/sea-stickleback.webp",
    "imageStatus": "verified",
    "sellPrice": 50,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "For plankton and tiny fry, the Sea Stickleback is much more threatening than its size suggests. Heartopia flips the scale perspective and presents this little fish as a serious predator to even smaller creatures."
  },
  {
    "id": "seahorse",
    "slug": "seahorse",
    "name": "Seahorse",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/seahorse.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "The Seahorse is given an odd combination of elegance and lethargy. Its unusual form is treated as graceful, but its movement is characterized as conspicuously slow."
  },
  {
    "id": "shortfin-mako-shark",
    "slug": "shortfin-mako-shark",
    "name": "Shortfin Mako Shark",
    "kind": "fish",
    "eventKey": "sea-fishing",
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/shortfin-mako-shark.webp",
    "imageStatus": "verified",
    "sellPrice": 850,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "A crescent is built into the Shortfin Mako Shark's silhouette. Heartopia focuses on the curved tail fin and turns it into lunar imagery, as though a moon shape were cutting through the sea."
  },
  {
    "id": "skipjack-tuna",
    "slug": "skipjack-tuna",
    "name": "Skipjack Tuna",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/skipjack-tuna.webp",
    "imageStatus": "verified",
    "sellPrice": 210,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Speed is jokingly explained as if the Skipjack Tuna carried extra propulsion hardware. The small fins behind the main dorsal fin are treated like concealed boosters that help sell its fast-swimmer reputation."
  },
  {
    "id": "smooth-hammerhead",
    "slug": "smooth-hammerhead",
    "name": "Smooth Hammerhead",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/smooth-hammerhead.webp",
    "imageStatus": "verified",
    "sellPrice": 850,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "The Smooth Hammerhead's hunting image comes from a full package of features: the broad hammer-like head, sharp teeth and fast movement all contribute to the intimidating predator Heartopia describes."
  },
  {
    "id": "spined-loach",
    "slug": "spined-loach",
    "name": "Spined Loach",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/spined-loach.webp",
    "imageStatus": "verified",
    "sellPrice": 50,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "A careful approach matters with Spined Loach because the fish is easily startled. Heartopia's practical advice is essentially to avoid rushing the catch and frightening it away."
  },
  {
    "id": "stone-loach",
    "slug": "stone-loach",
    "name": "Stone Loach",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/stone-loach.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Sand and gravel are easy terrain for Stone Loach's streamlined body. When danger surprises it, however, the fish does not simply bolt—it quickly flattens itself against nearby rock."
  },
  {
    "id": "streber",
    "slug": "streber",
    "name": "Streber",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/streber.webp",
    "imageStatus": "verified",
    "sellPrice": 50,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Large dark-blue blotches are what separate Streber visually from a generic freshwater perch. Heartopia uses that speckled pattern as the species' main identifying characteristic."
  },
  {
    "id": "striped-red-mullet",
    "slug": "striped-red-mullet",
    "name": "Striped Red Mullet",
    "kind": "fish",
    "eventKey": "sea-fishing",
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/striped-red-mullet.webp",
    "imageStatus": "verified",
    "sellPrice": 320,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Two long feelers under the Striped Red Mullet's chin completely change its expression. Heartopia turns them into facial hair, joking that the fish resembles an old goat with the look of a sage."
  },
  {
    "id": "swordfish",
    "slug": "swordfish",
    "name": "Swordfish",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/swordfish.webp",
    "imageStatus": "verified",
    "sellPrice": 850,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Heartopia treats the Swordfish's famous rostrum as only half the story. Its speed earns the species a playful title as the aquatic world's champion swimmer."
  },
  {
    "id": "tadpole",
    "slug": "tadpole",
    "name": "Tadpole",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/tadpole.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "A Tadpole represents an unfinished stage rather than a final form. Heartopia points forward to the transformation: surviving individuals are expected to become frogs by summer."
  },
  {
    "id": "tench",
    "slug": "tench",
    "name": "Tench",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/tench.webp",
    "imageStatus": "verified",
    "sellPrice": 50,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Tench carries a piece of fish folklore rather than a confirmed ability. Stories claim physical contact between individuals can promote healing, which is offered as the origin of the species' “Doctor Fish” nickname."
  },
  {
    "id": "three-spined-stickleback",
    "slug": "three-spined-stickleback",
    "name": "Three-Spined Stickleback",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/three-spined-stickleback.webp",
    "imageStatus": "verified",
    "sellPrice": 150,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Conflict makes the Three-Spined Stickleback visibly arm itself. The three body spines rise during confrontations, turning anatomy into a threat display meant to make rivals hesitate."
  },
  {
    "id": "tilapia",
    "slug": "tilapia",
    "name": "Tilapia",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/tilapia.webp",
    "imageStatus": "verified",
    "sellPrice": 320,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Tilapia's reputation for flavor is strong enough to generate a nickname. Heartopia notes that some people compare its taste favorably enough to call the fish “white salmon.”"
  },
  {
    "id": "trout",
    "slug": "trout",
    "name": "Trout",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/trout.webp",
    "imageStatus": "verified",
    "sellPrice": 230,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Cool water and striking coloration are the two traits Heartopia chooses for Trout. The species is presented as visually attractive while also favoring colder lake conditions."
  },
  {
    "id": "tub-gurnard",
    "slug": "tub-gurnard",
    "name": "Tub Gurnard",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/tub-gurnard.webp",
    "imageStatus": "verified",
    "sellPrice": 380,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "The Tub Gurnard's strongest visual accent runs along its back. Orange-red scales create the standout color, and Heartopia treats that dorsal band as the source of much of the fish's beauty."
  },
  {
    "id": "turbot",
    "slug": "turbot",
    "name": "Turbot",
    "kind": "fish",
    "eventKey": "sea-fishing",
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/turbot.webp",
    "imageStatus": "verified",
    "sellPrice": 320,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Turbot is used for a looks-versus-temperament contrast. Although the flatfish has an unconventional appearance, Heartopia gives it a notably mild and gentle disposition."
  },
  {
    "id": "wels-catfish",
    "slug": "wels-catfish",
    "name": "Wels Catfish",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/wels-catfish.webp",
    "imageStatus": "verified",
    "sellPrice": 610,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Longevity is the Wels Catfish's standout trait. Rather than focusing on appearance, Heartopia emphasizes that this freshwater fish can remain alive for decades."
  },
  {
    "id": "zander",
    "slug": "zander",
    "name": "Zander",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/zander.webp",
    "imageStatus": "verified",
    "sellPrice": 230,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/fish.ts"
    ],
    "notes": null,
    "description": "Zander's carnivorous diet is turned into a weight joke. Heartopia presents it as an eager meat eater and suggests that such enthusiasm can leave the fish putting on extra bulk."
  },
  {
    "id": "alpine-longhorn-beetle",
    "slug": "alpine-longhorn-beetle",
    "name": "Alpine Longhorn Beetle",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/alpine-longhorn-beetle.webp",
    "imageStatus": "verified",
    "sellPrice": 165,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "The Alpine Longhorn Beetle's proportions are dominated by its antennae. Those extremely long feelers make the small insect easy to recognize, while Heartopia also gives it a rather selective, fussy character."
  },
  {
    "id": "amethyst-flower-beetle",
    "slug": "amethyst-flower-beetle",
    "name": "Amethyst Flower Beetle",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/amethyst-flower-beetle.webp",
    "imageStatus": "verified",
    "sellPrice": 165,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "Color and setting work together for the Amethyst Flower Beetle. Its shell carries a strong blue-violet tone, and Heartopia associates the insect with rocky or mineral-rich surfaces that visually suit that jewel-like look."
  },
  {
    "id": "ant",
    "slug": "ant",
    "name": "Ant",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/ant.webp",
    "imageStatus": "verified",
    "sellPrice": 220,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "Ant behavior becomes a miniature weather sign in Heartopia. The entry draws on the idea that ants moving toward higher ground can precede heavy rain, turning their upward march into an omen of worsening weather."
  },
  {
    "id": "apollo",
    "slug": "apollo",
    "name": "Apollo",
    "kind": "insect",
    "eventKey": "bait-the-insects",
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/apollo.webp",
    "imageStatus": "verified",
    "sellPrice": 30,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "Cold conditions seem less threatening to Apollo than its delicate butterfly shape would suggest. Heartopia links that resilience to the insect's fuzzy-looking covering, which gives it the appearance of being dressed for chillier weather."
  },
  {
    "id": "asian-lady-beetle",
    "slug": "asian-lady-beetle",
    "name": "Asian Lady Beetle",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/asian-lady-beetle.webp",
    "imageStatus": "verified",
    "sellPrice": 165,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "A playful face seems to be built into the Asian Lady Beetle's shell: the arrangement of its dorsal spots resembles a smiling expression. That accidental-looking pattern is the main visual joke attached to the species in Heartopia."
  },
  {
    "id": "asparagus-beetle",
    "slug": "asparagus-beetle",
    "name": "Asparagus Beetle",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/asparagus-beetle.webp",
    "imageStatus": "verified",
    "sellPrice": 55,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "Rather than relying on bright colors, the Asparagus Beetle blends in with a comparatively muted body. Heartopia presents its understated appearance as part of the insect's identity."
  },
  {
    "id": "bagworm-moth",
    "slug": "bagworm-moth",
    "name": "Bagworm Moth",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/bagworm-moth.webp",
    "imageStatus": "verified",
    "sellPrice": 440,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "The Bagworm Moth effectively carries a handmade home, assembling protective cover from leaves and small pieces of vegetation. It is also a scarce encounter, so missing one can mean searching another area for the next appearance."
  },
  {
    "id": "beautiful-demoiselle",
    "slug": "beautiful-demoiselle",
    "name": "Beautiful Demoiselle",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/beautiful-demoiselle.webp",
    "imageStatus": "verified",
    "sellPrice": 110,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "A dark, restrained appearance gives the Beautiful Demoiselle a surprisingly serious character. Heartopia imagines the damselfly as looking worldly and self-possessed rather than delicate or carefree."
  },
  {
    "id": "beautiful-leopard",
    "slug": "beautiful-leopard",
    "name": "Beautiful Leopard",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/beautiful-leopard.webp",
    "imageStatus": "verified",
    "sellPrice": 90,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "The Beautiful Leopard's appeal comes from a naturally patterned set of wings that resembles fashionable animal print. Heartopia turns the butterfly's markings into a tongue-in-cheek style statement."
  },
  {
    "id": "blue-morpho",
    "slug": "blue-morpho",
    "name": "Blue Morpho",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/blue-morpho.webp",
    "imageStatus": "verified",
    "sellPrice": 150,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "Dense greenery makes the Blue Morpho's coloration even harder to miss. Its wings carry an intense blue that produces a strong contrast against forest vegetation."
  },
  {
    "id": "blue-shieldbug",
    "slug": "blue-shieldbug",
    "name": "Blue Shieldbug",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/blue-shieldbug.webp",
    "imageStatus": "verified",
    "sellPrice": 110,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "A glossy blue shell gives the Blue Shieldbug the look of a tiny piece of jewelry in motion. Heartopia focuses on that gem-like finish rather than on unusual behavior."
  },
  {
    "id": "bumblebee",
    "slug": "bumblebee",
    "name": "Bumblebee",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/bumblebee.webp",
    "imageStatus": "verified",
    "sellPrice": 110,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "Heartopia gives the Bumblebee a deliberately cuddly silhouette. Its heavy, rounded build inspires a joke that the insect resembles a very small bear after an overly generous meal."
  },
  {
    "id": "cabbage-white",
    "slug": "cabbage-white",
    "name": "Cabbage White",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/cabbage-white.webp",
    "imageStatus": "verified",
    "sellPrice": 30,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "The Cabbage White is intentionally understated beside more elaborate butterflies. Soft gray and white tones dominate its wings, and Heartopia turns that lack of flashiness into part of its quiet character."
  },
  {
    "id": "cerulean-carpenter",
    "slug": "cerulean-carpenter",
    "name": "Cerulean Carpenter",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/cerulean-carpenter.webp",
    "imageStatus": "verified",
    "sellPrice": 440,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "Blue dominates the Cerulean Carpenter so completely that Heartopia jokes about the insect wanting a broader palette. Its appearances under rainbow conditions become the setup for that color-related gag."
  },
  {
    "id": "chestnut-tiger",
    "slug": "chestnut-tiger",
    "name": "Chestnut Tiger",
    "kind": "insect",
    "eventKey": "bait-the-insects",
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/chestnut-tiger.webp",
    "imageStatus": "verified",
    "sellPrice": 150,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "Predators receive a visual warning from the Chestnut Tiger before they ever attack. Strong coloration advertises the butterfly's toxic defenses, making its appearance part of its protection."
  },
  {
    "id": "cicada",
    "slug": "cicada",
    "name": "Cicada",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/cicada.webp",
    "imageStatus": "verified",
    "sellPrice": 220,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "Most of a Cicada's life is spent out of sight, so Heartopia emphasizes the contrast once it finally surfaces. After a long underground wait, the adult insect becomes anything but discreet, filling the area with sound."
  },
  {
    "id": "comet-moth",
    "slug": "comet-moth",
    "name": "Comet Moth",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/comet-moth.webp",
    "imageStatus": "verified",
    "sellPrice": 240,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "The Comet Moth's rear wing extensions are so long that they trail visibly behind it in flight. Their motion creates the celestial impression that inspired the insect's name."
  },
  {
    "id": "common-blue-butterfly",
    "slug": "common-blue-butterfly",
    "name": "Common Blue Butterfly",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/common-blue-butterfly.webp",
    "imageStatus": "verified",
    "sellPrice": 105,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "Movement is part of the Common Blue Butterfly's appeal. As its bright wings open and close around town, Heartopia treats the repeated fluttering as a miniature performance in the air."
  },
  {
    "id": "common-brimstone",
    "slug": "common-brimstone",
    "name": "Common Brimstone",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/common-brimstone.webp",
    "imageStatus": "verified",
    "sellPrice": 30,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "The Common Brimstone avoids looking generic despite its name. Heartopia points to the particular mix of wing patterning and coloration that gives the butterfly its own recognizable appearance."
  },
  {
    "id": "common-whitetail",
    "slug": "common-whitetail",
    "name": "Common Whitetail",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/common-whitetail.webp",
    "imageStatus": "verified",
    "sellPrice": 75,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "Moist air suits the Common Whitetail especially well. Heartopia characterizes this dragonfly as comfortable in humid surroundings, making its environmental preference more notable than any elaborate lore."
  },
  {
    "id": "conehead-mantis",
    "slug": "conehead-mantis",
    "name": "Conehead Mantis",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/conehead-mantis.webp",
    "imageStatus": "verified",
    "sellPrice": 515,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "A raised structure on the head gives the Conehead Mantis its unusual silhouette. Even with that distinctive shape, Heartopia notes that spotting the insect in its surroundings can still be surprisingly difficult."
  },
  {
    "id": "crimson-marsh-glider",
    "slug": "crimson-marsh-glider",
    "name": "Crimson Marsh Glider",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/crimson-marsh-glider.webp",
    "imageStatus": "verified",
    "sellPrice": 185,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "The Crimson Marsh Glider is built around saturated color rather than camouflage. Heartopia gives the dragonfly a floral elegance, using its vivid body to evoke the impression of a blooming red flower."
  },
  {
    "id": "elegant-flower-beetle",
    "slug": "elegant-flower-beetle",
    "name": "Elegant Flower Beetle",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/elegant-flower-beetle.webp",
    "imageStatus": "verified",
    "sellPrice": 275,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "The name “Elegant” becomes part of the joke with Elegant Flower Beetle. Its colorful, attractive appearance supports the label, but Heartopia still teases the insect for advertising that quality so openly."
  },
  {
    "id": "european-firebug",
    "slug": "european-firebug",
    "name": "European Firebug",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/european-firebug.webp",
    "imageStatus": "verified",
    "sellPrice": 35,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "Red and black make the European Firebug immediately recognizable. Heartopia exaggerates the impact of that pattern by giving the insect a mock claim to fame in entomology publishing."
  },
  {
    "id": "fire-colored-beetle",
    "slug": "fire-colored-beetle",
    "name": "Fire-Colored Beetle",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/fire-colored-beetle.webp",
    "imageStatus": "verified",
    "sellPrice": 110,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "The Fire-Colored Beetle looks as though warmth has been painted directly onto its body. Heartopia turns the intense red into a personality gag, imagining the beetle as particularly fond of hot springs."
  },
  {
    "id": "four-spotted-ladybug",
    "slug": "four-spotted-ladybug",
    "name": "Four-Spotted Ladybug",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/four-spotted-ladybug.webp",
    "imageStatus": "verified",
    "sellPrice": 165,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "Counting spots is the easiest way Heartopia distinguishes this ladybug from its seven-spotted relative: this one carries four. A catching note also suggests checking above low vegetation when looking for it."
  },
  {
    "id": "four-spotted-skimmer",
    "slug": "four-spotted-skimmer",
    "name": "Four-Spotted Skimmer",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/four-spotted-skimmer.webp",
    "imageStatus": "verified",
    "sellPrice": 75,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "Four dark wing marks give the Four-Spotted Skimmer a decorated, battle-ready appearance. Heartopia treats those markings almost like badges earned by an experienced fighter."
  },
  {
    "id": "frostspore-mother-of-pearl",
    "slug": "frostspore-mother-of-pearl",
    "name": "Frostspore Mother-of-Pearl",
    "kind": "insect",
    "eventKey": "frostspore-butterfly-spirit-oak-pine-forest-forest-jump-puzzle",
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/frostspore-mother-of-pearl.webp",
    "imageStatus": "verified",
    "sellPrice": 60,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "After Frostspore takes hold, Mother-of-Pearl loses much of its ordinary butterfly feel. The altered surface becomes so decorative and crystalline that the insect is presented more like wearable ornamentation."
  },
  {
    "id": "frostspore-postman-butterfly",
    "slug": "frostspore-postman-butterfly",
    "name": "Frostspore Postman Butterfly",
    "kind": "insect",
    "eventKey": "frostspore-butterfly",
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/frostspore-postman-butterfly.webp",
    "imageStatus": "verified",
    "sellPrice": 90,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "Frostspore redraws the Postman Butterfly with much brighter linear markings. The infected wings take on an artificial-looking glow, creating a sharply different visual effect from the normal form."
  },
  {
    "id": "frostspore-purple-spotted-swallowtail",
    "slug": "frostspore-purple-spotted-swallowtail",
    "name": "Frostspore Purple Spotted Swallowtail",
    "kind": "insect",
    "eventKey": "frostspore-butterfly-spirit-oak-pine-forest",
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/frostspore-purple-spotted-swallowtail.webp",
    "imageStatus": "verified",
    "sellPrice": 60,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "The infected Purple Spotted Swallowtail is defined by how completely Frostspore changes its mood and appearance. Heartopia presents the result as softer and more dreamlike than the butterfly's usual form."
  },
  {
    "id": "frostspore-queen-alexandras-birdwing",
    "slug": "frostspore-queen-alexandras-birdwing",
    "name": "Frostspore Queen Alexandra's Birdwing",
    "kind": "insect",
    "eventKey": "frostspore-butterfly-deer-tower",
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/frostspore-queen-alexandras-birdwing.webp",
    "imageStatus": "verified",
    "sellPrice": 60,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "Queen Alexandra's Birdwing takes on an almost brittle appearance after Frostspore infection. The transformed insect looks crystalline enough that Heartopia jokes about it seeming too delicate to touch safely."
  },
  {
    "id": "frostspore-sulkowskys-morpho",
    "slug": "frostspore-sulkowskys-morpho",
    "name": "Frostspore Sulkowsky's Morpho",
    "kind": "insect",
    "eventKey": "frostspore-butterfly",
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/frostspore-sulkowskys-morpho.webp",
    "imageStatus": "verified",
    "sellPrice": 60,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "Frostspore intensifies the optical effect of Sulkowsky's Morpho. Its naturally translucent wings interact with light even more dramatically after infection, producing a noticeably brighter display."
  },
  {
    "id": "giant-asian-mantis",
    "slug": "giant-asian-mantis",
    "name": "Giant Asian Mantis",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/giant-asian-mantis.webp",
    "imageStatus": "verified",
    "sellPrice": 390,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "The Giant Asian Mantis is presented as an active fighter, with its front legs shaped like heavy cutting tools. When hunting for one, disturbed foliage can betray a mantis hiding inside the bushes."
  },
  {
    "id": "gold-grasshopper",
    "slug": "gold-grasshopper",
    "name": "Gold Grasshopper",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/gold-grasshopper.webp",
    "imageStatus": "verified",
    "sellPrice": 45,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "Antennae do more than complete the Gold Grasshopper's silhouette. Heartopia credits the long, sturdy pair with sensing shifts in the nearby environment."
  },
  {
    "id": "golden-jewel-scarab",
    "slug": "golden-jewel-scarab",
    "name": "Golden Jewel Scarab",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/golden-jewel-scarab.webp",
    "imageStatus": "verified",
    "sellPrice": 275,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "Metallic brilliance defines the Golden Jewel Scarab. Heartopia exaggerates that shine with a money-themed joke, treating the beetle as though a piece of precious metal had suddenly become airborne."
  },
  {
    "id": "golden-stag-beetle",
    "slug": "golden-stag-beetle",
    "name": "Golden Stag Beetle",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/golden-stag-beetle.webp",
    "imageStatus": "verified",
    "sellPrice": 440,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "Luxury is the running theme of the Golden Stag Beetle's presentation. A strong gold-toned finish covers the insect, giving it a deliberately expensive and polished look."
  },
  {
    "id": "green-birdwing",
    "slug": "green-birdwing",
    "name": "Green Birdwing",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/green-birdwing.webp",
    "imageStatus": "verified",
    "sellPrice": 150,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "The Green Birdwing's wings reflect light with a metallic quality rather than a flat green tone. Heartopia ties that shimmer to the kind of brightness seen when sunlight breaks through foliage."
  },
  {
    "id": "green-script-supervisor-bumblebee",
    "slug": "green-script-supervisor-bumblebee",
    "name": "Green Script Supervisor Bumblebee",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/green-script-supervisor-bumblebee.webp",
    "imageStatus": "verified",
    "sellPrice": 110,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "Dreamlight Cinematics gives this green bumblebee a backstage role rather than ordinary insect lore. It works as a script supervisor, with a joke that its screen appearances sometimes extend to nature-documentary cameos."
  },
  {
    "id": "green-tiger-beetle",
    "slug": "green-tiger-beetle",
    "name": "Green Tiger Beetle",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/green-tiger-beetle.webp",
    "imageStatus": "verified",
    "sellPrice": 110,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "The Green Tiger Beetle looks armored because of the hard, reflective surface across its back. Its green metallic finish gives that shell a polished, stone-like quality."
  },
  {
    "id": "hercules-beetle",
    "slug": "hercules-beetle",
    "name": "Hercules Beetle",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/hercules-beetle.webp",
    "imageStatus": "verified",
    "sellPrice": 440,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "The Hercules Beetle earns its mythic name through strength rather than size. Heartopia highlights how much weight it can move relative to its own body, making raw lifting power the species' defining feat."
  },
  {
    "id": "horned-beetle",
    "slug": "horned-beetle",
    "name": "Horned Beetle",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/horned-beetle.webp",
    "imageStatus": "verified",
    "sellPrice": 275,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "A large forked horn dominates the Horned Beetle's head and makes the insect look far more imposing than its compact body would suggest. Heartopia emphasizes that headgear as its main identifying feature."
  },
  {
    "id": "katydid",
    "slug": "katydid",
    "name": "Katydid",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/katydid.webp",
    "imageStatus": "verified",
    "sellPrice": 180,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "Heartopia gives the Katydid a simple emotional tell: happiness supposedly makes it vocal. Its chirping is framed less as background noise and more as the insect breaking into song."
  },
  {
    "id": "large-banded-grasshopper",
    "slug": "large-banded-grasshopper",
    "name": "Large Banded Grasshopper",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/large-banded-grasshopper.webp",
    "imageStatus": "verified",
    "sellPrice": 140,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "Color is concentrated in an unexpected place on the Large Banded Grasshopper. The hind legs carry a strong red tone, providing the clearest visual cue for recognizing the species."
  },
  {
    "id": "large-red-damselfly",
    "slug": "large-red-damselfly",
    "name": "Large Red Damselfly",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/large-red-damselfly.webp",
    "imageStatus": "verified",
    "sellPrice": 35,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "The Large Red Damselfly is presented as lively rather than merely colorful. Its movement around water is graceful and energetic enough that Heartopia treats the flight almost like dancing."
  },
  {
    "id": "mediterranean-mantis",
    "slug": "mediterranean-mantis",
    "name": "Mediterranean Mantis",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/mediterranean-mantis.webp",
    "imageStatus": "verified",
    "sellPrice": 195,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "The Mediterranean Mantis hides its most colorful feature. From the outside it can seem fairly plain, but opening the wings reveals much brighter, rainbow-like tones underneath."
  },
  {
    "id": "mini-moon-moth",
    "slug": "mini-moon-moth",
    "name": "Mini Moon Moth",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/mini-moon-moth.webp",
    "imageStatus": "verified",
    "sellPrice": 105,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "Muted color is what makes the Mini Moon Moth look refined. Instead of vivid saturation, its palette is restrained and soft, giving the insect a more sophisticated visual character."
  },
  {
    "id": "minotaur-beetle",
    "slug": "minotaur-beetle",
    "name": "Minotaur Beetle",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/minotaur-beetle.webp",
    "imageStatus": "verified",
    "sellPrice": 275,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "The Minotaur Beetle looks dangerous long before it behaves that way. Heartopia describes a calm, harmless temperament, even though the large horns on its head are capable of delivering real force."
  },
  {
    "id": "morpho-helena",
    "slug": "morpho-helena",
    "name": "Morpho Helena",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/morpho-helena.webp",
    "imageStatus": "verified",
    "sellPrice": 240,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "Blue and white alternate visually as Morpho Helena beats its wings. Heartopia uses that changing pattern to evoke the impression of bright surf moving across darker water."
  },
  {
    "id": "mother-of-pearl",
    "slug": "mother-of-pearl",
    "name": "Mother-Of-Pearl",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/mother-of-pearl.webp",
    "imageStatus": "verified",
    "sellPrice": 240,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "Time spent among flowers is woven into Mother-Of-Pearl's lore. Heartopia imagines the butterfly gradually taking on a soft pink-violet coloration that echoes the blossoms around it."
  },
  {
    "id": "mourning-cloak",
    "slug": "mourning-cloak",
    "name": "Mourning Cloak",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/mourning-cloak.webp",
    "imageStatus": "verified",
    "sellPrice": 90,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "The Mourning Cloak's name suggests darkness, but Heartopia highlights a much warmer visual detail. Its wings catch the eye with a strong yellow-orange brightness."
  },
  {
    "id": "old-world-swallowtail",
    "slug": "old-world-swallowtail",
    "name": "Old World Swallowtail",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/old-world-swallowtail.webp",
    "imageStatus": "verified",
    "sellPrice": 30,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "Heartopia treats the Old World Swallowtail almost like a living artwork. Its appearance has inspired the poetic labels “Flying Flower” and “Insect Artist,” both emphasizing how decorative the butterfly is considered."
  },
  {
    "id": "orange-tip",
    "slug": "orange-tip",
    "name": "Orange-Tip",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/orange-tip.webp",
    "imageStatus": "verified",
    "sellPrice": 30,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "The Orange-Tip is a familiar sight rather than an elusive oddity. Bright wing accents make it easy to recognize while it moves through the more populated parts of town."
  },
  {
    "id": "peacock-butterfly",
    "slug": "peacock-butterfly",
    "name": "Peacock Butterfly",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/peacock-butterfly.webp",
    "imageStatus": "verified",
    "sellPrice": 90,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "The Peacock Butterfly's large wing markings may function as a bluff. By resembling eyes, those spots can make the insect appear more threatening to predators and potentially discourage an attack."
  },
  {
    "id": "picasso-bug",
    "slug": "picasso-bug",
    "name": "Picasso Bug",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/picasso-bug.webp",
    "imageStatus": "verified",
    "sellPrice": 185,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "The Picasso Bug looks naturally illustrated, with complex abstract markings spread across its back. Heartopia leans into the artistic association, presenting the pattern as unusually bold and stylish."
  },
  {
    "id": "pink-katydid",
    "slug": "pink-katydid",
    "name": "Pink Katydid",
    "kind": "insect",
    "eventKey": "bait-the-insects",
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/pink-katydid.webp",
    "imageStatus": "verified",
    "sellPrice": 90,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "Nothing happened to dye this katydid after the fact—the pink is simply its natural coloration. Heartopia builds its joke around ruling out an absurd strawberry-jam accident as the explanation."
  },
  {
    "id": "pink-script-supervisor-bumblebee",
    "slug": "pink-script-supervisor-bumblebee",
    "name": "Pink Script Supervisor Bumblebee",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/pink-script-supervisor-bumblebee.webp",
    "imageStatus": "verified",
    "sellPrice": 110,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "Dreamlight Cinematics gives this pink bumblebee a behind-the-scenes job. It handles script supervision and is especially associated with romance productions rather than ordinary insect activity."
  },
  {
    "id": "postman-butterfly",
    "slug": "postman-butterfly",
    "name": "Postman Butterfly",
    "kind": "insect",
    "eventKey": "bait-the-insects",
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/postman-butterfly.webp",
    "imageStatus": "verified",
    "sellPrice": 30,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "Two red marks may catch the eye first, but Heartopia deliberately shifts attention away from them: the entry treats the entire Postman Butterfly as the artwork, not just those accents."
  },
  {
    "id": "purple-emperor",
    "slug": "purple-emperor",
    "name": "Purple Emperor",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/purple-emperor.webp",
    "imageStatus": "verified",
    "sellPrice": 90,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "Purple is more than a color preference for this butterfly. Heartopia's fantasy lore says that devotion to the hue led the Purple Emperor to learn magic involving light and shadow so it could recolor its own wings."
  },
  {
    "id": "purple-script-supervisor-bumblebee",
    "slug": "purple-script-supervisor-bumblebee",
    "name": "Purple Script Supervisor Bumblebee",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/purple-script-supervisor-bumblebee.webp",
    "imageStatus": "verified",
    "sellPrice": 110,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "Production trouble triggers an unusual reaction in this purple script supervisor: instead of staying composed, the bumblebee erupts into frantic buzzing that makes the moment feel like an accidental musical number."
  },
  {
    "id": "rainbow-stag-beetle",
    "slug": "rainbow-stag-beetle",
    "name": "Rainbow Stag Beetle",
    "kind": "insect",
    "eventKey": "bait-the-insects-ruins",
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/rainbow-stag-beetle.webp",
    "imageStatus": "verified",
    "sellPrice": 440,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "This beetle belongs to the extra stage of the Bait the Insects event rather than the ordinary encounter pool. Heartopia presents the catch as something visually comparable to capturing a fragment of a rainbow."
  },
  {
    "id": "rajah-brookes-birdwing",
    "slug": "rajah-brookes-birdwing",
    "name": "Rajah Brooke’s Birdwing",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/rajah-brookes-birdwing.webp",
    "imageStatus": "verified",
    "sellPrice": 90,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "The easiest feature to pick out on Rajah Brooke's Birdwing is not its overall wing shape but the red spotting on the body. Heartopia uses those marks as the butterfly's clearest visual cue."
  },
  {
    "id": "red-script-supervisor-bumblebee",
    "slug": "red-script-supervisor-bumblebee",
    "name": "Red Script Supervisor Bumblebee",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/red-script-supervisor-bumblebee.webp",
    "imageStatus": "verified",
    "sellPrice": 110,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "On Dreamlight Cinematics horror shoots, the red Script Supervisor Bumblebee is the meticulous one. Its role centers on tracking production details carefully instead of participating in the on-screen action."
  },
  {
    "id": "seven-spotted-ladybug",
    "slug": "seven-spotted-ladybug",
    "name": "Seven-Spotted Ladybug",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/seven-spotted-ladybug.webp",
    "imageStatus": "verified",
    "sellPrice": 110,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "Heartopia attaches a small superstition to the Seven-Spotted Ladybug: encountering one is considered fortunate. Its seven marks also invite a playful comparison with the related four-spotted ladybug."
  },
  {
    "id": "siberian-grasshopper",
    "slug": "siberian-grasshopper",
    "name": "Siberian Grasshopper",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/siberian-grasshopper.webp",
    "imageStatus": "verified",
    "sellPrice": 90,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "Two body features make the Siberian Grasshopper unusual at a glance: the front legs are oversized, while the antennae bend into a shape reminiscent of hockey equipment."
  },
  {
    "id": "silver-jewel-scarab",
    "slug": "silver-jewel-scarab",
    "name": "Silver Jewel Scarab",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/silver-jewel-scarab.webp",
    "imageStatus": "verified",
    "sellPrice": 165,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "A highly reflective silver shell gives this scarab an extravagant appearance. Heartopia turns that visual richness into a joke that the insect must come from money."
  },
  {
    "id": "spanish-moon-moth",
    "slug": "spanish-moon-moth",
    "name": "Spanish Moon Moth",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/spanish-moon-moth.webp",
    "imageStatus": "verified",
    "sellPrice": 150,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "Heartopia gives the Spanish Moon Moth a bittersweet identity: its beauty is paired with a brief lifespan. That makes seeing one feel more temporary than encounters with longer-lived insects."
  },
  {
    "id": "splay-footed-carpenter",
    "slug": "splay-footed-carpenter",
    "name": "Splay-Footed Carpenter",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/splay-footed-carpenter.webp",
    "imageStatus": "verified",
    "sellPrice": 165,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "A purple cast becomes visible across the Splay-Footed Carpenter's wings when they catch the light. Heartopia also gives the insect an aesthetic streak, portraying it as drawn toward especially picturesque places."
  },
  {
    "id": "stag-beetle",
    "slug": "stag-beetle",
    "name": "Stag Beetle",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/stag-beetle.webp",
    "imageStatus": "verified",
    "sellPrice": 275,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "“Flying Deer” is the nickname attached to Stag Beetle. Heartopia accepts the airborne half of that label without argument and treats the deer comparison with considerably more skepticism."
  },
  {
    "id": "sulkowskys-morpho",
    "slug": "sulkowskys-morpho",
    "name": "Sulkowsky’s Morpho",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/sulkowskys-morpho.webp",
    "imageStatus": "verified",
    "sellPrice": 90,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "Light passes through Sulkowsky's Morpho in a particularly delicate way because the wings are extremely thin and carry a pearly surface sheen. The result is a luminous, almost translucent look."
  },
  {
    "id": "sunset-morpho",
    "slug": "sunset-morpho",
    "name": "Sunset Morpho",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/sunset-morpho.webp",
    "imageStatus": "verified",
    "sellPrice": 240,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "Warm colors blend across Sunset Morpho in a gradient associated with the changing sky around dawn. Heartopia makes that atmospheric color transition the butterfly's main visual identity."
  },
  {
    "id": "waroona-cuckoo-bee",
    "slug": "waroona-cuckoo-bee",
    "name": "Waroona Cuckoo Bee",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/waroona-cuckoo-bee.webp",
    "imageStatus": "verified",
    "sellPrice": 165,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "The Waroona Cuckoo Bee's rear is crossed by alternating pale and gray bands. Heartopia jokes about the striped pattern as though the bee had borrowed its design from a zebra."
  },
  {
    "id": "wasp-beetle",
    "slug": "wasp-beetle",
    "name": "Wasp Beetle",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/wasp-beetle.webp",
    "imageStatus": "verified",
    "sellPrice": 110,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "Looking dangerous is part of the Wasp Beetle's defense. By closely imitating a hornet, it gains protection from predators that may hesitate to attack something they mistake for a stinging insect."
  },
  {
    "id": "white-witch",
    "slug": "white-witch",
    "name": "White Witch",
    "kind": "insect",
    "eventKey": "bait-the-insects",
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/white-witch.webp",
    "imageStatus": "verified",
    "sellPrice": 90,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/insects.ts"
    ],
    "notes": null,
    "description": "Heartopia gives White Witch an intentionally simple identity built around appearance: the insect is presented as striking no matter which side or angle the player sees."
  },
  {
    "id": "african-olive-pigeon",
    "slug": "african-olive-pigeon",
    "name": "African Olive Pigeon",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/african-olive-pigeon.webp",
    "imageStatus": "verified",
    "sellPrice": 27,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "White speckles cover large areas of the African Olive Pigeon's chest and back, creating a densely dotted pattern. Heartopia even turns the visual into a trypophobia warning joke."
  },
  {
    "id": "american-flamingo",
    "slug": "american-flamingo",
    "name": "American Flamingo",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/american-flamingo.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "Diet explains the American Flamingo's famous color in Heartopia's entry. Carotenoids accumulated through feeding are tied directly to the bird's pink feathers, making its appearance partly a product of what it eats."
  },
  {
    "id": "amur-falcon",
    "slug": "amur-falcon",
    "name": "Amur Falcon",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/amur-falcon.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "The Amur Falcon's mostly gray body makes the color on its legs stand out even more. Heartopia interprets those reddish limbs as if the bird had put on a conspicuous pair of boots."
  },
  {
    "id": "audouins-gull",
    "slug": "audouins-gull",
    "name": "Audouin’s Gull",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/audouins-gull.webp",
    "imageStatus": "verified",
    "sellPrice": 17,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "Freshness is non-negotiable for Audouin's Gull in Heartopia. The bird is portrayed as refusing anything except sea fish it has personally caught, giving it an unusually strict standard for food."
  },
  {
    "id": "azores-bullfinch",
    "slug": "azores-bullfinch",
    "name": "Azores Bullfinch",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/azores-bullfinch.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "The Azores Bullfinch gets a deliberately playful Heartopia profile rather than detailed behavior. Its entire reputation is built around being so cute that the game treats the charm itself as hazardous."
  },
  {
    "id": "azure-tit",
    "slug": "azure-tit",
    "name": "Azure Tit",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/azure-tit.webp",
    "imageStatus": "verified",
    "sellPrice": 22,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "The Azure Tit is given a watchful personality rather than a playful one. Heartopia depicts the small bird with a serious expression as it keeps close attention on what is happening around it."
  },
  {
    "id": "bearded-reedling",
    "slug": "bearded-reedling",
    "name": "Bearded Reedling",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/bearded-reedling.webp",
    "imageStatus": "verified",
    "sellPrice": 10,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "Dark feathers around the Bearded Reedling's eyes create the impression of someone badly short on sleep. Heartopia turns those markings into a joke about permanent-looking exhaustion."
  },
  {
    "id": "blue-and-yellow-macaw",
    "slug": "blue-and-yellow-macaw",
    "name": "Blue-and-yellow Macaw",
    "kind": "bird",
    "eventKey": "nest-of-hundreds",
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/blue-and-yellow-macaw.webp",
    "imageStatus": "verified",
    "sellPrice": 7,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "Heartopia gives the Blue-and-yellow Macaw a big personality to match its appearance: it is strong, eats enthusiastically and carries noticeable facial markings alongside its sharply contrasting plumage."
  },
  {
    "id": "blue-peafowl",
    "slug": "blue-peafowl",
    "name": "Blue Peafowl",
    "kind": "bird",
    "eventKey": "nest-of-hundreds",
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/blue-peafowl.webp",
    "imageStatus": "verified",
    "sellPrice": 10,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "Display behavior is the point of the Blue Peafowl's entry. Its tail becomes such a brilliant visual centerpiece that Heartopia treats showing it off as an entirely understandable act of pride."
  },
  {
    "id": "brown-noddy",
    "slug": "brown-noddy",
    "name": "Brown Noddy",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/brown-noddy.webp",
    "imageStatus": "verified",
    "sellPrice": 22,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "A white patch on top of the Brown Noddy's head gives the bird an unexpectedly formal look. Heartopia interprets it as miniature headwear while also characterizing the species as notably gentle."
  },
  {
    "id": "cinnamon-ground-dove",
    "slug": "cinnamon-ground-dove",
    "name": "Cinnamon Ground Dove",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/cinnamon-ground-dove.webp",
    "imageStatus": "verified",
    "sellPrice": 27,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "Warm coloration extends beyond the Cinnamon Ground Dove's name. Heartopia notes a sandy cast across the chest feathers, adding a softer coastal tone to the bird's overall appearance."
  },
  {
    "id": "common-kestrel",
    "slug": "common-kestrel",
    "name": "Common Kestrel",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/common-kestrel.webp",
    "imageStatus": "verified",
    "sellPrice": 47,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "A connected pair of pale eyebrow markings gives Common Kestrel a stubborn-looking expression, which Heartopia folds into its hard-to-tame personality. For observation, the guide recommends scanning the highest trees."
  },
  {
    "id": "double-barred-finch",
    "slug": "double-barred-finch",
    "name": "Double-Barred Finch",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/double-barred-finch.webp",
    "imageStatus": "verified",
    "sellPrice": 10,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "The facial pattern of the Double-Barred Finch can read like a pair of dark spectacles. Heartopia pairs that scholarly look with the opposite of solitude, presenting the bird as highly sociable."
  },
  {
    "id": "eagle-owl",
    "slug": "eagle-owl",
    "name": "Eagle-Owl",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/eagle-owl.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "Despite its appealing appearance, the Eagle-Owl would rather avoid human company. Heartopia characterizes it as intensely shy, and the associated viewing tip points birdwatchers toward the uppermost branches of tall trees."
  },
  {
    "id": "eastern-bluebird",
    "slug": "eastern-bluebird",
    "name": "Eastern Bluebird",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/eastern-bluebird.webp",
    "imageStatus": "verified",
    "sellPrice": 30,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "Open country fits the personality Heartopia assigns to the Eastern Bluebird. The brightly colored bird is cast as independent and happiest living freely rather than staying confined."
  },
  {
    "id": "eurasian-bullfinch",
    "slug": "eurasian-bullfinch",
    "name": "Eurasian Bullfinch",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/eurasian-bullfinch.webp",
    "imageStatus": "verified",
    "sellPrice": 7,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "Heartopia turns the Eurasian Bullfinch's colors into formalwear. In the joke, the red chest becomes a vest, gray plumage supplies the tailcoat, and the black cap finishes the outfit as a top hat."
  },
  {
    "id": "eurasian-chaffinch",
    "slug": "eurasian-chaffinch",
    "name": "Eurasian Chaffinch",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/eurasian-chaffinch.webp",
    "imageStatus": "verified",
    "sellPrice": 7,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "The Eurasian Chaffinch's gray-blue head covering gives it a relatively restrained look, but Heartopia does not make the personality match: the bird is characterized as an energetic singer."
  },
  {
    "id": "eurasian-collared-dove",
    "slug": "eurasian-collared-dove",
    "name": "Eurasian Collared Dove",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/eurasian-collared-dove.webp",
    "imageStatus": "verified",
    "sellPrice": 10,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "A calm demeanor should not be read as helplessness with the Eurasian Collared Dove. Heartopia gives the species a friendly, gentle nature while explicitly preserving a tougher side beneath that temperament."
  },
  {
    "id": "eurasian-golden-oriole",
    "slug": "eurasian-golden-oriole",
    "name": "Eurasian Golden Oriole",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/eurasian-golden-oriole.webp",
    "imageStatus": "verified",
    "sellPrice": 15,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "The Eurasian Golden Oriole is framed as aristocratic among birds. Its bright gold feathers are given a celestial quality in Heartopia, supporting that unusually noble presentation."
  },
  {
    "id": "eurasian-nuthatch",
    "slug": "eurasian-nuthatch",
    "name": "Eurasian Nuthatch",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/eurasian-nuthatch.webp",
    "imageStatus": "verified",
    "sellPrice": 10,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "Tree bark doubles as storage space for the Eurasian Nuthatch. The bird tucks food into natural gaps and cracks, effectively creating small caches for later use."
  },
  {
    "id": "eurasian-wigeon",
    "slug": "eurasian-wigeon",
    "name": "Eurasian Wigeon",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/eurasian-wigeon.webp",
    "imageStatus": "verified",
    "sellPrice": 17,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "A pale forehead breaks sharply against the Eurasian Wigeon's reddish-brown head. That high-contrast combination is what Heartopia says makes the bird easy to pick out among others."
  },
  {
    "id": "eurasian-wren",
    "slug": "eurasian-wren",
    "name": "Eurasian Wren",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/eurasian-wren.webp",
    "imageStatus": "verified",
    "sellPrice": 7,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "Heartopia connects the Eurasian Wren with stories where intelligence outweighs size. In those tales, the tiny bird succeeds against much larger eagles through cleverness rather than strength."
  },
  {
    "id": "european-bee-eater",
    "slug": "european-bee-eater",
    "name": "European Bee-Eater",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/european-bee-eater.webp",
    "imageStatus": "verified",
    "sellPrice": 22,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "The European Bee-Eater hunts exactly the prey its name suggests. Heartopia emphasizes how quickly and aggressively it goes after bees, making pursuit skill more central than the bird's colorful plumage."
  },
  {
    "id": "european-robin",
    "slug": "european-robin",
    "name": "European Robin",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/european-robin.webp",
    "imageStatus": "verified",
    "sellPrice": 7,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "Song is one of the European Robin's strengths, while its chest supplies the visual joke. Heartopia interprets the orange feathers there as a tiny piece of bib-like clothing."
  },
  {
    "id": "european-shag",
    "slug": "european-shag",
    "name": "European Shag",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/european-shag.webp",
    "imageStatus": "verified",
    "sellPrice": 17,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "Diving becomes a mock sporting event in the European Shag's lore. Heartopia exaggerates the bird's ability by imagining it sweeping every podium position in the discipline."
  },
  {
    "id": "great-green-macaw",
    "slug": "great-green-macaw",
    "name": "Great Green Macaw",
    "kind": "bird",
    "eventKey": "nest-of-hundreds",
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/great-green-macaw.webp",
    "imageStatus": "verified",
    "sellPrice": 15,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "The Great Green Macaw is not portrayed as outgoing despite its conspicuous appearance. It prefers limited social contact, and the naturally pinkish cheeks add a softer visual detail to that reserved character."
  },
  {
    "id": "great-tit",
    "slug": "great-tit",
    "name": "Great Tit",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/great-tit.webp",
    "imageStatus": "verified",
    "sellPrice": 7,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "Timidity is not part of the Great Tit's Heartopia personality. The bird is presented as active and bold, with an additional preference for relatively warm surroundings."
  },
  {
    "id": "greater-flamingo",
    "slug": "greater-flamingo",
    "name": "Greater Flamingo",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/greater-flamingo.webp",
    "imageStatus": "verified",
    "sellPrice": 15,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "The Greater Flamingo stands out for how long it can live. Heartopia highlights the species' exceptional longevity and cites an individual reaching 83 years of age."
  },
  {
    "id": "hawfinch",
    "slug": "hawfinch",
    "name": "Hawfinch",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/hawfinch.webp",
    "imageStatus": "verified",
    "sellPrice": 15,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "Attention goes straight to the Hawfinch's bill rather than its feathers. Heartopia emphasizes a short, pointed beak with a metallic-looking finish as the bird's defining feature."
  },
  {
    "id": "imperial-shag",
    "slug": "imperial-shag",
    "name": "Imperial Shag",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/imperial-shag.webp",
    "imageStatus": "verified",
    "sellPrice": 45,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "Heartopia takes the word “Imperial” literally for this shag. The bird is jokingly elevated above other cormorants, as though it were the species' reigning authority."
  },
  {
    "id": "jambu-fruit-dove",
    "slug": "jambu-fruit-dove",
    "name": "Jambu Fruit Dove",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/jambu-fruit-dove.webp",
    "imageStatus": "verified",
    "sellPrice": 27,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "Red and green dominate the Jambu Fruit Dove's plumage, producing a combination Heartopia reads as immediately festive. The joke links those colors to Christmas rather than to the bird's behavior."
  },
  {
    "id": "king-eider",
    "slug": "king-eider",
    "name": "King Eider",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/king-eider.webp",
    "imageStatus": "verified",
    "sellPrice": 17,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "Heartopia makes the King Eider's head the punchline: its smooth blue-black coloring is imagined as a freshly shaved scalp, giving this sea duck a surprisingly monk-like visual gag."
  },
  {
    "id": "lady-amherst-pheasant",
    "slug": "lady-amherst-pheasant",
    "name": "Lady Amherst Pheasant",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/lady-amherst-pheasant.webp",
    "imageStatus": "verified",
    "sellPrice": 17,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "Showy feathers do not make Lady Amherst Pheasant outgoing. Heartopia pairs its elaborate plumage with a reclusive temperament, presenting the bird as something of a hermit despite looking dressed for attention."
  },
  {
    "id": "lears-macaw",
    "slug": "lears-macaw",
    "name": "Lear's Macaw",
    "kind": "bird",
    "eventKey": "nest-of-hundreds",
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/lears-macaw.webp",
    "imageStatus": "verified",
    "sellPrice": 22,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "Lear's Macaw gets a reserved personality that contrasts with the usual noisy-parrot stereotype. Its deep indigo feathers support a calm, polished demeanor that Heartopia frames as almost gentlemanly."
  },
  {
    "id": "lesser-flamingo",
    "slug": "lesser-flamingo",
    "name": "Lesser Flamingo",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/lesser-flamingo.webp",
    "imageStatus": "verified",
    "sellPrice": 27,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "The Lesser Flamingo is distinguished less by behavior than by atmosphere: Heartopia treats its pink coloring as soft and almost unreal, while also emphasizing that it is the smaller counterpart to the Greater Flamingo."
  },
  {
    "id": "long-eared-owl",
    "slug": "long-eared-owl",
    "name": "Long Eared Owl",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/long-eared-owl.webp",
    "imageStatus": "verified",
    "sellPrice": 47,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "Silence is part of the Long Eared Owl's hunting toolkit. Soft flight feathers help it approach prey quietly at night, while large eyes support vision in low light; Heartodex also points observers toward high rocky ground."
  },
  {
    "id": "long-tailed-tit",
    "slug": "long-tailed-tit",
    "name": "Long-Tailed Tit",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/long-tailed-tit.webp",
    "imageStatus": "verified",
    "sellPrice": 2,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "Heartopia turns the Long-Tailed Tit into a tiny bundle of motion: fluffy in shape, but constantly lively and vocal. That energetic character is deliberately contrasted with the quieter mood associated with Blanc."
  },
  {
    "id": "mallard",
    "slug": "mallard",
    "name": "Mallard",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/mallard.webp",
    "imageStatus": "verified",
    "sellPrice": 12,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "The Mallard's sleep is more alert than it looks. Heartopia highlights unihemispheric rest, where one side of the brain can remain awake, and pairs that with the duck's habit of spending plenty of time preening."
  },
  {
    "id": "paradise-tanager",
    "slug": "paradise-tanager",
    "name": "Paradise Tanager",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/paradise-tanager.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "A brilliant green crown gives Paradise Tanager an unmistakable first impression, but Heartopia avoids making it merely cheerful. The bird is instead written as distant, proud and a little mysterious."
  },
  {
    "id": "peregrine-falcon",
    "slug": "peregrine-falcon",
    "name": "Peregrine Falcon",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/peregrine-falcon.webp",
    "imageStatus": "verified",
    "sellPrice": 65,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "Speed defines the Peregrine Falcon's status in Heartopia. It is treated as the avian benchmark for sheer velocity, with a proud expression to match; high mountain rocks are also suggested as good places to scan for one."
  },
  {
    "id": "pied-imperial-pigeon",
    "slug": "pied-imperial-pigeon",
    "name": "Pied Imperial Pigeon",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/pied-imperial-pigeon.webp",
    "imageStatus": "verified",
    "sellPrice": 10,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "Curiosity drives the Pied Imperial Pigeon more than caution. Its stark black-and-white feathers make it easy to recognize, while Heartopia depicts the bird repeatedly peeking around to inspect whatever catches its attention."
  },
  {
    "id": "pine-grosbeak",
    "slug": "pine-grosbeak",
    "name": "Pine Grosbeak",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/pine-grosbeak.webp",
    "imageStatus": "verified",
    "sellPrice": 15,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "Rose-toned feathers give the Pine Grosbeak a storybook quality. Rather than describing it as merely colorful, Heartopia imagines the small bird as a forest spirit passing quietly through the trees."
  },
  {
    "id": "pink-necked-green-pigeon",
    "slug": "pink-necked-green-pigeon",
    "name": "Pink-Necked Green Pigeon",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/pink-necked-green-pigeon.webp",
    "imageStatus": "verified",
    "sellPrice": 15,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "The orange-red area around this pigeon's neck is so conspicuous that Heartopia gives it a food-related explanation: the mark is joked about as leftover berry juice from a recent meal."
  },
  {
    "id": "pink-pigeon",
    "slug": "pink-pigeon",
    "name": "Pink Pigeon",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/pink-pigeon.webp",
    "imageStatus": "verified",
    "sellPrice": 27,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "Pink and white plumage helps the Pink Pigeon disappear in an unexpected way. Among blossoms, those colors can blend into the surrounding flowers closely enough that the bird becomes harder to notice."
  },
  {
    "id": "przevalskis-parrotbill",
    "slug": "przevalskis-parrotbill",
    "name": "Przevalski's Parrotbill",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/przevalskis-parrotbill.webp",
    "imageStatus": "verified",
    "sellPrice": 15,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "The Przevalski's Parrotbill has a pale gray-white head set against a rust-brown back. That sharp contrast is used to give the tiny bird a secretive, enigmatic presence."
  },
  {
    "id": "red-and-green-macaw",
    "slug": "red-and-green-macaw",
    "name": "Red-and-green Macaw",
    "kind": "bird",
    "eventKey": "nest-of-hundreds",
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/red-and-green-macaw.webp",
    "imageStatus": "verified",
    "sellPrice": 10,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "Heartopia gives the Red-and-green Macaw a gentle temperament even though the species can be extremely loud. Its plumage mixes green, blue and vivid red, a palette playfully connected with the basic components of light."
  },
  {
    "id": "red-faced-cormorant",
    "slug": "red-faced-cormorant",
    "name": "Red Faced Cormorant",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/red-faced-cormorant.webp",
    "imageStatus": "verified",
    "sellPrice": 22,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "A bright patch around the eyes makes Red Faced Cormorant look costumed. Heartopia treats the marking like a red mask and extends the joke by suggesting the bird might be better off leaving it on."
  },
  {
    "id": "redpoll",
    "slug": "redpoll",
    "name": "Redpoll",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [
      "redpolis"
    ],
    "image": "/icons/bird/redpoll.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts",
      "renamed-from:redpolis (corrupted English name; pt-BR \"Pintarroxo\" identifies it as the redpoll, Acanthis flammea)"
    ],
    "notes": null,
    "description": "The Redpoll's face already looks styled for attention: a crimson crown sits above a darker mask. Heartopia leans into that combination by treating each appearance as a miniature fashion moment."
  },
  {
    "id": "regent-bowerbird",
    "slug": "regent-bowerbird",
    "name": "Regent Bowerbird",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/regent-bowerbird.webp",
    "imageStatus": "verified",
    "sellPrice": 15,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "The Regent Bowerbird's red patches receive a deliberately ridiculous explanation. Because the species frequents tall pines, Heartopia jokes that the marks came from repeated tumbles out of the trees."
  },
  {
    "id": "ruddy-shelduck",
    "slug": "ruddy-shelduck",
    "name": "Ruddy Shelduck",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/ruddy-shelduck.webp",
    "imageStatus": "verified",
    "sellPrice": 17,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "Peaceful waterbird stereotypes do not fit the Ruddy Shelduck here. Heartopia writes it as intensely competitive, to the point that getting along with others becomes difficult."
  },
  {
    "id": "seagull",
    "slug": "seagull",
    "name": "Seagull",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/seagull.webp",
    "imageStatus": "verified",
    "sellPrice": 17,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "The Seagull's lore focuses on opportunism rather than elegance. Heartopia imagines it arriving at the wharf with one practical goal in mind: finding a chance to snatch some fries."
  },
  {
    "id": "silver-throated-tit",
    "slug": "silver-throated-tit",
    "name": "Silver-Throated Tit",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/silver-throated-tit.webp",
    "imageStatus": "verified",
    "sellPrice": 10,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "Its delicate appearance earns Silver-Throated Tit the nickname “Snow Fairy,” but Heartopia immediately undercuts the softness by giving this tiny bird unexpectedly formidable offensive power."
  },
  {
    "id": "smew",
    "slug": "smew",
    "name": "Smew",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/smew.webp",
    "imageStatus": "verified",
    "sellPrice": 22,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "The Smew looks polished before it even takes off, thanks to a swept-back crest that resembles a carefully styled pompadour. The joke is that its launch into flight is far less graceful than the hairstyle suggests."
  },
  {
    "id": "stock-dove",
    "slug": "stock-dove",
    "name": "Stock Dove",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/stock-dove.webp",
    "imageStatus": "verified",
    "sellPrice": 10,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "The Stock Dove's neck flashes between green and violet iridescence, which Heartopia treats as intentional accessorizing. The layered shine gives an ordinary pigeon an unexpectedly dressed-up identity."
  },
  {
    "id": "tern",
    "slug": "tern",
    "name": "Tern",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/tern.webp",
    "imageStatus": "verified",
    "sellPrice": 35,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "A male Tern turns successful fishing into courtship. He first secures a fish, then presents the catch to a female as part of attracting a mate."
  },
  {
    "id": "verditer-flycatcher",
    "slug": "verditer-flycatcher",
    "name": "Verditer Flycatcher",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": null,
    "imageStatus": "missing",
    "sellPrice": 30,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "heartodex:birds/verditer-flycatcher"
    ],
    "notes": "Added 2026-08-14. No artwork in this repo or heartopia-hub yet.",
    "description": "Its entire body gleams in vibrant turquoise, with the eye mask serving as the perfect finishing touch."
  },
  {
    "id": "wallaces-fruit-dove",
    "slug": "wallaces-fruit-dove",
    "name": "Wallace's Fruit Dove",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/wallaces-fruit-dove.webp",
    "imageStatus": "verified",
    "sellPrice": 17,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "Golden-yellow feathers give Wallace's Fruit Dove a bright appearance, while its personality comes from high standards at mealtime. Heartopia depicts the bird as choosy, especially when judging whether fruit is good enough to eat."
  },
  {
    "id": "white-headed-duck",
    "slug": "white-headed-duck",
    "name": "White-Headed Duck",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/white-headed-duck.webp",
    "imageStatus": "verified",
    "sellPrice": 45,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "The White-Headed Duck is built around sharp visual contrast: a bright face stands against dark glossy wings, while the vivid bill inspires a joke that it was intentionally dipped into dye."
  },
  {
    "id": "white-wagtail",
    "slug": "white-wagtail",
    "name": "White Wagtail",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/white-wagtail.webp",
    "imageStatus": "verified",
    "sellPrice": 15,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "Even when standing still, the White Wagtail keeps its tail in motion. Heartopia connects that constant bobbing with the bird's name and the long-standing interpretation of its genus as referring to tail-wagging."
  },
  {
    "id": "winter-eurasian-wigeon",
    "slug": "winter-eurasian-wigeon",
    "name": "Winter Eurasian Wigeon",
    "kind": "bird",
    "eventKey": "winter-birdwatching-suburban-lake",
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/winter-eurasian-wigeon.webp",
    "imageStatus": "verified",
    "sellPrice": 1,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "This Eurasian Wigeon belongs to the Winter Frost Season's bird-shaped climate devices rather than being a standard recolor. Its brown cold-weather outfit identifies it as the event version."
  },
  {
    "id": "winter-greater-flamingo",
    "slug": "winter-greater-flamingo",
    "name": "Winter Greater Flamingo",
    "kind": "bird",
    "eventKey": "winter-birdwatching-suburban-lake",
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/winter-greater-flamingo.webp",
    "imageStatus": "verified",
    "sellPrice": 1,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "Winter Frost turns the Greater Flamingo into one of the season's bird-shaped temperature devices. Heartopia gets the joke from anatomy: a neck that long is portrayed as needing plenty of insulation."
  },
  {
    "id": "winter-mallard",
    "slug": "winter-mallard",
    "name": "Winter Mallard",
    "kind": "bird",
    "eventKey": "winter-birdwatching-suburban-lake",
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/winter-mallard.webp",
    "imageStatus": "verified",
    "sellPrice": 1,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "The Winter Mallard is dressed as one of the Frost Season's temperature-control birds. Its oversized-looking head becomes a data-storage joke, as if the bulk came from information packed inside rather than feathers."
  },
  {
    "id": "winter-mandarin-duck",
    "slug": "winter-mandarin-duck",
    "name": "Winter Mandarin Duck",
    "kind": "bird",
    "eventKey": "winter-birdwatching",
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/winter-mandarin-duck.webp",
    "imageStatus": "verified",
    "sellPrice": 1,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "Romance remains part of the Mandarin Duck motif even in winter, with the seasonal costume forming a heart. This version belonged specifically to Winter Birdwatching's additional event stage."
  },
  {
    "id": "winter-smew",
    "slug": "winter-smew",
    "name": "Winter Smew",
    "kind": "bird",
    "eventKey": "winter-birdwatching-suburban-lake",
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/winter-smew.webp",
    "imageStatus": "verified",
    "sellPrice": 1,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "Cold-weather gear changes the Smew's signature silhouette by covering its normally slick hairstyle. Heartopia turns the loss of that polished look into an intentionally awkward-cute joke for the Winter Frost variant."
  },
  {
    "id": "wonga-pigeon",
    "slug": "wonga-pigeon",
    "name": "Wonga Pigeon",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/wonga-pigeon.webp",
    "imageStatus": "verified",
    "sellPrice": 15,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "The Wonga Pigeon's pale crown is given a stressful backstory. Heartopia jokes that surviving in the wild was so demanding that the feathers on top of its head went white prematurely."
  },
  {
    "id": "woodchat-shrike",
    "slug": "woodchat-shrike",
    "name": "Woodchat Shrike",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/woodchat-shrike.webp",
    "imageStatus": "verified",
    "sellPrice": 10,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "Vanity drives the Woodchat Shrike's personality in Heartopia. Its rust-colored crown plumage is treated like a prized hairstyle, and the bird seems completely certain that it outshines every other shrike."
  },
  {
    "id": "yellow-bellied-flycatcher",
    "slug": "yellow-bellied-flycatcher",
    "name": "Yellow Bellied Flycatcher",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/yellow-bellied-flycatcher.webp",
    "imageStatus": "verified",
    "sellPrice": 15,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/birds.ts"
    ],
    "notes": null,
    "description": "The Yellow Bellied Flycatcher earns its living as an insect specialist. Heartopia lists a broad menu of small prey, including ants, wasps, flies and caterpillars, making hunting ability its defining trait."
  },
  {
    "id": "avocado",
    "slug": "avocado",
    "name": "Avocado",
    "kind": "crop",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/crop/avocado.webp",
    "imageStatus": "verified",
    "sellPrice": 549,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/crops.ts"
    ],
    "notes": null,
    "description": "Avocado has a concrete culinary niche in Heartopia beyond ordinary crop use: it is paired with crayfish in the Crayfish Avocado Cup, giving the fruit a specific role in a later-game recipe."
  },
  {
    "id": "cacao",
    "slug": "cacao",
    "name": "Cacao",
    "kind": "crop",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/crop/cacao.webp",
    "imageStatus": "verified",
    "sellPrice": 330,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/crops.ts"
    ],
    "notes": null,
    "description": "Cacao comes from the seeds inside pods of the tropical Theobroma cacao tree. Those beans are the raw material processed into cocoa products and, ultimately, chocolate."
  },
  {
    "id": "carrot",
    "slug": "carrot",
    "name": "Carrot",
    "kind": "crop",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/crop/carrot.webp",
    "imageStatus": "verified",
    "sellPrice": 155,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/crops.ts"
    ],
    "notes": null,
    "description": "Heartopia reframes Carrot from childhood punishment into something worth eating. The joke acknowledges its reputation with picky kids, then emphasizes that the root is much more nutritious than its haters might admit."
  },
  {
    "id": "corn",
    "slug": "corn",
    "name": "Corn",
    "kind": "crop",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/crop/corn.webp",
    "imageStatus": "verified",
    "sellPrice": 510,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/crops.ts"
    ],
    "notes": null,
    "description": "Reliability is Corn's strongest farming trait in Heartopia. It is presented as straightforward to raise and capable of producing generously, making dependable harvests the crop's main practical appeal."
  },
  {
    "id": "eggplant",
    "slug": "eggplant",
    "name": "Eggplant",
    "kind": "crop",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/crop/eggplant.webp",
    "imageStatus": "verified",
    "sellPrice": 406,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/crops.ts"
    ],
    "notes": null,
    "description": "Eggplant earns its reputation in the kitchen by taking on whatever surrounds it. Heartopia highlights the vegetable's ability to soak up other flavors during cooking rather than focusing on appearance."
  },
  {
    "id": "grape",
    "slug": "grape",
    "name": "Grape",
    "kind": "crop",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/crop/grape.webp",
    "imageStatus": "verified",
    "sellPrice": 480,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/crops.ts"
    ],
    "notes": null,
    "description": "Grapes are small berries that grow together in clusters on vines. Depending on variety, they can be eaten fresh or processed into products such as juice, raisins and preserves."
  },
  {
    "id": "lettuce",
    "slug": "lettuce",
    "name": "Lettuce",
    "kind": "crop",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/crop/lettuce.webp",
    "imageStatus": "verified",
    "sellPrice": 435,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/crops.ts"
    ],
    "notes": null,
    "description": "Lettuce is a leafy vegetable cultivated for its tender leaves, most commonly eaten fresh. Its mild flavor makes it a basic ingredient rather than a strongly flavored crop."
  },
  {
    "id": "paddy",
    "slug": "paddy",
    "name": "Paddy",
    "kind": "crop",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": null,
    "imageStatus": "missing",
    "sellPrice": 37,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "heartodex:crops/paddy"
    ],
    "notes": "Added 2026-08-14. No artwork in this repo or heartopia-hub yet. The crop page shows no hobby level, unlike every other crop, so requiredLevel is left null rather than guessed.",
    "description": null
  },
  {
    "id": "pineapple",
    "slug": "pineapple",
    "name": "Pineapple",
    "kind": "crop",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/crop/pineapple.webp",
    "imageStatus": "verified",
    "sellPrice": 52,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/crops.ts"
    ],
    "notes": null,
    "description": "Heartopia is enthusiastic about Pineapple when it is eaten fresh or used in sweets, but the flavor text takes a hard turn on one debate: pizza is where the game's approval stops."
  },
  {
    "id": "potatoes",
    "slug": "potatoes",
    "name": "Potatoes",
    "kind": "crop",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/crop/potatoes.webp",
    "imageStatus": "verified",
    "sellPrice": 90,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/crops.ts"
    ],
    "notes": null,
    "description": "Potatoes are starchy underground tubers rather than roots. Their neutral flavor and dense texture make them versatile enough for boiling, baking, frying and many other preparations."
  },
  {
    "id": "romaine-lettuce",
    "slug": "romaine-lettuce",
    "name": "Romaine Lettuce",
    "kind": "crop",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/crop/romaine-lettuce.webp",
    "imageStatus": "verified",
    "sellPrice": 30,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/crops.ts"
    ],
    "notes": null,
    "description": "Romaine Lettuce came to Heartopia through Dreamlight Cinematics rather than the game's year-round crop selection. Since that event has ended, the vegetable now carries a useful piece of seasonal history."
  },
  {
    "id": "strawberry",
    "slug": "strawberry",
    "name": "Strawberry",
    "kind": "crop",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/crop/strawberry.webp",
    "imageStatus": "verified",
    "sellPrice": 375,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/crops.ts"
    ],
    "notes": null,
    "description": "Strawberry receives royal treatment in Heartopia's flavor text. Its sweet, springlike character is enough for the crop to be crowned with the in-game nickname “Queen of Fruits.”"
  },
  {
    "id": "tea",
    "slug": "tea",
    "name": "Tea",
    "kind": "crop",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/crop/tea.webp",
    "imageStatus": "verified",
    "sellPrice": 75,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/crops.ts"
    ],
    "notes": null,
    "description": "Tea Leaf functions mainly as a beverage crop in Heartopia. Documented drinks include Green Tea and Green Milk Tea, along with floral preparations such as Rose Tea and Daisy Tea."
  },
  {
    "id": "tomato",
    "slug": "tomato",
    "name": "Tomato",
    "kind": "crop",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/crop/tomato.webp",
    "imageStatus": "verified",
    "sellPrice": 30,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/crops.ts"
    ],
    "notes": null,
    "description": "Tomato is botanically a fleshy fruit, although it is usually treated as a vegetable in cooking. Its juicy, mildly acidic flesh works in both fresh dishes and cooked sauces."
  },
  {
    "id": "wheat",
    "slug": "wheat",
    "name": "Wheat",
    "kind": "crop",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/crop/wheat.webp",
    "imageStatus": "verified",
    "sellPrice": 285,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/crops.ts"
    ],
    "notes": null,
    "description": "Wheat is a cereal grain whose harvested kernels can be milled into flour. That makes it a foundational crop for breads, cakes, pasta and many other grain-based foods."
  },
  {
    "id": "white-radish",
    "slug": "white-radish",
    "name": "White Radish",
    "kind": "crop",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/crop/white-radish.webp",
    "imageStatus": "verified",
    "sellPrice": 30,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/crops.ts"
    ],
    "notes": null,
    "description": "White Radish is tied to the completed Winter Frost Season, giving the crop event history beyond ordinary farming. Heartopia also gives the nutritious root the folk-style nickname “commoner's ginseng.”"
  },
  {
    "id": "anthurium",
    "slug": "anthurium",
    "name": "Anthurium",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": null,
    "imageStatus": "missing",
    "sellPrice": 185,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/flowers.ts"
    ],
    "notes": null,
    "description": "Anthurium belongs to Heartopia's flower-breeding system rather than functioning as one fixed decorative color. Crosses stay within the Anthurium family, star ratings must be compatible, watering can improve the odds, and five-star blooms no longer yield breeding seed."
  },
  {
    "id": "calla-lily",
    "slug": "calla-lily",
    "name": "Calla Lily",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/white-calla-lily.webp",
    "imageStatus": "verified",
    "sellPrice": 250,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/flowers.ts"
    ],
    "notes": null,
    "description": "Calla Lily can produce new variants through Heartopia's crossbreeding mechanic. The important constraints are family and star compatibility—not parent color—and watering helps the attempt, while a five-star Calla Lily has reached the end of the breeding chain.",
    "isVariantGroup": true
  },
  {
    "id": "black-calla-lily",
    "slug": "black-calla-lily",
    "name": "Black Calla Lily",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/black-calla-lily.webp",
    "imageStatus": "verified",
    "sellPrice": 250,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/black-calla-lily.webp",
      "variant-of:calla-lily"
    ],
    "notes": null,
    "description": "Black Calla Lily stays inside the Calla Lily breeding family. Its visible color is not used to calculate a cross; Heartopia instead checks the flower species and the parents' star compatibility, with five-star plants unable to generate another breeding seed.",
    "flowerSpecies": "calla-lily",
    "flowerColor": "black",
    "variantOf": "calla-lily"
  },
  {
    "id": "orange-calla-lily",
    "slug": "orange-calla-lily",
    "name": "Orange Calla Lily",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/orange-calla-lily.webp",
    "imageStatus": "verified",
    "sellPrice": 250,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/orange-calla-lily.webp",
      "variant-of:calla-lily"
    ],
    "notes": null,
    "description": "The Orange Calla Lily color does not act like a genetic recipe in Heartopia. Breeding it still follows the Calla Lily rules: use another Calla Lily at a compatible star rating, and remember that the five-star stage is the endpoint for seed production.",
    "flowerSpecies": "calla-lily",
    "flowerColor": "orange",
    "variantOf": "calla-lily"
  },
  {
    "id": "peach-calla-lily",
    "slug": "peach-calla-lily",
    "name": "Peach Calla Lily",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/peach-calla-lily.webp",
    "imageStatus": "verified",
    "sellPrice": 250,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/peach-calla-lily.webp",
      "variant-of:calla-lily"
    ],
    "notes": null,
    "description": "Within the catalog, Peach Calla Lily appears as one color form of Calla Lily, but breeding does not ask for that color specifically. What matters is pairing flowers from the same family with suitable star levels; once a specimen reaches five stars, it can no longer continue the line by seed.",
    "flowerSpecies": "calla-lily",
    "flowerColor": "peach",
    "variantOf": "calla-lily"
  },
  {
    "id": "pink-calla-lily",
    "slug": "pink-calla-lily",
    "name": "Pink Calla Lily",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/pink-calla-lily.webp",
    "imageStatus": "verified",
    "sellPrice": 250,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/pink-calla-lily.webp",
      "variant-of:calla-lily"
    ],
    "notes": null,
    "description": "Treat Pink Calla Lily as part of the broader Calla Lily progression rather than a separate breeding species. Parent colors are ignored by the crossing rule, while species and nearby star ratings determine compatibility; five-star blooms are terminal for breeding.",
    "flowerSpecies": "calla-lily",
    "flowerColor": "pink",
    "variantOf": "calla-lily"
  },
  {
    "id": "purple-calla-lily",
    "slug": "purple-calla-lily",
    "name": "Purple Calla Lily",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/purple-calla-lily.webp",
    "imageStatus": "verified",
    "sellPrice": 250,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/purple-calla-lily.webp",
      "variant-of:calla-lily"
    ],
    "notes": null,
    "description": "Breeding a Purple Calla Lily does not require reproducing its visible color combination. Heartopia keeps the flower within the Calla Lily family and bases compatibility on star level, while flowers at the five-star cap stop yielding new breeding seeds.",
    "flowerSpecies": "calla-lily",
    "flowerColor": "purple",
    "variantOf": "calla-lily"
  },
  {
    "id": "red-calla-lily",
    "slug": "red-calla-lily",
    "name": "Red Calla Lily",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/red-calla-lily.webp",
    "imageStatus": "verified",
    "sellPrice": 250,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/red-calla-lily.webp",
      "variant-of:calla-lily"
    ],
    "notes": null,
    "description": "Red Calla Lily shares its breeding mechanics with every other Calla Lily variant. The game does not use color as an input for the cross; compatible star-rated Calla Lily parents are what matter, and reaching five stars ends further seed generation.",
    "flowerSpecies": "calla-lily",
    "flowerColor": "red",
    "variantOf": "calla-lily"
  },
  {
    "id": "sunglow-calla-lily",
    "slug": "sunglow-calla-lily",
    "name": "Sunglow Calla Lily",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/sunglow-calla-lily.webp",
    "imageStatus": "verified",
    "sellPrice": 250,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/sunglow-calla-lily.webp",
      "variant-of:calla-lily"
    ],
    "notes": null,
    "description": "For Sunglow Calla Lily, the visible hue is cosmetic to the breeding calculation. It still belongs to the Calla Lily line, so pairing depends on compatible star levels within that family; a five-star bloom cannot supply another breeding seed.",
    "flowerSpecies": "calla-lily",
    "flowerColor": "sunglow",
    "variantOf": "calla-lily"
  },
  {
    "id": "sunglow-highland-poppy",
    "slug": "sunglow-highland-poppy",
    "name": "Sunglow Highland Poppy",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/sunglow-highland-poppy.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/sunglow-highland-poppy.webp",
      "variant-of:highland-poppy",
      "renamed-from-asset:sunglow-poppy.webp (species identified from the artwork, not the filename)"
    ],
    "notes": null,
    "description": "Sunglow Highland Poppy belongs to the same breeding pool as the other Highland Poppy colors. Heartopia evaluates family and star-rating compatibility instead of matching hues, and the progression stops reproductively once a bloom reaches five stars.",
    "flowerSpecies": "highland-poppy",
    "flowerColor": "sunglow",
    "variantOf": "highland-poppy"
  },
  {
    "id": "white-calla-lily",
    "slug": "white-calla-lily",
    "name": "White Calla Lily",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/white-calla-lily.webp",
    "imageStatus": "verified",
    "sellPrice": 250,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/white-calla-lily.webp",
      "variant-of:calla-lily"
    ],
    "notes": null,
    "description": "Changing to White Calla Lily does not create a new breeding rule for Calla Lily. Crosses still depend on using the same flower family at compatible star levels, not on color formulas; five-star examples are finished branches that do not make further seeds.",
    "flowerSpecies": "calla-lily",
    "flowerColor": "white",
    "variantOf": "calla-lily"
  },
  {
    "id": "yellow-calla-lily",
    "slug": "yellow-calla-lily",
    "name": "Yellow Calla Lily",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/yellow-calla-lily.webp",
    "imageStatus": "verified",
    "sellPrice": 250,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/yellow-calla-lily.webp",
      "variant-of:calla-lily"
    ],
    "notes": null,
    "description": "For crossbreeding, Yellow Calla Lily should be treated simply as a Calla Lily variant. Its color does not control the result: family membership and suitable parent star levels do, and flowers at the five-star tier no longer supply seed for another generation.",
    "flowerSpecies": "calla-lily",
    "flowerColor": "yellow",
    "variantOf": "calla-lily"
  },
  {
    "id": "carnation",
    "slug": "carnation",
    "name": "Carnation",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/white-carnation.webp",
    "imageStatus": "verified",
    "sellPrice": 305,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/flowers.ts"
    ],
    "notes": null,
    "description": "Carnation has its own closed breeding line in Heartopia: it crosses with other Carnations whose star ratings are equal or close enough. Extra watering improves success, but once a flower reaches five stars it cannot continue the line with another seed.",
    "isVariantGroup": true
  },
  {
    "id": "black-carnation",
    "slug": "black-carnation",
    "name": "Black Carnation",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/black-carnation.webp",
    "imageStatus": "verified",
    "sellPrice": 305,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/black-carnation.webp",
      "variant-of:carnation"
    ],
    "notes": null,
    "description": "Black Carnation stays inside the Carnation breeding family. Its visible color is not used to calculate a cross; Heartopia instead checks the flower species and the parents' star compatibility, with five-star plants unable to generate another breeding seed.",
    "flowerSpecies": "carnation",
    "flowerColor": "black",
    "variantOf": "carnation"
  },
  {
    "id": "green-carnation",
    "slug": "green-carnation",
    "name": "Green Carnation",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/green-carnation.webp",
    "imageStatus": "verified",
    "sellPrice": 305,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/green-carnation.webp",
      "variant-of:carnation"
    ],
    "notes": null,
    "description": "The Green Carnation color does not act like a genetic recipe in Heartopia. Breeding it still follows the Carnation rules: use another Carnation at a compatible star rating, and remember that the five-star stage is the endpoint for seed production.",
    "flowerSpecies": "carnation",
    "flowerColor": "green",
    "variantOf": "carnation"
  },
  {
    "id": "orange-carnation",
    "slug": "orange-carnation",
    "name": "Orange Carnation",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/orange-carnation.webp",
    "imageStatus": "verified",
    "sellPrice": 305,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/orange-carnation.webp",
      "variant-of:carnation"
    ],
    "notes": null,
    "description": "Orange Carnation remains part of the ordinary Carnation breeding line despite its color. Crosses are decided by flower family and suitable star levels rather than hue, and a five-star specimen cannot produce another breeding seed.",
    "flowerSpecies": "carnation",
    "flowerColor": "orange",
    "variantOf": "carnation"
  },
  {
    "id": "peach-carnation",
    "slug": "peach-carnation",
    "name": "Peach Carnation",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/peach-carnation.webp",
    "imageStatus": "verified",
    "sellPrice": 305,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/peach-carnation.webp",
      "variant-of:carnation"
    ],
    "notes": null,
    "description": "Treat Peach Carnation as part of the broader Carnation progression rather than a separate breeding species. Parent colors are ignored by the crossing rule, while species and nearby star ratings determine compatibility; five-star blooms are terminal for breeding.",
    "flowerSpecies": "carnation",
    "flowerColor": "peach",
    "variantOf": "carnation"
  },
  {
    "id": "pink-carnation",
    "slug": "pink-carnation",
    "name": "Pink Carnation",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/pink-carnation.webp",
    "imageStatus": "verified",
    "sellPrice": 305,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/pink-carnation.webp",
      "variant-of:carnation"
    ],
    "notes": null,
    "description": "Breeding a Pink Carnation does not require reproducing its visible color combination. Heartopia keeps the flower within the Carnation family and bases compatibility on star level, while flowers at the five-star cap stop yielding new breeding seeds.",
    "flowerSpecies": "carnation",
    "flowerColor": "pink",
    "variantOf": "carnation"
  },
  {
    "id": "red-carnation",
    "slug": "red-carnation",
    "name": "Red Carnation",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/red-carnation.webp",
    "imageStatus": "verified",
    "sellPrice": 305,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/red-carnation.webp",
      "variant-of:carnation"
    ],
    "notes": null,
    "description": "Red Carnation shares its breeding mechanics with every other Carnation variant. The game does not use color as an input for the cross; compatible star-rated Carnation parents are what matter, and reaching five stars ends further seed generation.",
    "flowerSpecies": "carnation",
    "flowerColor": "red",
    "variantOf": "carnation"
  },
  {
    "id": "selene-carnation",
    "slug": "selene-carnation",
    "name": "Selene Carnation",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/selene-carnation.webp",
    "imageStatus": "verified",
    "sellPrice": 305,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/selene-carnation.webp",
      "variant-of:carnation"
    ],
    "notes": null,
    "description": "The useful breeding fact for Selene Carnation is that color is cosmetic to the crossing calculation. It remains a Carnation, so only another compatible Carnation can be paired with it, and a flower that has reached five stars cannot produce the next seed.",
    "flowerSpecies": "carnation",
    "flowerColor": "selene",
    "variantOf": "carnation"
  },
  {
    "id": "white-carnation",
    "slug": "white-carnation",
    "name": "White Carnation",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/white-carnation.webp",
    "imageStatus": "verified",
    "sellPrice": 305,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/white-carnation.webp",
      "variant-of:carnation"
    ],
    "notes": null,
    "description": "White Carnation belongs to the same breeding pool as the other Carnation colors. Heartopia evaluates family and star-rating compatibility instead of matching hues, and the progression stops reproductively once a bloom reaches five stars.",
    "flowerSpecies": "carnation",
    "flowerColor": "white",
    "variantOf": "carnation"
  },
  {
    "id": "yellow-carnation",
    "slug": "yellow-carnation",
    "name": "Yellow Carnation",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/yellow-carnation.webp",
    "imageStatus": "verified",
    "sellPrice": 305,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/yellow-carnation.webp",
      "variant-of:carnation"
    ],
    "notes": null,
    "description": "Changing to Yellow Carnation does not create a new breeding rule for Carnation. Crosses still depend on using the same flower family at compatible star levels, not on color formulas; five-star examples are finished branches that do not make further seeds.",
    "flowerSpecies": "carnation",
    "flowerColor": "yellow",
    "variantOf": "carnation"
  },
  {
    "id": "corn-poppy",
    "slug": "corn-poppy",
    "name": "Corn Poppy",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/white-poppy.webp",
    "imageStatus": "verified",
    "sellPrice": 185,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/flowers.ts"
    ],
    "notes": null,
    "description": "Corn Poppy participates in the same star-based breeding progression as other Heartopia flowers. Parents must remain within the Corn Poppy species and use compatible ratings; color itself does not determine the result, and five-star specimens are breeding endpoints.",
    "isVariantGroup": true
  },
  {
    "id": "red-corn-poppy",
    "slug": "red-corn-poppy",
    "name": "Red Corn Poppy",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/red-poppy.webp",
    "imageStatus": "verified",
    "sellPrice": 185,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/red-poppy.webp",
      "variant-of:corn-poppy"
    ],
    "notes": null,
    "description": "For crossbreeding, Red Corn Poppy should be treated simply as a Corn Poppy variant. Its color does not control the result: family membership and suitable parent star levels do, and flowers at the five-star tier no longer supply seed for another generation.",
    "flowerSpecies": "corn-poppy",
    "flowerColor": "red",
    "variantOf": "corn-poppy"
  },
  {
    "id": "white-corn-poppy",
    "slug": "white-corn-poppy",
    "name": "White Corn Poppy",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/white-poppy.webp",
    "imageStatus": "verified",
    "sellPrice": 185,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/white-poppy.webp",
      "variant-of:corn-poppy"
    ],
    "notes": null,
    "description": "White Corn Poppy stays inside the Corn Poppy breeding family. Its visible color is not used to calculate a cross; Heartopia instead checks the flower species and the parents' star compatibility, with five-star plants unable to generate another breeding seed.",
    "flowerSpecies": "corn-poppy",
    "flowerColor": "white",
    "variantOf": "corn-poppy"
  },
  {
    "id": "yellow-corn-poppy",
    "slug": "yellow-corn-poppy",
    "name": "Yellow Corn Poppy",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/yellow-poppy.webp",
    "imageStatus": "verified",
    "sellPrice": 185,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/yellow-poppy.webp",
      "variant-of:corn-poppy"
    ],
    "notes": null,
    "description": "The Yellow Corn Poppy color does not act like a genetic recipe in Heartopia. Breeding it still follows the Corn Poppy rules: use another Corn Poppy at a compatible star rating, and remember that the five-star stage is the endpoint for seed production.",
    "flowerSpecies": "corn-poppy",
    "flowerColor": "yellow",
    "variantOf": "corn-poppy"
  },
  {
    "id": "black-corn-poppy",
    "slug": "black-corn-poppy",
    "name": "Black Corn Poppy",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/black-corn-poppy.webp",
    "imageStatus": "verified",
    "sellPrice": 185,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/black-corn-poppy.webp",
      "variant-of:corn-poppy"
    ],
    "notes": null,
    "description": "Within the catalog, Black Corn Poppy appears as one color form of Corn Poppy, but breeding does not ask for that color specifically. What matters is pairing flowers from the same family with suitable star levels; once a specimen reaches five stars, it can no longer continue the line by seed.",
    "flowerSpecies": "corn-poppy",
    "flowerColor": "black",
    "variantOf": "corn-poppy"
  },
  {
    "id": "orange-corn-poppy",
    "slug": "orange-corn-poppy",
    "name": "Orange Corn Poppy",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/orange-corn-poppy.webp",
    "imageStatus": "verified",
    "sellPrice": 185,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/orange-corn-poppy.webp",
      "variant-of:corn-poppy"
    ],
    "notes": null,
    "description": "Treat Orange Corn Poppy as part of the broader Corn Poppy progression rather than a separate breeding species. Parent colors are ignored by the crossing rule, while species and nearby star ratings determine compatibility; five-star blooms are terminal for breeding.",
    "flowerSpecies": "corn-poppy",
    "flowerColor": "orange",
    "variantOf": "corn-poppy"
  },
  {
    "id": "pink-corn-poppy",
    "slug": "pink-corn-poppy",
    "name": "Pink Corn Poppy",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/pink-corn-poppy.webp",
    "imageStatus": "verified",
    "sellPrice": 185,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/pink-corn-poppy.webp",
      "variant-of:corn-poppy"
    ],
    "notes": null,
    "description": "Breeding a Pink Corn Poppy does not require reproducing its visible color combination. Heartopia keeps the flower within the Corn Poppy family and bases compatibility on star level, while flowers at the five-star cap stop yielding new breeding seeds.",
    "flowerSpecies": "corn-poppy",
    "flowerColor": "pink",
    "variantOf": "corn-poppy"
  },
  {
    "id": "purple-corn-poppy",
    "slug": "purple-corn-poppy",
    "name": "Purple Corn Poppy",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/purple-corn-poppy.webp",
    "imageStatus": "verified",
    "sellPrice": 185,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/purple-corn-poppy.webp",
      "variant-of:corn-poppy"
    ],
    "notes": null,
    "description": "Purple Corn Poppy shares its breeding mechanics with every other Corn Poppy variant. The game does not use color as an input for the cross; compatible star-rated Corn Poppy parents are what matter, and reaching five stars ends further seed generation.",
    "flowerSpecies": "corn-poppy",
    "flowerColor": "purple",
    "variantOf": "corn-poppy"
  },
  {
    "id": "cranesbill",
    "slug": "cranesbill",
    "name": "Cranesbill",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/black-cranesbill.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/flowers.ts"
    ],
    "notes": null,
    "description": "Cranesbill is one of Heartopia's crossbreedable flower families. Breeding is governed by species and compatible star ratings rather than color matching, with watering helping the attempt and five-star blooms unable to produce further seed.",
    "isVariantGroup": true
  },
  {
    "id": "daisy",
    "slug": "daisy",
    "name": "Daisy",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/white-daisy.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/flowers.ts"
    ],
    "notes": null,
    "description": "Daisy variants come from Heartopia's flower-crossing system. Two Daisy parents need compatible star levels, watering can raise the chance of success, and the color shown on either parent is not what the breeding calculation uses.",
    "isVariantGroup": true
  },
  {
    "id": "green-daisy",
    "slug": "green-daisy",
    "name": "Green Daisy",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/green-daisy.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/green-daisy.webp",
      "variant-of:daisy"
    ],
    "notes": null,
    "description": "Green Daisy belongs to the same breeding pool as the other Daisy colors. Heartopia evaluates family and star-rating compatibility instead of matching hues, and the progression stops reproductively once a bloom reaches five stars.",
    "flowerSpecies": "daisy",
    "flowerColor": "green",
    "variantOf": "daisy"
  },
  {
    "id": "pink-daisy",
    "slug": "pink-daisy",
    "name": "Pink Daisy",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/pink-daisy.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/pink-daisy.webp",
      "variant-of:daisy"
    ],
    "notes": null,
    "description": "Pink Daisy does not need a matching parent color to reproduce. Heartopia treats it as part of the Daisy family, where suitable star levels determine compatibility and the five-star stage ends further seed production.",
    "flowerSpecies": "daisy",
    "flowerColor": "pink",
    "variantOf": "daisy"
  },
  {
    "id": "red-daisy",
    "slug": "red-daisy",
    "name": "Red Daisy",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/red-daisy.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/red-daisy.webp",
      "variant-of:daisy"
    ],
    "notes": null,
    "description": "For crossbreeding, Red Daisy should be treated simply as a Daisy variant. Its color does not control the result: family membership and suitable parent star levels do, and flowers at the five-star tier no longer supply seed for another generation.",
    "flowerSpecies": "daisy",
    "flowerColor": "red",
    "variantOf": "daisy"
  },
  {
    "id": "selene-daisy",
    "slug": "selene-daisy",
    "name": "Selene Daisy",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/selene-daisy.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/selene-daisy.webp",
      "variant-of:daisy"
    ],
    "notes": null,
    "description": "Selene Daisy stays inside the Daisy breeding family. Its visible color is not used to calculate a cross; Heartopia instead checks the flower species and the parents' star compatibility, with five-star plants unable to generate another breeding seed.",
    "flowerSpecies": "daisy",
    "flowerColor": "selene",
    "variantOf": "daisy"
  },
  {
    "id": "white-daisy",
    "slug": "white-daisy",
    "name": "White Daisy",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/white-daisy.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/white-daisy.webp",
      "variant-of:daisy"
    ],
    "notes": null,
    "description": "The White Daisy color does not act like a genetic recipe in Heartopia. Breeding it still follows the Daisy rules: use another Daisy at a compatible star rating, and remember that the five-star stage is the endpoint for seed production.",
    "flowerSpecies": "daisy",
    "flowerColor": "white",
    "variantOf": "daisy"
  },
  {
    "id": "dandelion",
    "slug": "dandelion",
    "name": "Dandelion",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/black-dandelion.webp",
    "imageStatus": "verified",
    "sellPrice": 1,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/flowers.ts"
    ],
    "notes": null,
    "description": "Dandelion arrived as a seasonal flower for Dreamlight Cinematics and still follows Heartopia's normal breeding logic. Crosses depend on staying within the species and pairing compatible star ratings instead of mixing specific colors.",
    "isVariantGroup": true
  },
  {
    "id": "highland-poppy",
    "slug": "highland-poppy",
    "name": "Highland Poppy",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/white-highland-poppy.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/flowers.ts"
    ],
    "notes": null,
    "description": "Highland Poppy forms a complete breeding family in Heartopia. Progress comes from compatible star-rated parents within that species, not from a recipe of parent colors; watering helps, and five-star flowers cannot extend the chain.",
    "isVariantGroup": true
  },
  {
    "id": "black-highland-poppy",
    "slug": "black-highland-poppy",
    "name": "Black Highland Poppy",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/black-highland-poppy.webp",
    "imageStatus": "verified",
    "sellPrice": 250,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/black-highland-poppy.webp",
      "variant-of:highland-poppy"
    ],
    "notes": null,
    "description": "Treat Black Highland Poppy as part of the broader Highland Poppy progression rather than a separate breeding species. Parent colors are ignored by the crossing rule, while species and nearby star ratings determine compatibility; five-star blooms are terminal for breeding.",
    "flowerSpecies": "highland-poppy",
    "flowerColor": "black",
    "variantOf": "highland-poppy"
  },
  {
    "id": "blue-highland-poppy",
    "slug": "blue-highland-poppy",
    "name": "Blue Highland Poppy",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/blue-highland-poppy.webp",
    "imageStatus": "verified",
    "sellPrice": 315,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/blue-highland-poppy.webp",
      "variant-of:highland-poppy"
    ],
    "notes": null,
    "description": "Within the catalog, Blue Highland Poppy appears as one color form of Highland Poppy, but breeding does not ask for that color specifically. What matters is pairing flowers from the same family with suitable star levels; once a specimen reaches five stars, it can no longer continue the line by seed.",
    "flowerSpecies": "highland-poppy",
    "flowerColor": "blue",
    "variantOf": "highland-poppy"
  },
  {
    "id": "green-highland-poppy",
    "slug": "green-highland-poppy",
    "name": "Green Highland Poppy",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/green-highland-poppy.webp",
    "imageStatus": "verified",
    "sellPrice": 315,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/green-highland-poppy.webp",
      "variant-of:highland-poppy"
    ],
    "notes": null,
    "description": "Breeding a Green Highland Poppy does not require reproducing its visible color combination. Heartopia keeps the flower within the Highland Poppy family and bases compatibility on star level, while flowers at the five-star cap stop yielding new breeding seeds.",
    "flowerSpecies": "highland-poppy",
    "flowerColor": "green",
    "variantOf": "highland-poppy"
  },
  {
    "id": "orange-highland-poppy",
    "slug": "orange-highland-poppy",
    "name": "Orange Highland Poppy",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/orange-highland-poppy.webp",
    "imageStatus": "verified",
    "sellPrice": 190,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/orange-highland-poppy.webp",
      "variant-of:highland-poppy"
    ],
    "notes": null,
    "description": "Orange Highland Poppy shares its breeding mechanics with every other Highland Poppy variant. The game does not use color as an input for the cross; compatible star-rated Highland Poppy parents are what matter, and reaching five stars ends further seed generation.",
    "flowerSpecies": "highland-poppy",
    "flowerColor": "orange",
    "variantOf": "highland-poppy"
  },
  {
    "id": "peach-highland-poppy",
    "slug": "peach-highland-poppy",
    "name": "Peach Highland Poppy",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/peach-highland-poppy.webp",
    "imageStatus": "verified",
    "sellPrice": 250,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/peach-highland-poppy.webp",
      "variant-of:highland-poppy"
    ],
    "notes": null,
    "description": "The useful breeding fact for Peach Highland Poppy is that color is cosmetic to the crossing calculation. It remains a Highland Poppy, so only another compatible Highland Poppy can be paired with it, and a flower that has reached five stars cannot produce the next seed.",
    "flowerSpecies": "highland-poppy",
    "flowerColor": "peach",
    "variantOf": "highland-poppy"
  },
  {
    "id": "pink-highland-poppy",
    "slug": "pink-highland-poppy",
    "name": "Pink Highland Poppy",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/pink-highland-poppy.webp",
    "imageStatus": "verified",
    "sellPrice": 190,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/pink-highland-poppy.webp",
      "variant-of:highland-poppy"
    ],
    "notes": null,
    "description": "Pink Highland Poppy does not need a matching parent color to reproduce. Heartopia treats it as part of the Highland Poppy family, where suitable star levels determine compatibility and the five-star stage ends further seed production.",
    "flowerSpecies": "highland-poppy",
    "flowerColor": "pink",
    "variantOf": "highland-poppy"
  },
  {
    "id": "red-highland-poppy",
    "slug": "red-highland-poppy",
    "name": "Red Highland Poppy",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/red-highland-poppy.webp",
    "imageStatus": "verified",
    "sellPrice": 125,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/red-highland-poppy.webp",
      "variant-of:highland-poppy"
    ],
    "notes": null,
    "description": "Changing to Red Highland Poppy does not create a new breeding rule for Highland Poppy. Crosses still depend on using the same flower family at compatible star levels, not on color formulas; five-star examples are finished branches that do not make further seeds.",
    "flowerSpecies": "highland-poppy",
    "flowerColor": "red",
    "variantOf": "highland-poppy"
  },
  {
    "id": "selene-highland-poppy",
    "slug": "selene-highland-poppy",
    "name": "Selene Highland Poppy",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/selene-highland-poppy.webp",
    "imageStatus": "verified",
    "sellPrice": 500,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/selene-highland-poppy.webp",
      "variant-of:highland-poppy"
    ],
    "notes": null,
    "description": "For crossbreeding, Selene Highland Poppy should be treated simply as a Highland Poppy variant. Its color does not control the result: family membership and suitable parent star levels do, and flowers at the five-star tier no longer supply seed for another generation.",
    "flowerSpecies": "highland-poppy",
    "flowerColor": "selene",
    "variantOf": "highland-poppy"
  },
  {
    "id": "white-highland-poppy",
    "slug": "white-highland-poppy",
    "name": "White Highland Poppy",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/white-highland-poppy.webp",
    "imageStatus": "verified",
    "sellPrice": 125,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/white-highland-poppy.webp",
      "variant-of:highland-poppy"
    ],
    "notes": null,
    "description": "White Highland Poppy stays inside the Highland Poppy breeding family. Its visible color is not used to calculate a cross; Heartopia instead checks the flower species and the parents' star compatibility, with five-star plants unable to generate another breeding seed.",
    "flowerSpecies": "highland-poppy",
    "flowerColor": "white",
    "variantOf": "highland-poppy"
  },
  {
    "id": "yellow-highland-poppy",
    "slug": "yellow-highland-poppy",
    "name": "Yellow Highland Poppy",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/yellow-highland-poppy.webp",
    "imageStatus": "verified",
    "sellPrice": 125,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/yellow-highland-poppy.webp",
      "variant-of:highland-poppy"
    ],
    "notes": null,
    "description": "The Yellow Highland Poppy color does not act like a genetic recipe in Heartopia. Breeding it still follows the Highland Poppy rules: use another Highland Poppy at a compatible star rating, and remember that the five-star stage is the endpoint for seed production.",
    "flowerSpecies": "highland-poppy",
    "flowerColor": "yellow",
    "variantOf": "highland-poppy"
  },
  {
    "id": "hyacinth",
    "slug": "hyacinth",
    "name": "Hyacinth",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/black-hyacinth.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/flowers.ts"
    ],
    "notes": null,
    "description": "Hyacinth is part of Heartopia's crossbreeding system, where progress is based on pairing Hyacinths with suitable star ratings. Color does not act as the breeding input, watering improves the odds, and a five-star bloom cannot create another seed.",
    "isVariantGroup": true
  },
  {
    "id": "laceleaf",
    "slug": "laceleaf",
    "name": "Laceleaf",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/white-lanceleaf.webp",
    "imageStatus": "verified",
    "sellPrice": 185,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/flowers.ts"
    ],
    "notes": null,
    "description": "To crossbreed Laceleaf, keep both parents inside the Laceleaf family. Heartopia checks whether their star ratings are close enough rather than matching flower colors; watering can improve the attempt, and a five-star bloom cannot create another breeding seed.",
    "isVariantGroup": true
  },
  {
    "id": "green-laceleaf",
    "slug": "green-laceleaf",
    "name": "Green Laceleaf",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/green-lanceleaf.webp",
    "imageStatus": "verified",
    "sellPrice": 185,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/green-lanceleaf.webp",
      "variant-of:laceleaf"
    ],
    "notes": null,
    "description": "The Green Laceleaf color is cosmetic to Heartopia's crossing rules. What matters is that both parents are Laceleaf flowers with star ratings close enough to pair; once a bloom reaches five stars, seed production for further crosses ends.",
    "flowerSpecies": "laceleaf",
    "flowerColor": "green",
    "variantOf": "laceleaf"
  },
  {
    "id": "orange-laceleaf",
    "slug": "orange-laceleaf",
    "name": "Orange Laceleaf",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/orange-lanceleaf.webp",
    "imageStatus": "verified",
    "sellPrice": 185,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/orange-lanceleaf.webp",
      "variant-of:laceleaf"
    ],
    "notes": null,
    "description": "You do not need a parent of the same color to breed toward Orange Laceleaf. Heartopia evaluates the Laceleaf species and the parents' star levels instead, while a five-star flower is already at the point where it stops generating breeding seed.",
    "flowerSpecies": "laceleaf",
    "flowerColor": "orange",
    "variantOf": "laceleaf"
  },
  {
    "id": "peach-laceleaf",
    "slug": "peach-laceleaf",
    "name": "Peach Laceleaf",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/peach-lanceleaf.webp",
    "imageStatus": "verified",
    "sellPrice": 185,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/peach-lanceleaf.webp",
      "variant-of:laceleaf"
    ],
    "notes": null,
    "description": "Although Peach Laceleaf appears as its own catalog color, the game still handles it as a Laceleaf for breeding. Hue is ignored in the pairing check; compatible star ranks are what count, and five-star blooms cannot continue the chain with another seed.",
    "flowerSpecies": "laceleaf",
    "flowerColor": "peach",
    "variantOf": "laceleaf"
  },
  {
    "id": "pink-laceleaf",
    "slug": "pink-laceleaf",
    "name": "Pink Laceleaf",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/pink-lanceleaf.webp",
    "imageStatus": "verified",
    "sellPrice": 185,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/pink-lanceleaf.webp",
      "variant-of:laceleaf"
    ],
    "notes": null,
    "description": "Pink Laceleaf does not introduce a separate genetic formula. Crossbreeding still happens only with another Laceleaf whose star level is compatible, and the visible shade has no role in that calculation. At five stars, the plant no longer produces breeding seed.",
    "flowerSpecies": "laceleaf",
    "flowerColor": "pink",
    "variantOf": "laceleaf"
  },
  {
    "id": "red-laceleaf",
    "slug": "red-laceleaf",
    "name": "Red Laceleaf",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/red-lanceleaf.webp",
    "imageStatus": "verified",
    "sellPrice": 185,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/red-lanceleaf.webp",
      "variant-of:laceleaf"
    ],
    "notes": null,
    "description": "For breeding purposes, Red Laceleaf belongs completely to the Laceleaf line. Heartopia uses flower family plus compatible star ratings to decide whether a cross can work, not the parents' colors; five-star flowers are terminal for seed generation.",
    "flowerSpecies": "laceleaf",
    "flowerColor": "red",
    "variantOf": "laceleaf"
  },
  {
    "id": "white-laceleaf",
    "slug": "white-laceleaf",
    "name": "White Laceleaf",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/white-lanceleaf.webp",
    "imageStatus": "verified",
    "sellPrice": 185,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/white-lanceleaf.webp",
      "variant-of:laceleaf"
    ],
    "notes": null,
    "description": "The path to White Laceleaf is not based on mixing named colors. As a Laceleaf variant, it participates in the same star-based compatibility system as the rest of the family, with five stars acting as the final non-seeding stage.",
    "flowerSpecies": "laceleaf",
    "flowerColor": "white",
    "variantOf": "laceleaf"
  },
  {
    "id": "yellow-laceleaf",
    "slug": "yellow-laceleaf",
    "name": "Yellow Laceleaf",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/yellow-lanceleaf.webp",
    "imageStatus": "verified",
    "sellPrice": 185,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/yellow-lanceleaf.webp",
      "variant-of:laceleaf"
    ],
    "notes": null,
    "description": "Treat Yellow Laceleaf as a color form within the Laceleaf progression rather than a separate species. Crosses require compatible star-rated Laceleaf parents, while hue is ignored and five-star plants cannot produce another breeding seed.",
    "flowerSpecies": "laceleaf",
    "flowerColor": "yellow",
    "variantOf": "laceleaf"
  },
  {
    "id": "lily",
    "slug": "lily",
    "name": "Lily",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/white-lily.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/flowers.ts"
    ],
    "notes": null,
    "description": "Lily follows the Lily breeding line. A viable pair needs the same flower species with compatible star ranks, while color itself does not determine the cross. Extra watering helps the odds, and five stars marks the reproductive endpoint.",
    "isVariantGroup": true
  },
  {
    "id": "black-lily",
    "slug": "black-lily",
    "name": "Black Lily",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/black-lily.webp",
    "imageStatus": "verified",
    "sellPrice": 970,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/black-lily.webp",
      "variant-of:lily"
    ],
    "notes": null,
    "description": "Heartopia separates appearance from breeding logic for Black Lily. The flower remains a Lily, so the useful variables are species and star compatibility—not color—and reaching five stars closes off further seed production.",
    "flowerSpecies": "lily",
    "flowerColor": "black",
    "variantOf": "lily"
  },
  {
    "id": "green-lily",
    "slug": "green-lily",
    "name": "Green Lily",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/green-lily.webp",
    "imageStatus": "verified",
    "sellPrice": 1215,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/green-lily.webp",
      "variant-of:lily"
    ],
    "notes": null,
    "description": "Green Lily's shade identifies the catalog variant, but it does not tell the breeding system what to do. Pair compatible Lily flowers by star rating instead; a five-star result can be kept, but it will not generate a new breeding seed.",
    "flowerSpecies": "lily",
    "flowerColor": "green",
    "variantOf": "lily"
  },
  {
    "id": "orange-lily",
    "slug": "orange-lily",
    "name": "Orange Lily",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/orange-lily.webp",
    "imageStatus": "verified",
    "sellPrice": 730,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/orange-lily.webp",
      "variant-of:lily"
    ],
    "notes": null,
    "description": "Orange Lily is visually distinct, but its color does not function as a breeding ingredient. It remains a Lily: pair it with another Lily at a compatible star rank, and remember that five-star specimens cannot pass the line on through new breeding seed.",
    "flowerSpecies": "lily",
    "flowerColor": "orange",
    "variantOf": "lily"
  },
  {
    "id": "peach-lily",
    "slug": "peach-lily",
    "name": "Peach Lily",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/peach-lily.webp",
    "imageStatus": "verified",
    "sellPrice": 970,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/peach-lily.webp",
      "variant-of:lily"
    ],
    "notes": null,
    "description": "The Peach Lily color is cosmetic to Heartopia's crossing rules. What matters is that both parents are Lily flowers with star ratings close enough to pair; once a bloom reaches five stars, seed production for further crosses ends.",
    "flowerSpecies": "lily",
    "flowerColor": "peach",
    "variantOf": "lily"
  },
  {
    "id": "pink-lily",
    "slug": "pink-lily",
    "name": "Pink Lily",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/pink-lily.webp",
    "imageStatus": "verified",
    "sellPrice": 730,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/pink-lily.webp",
      "variant-of:lily"
    ],
    "notes": null,
    "description": "You do not need a parent of the same color to breed toward Pink Lily. Heartopia evaluates the Lily species and the parents' star levels instead, while a five-star flower is already at the point where it stops generating breeding seed.",
    "flowerSpecies": "lily",
    "flowerColor": "pink",
    "variantOf": "lily"
  },
  {
    "id": "purple-lily",
    "slug": "purple-lily",
    "name": "Purple Lily",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/purple-lily.webp",
    "imageStatus": "verified",
    "sellPrice": 1215,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/purple-lily.webp",
      "variant-of:lily"
    ],
    "notes": null,
    "description": "Although Purple Lily appears as its own catalog color, the game still handles it as a Lily for breeding. Hue is ignored in the pairing check; compatible star ranks are what count, and five-star blooms cannot continue the chain with another seed.",
    "flowerSpecies": "lily",
    "flowerColor": "purple",
    "variantOf": "lily"
  },
  {
    "id": "red-lily",
    "slug": "red-lily",
    "name": "Red Lily",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/red-lily.webp",
    "imageStatus": "verified",
    "sellPrice": 485,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/red-lily.webp",
      "variant-of:lily"
    ],
    "notes": null,
    "description": "Red Lily does not introduce a separate genetic formula. Crossbreeding still happens only with another Lily whose star level is compatible, and the visible shade has no role in that calculation. At five stars, the plant no longer produces breeding seed.",
    "flowerSpecies": "lily",
    "flowerColor": "red",
    "variantOf": "lily"
  },
  {
    "id": "selene-lily",
    "slug": "selene-lily",
    "name": "Selene Lily",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/selene-lily.webp",
    "imageStatus": "verified",
    "sellPrice": 1940,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/selene-lily.webp",
      "variant-of:lily"
    ],
    "notes": null,
    "description": "For breeding purposes, Selene Lily belongs completely to the Lily line. Heartopia uses flower family plus compatible star ratings to decide whether a cross can work, not the parents' colors; five-star flowers are terminal for seed generation.",
    "flowerSpecies": "lily",
    "flowerColor": "selene",
    "variantOf": "lily"
  },
  {
    "id": "white-lily",
    "slug": "white-lily",
    "name": "White Lily",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/white-lily.webp",
    "imageStatus": "verified",
    "sellPrice": 485,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/white-lily.webp",
      "variant-of:lily"
    ],
    "notes": null,
    "description": "The path to White Lily is not based on mixing named colors. As a Lily variant, it participates in the same star-based compatibility system as the rest of the family, with five stars acting as the final non-seeding stage.",
    "flowerSpecies": "lily",
    "flowerColor": "white",
    "variantOf": "lily"
  },
  {
    "id": "yellow-lily",
    "slug": "yellow-lily",
    "name": "Yellow Lily",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/yellow-lily.webp",
    "imageStatus": "verified",
    "sellPrice": 485,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/yellow-lily.webp",
      "variant-of:lily"
    ],
    "notes": null,
    "description": "Treat Yellow Lily as a color form within the Lily progression rather than a separate species. Crosses require compatible star-rated Lily parents, while hue is ignored and five-star plants cannot produce another breeding seed.",
    "flowerSpecies": "lily",
    "flowerColor": "yellow",
    "variantOf": "lily"
  },
  {
    "id": "morning-glory",
    "slug": "morning-glory",
    "name": "Morning Glory",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/white-morning-glory.webp",
    "imageStatus": "verified",
    "sellPrice": 250,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/flowers.ts"
    ],
    "notes": null,
    "description": "Breeding Morning Glory is a star-level problem, not a color recipe. Pair it with another Morning Glory whose rating is compatible, water the plants to raise the chance of success, and note that a five-star flower will not yield a further breeding seed.",
    "isVariantGroup": true
  },
  {
    "id": "selene-morning-glory",
    "slug": "selene-morning-glory",
    "name": "Selene Morning Glory",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/selene-morning-glory.webp",
    "imageStatus": "verified",
    "sellPrice": 250,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/selene-morning-glory.webp",
      "variant-of:morning-glory"
    ],
    "notes": null,
    "description": "The Selene form still belongs to Morning Glory for breeding purposes. Parent hue is ignored; the game checks whether both flowers belong together and whether their star ranks are close enough. At five stars, the line no longer yields seed for another cross.",
    "flowerSpecies": "morning-glory",
    "flowerColor": "selene",
    "variantOf": "morning-glory"
  },
  {
    "id": "black-morning-glory",
    "slug": "black-morning-glory",
    "name": "Black Morning Glory",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/black-morning-glory.webp",
    "imageStatus": "verified",
    "sellPrice": 250,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/black-morning-glory.webp",
      "variant-of:morning-glory"
    ],
    "notes": null,
    "description": "Black Morning Glory's shade identifies the catalog variant, but it does not tell the breeding system what to do. Pair compatible Morning Glory flowers by star rating instead; a five-star result can be kept, but it will not generate a new breeding seed.",
    "flowerSpecies": "morning-glory",
    "flowerColor": "black",
    "variantOf": "morning-glory"
  },
  {
    "id": "orange-morning-glory",
    "slug": "orange-morning-glory",
    "name": "Orange Morning Glory",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/orange-morning-glory.webp",
    "imageStatus": "verified",
    "sellPrice": 250,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/orange-morning-glory.webp",
      "variant-of:morning-glory"
    ],
    "notes": null,
    "description": "Orange Morning Glory is visually distinct, but its color does not function as a breeding ingredient. It remains a Morning Glory: pair it with another Morning Glory at a compatible star rank, and remember that five-star specimens cannot pass the line on through new breeding seed.",
    "flowerSpecies": "morning-glory",
    "flowerColor": "orange",
    "variantOf": "morning-glory"
  },
  {
    "id": "peach-morning-glory",
    "slug": "peach-morning-glory",
    "name": "Peach Morning Glory",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/peach-morning-glory.webp",
    "imageStatus": "verified",
    "sellPrice": 250,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/peach-morning-glory.webp",
      "variant-of:morning-glory"
    ],
    "notes": null,
    "description": "The Peach Morning Glory color is cosmetic to Heartopia's crossing rules. What matters is that both parents are Morning Glory flowers with star ratings close enough to pair; once a bloom reaches five stars, seed production for further crosses ends.",
    "flowerSpecies": "morning-glory",
    "flowerColor": "peach",
    "variantOf": "morning-glory"
  },
  {
    "id": "pink-morning-glory",
    "slug": "pink-morning-glory",
    "name": "Pink Morning Glory",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/pink-morning-glory.webp",
    "imageStatus": "verified",
    "sellPrice": 250,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/pink-morning-glory.webp",
      "variant-of:morning-glory"
    ],
    "notes": null,
    "description": "You do not need a parent of the same color to breed toward Pink Morning Glory. Heartopia evaluates the Morning Glory species and the parents' star levels instead, while a five-star flower is already at the point where it stops generating breeding seed.",
    "flowerSpecies": "morning-glory",
    "flowerColor": "pink",
    "variantOf": "morning-glory"
  },
  {
    "id": "purple-morning-glory",
    "slug": "purple-morning-glory",
    "name": "Purple Morning Glory",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/purple-morning-glory.webp",
    "imageStatus": "verified",
    "sellPrice": 250,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/purple-morning-glory.webp",
      "variant-of:morning-glory"
    ],
    "notes": null,
    "description": "Although Purple Morning Glory appears as its own catalog color, the game still handles it as a Morning Glory for breeding. Hue is ignored in the pairing check; compatible star ranks are what count, and five-star blooms cannot continue the chain with another seed.",
    "flowerSpecies": "morning-glory",
    "flowerColor": "purple",
    "variantOf": "morning-glory"
  },
  {
    "id": "red-morning-glory",
    "slug": "red-morning-glory",
    "name": "Red Morning Glory",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/red-morning-glory.webp",
    "imageStatus": "verified",
    "sellPrice": 250,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/red-morning-glory.webp",
      "variant-of:morning-glory"
    ],
    "notes": null,
    "description": "For the red variant, breeding still stays entirely inside the Morning Glory line. The visible shade has no role in the pairing check; suitable star ranks do, and the five-star stage is the end of further seed production.",
    "flowerSpecies": "morning-glory",
    "flowerColor": "red",
    "variantOf": "morning-glory"
  },
  {
    "id": "white-morning-glory",
    "slug": "white-morning-glory",
    "name": "White Morning Glory",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/white-morning-glory.webp",
    "imageStatus": "verified",
    "sellPrice": 250,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/white-morning-glory.webp",
      "variant-of:morning-glory"
    ],
    "notes": null,
    "description": "For breeding purposes, White Morning Glory belongs completely to the Morning Glory line. Heartopia uses flower family plus compatible star ratings to decide whether a cross can work, not the parents' colors; five-star flowers are terminal for seed generation.",
    "flowerSpecies": "morning-glory",
    "flowerColor": "white",
    "variantOf": "morning-glory"
  },
  {
    "id": "moth-orchid",
    "slug": "moth-orchid",
    "name": "Moth Orchid",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/black-moth-orchid.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/flowers.ts"
    ],
    "notes": null,
    "description": "Heartopia treats Moth Orchid as part of one Moth Orchid breeding pool. Crosses stay within that species and depend on sufficiently close star ratings; parent hues are irrelevant, watering is beneficial, and the line stops producing seed at five stars.",
    "isVariantGroup": true
  },
  {
    "id": "pansy",
    "slug": "pansy",
    "name": "Pansy",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/yellow-pansy.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/flowers.ts"
    ],
    "notes": null,
    "description": "For Pansy, successful crossbreeding comes from choosing another compatible Pansy, not from recreating a specific color combination. Star rank controls compatibility, watering boosts success, and five-star flowers sit at the end of the seed-producing chain.",
    "isVariantGroup": true
  },
  {
    "id": "black-pansy",
    "slug": "black-pansy",
    "name": "Black Pansy",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/black-pansy.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/black-pansy.webp",
      "variant-of:pansy"
    ],
    "notes": null,
    "description": "The path to Black Pansy is not based on mixing named colors. As a Pansy variant, it participates in the same star-based compatibility system as the rest of the family, with five stars acting as the final non-seeding stage.",
    "flowerSpecies": "pansy",
    "flowerColor": "black",
    "variantOf": "pansy"
  },
  {
    "id": "orange-pansy",
    "slug": "orange-pansy",
    "name": "Orange Pansy",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/orange-pansy.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/orange-pansy.webp",
      "variant-of:pansy"
    ],
    "notes": null,
    "description": "Treat Orange Pansy as a color form within the Pansy progression rather than a separate species. Crosses require compatible star-rated Pansy parents, while hue is ignored and five-star plants cannot produce another breeding seed.",
    "flowerSpecies": "pansy",
    "flowerColor": "orange",
    "variantOf": "pansy"
  },
  {
    "id": "purple-pansy",
    "slug": "purple-pansy",
    "name": "Purple Pansy",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/purple-pansy.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/purple-pansy.webp",
      "variant-of:pansy"
    ],
    "notes": null,
    "description": "Heartopia separates appearance from breeding logic for Purple Pansy. The flower remains a Pansy, so the useful variables are species and star compatibility—not color—and reaching five stars closes off further seed production.",
    "flowerSpecies": "pansy",
    "flowerColor": "purple",
    "variantOf": "pansy"
  },
  {
    "id": "sunglow-pansy",
    "slug": "sunglow-pansy",
    "name": "Sunglow Pansy",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/sunglow-pansy.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/sunglow-pansy.webp",
      "variant-of:pansy"
    ],
    "notes": null,
    "description": "Sunglow Pansy's shade identifies the catalog variant, but it does not tell the breeding system what to do. Pair compatible Pansy flowers by star rating instead; a five-star result can be kept, but it will not generate a new breeding seed.",
    "flowerSpecies": "pansy",
    "flowerColor": "sunglow",
    "variantOf": "pansy"
  },
  {
    "id": "yellow-pansy",
    "slug": "yellow-pansy",
    "name": "Yellow Pansy",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/yellow-pansy.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/yellow-pansy.webp",
      "variant-of:pansy"
    ],
    "notes": null,
    "description": "Yellow Pansy is visually distinct, but its color does not function as a breeding ingredient. It remains a Pansy: pair it with another Pansy at a compatible star rank, and remember that five-star specimens cannot pass the line on through new breeding seed.",
    "flowerSpecies": "pansy",
    "flowerColor": "yellow",
    "variantOf": "pansy"
  },
  {
    "id": "rose",
    "slug": "rose",
    "name": "Rose",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/white-rose.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/flowers.ts"
    ],
    "notes": null,
    "description": "To crossbreed Rose, keep both parents inside the Rose family. Heartopia checks whether their star ratings are close enough rather than matching flower colors; watering can improve the attempt, and a five-star bloom cannot create another breeding seed.",
    "isVariantGroup": true
  },
  {
    "id": "black-rose",
    "slug": "black-rose",
    "name": "Black Rose",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/black-rose.webp",
    "imageStatus": "verified",
    "sellPrice": 1530,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/black-rose.webp",
      "variant-of:rose"
    ],
    "notes": null,
    "description": "The Black Rose color is cosmetic to Heartopia's crossing rules. What matters is that both parents are Rose flowers with star ratings close enough to pair; once a bloom reaches five stars, seed production for further crosses ends.",
    "flowerSpecies": "rose",
    "flowerColor": "black",
    "variantOf": "rose"
  },
  {
    "id": "blue-rose",
    "slug": "blue-rose",
    "name": "Blue Rose",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/blue-rose.webp",
    "imageStatus": "verified",
    "sellPrice": 1915,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/blue-rose.webp",
      "variant-of:rose"
    ],
    "notes": null,
    "description": "You do not need a parent of the same color to breed toward Blue Rose. Heartopia evaluates the Rose species and the parents' star levels instead, while a five-star flower is already at the point where it stops generating breeding seed.",
    "flowerSpecies": "rose",
    "flowerColor": "blue",
    "variantOf": "rose"
  },
  {
    "id": "orange-rose",
    "slug": "orange-rose",
    "name": "Orange Rose",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/orange-rose.webp",
    "imageStatus": "verified",
    "sellPrice": 1150,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/orange-rose.webp",
      "variant-of:rose"
    ],
    "notes": null,
    "description": "Although Orange Rose appears as its own catalog color, the game still handles it as a Rose for breeding. Hue is ignored in the pairing check; compatible star ranks are what count, and five-star blooms cannot continue the chain with another seed.",
    "flowerSpecies": "rose",
    "flowerColor": "orange",
    "variantOf": "rose"
  },
  {
    "id": "peach-rose",
    "slug": "peach-rose",
    "name": "Peach Rose",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/peach-rose.webp",
    "imageStatus": "verified",
    "sellPrice": 1530,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/peach-rose.webp",
      "variant-of:rose"
    ],
    "notes": null,
    "description": "Peach Rose does not introduce a separate genetic formula. Crossbreeding still happens only with another Rose whose star level is compatible, and the visible shade has no role in that calculation. At five stars, the plant no longer produces breeding seed.",
    "flowerSpecies": "rose",
    "flowerColor": "peach",
    "variantOf": "rose"
  },
  {
    "id": "pink-rose",
    "slug": "pink-rose",
    "name": "Pink Rose",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/pink-rose.webp",
    "imageStatus": "verified",
    "sellPrice": 1150,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/pink-rose.webp",
      "variant-of:rose"
    ],
    "notes": null,
    "description": "For breeding purposes, Pink Rose belongs completely to the Rose line. Heartopia uses flower family plus compatible star ratings to decide whether a cross can work, not the parents' colors; five-star flowers are terminal for seed generation.",
    "flowerSpecies": "rose",
    "flowerColor": "pink",
    "variantOf": "rose"
  },
  {
    "id": "purple-rose",
    "slug": "purple-rose",
    "name": "Purple Rose",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/purple-rose.webp",
    "imageStatus": "verified",
    "sellPrice": 1915,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/purple-rose.webp",
      "variant-of:rose"
    ],
    "notes": null,
    "description": "The path to Purple Rose is not based on mixing named colors. As a Rose variant, it participates in the same star-based compatibility system as the rest of the family, with five stars acting as the final non-seeding stage.",
    "flowerSpecies": "rose",
    "flowerColor": "purple",
    "variantOf": "rose"
  },
  {
    "id": "selene-rose",
    "slug": "selene-rose",
    "name": "Selene Rose",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/selene-rose.webp",
    "imageStatus": "verified",
    "sellPrice": 3060,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/selene-rose.webp",
      "variant-of:rose"
    ],
    "notes": null,
    "description": "Treat Selene Rose as a color form within the Rose progression rather than a separate species. Crosses require compatible star-rated Rose parents, while hue is ignored and five-star plants cannot produce another breeding seed.",
    "flowerSpecies": "rose",
    "flowerColor": "selene",
    "variantOf": "rose"
  },
  {
    "id": "sunglow-rose",
    "slug": "sunglow-rose",
    "name": "Sunglow Rose",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/sunglow-rose.webp",
    "imageStatus": "verified",
    "sellPrice": 3060,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/sunglow-rose.webp",
      "variant-of:rose"
    ],
    "notes": null,
    "description": "Heartopia separates appearance from breeding logic for Sunglow Rose. The flower remains a Rose, so the useful variables are species and star compatibility—not color—and reaching five stars closes off further seed production.",
    "flowerSpecies": "rose",
    "flowerColor": "sunglow",
    "variantOf": "rose"
  },
  {
    "id": "white-rose",
    "slug": "white-rose",
    "name": "White Rose",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/white-rose.webp",
    "imageStatus": "verified",
    "sellPrice": 765,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/white-rose.webp",
      "variant-of:rose"
    ],
    "notes": null,
    "description": "White Rose's shade identifies the catalog variant, but it does not tell the breeding system what to do. Pair compatible Rose flowers by star rating instead; a five-star result can be kept, but it will not generate a new breeding seed.",
    "flowerSpecies": "rose",
    "flowerColor": "white",
    "variantOf": "rose"
  },
  {
    "id": "yellow-rose",
    "slug": "yellow-rose",
    "name": "Yellow Rose",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/yellow-rose.webp",
    "imageStatus": "verified",
    "sellPrice": 765,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/yellow-rose.webp",
      "variant-of:rose"
    ],
    "notes": null,
    "description": "Yellow Rose is visually distinct, but its color does not function as a breeding ingredient. It remains a Rose: pair it with another Rose at a compatible star rank, and remember that five-star specimens cannot pass the line on through new breeding seed.",
    "flowerSpecies": "rose",
    "flowerColor": "yellow",
    "variantOf": "rose"
  },
  {
    "id": "tulip",
    "slug": "tulip",
    "name": "Tulip",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/white-tulip.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/flowers.ts"
    ],
    "notes": null,
    "description": "Lily-style color recipes do not apply to Tulip: Heartopia treats the species as a star-based breeding family. Use another Tulip whose star rank is compatible, water to improve the chance, and expect the line to stop producing seed once five stars is reached.",
    "isVariantGroup": true
  },
  {
    "id": "black-tulip",
    "slug": "black-tulip",
    "name": "Black Tulip",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/black-tulip.webp",
    "imageStatus": "verified",
    "sellPrice": 830,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/black-tulip.webp",
      "variant-of:tulip"
    ],
    "notes": null,
    "description": "The Black Tulip color is cosmetic to Heartopia's crossing rules. What matters is that both parents are Tulip flowers with star ratings close enough to pair; once a bloom reaches five stars, seed production for further crosses ends.",
    "flowerSpecies": "tulip",
    "flowerColor": "black",
    "variantOf": "tulip"
  },
  {
    "id": "blue-tulip",
    "slug": "blue-tulip",
    "name": "Blue Tulip",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/blue-tulip.webp",
    "imageStatus": "verified",
    "sellPrice": 1040,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/blue-tulip.webp",
      "variant-of:tulip"
    ],
    "notes": null,
    "description": "You do not need a parent of the same color to breed toward Blue Tulip. Heartopia evaluates the Tulip species and the parents' star levels instead, while a five-star flower is already at the point where it stops generating breeding seed.",
    "flowerSpecies": "tulip",
    "flowerColor": "blue",
    "variantOf": "tulip"
  },
  {
    "id": "orange-tulip",
    "slug": "orange-tulip",
    "name": "Orange Tulip",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/orange-tulip.webp",
    "imageStatus": "verified",
    "sellPrice": 625,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/orange-tulip.webp",
      "variant-of:tulip"
    ],
    "notes": null,
    "description": "Although Orange Tulip appears as its own catalog color, the game still handles it as a Tulip for breeding. Hue is ignored in the pairing check; compatible star ranks are what count, and five-star blooms cannot continue the chain with another seed.",
    "flowerSpecies": "tulip",
    "flowerColor": "orange",
    "variantOf": "tulip"
  },
  {
    "id": "peach-tulip",
    "slug": "peach-tulip",
    "name": "Peach Tulip",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/peach-tulip.webp",
    "imageStatus": "verified",
    "sellPrice": 830,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/peach-tulip.webp",
      "variant-of:tulip"
    ],
    "notes": null,
    "description": "Peach Tulip does not introduce a separate genetic formula. Crossbreeding still happens only with another Tulip whose star level is compatible, and the visible shade has no role in that calculation. At five stars, the plant no longer produces breeding seed.",
    "flowerSpecies": "tulip",
    "flowerColor": "peach",
    "variantOf": "tulip"
  },
  {
    "id": "pink-tulip",
    "slug": "pink-tulip",
    "name": "Pink Tulip",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/pink-tulip.webp",
    "imageStatus": "verified",
    "sellPrice": 625,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/pink-tulip.webp",
      "variant-of:tulip"
    ],
    "notes": null,
    "description": "For breeding purposes, Pink Tulip belongs completely to the Tulip line. Heartopia uses flower family plus compatible star ratings to decide whether a cross can work, not the parents' colors; five-star flowers are terminal for seed generation.",
    "flowerSpecies": "tulip",
    "flowerColor": "pink",
    "variantOf": "tulip"
  },
  {
    "id": "purple-tulip",
    "slug": "purple-tulip",
    "name": "Purple Tulip",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/purple-tulip.webp",
    "imageStatus": "verified",
    "sellPrice": 1040,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/purple-tulip.webp",
      "variant-of:tulip"
    ],
    "notes": null,
    "description": "The path to Purple Tulip is not based on mixing named colors. As a Tulip variant, it participates in the same star-based compatibility system as the rest of the family, with five stars acting as the final non-seeding stage.",
    "flowerSpecies": "tulip",
    "flowerColor": "purple",
    "variantOf": "tulip"
  },
  {
    "id": "sunglow-tulip",
    "slug": "sunglow-tulip",
    "name": "Sunglow Tulip",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/sunglow-tulip.webp",
    "imageStatus": "verified",
    "sellPrice": 1660,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/sunglow-tulip.webp",
      "variant-of:tulip"
    ],
    "notes": null,
    "description": "Treat Sunglow Tulip as a color form within the Tulip progression rather than a separate species. Crosses require compatible star-rated Tulip parents, while hue is ignored and five-star plants cannot produce another breeding seed.",
    "flowerSpecies": "tulip",
    "flowerColor": "sunglow",
    "variantOf": "tulip"
  },
  {
    "id": "white-tulip",
    "slug": "white-tulip",
    "name": "White Tulip",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/white-tulip.webp",
    "imageStatus": "verified",
    "sellPrice": 415,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/white-tulip.webp",
      "variant-of:tulip"
    ],
    "notes": null,
    "description": "Heartopia separates appearance from breeding logic for White Tulip. The flower remains a Tulip, so the useful variables are species and star compatibility—not color—and reaching five stars closes off further seed production.",
    "flowerSpecies": "tulip",
    "flowerColor": "white",
    "variantOf": "tulip"
  },
  {
    "id": "yellow-tulip",
    "slug": "yellow-tulip",
    "name": "Yellow Tulip",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/yellow-tulip.webp",
    "imageStatus": "verified",
    "sellPrice": 415,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/flower/yellow-tulip.webp",
      "variant-of:tulip"
    ],
    "notes": null,
    "description": "Yellow Tulip's shade identifies the catalog variant, but it does not tell the breeding system what to do. Pair compatible Tulip flowers by star rating instead; a five-star result can be kept, but it will not generate a new breeding seed.",
    "flowerSpecies": "tulip",
    "flowerColor": "yellow",
    "variantOf": "tulip"
  },
  {
    "id": "apple",
    "slug": "apple",
    "name": "Apple",
    "kind": "forageable",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/forageable/apple.webp",
    "imageStatus": "verified",
    "sellPrice": 28,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/forageables.ts"
    ],
    "notes": null,
    "description": "A trio of Apples is enough to craft fishing Bait at the crafting bench. That gives this common forage item a direct role in fishing preparation even when no cooking recipe needs it."
  },
  {
    "id": "bamboo",
    "slug": "bamboo",
    "name": "Bamboo",
    "kind": "forageable",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/forageable/bamboo.webp",
    "imageStatus": "verified",
    "sellPrice": 7,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/forageables.ts"
    ],
    "notes": null,
    "description": "Saving Bamboo can make Panda bonding easier. It counts among that wild animal's preferred foods, and favorites award stronger relationship progress than ordinary acceptable snacks."
  },
  {
    "id": "bizarre-button-mushroom-blue",
    "slug": "bizarre-button-mushroom-blue",
    "name": "Bizarre Button Mushroom Blue",
    "kind": "forageable",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/forageable/bizarre-button-mushroom-blue.webp",
    "imageStatus": "verified",
    "sellPrice": 16,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/forageables.ts"
    ],
    "notes": null,
    "description": "This blue Button Mushroom is one of the unusual “bizarre” mushroom forms. Guides treat these rare variants as collection pieces rather than food, so their value is in finding and keeping them instead of cooking them."
  },
  {
    "id": "bizarre-button-mushroom-green",
    "slug": "bizarre-button-mushroom-green",
    "name": "Bizarre Button Mushroom Green",
    "kind": "forageable",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/forageable/bizarre-button-mushroom-green.webp",
    "imageStatus": "verified",
    "sellPrice": 16,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/forageables.ts"
    ],
    "notes": null,
    "description": "The green form belongs to Heartopia's rare bizarre Button Mushrooms. Unlike normal edible mushrooms, these odd-colored finds are described as collectibles, making display or completion a better purpose than recipes."
  },
  {
    "id": "bizarre-button-mushroom-red",
    "slug": "bizarre-button-mushroom-red",
    "name": "Bizarre Button Mushroom Red",
    "kind": "forageable",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/forageable/bizarre-button-mushroom-red.webp",
    "imageStatus": "verified",
    "sellPrice": 16,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/forageables.ts"
    ],
    "notes": null,
    "description": "Red Bizarre Button Mushroom is a rare collectible version of the ordinary Button Mushroom. Current guides distinguish bizarre forms from edible mushrooms, so this one is better regarded as a collection find than a cooking ingredient."
  },
  {
    "id": "bizarre-oyster-mushroom-orange",
    "slug": "bizarre-oyster-mushroom-orange",
    "name": "Bizarre Oyster Mushroom Orange",
    "kind": "forageable",
    "eventKey": null,
    "status": "active",
    "aliases": [
      "bizarre-ogster-mushroom-orange"
    ],
    "image": "/icons/forageable/bizarre-oyster-mushroom-orange.webp",
    "imageStatus": "verified",
    "sellPrice": 16,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/forageables.ts",
      "renamed-from:bizarre-ogster-mushroom-orange (misspelling in the id and English name)"
    ],
    "notes": null,
    "description": "Orange is one of the rare bizarre colors that can appear on Oyster Mushroom. These special forms are documented as non-food collectibles, giving them a different role from the ordinary mushroom used in gathering and cooking."
  },
  {
    "id": "bizarre-oyster-mushroom-pink",
    "slug": "bizarre-oyster-mushroom-pink",
    "name": "Bizarre Oyster Mushroom Pink",
    "kind": "forageable",
    "eventKey": null,
    "status": "active",
    "aliases": [
      "bizarre-ogster-mushroom-pink"
    ],
    "image": "/icons/forageable/bizarre-oyster-mushroom-pink.webp",
    "imageStatus": "verified",
    "sellPrice": 16,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/forageables.ts",
      "renamed-from:bizarre-ogster-mushroom-pink (misspelling in the id and English name)"
    ],
    "notes": null,
    "description": "Pink Bizarre Oyster Mushroom belongs to the scarce collectible mushroom set rather than the normal food pool. Guides classify these unusual forms as items to keep or exhibit, not ingredients meant for eating."
  },
  {
    "id": "bizarre-oyster-mushroom-purple",
    "slug": "bizarre-oyster-mushroom-purple",
    "name": "Bizarre Oyster Mushroom Purple",
    "kind": "forageable",
    "eventKey": null,
    "status": "active",
    "aliases": [
      "bizarre-ogster-mushroom-purple"
    ],
    "image": "/icons/forageable/bizarre-oyster-mushroom-purple.webp",
    "imageStatus": "verified",
    "sellPrice": 16,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/forageables.ts",
      "renamed-from:bizarre-ogster-mushroom-purple (misspelling in the id and English name)"
    ],
    "notes": null,
    "description": "Purple Bizarre Oyster Mushroom is a collectible mutation of the usual Oyster Mushroom. Guides separate these unusual color forms from normal edible mushrooms, so finding one is primarily a completion or display reward."
  },
  {
    "id": "bizarre-penny-bun-pink",
    "slug": "bizarre-penny-bun-pink",
    "name": "Bizarre Penny Bun (Pink)",
    "kind": "forageable",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/forageable/bizarre-penny-bun-pink.webp",
    "imageStatus": "verified",
    "sellPrice": 16,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/forageables.ts"
    ],
    "notes": null,
    "description": "The pink Penny Bun is one of Heartopia's scarce bizarre mushroom variants. It is not treated as normal food; guides place these forms in the collectible category instead."
  },
  {
    "id": "bizarre-penny-bun-purple",
    "slug": "bizarre-penny-bun-purple",
    "name": "Bizarre Penny Bun (Purple)",
    "kind": "forageable",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/forageable/bizarre-penny-bun-purple.webp",
    "imageStatus": "verified",
    "sellPrice": 16,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/forageables.ts"
    ],
    "notes": null,
    "description": "Purple Bizarre Penny Bun trades the normal mushroom's culinary role for rarity. Current guides describe bizarre mushroom colors as non-consumable collectibles, making the unusual appearance the point of the find."
  },
  {
    "id": "bizarre-penny-bun-red",
    "slug": "bizarre-penny-bun-red",
    "name": "Bizarre Penny Bun (Red)",
    "kind": "forageable",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/forageable/bizarre-penny-bun-red.webp",
    "imageStatus": "verified",
    "sellPrice": 16,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/forageables.ts"
    ],
    "notes": null,
    "description": "This red Penny Bun is part of the bizarre mushroom set rather than the ordinary edible pool. Its practical purpose is collection or display, since guides mark bizarre forms as unsuitable for eating."
  },
  {
    "id": "bizarre-shiitake-blue",
    "slug": "bizarre-shiitake-blue",
    "name": "Bizarre Shiitake Blue",
    "kind": "forageable",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/forageable/bizarre-shiitake-blue.webp",
    "imageStatus": "verified",
    "sellPrice": 16,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/forageables.ts"
    ],
    "notes": null,
    "description": "Blue Bizarre Shiitake is a rare color form meant to be collected rather than cooked. Heartopia mushroom guides distinguish these bizarre variants from the standard edible Shiitake."
  },
  {
    "id": "bizarre-shiitake-black",
    "slug": "bizarre-shiitake-black",
    "name": "Bizarre Shiitake Black",
    "kind": "forageable",
    "eventKey": null,
    "status": "active",
    "aliases": [
      "bizarre-shiitak-black"
    ],
    "image": "/icons/forageable/bizarre-shiitake-black.webp",
    "imageStatus": "verified",
    "sellPrice": 16,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/forageables.ts",
      "renamed-from:bizarre-shiitak-black (misspelling in the id and English name)"
    ],
    "notes": null,
    "description": "The black Shiitake variant belongs to the rare bizarre mushroom group. Unlike ordinary Shiitake, these unusual forms are documented as non-consumable and therefore matter mainly for collecting."
  },
  {
    "id": "bizarre-shiitake-red",
    "slug": "bizarre-shiitake-red",
    "name": "Bizarre Shiitake Red",
    "kind": "forageable",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/forageable/bizarre-shiitake-red.webp",
    "imageStatus": "verified",
    "sellPrice": 16,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/forageables.ts"
    ],
    "notes": null,
    "description": "Red Bizarre Shiitake is one of the uncommon collectible versions of Shiitake. Guides note that bizarre mushrooms are not for eating, so this variant's significance comes from rarity and collection value."
  },
  {
    "id": "black-truffle",
    "slug": "black-truffle",
    "name": "Black Truffle",
    "kind": "forageable",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/forageable/black-truffle.webp",
    "imageStatus": "verified",
    "sellPrice": 99,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/forageables.ts"
    ],
    "notes": null,
    "description": "Black Truffle is easy to walk past because it sits below a small patch of disturbed soil instead of rising visibly like most mushrooms. Gathering guides place the return window at about a quarter of an hour."
  },
  {
    "id": "blueberry",
    "slug": "blueberry",
    "name": "Blueberry",
    "kind": "forageable",
    "eventKey": null,
    "status": "active",
    "aliases": [
      "blueberries"
    ],
    "image": "/icons/forageable/blueberry.webp",
    "imageStatus": "verified",
    "sellPrice": 16,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/forageables.ts"
    ],
    "notes": null,
    "description": "Blueberries have a use in wildlife bonding that is easy to overlook. They are a favorite food for the Alpaca, so holding some back can produce better daily relationship gains than spending every berry elsewhere."
  },
  {
    "id": "branch",
    "slug": "branch",
    "name": "Branch",
    "kind": "forageable",
    "eventKey": null,
    "status": "active",
    "aliases": [
      "branches"
    ],
    "image": "/icons/forageable/branch.webp",
    "imageStatus": "verified",
    "sellPrice": 5,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/forageables.ts"
    ],
    "notes": null,
    "description": "Branches bridge crafting and wildlife care. A set of five is enough for the entry-level Repair Kit, and Deer also recognize this basic material as a preferred snack for bonding."
  },
  {
    "id": "burdock",
    "slug": "burdock",
    "name": "Burdock",
    "kind": "forageable",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/forageable/burdock.webp",
    "imageStatus": "verified",
    "sellPrice": 5,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/forageables.ts"
    ],
    "notes": null,
    "description": "Burdock entered Heartopia as one of Dreamlight Cinematics' seasonal wild greens. Players forage it from the world rather than plant it as an ordinary crop, and the event uses those gathered greens in its special cooking content."
  },
  {
    "id": "button-mushroom",
    "slug": "button-mushroom",
    "name": "Button Mushroom",
    "kind": "forageable",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/forageable/button-mushroom.webp",
    "imageStatus": "verified",
    "sellPrice": 16,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/forageables.ts"
    ],
    "notes": null,
    "description": "Button Mushroom is gathered from natural spawns rather than planted in a field. A current mushroom route guide gives it a fast return time of around two to three minutes, making short repeat circuits practical."
  },
  {
    "id": "fiddlehead",
    "slug": "fiddlehead",
    "name": "Fiddlehead",
    "kind": "forageable",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/forageable/fiddlehead.webp",
    "imageStatus": "verified",
    "sellPrice": 5,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/forageables.ts"
    ],
    "notes": null,
    "description": "Dreamlight Cinematics introduced Fiddlehead as a temporary wild green. It is collected through foraging instead of standard farming and feeds into the event's dedicated cooking activities."
  },
  {
    "id": "flawless-fluorite",
    "slug": "flawless-fluorite",
    "name": "Flawless Fluorite",
    "kind": "forageable",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/forageable/flawless-fluorite.webp",
    "imageStatus": "verified",
    "sellPrice": 150,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "gift-code-rewards:src/data/source/gift-codes.json",
      "icon-asset:apps/web-vite/public/icons/forageable/flawless-fluorite.webp"
    ],
    "notes": null,
    "description": "Completing Astralis unlocks a daily search for Flawless Fluorite. The resource shows up as a blue glow attached to roaming beige rocks near homes, and guides indicate that only three pieces can normally be collected each day."
  },
  {
    "id": "mandarin",
    "slug": "mandarin",
    "name": "Mandarin",
    "kind": "forageable",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/forageable/mandarin.webp",
    "imageStatus": "verified",
    "sellPrice": 28,
    "energy": 8,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/forageables.ts",
      "research:chatgpt-heartodex-2026-07-11 (energy value)"
    ],
    "notes": null,
    "description": "Mandarin is a small citrus fruit with segmented flesh and a thin, loose rind that is usually easier to peel than a standard orange. Its flavor is typically sweet and aromatic."
  },
  {
    "id": "matsutake",
    "slug": "matsutake",
    "name": "Matsutake",
    "kind": "forageable",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/forageable/matsutake.webp",
    "imageStatus": "verified",
    "sellPrice": 16,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/forageables.ts"
    ],
    "notes": null,
    "description": "Matsutake is the mushroom that demands the most careful searching. Current gathering guides call it the hardest and rarest type to locate and note that it can be concealed beneath pine and oak trees."
  },
  {
    "id": "mustard-greens",
    "slug": "mustard-greens",
    "name": "Mustard Greens",
    "kind": "forageable",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/forageable/mustard-greens.webp",
    "imageStatus": "verified",
    "sellPrice": 5,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/forageables.ts"
    ],
    "notes": null,
    "description": "Mustard Greens belongs to the group of wild vegetables added for Dreamlight Cinematics. Instead of growing it in a normal crop plot, players forage it during the seasonal content and use those greens in festival cooking."
  },
  {
    "id": "orange",
    "slug": "orange",
    "name": "Orange",
    "kind": "forageable",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/forageable/orange.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "gift-code-rewards:src/data/source/gift-codes.json",
      "icon-asset:apps/web-vite/public/icons/forageable/orange.webp"
    ],
    "notes": null,
    "description": "Orange is a round citrus fruit built from juicy segments enclosed by an aromatic rind. Most sweet-orange varieties balance noticeable sweetness with mild citrus acidity."
  },
  {
    "id": "oyster-mushroom",
    "slug": "oyster-mushroom",
    "name": "Oyster Mushroom",
    "kind": "forageable",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/forageable/oyster-mushroom.webp",
    "imageStatus": "verified",
    "sellPrice": 16,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/forageables.ts"
    ],
    "notes": null,
    "description": "Oyster Mushroom comes from world spawns, not from a garden crop cycle. Guides published in July 2026 estimate only a two-to-three-minute respawn, so the same gathering circuit can be revisited quickly."
  },
  {
    "id": "penny-bun",
    "slug": "penny-bun",
    "name": "Penny Bun",
    "kind": "forageable",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/forageable/penny-bun.webp",
    "imageStatus": "verified",
    "sellPrice": 16,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/forageables.ts"
    ],
    "notes": null,
    "description": "Penny Bun is another naturally appearing mushroom rather than something planted on the farm. Current gathering guidance puts its return at roughly two to three minutes, supporting efficient repeated routes."
  },
  {
    "id": "quality-timber",
    "slug": "quality-timber",
    "name": "Quality Timber",
    "kind": "forageable",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/forageable/quality-timber.webp",
    "imageStatus": "verified",
    "sellPrice": 12,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "gift-code-rewards:src/data/source/gift-codes.json",
      "icon-asset:apps/web-vite/public/icons/forageable/quality-timber.webp"
    ],
    "notes": null,
    "description": "Compared with basic wood, Quality Timber belongs to the scarcer upgrade-material tier. Guides point to palms and substantial woodland trees as its sources, with the usual daily haul estimated at only around ten to fifteen pieces."
  },
  {
    "id": "rare-timber",
    "slug": "rare-timber",
    "name": "Rare Timber",
    "kind": "forageable",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/forageable/rare-timber.webp",
    "imageStatus": "verified",
    "sellPrice": 50,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "gift-code-rewards:src/data/source/gift-codes.json",
      "icon-asset:apps/web-vite/public/icons/forageable/rare-timber.webp"
    ],
    "notes": null,
    "description": "Rare Timber is intentionally limited to a few exceptional trees instead of normal chopping spots. Material guides estimate about eight harvest opportunities per day, so planning a route is more efficient than gathering at random."
  },
  {
    "id": "raspberry",
    "slug": "raspberry",
    "name": "Raspberry",
    "kind": "forageable",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/forageable/raspberry.webp",
    "imageStatus": "verified",
    "sellPrice": 26,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/forageables.ts"
    ],
    "notes": null,
    "description": "Raspberries can be converted into stronger animal-bond progress by feeding them to Capybaras. They are listed among that animal's favorites, which makes them worth saving for relationship routines as well as recipes."
  },
  {
    "id": "roaming-oak-timber",
    "slug": "roaming-oak-timber",
    "name": "Roaming Oak Timber",
    "kind": "forageable",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/forageable/roaming-oak-timber.webp",
    "imageStatus": "verified",
    "sellPrice": 150,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "gift-code-rewards:src/data/source/gift-codes.json",
      "icon-asset:apps/web-vite/public/icons/forageable/roaming-oak-timber.webp"
    ],
    "notes": null,
    "description": "Roaming Oak Timber comes from the wandering Oak-Oak encounter instead of a permanent gathering node. Community material guides put the daily take at three pieces, so finding that day's reported Oak-Oak position saves a lot of aimless searching."
  },
  {
    "id": "shiitake",
    "slug": "shiitake",
    "name": "Shiitake",
    "kind": "forageable",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/forageable/shiitake.webp",
    "imageStatus": "verified",
    "sellPrice": 16,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/forageables.ts"
    ],
    "notes": null,
    "description": "Shiitake grows as a natural gatherable mushroom, separate from normal crop farming. A recent route guide estimates that its spawn can return in about two to three minutes, which supports repeated collection passes."
  },
  {
    "id": "stone",
    "slug": "stone",
    "name": "Stone",
    "kind": "forageable",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/forageable/stone.webp",
    "imageStatus": "verified",
    "sellPrice": 8,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "gift-code-rewards:src/data/source/gift-codes.json",
      "icon-asset:apps/web-vite/public/icons/forageable/stone.webp"
    ],
    "notes": null,
    "description": "Stone is Heartopia's straightforward rock material: a hard mineral resource rather than one of the rarer ore or timber tiers. It serves as a basic building and crafting material in the wider resource system."
  },
  {
    "id": "tall-mustard",
    "slug": "tall-mustard",
    "name": "Tall Mustard",
    "kind": "forageable",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/forageable/tall-mustard.webp",
    "imageStatus": "verified",
    "sellPrice": 5,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/forageables.ts"
    ],
    "notes": null,
    "description": "Tall Mustard was part of the Dreamlight Cinematics wild-green set. Its gameplay loop is foraging rather than planting, with the gathered vegetable feeding into the festival's event-specific cooking."
  },
  {
    "id": "timber",
    "slug": "timber",
    "name": "Timber",
    "kind": "forageable",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/forageable/timber.webp",
    "imageStatus": "verified",
    "sellPrice": 6,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "gift-code-rewards:src/data/source/gift-codes.json",
      "icon-asset:apps/web-vite/public/icons/forageable/timber.webp"
    ],
    "notes": null,
    "description": "Timber is the basic wood resource in Heartopia's material hierarchy. It represents ordinary usable wood before the game moves into scarcer grades such as Quality Timber and Rare Timber."
  },
  {
    "id": "weed",
    "slug": "weed",
    "name": "Weed",
    "kind": "forageable",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/forageable/weed.webp",
    "imageStatus": "verified",
    "sellPrice": 0,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/forageables.ts"
    ],
    "notes": null,
    "description": "Weeds are useful in two places that have nothing to do with clearing a garden. Four Weeds combined with three Timber make Fertilizer, and wild Bunnies also treat Weeds as one of their favorite foods."
  },
  {
    "id": "bunny",
    "slug": "bunny",
    "name": "Bunny",
    "kind": "animal",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/animal/bunny.webp",
    "imageStatus": "verified",
    "sellPrice": 1,
    "energy": null,
    "tags": [
      "animal",
      "wildlife"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/animals.ts",
      "supabase:items(type=ANIMAL)"
    ],
    "notes": "Wild animal — ambient/sighting-based, no obtain_methods row exists in the source DB.",
    "description": "Bonding with a Bunny can be done cheaply because Weeds are among its favorites, alongside Carrots and Strawberries. Feeding a favorite gives the larger daily relationship increase."
  },
  {
    "id": "capybara",
    "slug": "capybara",
    "name": "Capybara",
    "kind": "animal",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/animal/capybara.webp",
    "imageStatus": "verified",
    "sellPrice": 1,
    "energy": null,
    "tags": [
      "animal",
      "wildlife"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/animals.ts",
      "supabase:items(type=ANIMAL)"
    ],
    "notes": "Wild animal — ambient/sighting-based, no obtain_methods row exists in the source DB.",
    "description": "Raspberries and Tomatoes are favorite foods for the wild Capybara. Using favorites instead of merely acceptable food improves the amount of bond progress gained from a feeding."
  },
  {
    "id": "deer",
    "slug": "deer",
    "name": "Deer",
    "kind": "animal",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/animal/deer.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [
      "animal",
      "wildlife"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/animals.ts",
      "supabase:items(type=ANIMAL)"
    ],
    "notes": "Wild animal — ambient/sighting-based, no obtain_methods row exists in the source DB.",
    "description": "Cheap materials work well for Deer bonding because Branches count as a favorite. The preferred menu also includes House Salad and Lettuce, and any favorite gives more relationship progress than ordinary food."
  },
  {
    "id": "ferret",
    "slug": "ferret",
    "name": "Ferret",
    "kind": "animal",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/animal/ferret.webp",
    "imageStatus": "verified",
    "sellPrice": 1,
    "energy": null,
    "tags": [
      "animal",
      "wildlife"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/animals.ts",
      "supabase:items(type=ANIMAL)"
    ],
    "notes": "Wild animal — ambient/sighting-based, no obtain_methods row exists in the source DB.",
    "description": "The wild Ferret responds best to Eggs, Goby and Sea Bass. Feeding from that preferred set improves daily bond gains and helps move the animal toward later relationship interactions."
  },
  {
    "id": "fox",
    "slug": "fox",
    "name": "Fox",
    "kind": "animal",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/animal/fox.webp",
    "imageStatus": "verified",
    "sellPrice": 1,
    "energy": null,
    "tags": [
      "animal",
      "wildlife"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/animals.ts",
      "supabase:items(type=ANIMAL)"
    ],
    "notes": "Wild animal — ambient/sighting-based, no obtain_methods row exists in the source DB.",
    "description": "A Fox can turn spare fishing catches into relationship progress. Meat is a favorite, and two fish—Largemouth Bass plus European Perch—also qualify for the higher bond reward."
  },
  {
    "id": "llama",
    "slug": "llama",
    "name": "Llama",
    "kind": "animal",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/animal/llama.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [
      "animal",
      "wildlife"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/animals.ts",
      "supabase:items(type=ANIMAL)"
    ],
    "notes": "Wild animal — ambient/sighting-based, no obtain_methods row exists in the source DB.",
    "description": "A llama is a domesticated South American camelid recognizable by its long neck, upright ears and woolly coat. This description stays general because current Heartopia guides more often document Alpaca as the named wildlife entry."
  },
  {
    "id": "penguin",
    "slug": "penguin",
    "name": "Penguin",
    "kind": "animal",
    "eventKey": "winter-frost-season-old-sea",
    "status": "active",
    "aliases": [],
    "image": "/icons/animal/penguin.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [
      "animal",
      "wildlife",
      "event"
    ],
    "sourceRefs": [
      "heartodex:wild-animals/penguin"
    ],
    "notes": "Wild animal from the Winter Frost Season event (Jan 24 - Mar 14, 2026) at Old Sea — event ended, no longer sightable.",
    "description": "Unlike the permanent wildlife roster, Penguin is associated with the Winter Frost season. Because its appearance is seasonal, players have a more limited window in which to work on its daily bond progress."
  },
  {
    "id": "panda",
    "slug": "panda",
    "name": "Panda",
    "kind": "animal",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/animal/panda.webp",
    "imageStatus": "verified",
    "sellPrice": 1,
    "energy": null,
    "tags": [
      "animal",
      "wildlife"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/animals.ts",
      "supabase:items(type=ANIMAL)"
    ],
    "notes": "Wild animal — ambient/sighting-based, no obtain_methods row exists in the source DB.",
    "description": "For the Panda, preferred feeding options include Corn, Apple and Bamboo. Favorite foods award better bond progress, while nearby Bamboo makes one of those choices especially easy to restock."
  },
  {
    "id": "sea-otter",
    "slug": "sea-otter",
    "name": "Sea Otter",
    "kind": "animal",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/animal/sea-otter.webp",
    "imageStatus": "verified",
    "sellPrice": 1,
    "energy": null,
    "tags": [
      "animal",
      "wildlife"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/animals.ts",
      "supabase:items(type=ANIMAL)"
    ],
    "notes": "Wild animal — ambient/sighting-based, no obtain_methods row exists in the source DB.",
    "description": "Sea Otter bonding works well if you save several shellfish catches instead of selling them all. Its favorite menu includes both Common and Oriental Shrimp together with Mussels, so routine fishing can double as relationship progress."
  },
  {
    "id": "afternoon-tea",
    "slug": "afternoon-tea",
    "name": "Afternoon Tea",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/afternoon-tea.webp",
    "imageStatus": "verified",
    "sellPrice": 710,
    "energy": 20,
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "Two small cakes accompanied by black tea, perfect for a relaxing afternoon."
  },
  {
    "id": "apple-jam",
    "slug": "apple-jam",
    "name": "Apple Jam",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/apple-jam.webp",
    "imageStatus": "verified",
    "sellPrice": 270,
    "energy": 35,
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "Smooth get pulpy with real apple chunks. Remember to close the lid snugly!"
  },
  {
    "id": "apple-pie",
    "slug": "apple-pie",
    "name": "Apple Pie",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/apple-pie.webp",
    "imageStatus": "verified",
    "sellPrice": 730,
    "energy": 70,
    "tags": [
      "food",
      "dish",
      "pie",
      "apple"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "Crunchy base with tender, sweet-and-sour apple—double the pleasure."
  },
  {
    "id": "baked-eggplant-w-meat",
    "slug": "baked-eggplant-w-meat",
    "name": "Baked Eggplant w/ Meat",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [
      "baked-eggplant-with-meat"
    ],
    "image": "/icons/dish/baked-eggplant-w-meat.webp",
    "imageStatus": "verified",
    "sellPrice": 1230,
    "energy": 75,
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "Soft, tender eggplant coated in a savory meat sauce slow-simmered over low heat—perfect with rice!"
  },
  {
    "id": "bizarre-food",
    "slug": "bizarre-food",
    "name": "Bizarre Food",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/bizarre-food.webp",
    "imageStatus": "verified",
    "sellPrice": 10,
    "energy": 10,
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "It is obtained by cooking any food and failing."
  },
  {
    "id": "bizzare-drink",
    "slug": "bizzare-drink",
    "name": "Bizzare Drink",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [
      "bizarre-drink"
    ],
    "image": "/icons/dish/bizzare-drink.webp",
    "imageStatus": "verified",
    "sellPrice": 10,
    "energy": 10,
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "It is obtained by preparing any beverage and failing."
  },
  {
    "id": "black-truffle-cream-pasta",
    "slug": "black-truffle-cream-pasta",
    "name": "Black Truffle Cream Pasta",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/black-truffle-cream-pasta.webp",
    "imageStatus": "verified",
    "sellPrice": 900,
    "energy": 90,
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "A creamy black truffle sauce coats each noodle evenly, aromatic without being cloying."
  },
  {
    "id": "black-truffle-pie",
    "slug": "black-truffle-pie",
    "name": "Black Truffle Pie",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/black-truffle-pie.webp",
    "imageStatus": "verified",
    "sellPrice": 830,
    "energy": 80,
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "The jewel in the crown of mushroom pies, a real challenge for chefs' skills."
  },
  {
    "id": "blue-roll-cake",
    "slug": "blue-roll-cake",
    "name": "Blue Roll Cake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/blue-roll-cake.webp",
    "imageStatus": "verified",
    "sellPrice": 570,
    "energy": 48,
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "With cyan sugar, it evokes verses such as «sky blue weeping woman»."
  },
  {
    "id": "blueberry-jam",
    "slug": "blueberry-jam",
    "name": "Blueberry Jam",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/blueberry-jam.webp",
    "imageStatus": "verified",
    "sellPrice": 170,
    "energy": 22,
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "Sweet with a rich blueberry aroma. Though dark like tar, it's said to benefit the eyes."
  },
  {
    "id": "button-mushroom-pie",
    "slug": "button-mushroom-pie",
    "name": "Button Mushroom Pie",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/button-mushroom-pie.webp",
    "imageStatus": "verified",
    "sellPrice": 500,
    "energy": 35,
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "A cake with a creamy aroma, light as a cloud."
  },
  {
    "id": "candlelight-dinner",
    "slug": "candlelight-dinner",
    "name": "Candlelight Dinner",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/candlelight-dinner.webp",
    "imageStatus": "verified",
    "sellPrice": 1760,
    "energy": 75,
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "The ultimate expression of a romantic dinner—paired with a night view and soft, soothing music, it helps bring people closer together."
  },
  {
    "id": "caramel-popcorn-bucket",
    "slug": "caramel-popcorn-bucket",
    "name": "Caramel Popcorn Bucket",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/caramel-popcorn-bucket.webp",
    "imageStatus": "verified",
    "sellPrice": 820,
    "energy": null,
    "tags": [
      "event",
      "dreamlight-cinematics",
      "recipe"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "An irresistible caramel aroma evenlg coats every kernel, sweet and crunchy."
  },
  {
    "id": "carrot-cake",
    "slug": "carrot-cake",
    "name": "Carrot Cake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/carrot-cake.webp",
    "imageStatus": "verified",
    "sellPrice": 840,
    "energy": 55,
    "tags": [
      "food",
      "dish",
      "cake",
      "carrot"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "Fresh carrots are carefully grated and blended into a fluffy cake base, offering a unique natural sweetness and wholesome nutrition."
  },
  {
    "id": "cheese-cake",
    "slug": "cheese-cake",
    "name": "Cheese Cake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [
      "cheesecake"
    ],
    "image": "/icons/dish/cheese-cake.webp",
    "imageStatus": "verified",
    "sellPrice": 480,
    "energy": 50,
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "A smooth and creamy dessert, served on a delicate plate with a milky aroma."
  },
  {
    "id": "chocolate-sauce",
    "slug": "chocolate-sauce",
    "name": "Chocolate Sauce",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/chocolate-sauce.webp",
    "imageStatus": "verified",
    "sellPrice": 1400,
    "energy": null,
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "Who said this is too sweet? This is the best chocolate sauce ever!"
  },
  {
    "id": "coffee",
    "slug": "coffee",
    "name": "Coffee",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/coffee.webp",
    "imageStatus": "verified",
    "sellPrice": 290,
    "energy": 40,
    "tags": [
      "drink",
      "crafted"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "Savor the coffee carefully; aroma, sweetness, acidity, bitterness, and body in balance."
  },
  {
    "id": "coffee-latte",
    "slug": "coffee-latte",
    "name": "Coffee Latte",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/coffee-latte.webp",
    "imageStatus": "verified",
    "sellPrice": 300,
    "energy": 40,
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "Classic espresso and milk coffee, topped with foam art."
  },
  {
    "id": "colorful-movie-combo",
    "slug": "colorful-movie-combo",
    "name": "Colorful Movie Combo",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/colorful-movie-combo.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [
      "event",
      "dreamlight-cinematics",
      "recipe"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "Colorful Combo Set—one serving satisfies both sight and taste."
  },
  {
    "id": "corn-soup",
    "slug": "corn-soup",
    "name": "Corn Soup",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/corn-soup.webp",
    "imageStatus": "verified",
    "sellPrice": 1340,
    "energy": 80,
    "tags": [
      "food",
      "dish",
      "soup",
      "corn"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "Surrounded by the rich aroma of corn, every bite is a double delight for both the nose and the palate."
  },
  {
    "id": "crayfish-sashimi",
    "slug": "crayfish-sashimi",
    "name": "Crayfish Sashimi",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/crayfish-sashimi.webp",
    "imageStatus": "verified",
    "sellPrice": 850,
    "energy": 30,
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "A cold dish that preserves the lobster’s natural flavor to the fullest; fresh and delicious."
  },
  {
    "id": "deluxe-seafood-platter",
    "slug": "deluxe-seafood-platter",
    "name": "Deluxe Seafood Platter",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/deluxe-seafood-platter.webp",
    "imageStatus": "verified",
    "sellPrice": 410,
    "energy": 65,
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "A seemingly ordinary seafood platter instantly becomes luxurious just by adding two crayfish."
  },
  {
    "id": "fish-and-chips",
    "slug": "fish-and-chips",
    "name": "Fish and Chips",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/fish-and-chips.webp",
    "imageStatus": "verified",
    "sellPrice": 250,
    "energy": 40,
    "tags": [
      "food",
      "dish",
      "fish",
      "potato"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "Boneless fried fish in crispy batter, served with hot chips. Classic."
  },
  {
    "id": "fish-n-chips",
    "slug": "fish-n-chips",
    "name": "Fish N Chips",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/fish-n-chips.webp",
    "imageStatus": "verified",
    "sellPrice": 310,
    "energy": 40,
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "Boneless fried fish in crispy batter, served with hot chips. Classic."
  },
  {
    "id": "grape-jam",
    "slug": "grape-jam",
    "name": "Grape Jam",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/grape-jam.webp",
    "imageStatus": "verified",
    "sellPrice": 2020,
    "energy": 40,
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "Stimulate the appetite and reduce fatigue. Being tasty is just a bonus."
  },
  {
    "id": "green-roll-cake",
    "slug": "green-roll-cake",
    "name": "Green Roll Cake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/green-roll-cake.webp",
    "imageStatus": "verified",
    "sellPrice": 670,
    "energy": 48,
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "Matcha cake roll, tasty and never cloying."
  },
  {
    "id": "grilled-button-mushroom",
    "slug": "grilled-button-mushroom",
    "name": "Grilled Button Mushroom",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/grilled-button-mushroom.webp",
    "imageStatus": "verified",
    "sellPrice": 180,
    "energy": 15,
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "Like little bowls overflowing with juice. Be careful when eating them, they could burn your mouth!"
  },
  {
    "id": "grilled-mushrooms",
    "slug": "grilled-mushrooms",
    "name": "Grilled Mushrooms",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/grilled-mushrooms.webp",
    "imageStatus": "verified",
    "sellPrice": 180,
    "energy": 15,
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "Seasoned and roasted to perfection, the mushrooms become little golden, crispy “bombs” of freshness."
  },
  {
    "id": "grilled-oyster-mushroom",
    "slug": "grilled-oyster-mushroom",
    "name": "Grilled Oyster Mushroom",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/grilled-oyster-mushroom.webp",
    "imageStatus": "verified",
    "sellPrice": 180,
    "energy": 15,
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "Crispy and tasty, they taste best when the edges are golden brown and slightly curled."
  },
  {
    "id": "grilled-penny-bun",
    "slug": "grilled-penny-bun",
    "name": "Grilled Penny Bun",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/grilled-penny-bun.webp",
    "imageStatus": "verified",
    "sellPrice": 180,
    "energy": 15,
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "Just a simple roasted mushroom? No: a delicacy on par with a steak!"
  },
  {
    "id": "grilled-shiitake-mushroom",
    "slug": "grilled-shiitake-mushroom",
    "name": "Grilled Shiitake Mushroom",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/grilled-shiitake-mushroom.webp",
    "imageStatus": "verified",
    "sellPrice": 180,
    "energy": 15,
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "With a cross marked on top that seals in the juices, full of flavor in every bite."
  },
  {
    "id": "house-salad",
    "slug": "house-salad",
    "name": "House Salad",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/house-salad.webp",
    "imageStatus": "verified",
    "sellPrice": 90,
    "energy": 15,
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "A cold dish made with fresh vegetables and sauce. Just mix it up and dig in!"
  },
  {
    "id": "indigo-roll-cake",
    "slug": "indigo-roll-cake",
    "name": "Indigo Roll Cake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/indigo-roll-cake.webp",
    "imageStatus": "verified",
    "sellPrice": 570,
    "energy": 48,
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "It smells like blue skies. The flower next to the cream is decorative, not edible!"
  },
  {
    "id": "latte",
    "slug": "latte",
    "name": "Latte",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/latte.webp",
    "imageStatus": "verified",
    "sellPrice": 300,
    "energy": 40,
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null
  },
  {
    "id": "mandarin-jam",
    "slug": "mandarin-jam",
    "name": "Mandarin Jam",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/mandarin-jam.webp",
    "imageStatus": "verified",
    "sellPrice": 270,
    "energy": 35,
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "The Unique citrus flavor once made it a top choice for gifting."
  },
  {
    "id": "meat-burger",
    "slug": "meat-burger",
    "name": "Meat Burger",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/meat-burger.webp",
    "imageStatus": "verified",
    "sellPrice": 1350,
    "energy": 75,
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "Junk food? It’s clearly the king of fast food, complete with meat, vegetables, and a staple all in one."
  },
  {
    "id": "meat-sauce-pasta",
    "slug": "meat-sauce-pasta",
    "name": "Meat Sauce Pasta",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/meat-sauce-pasta.webp",
    "imageStatus": "verified",
    "sellPrice": 670,
    "energy": 80,
    "tags": [
      "food",
      "dish",
      "pasta",
      "meat"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "Easy and tasty, meat and tomato in sauce, topped with pasta and cheese."
  },
  {
    "id": "mixed-jam",
    "slug": "mixed-jam",
    "name": "Mixed Jam",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/mixed-jam.webp",
    "imageStatus": "verified",
    "sellPrice": 160,
    "energy": 22,
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "Varied fruits, diverse flavors. One single bite will fill you with pleasure."
  },
  {
    "id": "mushroom-pie",
    "slug": "mushroom-pie",
    "name": "Mushroom Pie",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/mushroom-pie.webp",
    "imageStatus": "verified",
    "sellPrice": 500,
    "energy": 35,
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "A savory pie filled mainly with mushrooms, soft and full of flavor."
  },
  {
    "id": "onsen-egg",
    "slug": "onsen-egg",
    "name": "Onsen Egg",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/onsen-egg.webp",
    "imageStatus": "verified",
    "sellPrice": 130,
    "energy": 15,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "Naughty says it's the perfect onsen egg, while the Traveling Gourmet calls it the worst. In a wau, they both mean the same thing."
  },
  {
    "id": "orange-roll-cake",
    "slug": "orange-roll-cake",
    "name": "Orange Roll Cake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/orange-roll-cake.webp",
    "imageStatus": "verified",
    "sellPrice": 670,
    "energy": 48,
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "Orange and puffy. Is it inspired by the morning glow?"
  },
  {
    "id": "original-roll-cake",
    "slug": "original-roll-cake",
    "name": "Original Roll Cake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/original-roll-cake.webp",
    "imageStatus": "verified",
    "sellPrice": 550,
    "energy": 35,
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "Puffy cream topped with rainbow sugar, just like rainbow days in the town."
  },
  {
    "id": "oyster-mushroom-pie",
    "slug": "oyster-mushroom-pie",
    "name": "Oyster Mushroom Pie",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/oyster-mushroom-pie.webp",
    "imageStatus": "verified",
    "sellPrice": 500,
    "energy": 35,
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "An oyster mushroom pie with a salty and intense flavor—its deliciousness is almost impossible to measure!"
  },
  {
    "id": "penny-bun-pie",
    "slug": "penny-bun-pie",
    "name": "Penny Bun Pie",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/penny-bun-pie.webp",
    "imageStatus": "verified",
    "sellPrice": 500,
    "energy": 35,
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "With smoky notes of damp wood and a juicy flavor comparable to meat, it's a wonderful gift from the forest!"
  },
  {
    "id": "picnic-set",
    "slug": "picnic-set",
    "name": "Picnic Set",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/picnic-set.webp",
    "imageStatus": "verified",
    "sellPrice": 2260,
    "energy": 100,
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "It includes a variety of easy-to-carry, generous portions of food, perfect for sharing with friends in a scenic outdoor setting."
  },
  {
    "id": "pineapple-jam",
    "slug": "pineapple-jam",
    "name": "Pineapple Jam",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/pineapple-jam.webp",
    "imageStatus": "verified",
    "sellPrice": 280,
    "energy": 40,
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "Preserved pineapple's unique aroma and tropical flavor. Remember to close the lid snugly!"
  },
  {
    "id": "raspberry-jam",
    "slug": "raspberry-jam",
    "name": "Raspberry Jam",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/raspberry-jam.webp",
    "imageStatus": "verified",
    "sellPrice": 250,
    "energy": 30,
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "Red with a mildly tart flavor, leaving a lasting impression."
  },
  {
    "id": "red-roll-cake",
    "slug": "red-roll-cake",
    "name": "Red Roll Cake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/red-roll-cake.webp",
    "imageStatus": "verified",
    "sellPrice": 670,
    "energy": 48,
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "Strawberries and red sugar turn the cake Pink, just like the evening glow in the town."
  },
  {
    "id": "romaine-lettuce-taco",
    "slug": "romaine-lettuce-taco",
    "name": "Romaine Lettuce Taco",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/romaine-lettuce-taco.webp",
    "imageStatus": "verified",
    "sellPrice": 260,
    "energy": null,
    "tags": [
      "event",
      "dreamlight-cinematics",
      "recipe"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "Crisp, juicy leaves encase a hearty filling—healthy, refreshing, and guilt-free."
  },
  {
    "id": "rustic-ratatouille",
    "slug": "rustic-ratatouille",
    "name": "Rustic Ratatouille",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/rustic-ratatouille.webp",
    "imageStatus": "verified",
    "sellPrice": 640,
    "energy": 60,
    "tags": [
      "food",
      "dish",
      "vegetable"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "Common ingredients such as tomatoes, potatoes, and lettuce, after unique preparation and seasoning, become a richly textured and beautifully presented dish."
  },
  {
    "id": "salsa-wavy-potato-chips",
    "slug": "salsa-wavy-potato-chips",
    "name": "Salsa Wavy Potato Chips",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/salsa-wavy-potato-chips.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [
      "event",
      "dreamlight-cinematics",
      "recipe"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "Rippled potato chips paired with salsa—one bite, and gour heart Will soar!"
  },
  {
    "id": "savory-double-combo-bucket",
    "slug": "savory-double-combo-bucket",
    "name": "Savory Double Combo Bucket",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/savory-double-combo-bucket.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [
      "event",
      "dreamlight-cinematics",
      "recipe"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "Salted Duo, double the flavor!"
  },
  {
    "id": "savory-popcorn-bucket",
    "slug": "savory-popcorn-bucket",
    "name": "Savory Popcorn Bucket",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/savory-popcorn-bucket.webp",
    "imageStatus": "verified",
    "sellPrice": 900,
    "energy": null,
    "tags": [
      "event",
      "dreamlight-cinematics",
      "recipe"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "Bursting with a rich buttery fragrance, the popcorn is crispy and savory."
  },
  {
    "id": "seafood-pizza",
    "slug": "seafood-pizza",
    "name": "Seafood Pizza",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/seafood-pizza.webp",
    "imageStatus": "verified",
    "sellPrice": 780,
    "energy": 70,
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "Seafood paired with stretchy melted cheese delivers a rich, ocean-flavored taste."
  },
  {
    "id": "seafood-risotto",
    "slug": "seafood-risotto",
    "name": "Seafood Risotto",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/seafood-risotto.webp",
    "imageStatus": "verified",
    "sellPrice": 490,
    "energy": 40,
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "Rice that is both soft and crispy, accompanied by fresh seafood."
  },
  {
    "id": "shiitake-pie",
    "slug": "shiitake-pie",
    "name": "Shiitake Pie",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/shiitake-pie.webp",
    "imageStatus": "verified",
    "sellPrice": 500,
    "energy": 35,
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "A savory pie filled mainly with mushrooms, soft and full of flavor."
  },
  {
    "id": "smoked-fish-bagel",
    "slug": "smoked-fish-bagel",
    "name": "Smoked Fish Bagel",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/smoked-fish-bagel.webp",
    "imageStatus": "verified",
    "sellPrice": 520,
    "energy": 50,
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "Mild smoked salmon, firm and flavorful bagel—a satisfying combination."
  },
  {
    "id": "tiramisu",
    "slug": "tiramisu",
    "name": "Tiramisu",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/tiramisu.webp",
    "imageStatus": "verified",
    "sellPrice": 530,
    "energy": 65,
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "A creative dessert, ladyfinger cookies instead of sponge cake."
  },
  {
    "id": "tomato-sauce",
    "slug": "tomato-sauce",
    "name": "Tomato Sauce",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/tomato-sauce.webp",
    "imageStatus": "verified",
    "sellPrice": 180,
    "energy": 35,
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "Richly tangy. A must-have for seafood pizza."
  },
  {
    "id": "violet-roll-cake",
    "slug": "violet-roll-cake",
    "name": "Violet Roll Cake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/violet-roll-cake.webp",
    "imageStatus": "verified",
    "sellPrice": 570,
    "energy": 48,
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "Un pastel morado como niebla suave. Seguro te dará dulces sueños."
  },
  {
    "id": "wild-bracken-celtuce-taco",
    "slug": "wild-bracken-celtuce-taco",
    "name": "Wild Bracken Celtuce Taco",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/wild-bracken-celtuce-taco.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [
      "event",
      "dreamlight-cinematics",
      "recipe"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "A creative dish that blends rustic flavor with modern light cuisine—packed with greens for a healthy bite!"
  },
  {
    "id": "wild-burdock-celtuce-taco",
    "slug": "wild-burdock-celtuce-taco",
    "name": "Wild Burdock Celtuce Taco",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/wild-burdock-celtuce-taco.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [
      "event",
      "dreamlight-cinematics",
      "recipe"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "Hearty, earthy notes with cooling, anti-inflammatory properties. Perfect if you've been feeling a bit \"heated\" lately."
  },
  {
    "id": "wild-garlic-mustard-celtuce-taco",
    "slug": "wild-garlic-mustard-celtuce-taco",
    "name": "Wild Garlic Mustard Celtuce Taco",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/wild-garlic-mustard-celtuce-taco.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [
      "event",
      "dreamlight-cinematics",
      "recipe"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "Beneath its fresh green exterior rages a \"spicy storm\" that sweeps across gour taste buds."
  },
  {
    "id": "wild-mustard-greens-celtuce-taco",
    "slug": "wild-mustard-greens-celtuce-taco",
    "name": "Wild Mustard Greens Celtuce Taco",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/wild-mustard-greens-celtuce-taco.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [
      "event",
      "dreamlight-cinematics",
      "recipe"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "A flavor-packed \"wild\" taco with rich lagers of texture, best enjoyed with a tangy sauce."
  },
  {
    "id": "wild-vegetable-celtuce-taco",
    "slug": "wild-vegetable-celtuce-taco",
    "name": "Wild Vegetable Celtuce Taco",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/wild-vegetable-celtuce-taco.webp",
    "imageStatus": "verified",
    "sellPrice": 330,
    "energy": null,
    "tags": [
      "event",
      "dreamlight-cinematics",
      "recipe"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "Celtuce taco filled with fresh wild greens, the top choice for vegetarians."
  },
  {
    "id": "winter-frost-season-apple-frosted-pancake",
    "slug": "winter-frost-season-apple-frosted-pancake",
    "name": "Winter Frost Season: Apple Frosted Pancake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/winter-frost-season-apple-frosted-pancake.webp",
    "imageStatus": "verified",
    "sellPrice": 360,
    "energy": 25,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null
  },
  {
    "id": "winter-frost-season-aurora-banquet",
    "slug": "winter-frost-season-aurora-banquet",
    "name": "Winter Frost Season: Aurora Banquet",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/winter-frost-season-aurora-banquet.webp",
    "imageStatus": "verified",
    "sellPrice": 1630,
    "energy": 40,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null
  },
  {
    "id": "winter-frost-season-blueberry-frosted-pancake",
    "slug": "winter-frost-season-blueberry-frosted-pancake",
    "name": "Winter Frost Season: Blueberry Frosted Pancake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/winter-frost-season-blueberry-frosted-pancake.webp",
    "imageStatus": "verified",
    "sellPrice": 330,
    "energy": 25,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null
  },
  {
    "id": "winter-frost-season-creamy-white-radish-soup",
    "slug": "winter-frost-season-creamy-white-radish-soup",
    "name": "Winter Frost Season: Creamy White Radish Soup",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/winter-frost-season-creamy-white-radish-soup.webp",
    "imageStatus": "verified",
    "sellPrice": 340,
    "energy": 25,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null
  },
  {
    "id": "winter-frost-season-iced-coffee",
    "slug": "winter-frost-season-iced-coffee",
    "name": "Winter Frost Season: Iced Coffee",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/winter-frost-season-iced-coffee.webp",
    "imageStatus": "verified",
    "sellPrice": 280,
    "energy": 20,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null
  },
  {
    "id": "winter-frost-season-iced-latte",
    "slug": "winter-frost-season-iced-latte",
    "name": "Winter Frost Season: Iced Latte",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/winter-frost-season-iced-latte.webp",
    "imageStatus": "verified",
    "sellPrice": 280,
    "energy": 20,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null
  },
  {
    "id": "winter-frost-season-mandarin-frosted-pancake",
    "slug": "winter-frost-season-mandarin-frosted-pancake",
    "name": "Winter Frost Season: Mandarin Frosted Pancake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/winter-frost-season-mandarin-frosted-pancake.webp",
    "imageStatus": "verified",
    "sellPrice": 360,
    "energy": 25,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null
  },
  {
    "id": "winter-frost-season-original-frosted-pancake",
    "slug": "winter-frost-season-original-frosted-pancake",
    "name": "Winter Frost Season: Original Frosted Pancake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/winter-frost-season-original-frosted-pancake.webp",
    "imageStatus": "verified",
    "sellPrice": 330,
    "energy": 25,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null
  },
  {
    "id": "winter-frost-season-raspberry-frosted-pancake",
    "slug": "winter-frost-season-raspberry-frosted-pancake",
    "name": "Winter Frost Season: Raspberry Frosted Pancake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/winter-frost-season-raspberry-frosted-pancake.webp",
    "imageStatus": "verified",
    "sellPrice": 350,
    "energy": 25,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null
  },
  {
    "id": "winter-frost-season-steak-w-mashed-white-radish",
    "slug": "winter-frost-season-steak-w-mashed-white-radish",
    "name": "Winter Frost Season: Steak w/ Mashed White Radish",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/winter-frost-season-steak-w-mashed-white-radish.webp",
    "imageStatus": "verified",
    "sellPrice": 630,
    "energy": 40,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null
  },
  {
    "id": "yellow-roll-cake",
    "slug": "yellow-roll-cake",
    "name": "Yellow Roll Cake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/yellow-roll-cake.webp",
    "imageStatus": "verified",
    "sellPrice": 670,
    "energy": 48,
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts",
      "supabase:items(type=DISH)"
    ],
    "notes": null,
    "description": "Crema y pastel amarillos, con un sabor tan cálido como el sol."
  },
  {
    "id": "egg",
    "slug": "egg",
    "name": "Egg",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/egg.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [
      "ingredient",
      "cooking"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Egg is a basic cooking staple made of a yolk and white enclosed by a shell. In Heartopia it functions as a flexible recipe ingredient rather than an event-specific specialty item."
  },
  {
    "id": "butter",
    "slug": "butter",
    "name": "Butter",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/butter.webp",
    "imageStatus": "verified",
    "sellPrice": 75,
    "energy": null,
    "tags": [
      "ingredient",
      "cooking"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Butter is a dairy fat produced by churning cream, valued for the richness it adds to cooked and baked foods. Heartopia uses it as one of the ordinary pantry-style ingredients in its recipe system."
  },
  {
    "id": "meat",
    "slug": "meat",
    "name": "Meat",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/meat.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [
      "ingredient",
      "cooking"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Meat is Heartopia's general savory protein ingredient rather than a named cut from one specific animal. It fills the role of a versatile base for hearty dishes that need a meat component."
  },
  {
    "id": "cooking-oil",
    "slug": "cooking-oil",
    "name": "Cooking Oil",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/cooking-oil.webp",
    "imageStatus": "verified",
    "sellPrice": 50,
    "energy": null,
    "tags": [
      "ingredient",
      "cooking"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Cooking Oil is an edible fat used to transfer heat and add richness during food preparation. In Heartopia it acts as a general-purpose kitchen ingredient rather than a finished dish of its own."
  },
  {
    "id": "any-failed-dish",
    "slug": "any-failed-dish",
    "name": "Any Failed Dish",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/any-failed-dish.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "This entry represents the result of an unsuccessful cooking attempt. Missing Heartopia's heat-adjustment timing can ruin a recipe, producing a failed or bizarre dish instead of the intended food."
  },
  {
    "id": "milk",
    "slug": "milk",
    "name": "Milk",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/milk.webp",
    "imageStatus": "verified",
    "sellPrice": 26,
    "energy": 10,
    "tags": [
      "ingredient",
      "cooking"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Milk is a familiar dairy ingredient with a mild, creamy profile. Heartopia treats it as a pantry staple that can support both drinks and richer cooked or baked recipes."
  },
  {
    "id": "blue-sugar",
    "slug": "blue-sugar",
    "name": "Blue Sugar",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/blue-sugar.webp",
    "imageStatus": "verified",
    "sellPrice": 75,
    "energy": null,
    "tags": [
      "sweet",
      "crafted"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Blue Sugar is one of Doris's limited Rainbow Event ingredients. Its practical identity comes from the event's color-matched baking system, where it produces the blue version of the Roll Cake."
  },
  {
    "id": "springday-brown-sugar",
    "slug": "springday-brown-sugar",
    "name": "Springday Brown Sugar",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/springday-brown-sugar.webp",
    "imageStatus": "verified",
    "sellPrice": 25,
    "energy": null,
    "tags": [
      "event",
      "dreamlight-cinematics",
      "vendor-item"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Springday Brown Sugar belongs to Dreamlight Cinematics' temporary pantry rather than the permanent ingredient pool. The festival uses it in theater-themed foods such as caramel popcorn and seasonal tea preparations."
  },
  {
    "id": "cheese",
    "slug": "cheese",
    "name": "Cheese",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/cheese.webp",
    "imageStatus": "verified",
    "sellPrice": 50,
    "energy": null,
    "tags": [
      "ingredient",
      "cooking"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Cheese is a dairy food made by coagulating milk and separating the curds. In Heartopia it serves as a savory cooking ingredient that adds a richer, more substantial component to several dishes."
  },
  {
    "id": "coffee-beans",
    "slug": "coffee-beans",
    "name": "Coffee Beans",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/coffee-beans.webp",
    "imageStatus": "verified",
    "sellPrice": 1,
    "energy": null,
    "tags": [
      "ingredient",
      "cooking"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Coffee Beans are the roasted seeds used to brew coffee. Heartopia extends them beyond a single drink, using the ingredient across coffee, latte and dessert-style recipes."
  },
  {
    "id": "sweet-duo-bucket",
    "slug": "sweet-duo-bucket",
    "name": "Sweet Duo Bucket",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/sweet-duo-bucket.webp",
    "imageStatus": "verified",
    "sellPrice": 1150,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)"
    ],
    "notes": "Classified by id-pattern heuristic — verify kind/name/image manually.",
    "description": "Dreamlight Cinematics builds this item by combining two prepared theater snacks, then uses the result again inside the larger Colorful Movie Combo. It functions as a middle step in the festival's layered recipe chain."
  },
  {
    "id": "green-sugar",
    "slug": "green-sugar",
    "name": "Green Sugar",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/green-sugar.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [
      "sweet",
      "crafted"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "The Rainbow Event gives Green Sugar a narrow but distinctive purpose: Doris supplies it during the event, and bakers can use the color to turn the standard Roll Cake into its green variant."
  },
  {
    "id": "indigo-sugar",
    "slug": "indigo-sugar",
    "name": "Indigo Sugar",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/indigo-sugar.webp",
    "imageStatus": "verified",
    "sellPrice": 75,
    "energy": null,
    "tags": [
      "sweet",
      "crafted"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Indigo Sugar belongs to the temporary set of Rainbow Event sweeteners sold by Doris. Its color matters in the kitchen because using it on the event cake path produces the corresponding indigo Roll Cake."
  },
  {
    "id": "pasteurized-egg",
    "slug": "pasteurized-egg",
    "name": "Pasteurized Egg",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [
      "posteurized-egg"
    ],
    "image": "/icons/ingredient/pasteurized-egg.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Winter Frost gives Pasteurized Egg a specialized job that normal eggs do not share. It is the required egg for the seasonal Onsen Egg, which is cooked using a basket in the hot spring rather than an ordinary stove."
  },
  {
    "id": "orange-sugar",
    "slug": "orange-sugar",
    "name": "Orange Sugar",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/orange-sugar.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [
      "sweet",
      "crafted"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Orange Sugar is a Rainbow Event baking ingredient rather than everyday sugar. During the event, Doris provides the colored sweetener used to create the orange Roll Cake variant."
  },
  {
    "id": "red-sugar",
    "slug": "red-sugar",
    "name": "Red Sugar",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/red-sugar.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [
      "sweet",
      "crafted"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Red Sugar comes from the Rainbow Event's temporary ingredient selection. Its main distinguishing use is color-specific baking, where it transforms the Roll Cake recipe into the red version."
  },
  {
    "id": "salsa-sauce",
    "slug": "salsa-sauce",
    "name": "Salsa Sauce",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/salsa-sauce.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [
      "event",
      "dreamlight-cinematics",
      "vendor-item"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Salsa Sauce acts as a shared component across Dreamlight Cinematics cooking. The festival routes it into both the romaine taco branch and its wavy potato-chip snack line."
  },
  {
    "id": "violet-sugar",
    "slug": "violet-sugar",
    "name": "Violet Sugar",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/violet-sugar.webp",
    "imageStatus": "verified",
    "sellPrice": 75,
    "energy": null,
    "tags": [
      "sweet",
      "crafted"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Violet Sugar is part of Doris's event-only colored sugar assortment. Using that shade in the Rainbow Event baking line gives the Roll Cake its violet variant instead of the standard finish."
  },
  {
    "id": "frosted",
    "slug": "frosted",
    "name": "Frosted",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/frosted.webp",
    "imageStatus": "verified",
    "sellPrice": 25,
    "energy": null,
    "tags": [
      "ingredient",
      "cooking"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Frosted is tied specifically to Winter Frost's seasonal kitchen. The ingredient appears repeatedly in the event menu, including chilled drinks and the various Frosted Pancake preparations."
  },
  {
    "id": "yellow-sugar",
    "slug": "yellow-sugar",
    "name": "Yellow Sugar",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/yellow-sugar.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [
      "sweet",
      "crafted"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Yellow Sugar is one of the temporary colored sweeteners associated with the Rainbow Event. Its dedicated baking use is the yellow Roll Cake, giving the ingredient a purpose beyond ordinary sweetness."
  },
  {
    "id": "black-motorcycle",
    "slug": "black-motorcycle",
    "name": "Black Motorcycle",
    "kind": "vehicle",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/vehicle/black-motorcycle.webp",
    "imageStatus": "verified",
    "sellPrice": 2000,
    "energy": null,
    "tags": [
      "vehicle"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Black Motorcycle shares the normal motorcycle performance tier, so choosing it is mainly about appearance. It does not gain extra speed simply from being a paid color alternative to the starter bike."
  },
  {
    "id": "black-sedan",
    "slug": "black-sedan",
    "name": "Black Sedan",
    "kind": "vehicle",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/vehicle/black-sedan.webp",
    "imageStatus": "verified",
    "sellPrice": 16250,
    "energy": null,
    "tags": [
      "vehicle"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Black Sedan trades the motorcycle's solo focus for a two-seat layout while remaining in Heartopia's fast vehicle class. Its practical advantage is letting another player ride along without dropping to a slower travel option."
  },
  {
    "id": "blue-sedan",
    "slug": "blue-sedan",
    "name": "Blue Sedan",
    "kind": "vehicle",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/vehicle/blue-sedan.webp",
    "imageStatus": "verified",
    "sellPrice": 16250,
    "energy": null,
    "tags": [
      "vehicle"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "The Blue Sedan combines fast overland travel with room for a second player. Color is cosmetic; the meaningful difference from a motorcycle is the passenger seat and sedan-level speed."
  },
  {
    "id": "green-motorcycle",
    "slug": "green-motorcycle",
    "name": "Green Motorcycle",
    "kind": "vehicle",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/vehicle/green-motorcycle.webp",
    "imageStatus": "verified",
    "sellPrice": 2000,
    "energy": null,
    "tags": [
      "vehicle"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Andrew's story progression awards the Green Motorcycle as Heartopia's baseline motorbike. Later color versions remain in the same ordinary speed class, so changing bikes mainly changes style rather than travel performance."
  },
  {
    "id": "pink-motorcycle",
    "slug": "pink-motorcycle",
    "name": "Pink Motorcycle",
    "kind": "vehicle",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/vehicle/pink-motorcycle.webp",
    "imageStatus": "verified",
    "sellPrice": 2000,
    "energy": null,
    "tags": [
      "vehicle"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Pink Motorcycle remains in Heartopia's ordinary motorbike performance class instead of becoming a faster upgrade. Choosing it is therefore about the pink styling, not gaining extra speed over the starter model."
  },
  {
    "id": "pink-sedan",
    "slug": "pink-sedan",
    "name": "Pink Sedan",
    "kind": "vehicle",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/vehicle/pink-sedan.webp",
    "imageStatus": "verified",
    "sellPrice": 16250,
    "energy": null,
    "tags": [
      "vehicle"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Pink Sedan sits in Heartopia's fast two-person vehicle category. Compared with motorcycles, the useful change is being able to transport a passenger while retaining strong travel speed."
  },
  {
    "id": "red-motorcycle",
    "slug": "red-motorcycle",
    "name": "Red Motorcycle",
    "kind": "vehicle",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/vehicle/red-motorcycle.webp",
    "imageStatus": "verified",
    "sellPrice": 2000,
    "energy": null,
    "tags": [
      "vehicle"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Red Motorcycle is a cosmetic alternative within the regular motorcycle tier. Its movement performance matches the other standard motorcycles, so the red finish is the feature that distinguishes it."
  },
  {
    "id": "simplistic-mountain-bike",
    "slug": "simplistic-mountain-bike",
    "name": "Simplistic Mountain Bike",
    "kind": "vehicle",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/vehicle/simplistic-mountain-bike.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [
      "vehicle"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Simplistic Mountain Bike stands apart because it is the bicycle entry in Heartopia's vehicle roster. Despite the different frame and pedal-bike aesthetic, it still occupies the game's standard travel-speed tier."
  },
  {
    "id": "white-convertible",
    "slug": "white-convertible",
    "name": "White Convertible",
    "kind": "vehicle",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/vehicle/white-convertible.webp",
    "imageStatus": "verified",
    "sellPrice": 40500,
    "energy": null,
    "tags": [
      "vehicle"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "White Convertible combines seating for two with the highest speed available among Heartopia's non-premium vehicles. That makes it useful both for rapid travel and for carrying another player."
  },
  {
    "id": "white-motorcycle",
    "slug": "white-motorcycle",
    "name": "White Motorcycle",
    "kind": "vehicle",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/vehicle/white-motorcycle.webp",
    "imageStatus": "verified",
    "sellPrice": 2000,
    "energy": null,
    "tags": [
      "vehicle"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "White Motorcycle changes the visual theme without changing the underlying motorcycle tier. Its speed stays aligned with the other standard bikes, making the white bodywork the meaningful distinction."
  },
  {
    "id": "yellow-sedan",
    "slug": "yellow-sedan",
    "name": "Yellow Sedan",
    "kind": "vehicle",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/vehicle/yellow-sedan.webp",
    "imageStatus": "verified",
    "sellPrice": 16250,
    "energy": null,
    "tags": [
      "vehicle"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Yellow Sedan is a fast vehicle built for two riders. Its practical value comes from combining sedan speed with a passenger seat, while the yellow finish is simply the chosen cosmetic variant."
  },
  {
    "id": "anthurium-seeds",
    "slug": "anthurium-seeds",
    "name": "Anthurium Seeds",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": null,
    "imageStatus": "missing",
    "sellPrice": 55,
    "energy": null,
    "tags": [
      "seed",
      "flower"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Anthurium Seeds establish the base plant for the Anthurium breeding family. Later crosses remain within Anthurium and depend on compatible star ratings; the visible flower color is not the formula that determines pairing."
  },
  {
    "id": "calla-lily-seeds",
    "slug": "calla-lily-seeds",
    "name": "Calla Lily Seeds",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/white-calla-lily-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 30,
    "energy": null,
    "tags": [
      "seed",
      "flower"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Calla Lily Seeds give you the starting plant for that flower family. Once grown, breeding is handled through Calla Lily parents with suitable star levels rather than by combining particular colors.",
    "isVariantGroup": true
  },
  {
    "id": "carnation-seeds",
    "slug": "carnation-seeds",
    "name": "Carnation Seeds",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/white-carnation-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 30,
    "energy": null,
    "tags": [
      "seed",
      "flower"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Carnation Seeds are the entry point to raising Carnations before crossbreeding begins. The breeding system keeps pairings inside the same species and checks star compatibility instead of treating color as genetics.",
    "isVariantGroup": true
  },
  {
    "id": "corn-poppy-seeds",
    "slug": "corn-poppy-seeds",
    "name": "Corn Poppy Seeds",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/white-corn-poppy-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 55,
    "energy": null,
    "tags": [
      "seed",
      "flower"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Planting Corn Poppy Seeds establishes the basic flower used for that species' later breeding path. Future crosses compare Corn Poppy parents by star rank, while petal colors themselves are not treated as a mixing recipe.",
    "isVariantGroup": true
  },
  {
    "id": "cranesbill-seeds",
    "slug": "cranesbill-seeds",
    "name": "Cranesbill Seeds",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/black-cranesbill-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 30,
    "energy": null,
    "tags": [
      "seed",
      "flower"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Cranesbill Seeds provide the initial Cranesbill plant for later flower breeding. Any cross still needs another Cranesbill at a compatible star level, with watering helping the chance of a successful seed.",
    "isVariantGroup": true
  },
  {
    "id": "daisy-seeds",
    "slug": "daisy-seeds",
    "name": "Daisy Seeds",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/white-daisy-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 30,
    "energy": null,
    "tags": [
      "seed",
      "flower"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Daisy Seeds create the starting Daisy plants used before the breeding progression branches into variants. Parent color is not the deciding input; Heartopia instead checks Daisy identity and compatible star ratings.",
    "isVariantGroup": true
  },
  {
    "id": "highland-poppy-seeds",
    "slug": "highland-poppy-seeds",
    "name": "Highland Poppy Seeds",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/white-highland-poppy-seed.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "supabase-lookup:scripts/_supabase-lookups/other-items.json"
    ],
    "notes": null,
    "description": "Highland Poppy Seeds begin the Highland Poppy breeding track. After the flowers mature, progress comes from pairing compatible star-ranked Highland Poppies rather than following a fixed color-mixing chart.",
    "isVariantGroup": true
  },
  {
    "id": "hyacinth-seeds",
    "slug": "hyacinth-seeds",
    "name": "Hyacinth Seeds",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/hyacinth-seeds.webp",
    "imageStatus": "verified",
    "sellPrice": 30,
    "energy": null,
    "tags": [
      "seed",
      "flower"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Hyacinth Seeds supply the base Hyacinth needed to enter that flower's breeding family. Crosses stay species-specific and depend on star-level compatibility, with watering improving the odds."
  },
  {
    "id": "laceleaf-seeds",
    "slug": "laceleaf-seeds",
    "name": "Laceleaf Seeds",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/white-laceleaft-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 30,
    "energy": null,
    "tags": [
      "seed",
      "flower"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Laceleaf Seeds are the starting material for growing Laceleaf before any advanced variants are bred. The later crossbreeding check uses flower family and nearby star ranks instead of parent colors.",
    "isVariantGroup": true
  },
  {
    "id": "lily-seeds",
    "slug": "lily-seeds",
    "name": "Lily Seeds",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": null,
    "imageStatus": "missing",
    "sellPrice": 30,
    "energy": null,
    "tags": [
      "seed",
      "flower"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Lily Seeds start the ordinary Lily line. Once mature flowers are available, new breeding attempts require another Lily with a compatible star rating; matching or mixing colors is not what controls the cross."
  },
  {
    "id": "morning-glory-seeds",
    "slug": "morning-glory-seeds",
    "name": "Morning Glory Seeds",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/white-morning-glory-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 30,
    "energy": null,
    "tags": [
      "seed",
      "flower"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Morning Glory Seeds establish the base flower used for that species' breeding progression. Heartopia keeps later crosses within Morning Glory and judges compatibility by star rank rather than hue.",
    "isVariantGroup": true
  },
  {
    "id": "moth-orchid-seeds",
    "slug": "moth-orchid-seeds",
    "name": "Moth Orchid Seeds",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/moth-orchid-seeds.webp",
    "imageStatus": "verified",
    "sellPrice": 30,
    "energy": null,
    "tags": [
      "seed",
      "flower"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Moth Orchid Seeds let players grow the foundational Moth Orchid before pursuing bred variants. Subsequent crosses use another Moth Orchid at a suitable star level, while flower color itself is ignored."
  },
  {
    "id": "pansy-seeds",
    "slug": "pansy-seeds",
    "name": "Pansy Seeds",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/red-pansy-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 30,
    "energy": null,
    "tags": [
      "seed",
      "flower"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Pansy Seeds form the starting point of the Pansy breeding family. Developing later variants means pairing Pansies whose star ratings are compatible, not reproducing a named color combination.",
    "isVariantGroup": true
  },
  {
    "id": "pink-daisy-seed",
    "slug": "pink-daisy-seed",
    "name": "Pink Daisy Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/pink-daisy-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 25,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/seed/pink-daisy-seed.webp",
      "variant-of:daisy-seeds"
    ],
    "notes": null,
    "description": "Pink Daisy Seed directly represents a colored Daisy starting point, but the pink shade does not become a breeding rule. After growth, successful pairings are still decided by Daisy family membership and suitable star ranks.",
    "flowerSpecies": "daisy-seeds",
    "flowerColor": "pink",
    "variantOf": "daisy-seeds"
  },
  {
    "id": "red-calla-lily-seed",
    "slug": "red-calla-lily-seed",
    "name": "Red Calla Lily Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/red-calla-lily-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 45,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/seed/red-calla-lily-seed.webp",
      "variant-of:calla-lily-seeds"
    ],
    "notes": null,
    "description": "Red Calla Lily Seed gives a color-specific Calla Lily, yet future breeding does not ask players to recreate the red hue. The game continues to use Calla Lily family membership and star-level compatibility.",
    "flowerSpecies": "calla-lily-seeds",
    "flowerColor": "red",
    "variantOf": "calla-lily-seeds"
  },
  {
    "id": "red-carnation-seed",
    "slug": "red-carnation-seed",
    "name": "Red Carnation Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/red-carnation-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 60,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/seed/red-carnation-seed.webp",
      "variant-of:carnation-seeds"
    ],
    "notes": null,
    "description": "Growing Red Carnation Seed produces a colored member of the Carnation family. For later crosses, the red appearance is cosmetic to the calculation; compatible Carnation star ranks are what matter.",
    "flowerSpecies": "carnation-seeds",
    "flowerColor": "red",
    "variantOf": "carnation-seeds"
  },
  {
    "id": "red-corn-poppy-seed",
    "slug": "red-corn-poppy-seed",
    "name": "Red Corn Poppy Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/red-corn-poppy-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 30,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/seed/red-corn-poppy-seed.webp",
      "variant-of:corn-poppy-seeds"
    ],
    "notes": null,
    "description": "Red Corn Poppy Seed supplies a specific color form without changing how Corn Poppy breeding works. Later pairings still rely on two Corn Poppies with suitable star ratings rather than color recipes.",
    "flowerSpecies": "corn-poppy-seeds",
    "flowerColor": "red",
    "variantOf": "corn-poppy-seeds"
  },
  {
    "id": "red-daisy-seed",
    "slug": "red-daisy-seed",
    "name": "Red Daisy Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/red-daisy-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 15,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/seed/red-daisy-seed.webp",
      "variant-of:daisy-seeds"
    ],
    "notes": null,
    "description": "Red Daisy Seed is useful for starting that catalog color directly, but Heartopia does not treat red as a genetic input. Any subsequent breeding follows normal Daisy star-compatibility rules.",
    "flowerSpecies": "daisy-seeds",
    "flowerColor": "red",
    "variantOf": "daisy-seeds"
  },
  {
    "id": "red-highland-poppy-seed",
    "slug": "red-highland-poppy-seed",
    "name": "Red Highland Poppy Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/red-highland-poppy-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 15,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/seed/red-highland-poppy-seed.webp",
      "variant-of:highland-poppy-seeds"
    ],
    "notes": null,
    "description": "Red Highland Poppy Seed starts the red variant as a plantable flower. Once it is grown, breeding remains a Highland Poppy system based on compatible star levels instead of the visible red color.",
    "flowerSpecies": "highland-poppy-seeds",
    "flowerColor": "red",
    "variantOf": "highland-poppy-seeds"
  },
  {
    "id": "red-laceleaft-seed",
    "slug": "red-laceleaft-seed",
    "name": "Red Laceleaf Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/red-laceleaft-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 30,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/seed/red-laceleaft-seed.webp",
      "variant-of:laceleaf-seeds"
    ],
    "notes": null,
    "description": "Red Laceleaf Seed provides a red Laceleaf directly, while later crosses still ignore hue. Heartopia keeps breeding inside the Laceleaf family and decides compatibility from the parents' star ratings.",
    "flowerSpecies": "laceleaf-seeds",
    "flowerColor": "red",
    "variantOf": "laceleaf-seeds"
  },
  {
    "id": "red-morning-glory-seed",
    "slug": "red-morning-glory-seed",
    "name": "Red Morning Glory Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/red-morning-glory-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 45,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/seed/red-morning-glory-seed.webp",
      "variant-of:morning-glory-seeds"
    ],
    "notes": null,
    "description": "Red Morning Glory Seed gives players that color form without creating a special breeding recipe. Once mature, it can only cross within Morning Glory, and the important compatibility check comes from the parents' star ranks.",
    "flowerSpecies": "morning-glory-seeds",
    "flowerColor": "red",
    "variantOf": "morning-glory-seeds"
  },
  {
    "id": "red-pansy-seed",
    "slug": "red-pansy-seed",
    "name": "Red Pansy Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/red-pansy-seed.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/seed/red-pansy-seed.webp",
      "variant-of:pansy-seeds"
    ],
    "notes": null,
    "description": "Red Pansy Seed starts a red Pansy, but the color itself has no special role in later crossing. Pansy breeding continues to depend on using the same species with suitable star ratings.",
    "flowerSpecies": "pansy-seeds",
    "flowerColor": "red",
    "variantOf": "pansy-seeds"
  },
  {
    "id": "romaine-lettuce-seed",
    "slug": "romaine-lettuce-seed",
    "name": "Romaine Lettuce Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/romaine-lettuce-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 5,
    "energy": null,
    "tags": [
      "event",
      "dreamlight-cinematics",
      "crop"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Romaine Lettuce Seed belonged to Dreamlight Cinematics' temporary gardening loop. Event guides report a very short growing cycle of about fifteen minutes, which suited repeated festival cooking."
  },
  {
    "id": "rose-seeds",
    "slug": "rose-seeds",
    "name": "Rose Seeds",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/black-rose-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 30,
    "energy": null,
    "tags": [
      "seed",
      "flower"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Rose Seeds create the base plants needed to enter the Rose breeding progression. Once flowers mature, pairings stay within Rose and rely on compatible star ratings instead of a color-combination formula.",
    "isVariantGroup": true
  },
  {
    "id": "tulip-seeds",
    "slug": "tulip-seeds",
    "name": "Tulip Seeds",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/black-tulip-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 30,
    "energy": null,
    "tags": [
      "seed",
      "flower"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Tulip Seeds begin the Tulip flower line. Later variants come from star-compatible Tulip parents, while the game does not use the parents' displayed colors as the breeding input.",
    "isVariantGroup": true
  },
  {
    "id": "avocado-seed",
    "slug": "avocado-seed",
    "name": "Avocado Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/avocado-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 90,
    "energy": null,
    "tags": [
      "seed",
      "crop",
      "farming"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Avocado Seed is the planting form used to grow an avocado plant. The resulting crop produces the familiar creamy green fruit, turning this seed into the starting point for replenishing Avocado through gardening."
  },
  {
    "id": "cacao-seed",
    "slug": "cacao-seed",
    "name": "Cacao Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": null,
    "imageStatus": "missing",
    "sellPrice": null,
    "energy": null,
    "tags": [
      "seed",
      "crop",
      "farming"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Cacao Seed starts the crop that eventually produces cacao pods and beans, the raw material associated with cocoa and chocolate. In Heartopia it is simply the garden-side starting point for that ingredient."
  },
  {
    "id": "carrot-seed",
    "slug": "carrot-seed",
    "name": "Carrot Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/carrot-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 25,
    "energy": null,
    "tags": [
      "seed",
      "crop",
      "farming"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Carrot Seed is planted to produce the familiar orange root vegetable. It represents the beginning of the gardening cycle for Carrot before the harvested crop moves into food or other uses."
  },
  {
    "id": "corn-seed",
    "slug": "corn-seed",
    "name": "Corn Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/corn-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 85,
    "energy": 1,
    "tags": [
      "seed",
      "crop",
      "farming"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Corn Seed starts a maize plant that develops ears filled with edible kernels. In Heartopia it is the basic planting item behind a crop known for dependable, generous harvests."
  },
  {
    "id": "eggplant-seed",
    "slug": "eggplant-seed",
    "name": "Eggplant Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/eggplant-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 67,
    "energy": null,
    "tags": [
      "seed",
      "crop",
      "farming"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Eggplant Seed grows into the purple-skinned vegetable used in Heartopia cooking. Planting the seed is the garden stage that comes before harvesting Eggplant for its flavor-absorbing culinary role."
  },
  {
    "id": "auto-bird-whistle",
    "slug": "auto-bird-whistle",
    "name": "Auto Bird Whistle",
    "kind": "tool",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/tool/auto-bird-whistle.webp",
    "imageStatus": "verified",
    "sellPrice": 1,
    "energy": null,
    "tags": [
      "tool",
      "birdwatching"
    ],
    "sourceRefs": [
      "icon-asset:apps/web-vite/public/icons/tool/auto-bird-whistle.webp"
    ],
    "notes": null,
    "description": "Auto Bird Whistle reduces the time spent searching blindly for birdwatching targets. Activating it prompts nearby birds to move and places markers, making subjects easier to find before taking Scanner photos."
  },
  {
    "id": "axe",
    "slug": "axe",
    "name": "Axe",
    "kind": "tool",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/tool/axe.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [
      "tool",
      "gathering"
    ],
    "sourceRefs": [
      "icon-asset:apps/web-vite/public/icons/tool/axe.webp"
    ],
    "notes": null,
    "description": "Axe is the straightforward chopping tool used on trees and other wood sources. Its purpose is functional rather than decorative: it converts suitable vegetation into timber-type gathering materials."
  },
  {
    "id": "bait",
    "slug": "bait",
    "name": "Bait",
    "kind": "tool",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/tool/bait.webp",
    "imageStatus": "verified",
    "sellPrice": 50,
    "energy": null,
    "tags": [
      "tool",
      "fishing"
    ],
    "sourceRefs": [
      "icon-asset:apps/web-vite/public/icons/tool/bait.webp"
    ],
    "notes": null,
    "description": "Three Apples can be converted into fishing Bait at the crafting bench. Using it draws fish toward the player, giving a common forage fruit a practical way to shorten otherwise slower fishing sessions."
  },
  {
    "id": "camouflage-bush",
    "slug": "camouflage-bush",
    "name": "Camouflage Bush",
    "kind": "tool",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/tool/camouflage-bush.webp",
    "imageStatus": "verified",
    "sellPrice": 1,
    "energy": null,
    "tags": [
      "tool",
      "birdwatching"
    ],
    "sourceRefs": [
      "icon-asset:apps/web-vite/public/icons/tool/camouflage-bush.webp"
    ],
    "notes": null,
    "description": "Camouflage Bush supports close-range birdwatching by helping the player approach without immediately disturbing the subject. It becomes especially useful when ordinary movement would make a photo target flee."
  },
  {
    "id": "crafty-repair-kit",
    "slug": "crafty-repair-kit",
    "name": "Crafty Repair Kit",
    "kind": "tool",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/tool/crafty-repair-kit.webp",
    "imageStatus": "verified",
    "sellPrice": 7250,
    "energy": null,
    "tags": [
      "tool",
      "repair"
    ],
    "sourceRefs": [
      "icon-asset:apps/web-vite/public/icons/tool/crafty-repair-kit.webp"
    ],
    "notes": null,
    "description": "The Crafty version upgrades the normal repair item's effect. Community testing says its restoration zone lasts twenty seconds and can return a tool from empty to full durability when the player stays inside for the whole duration."
  },
  {
    "id": "dye",
    "slug": "dye",
    "name": "Dye",
    "kind": "tool",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/tool/dye.webp",
    "imageStatus": "verified",
    "sellPrice": 50,
    "energy": null,
    "tags": [
      "tool"
    ],
    "sourceRefs": [
      "icon-asset:apps/web-vite/public/icons/tool/dye.webp"
    ],
    "notes": null,
    "description": "Dye changes the appearance of compatible crafted furniture through Heartopia's workbench recoloring system. Some supported pieces expose multiple colorable sections, allowing more than a single flat recolor."
  },
  {
    "id": "fertilizer",
    "slug": "fertilizer",
    "name": "Fertilizer",
    "kind": "tool",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/tool/fertilizer.webp",
    "imageStatus": "verified",
    "sellPrice": 1,
    "energy": null,
    "tags": [
      "tool",
      "gardening"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Fertilizer targets crop quality rather than simply shortening growth time. Heartopia also lets players turn common yard resources—Weeds together with basic Timber—into this useful gardening aid."
  },
  {
    "id": "grape-seed",
    "slug": "grape-seed",
    "name": "Grape Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/grape-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 80,
    "energy": null,
    "tags": [
      "seed",
      "crop",
      "farming"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Grape Seed is the planting item behind the vine crop. Once grown, it produces clusters of Grapes, small berries that can be harvested for fresh-food and preserve-style uses."
  },
  {
    "id": "fishing-rod",
    "slug": "fishing-rod",
    "name": "Fishing Rod",
    "kind": "tool",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/tool/fishing-rod.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [
      "tool",
      "fishing"
    ],
    "sourceRefs": [
      "icon-asset:apps/web-vite/public/icons/tool/fishing-rod.webp"
    ],
    "notes": null,
    "description": "Fishing Rod is Heartopia's core tool for catching fish from rivers, lakes and coastal waters. It turns visible fish shadows into an interactive catch attempt rather than functioning as a consumable item."
  },
  {
    "id": "free-spirited-coffee-umbrella",
    "slug": "free-spirited-coffee-umbrella",
    "name": "Free-Spirited Coffee Umbrella",
    "kind": "tool",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/tool/free-spirited-coffee-umbrella.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [
      "tool"
    ],
    "sourceRefs": [
      "icon-asset:apps/web-vite/public/icons/tool/free-spirited-coffee-umbrella.webp"
    ],
    "notes": null,
    "description": "Free-Spirited Coffee Umbrella is a themed tool whose identity comes primarily from its coffee-inspired styling. No distinct gameplay bonus is documented, so it is best treated as a cosmetic catalog variant."
  },
  {
    "id": "growth-booster",
    "slug": "growth-booster",
    "name": "Growth Booster",
    "kind": "tool",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/tool/growth-booster.webp",
    "imageStatus": "verified",
    "sellPrice": 1,
    "energy": null,
    "tags": [
      "tool",
      "gardening"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Growth Booster is for situations where waiting is the problem. Blanc's gardening aid shortens crop development time, letting players bring a harvest forward instead of relying only on the normal timer."
  },
  {
    "id": "lettuce-seed",
    "slug": "lettuce-seed",
    "name": "Lettuce Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/lettuce-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 72,
    "energy": 1,
    "tags": [
      "seed",
      "crop",
      "farming"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Lettuce Seed begins the garden cycle for Lettuce, a mild leafy vegetable harvested mainly for its tender leaves. The seed itself is simply the plantable stage before the crop becomes a cooking ingredient."
  },
  {
    "id": "pineapple-seed",
    "slug": "pineapple-seed",
    "name": "Pineapple Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/pineapple-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 7,
    "energy": null,
    "tags": [
      "seed",
      "crop",
      "farming"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Pineapple Seed is the planting item used to establish the tropical fruit crop. After growing, the plant yields Pineapple with its distinctive rough exterior, sweet-tart flesh and dessert-friendly flavor."
  },
  {
    "id": "potato-seed",
    "slug": "potato-seed",
    "name": "Potato Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/potato-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 15,
    "energy": 1,
    "tags": [
      "seed",
      "crop",
      "farming"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Potato Seed starts the crop that produces starchy underground tubers. Harvested Potatoes are the edible stage, while this seed item belongs purely to the gardening side of that cycle."
  },
  {
    "id": "strawberry-seed",
    "slug": "strawberry-seed",
    "name": "Strawberry Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/strawberry-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 62,
    "energy": null,
    "tags": [
      "seed",
      "crop",
      "farming"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Strawberry Seed grows the low fruiting plant that later produces sweet red berries. In Heartopia it is the renewable gardening source behind the Strawberry crop rather than a finished ingredient itself."
  },
  {
    "id": "tomato-seed",
    "slug": "tomato-seed",
    "name": "Tomato Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/tomato-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 5,
    "energy": 1,
    "tags": [
      "seed",
      "crop",
      "farming"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Tomato Seed establishes a plant that produces juicy red Tomatoes. Although the harvested item is botanically a fruit, Heartopia gardening treats the seed as the ordinary starting point for replenishing the crop."
  },
  {
    "id": "wheat-seed",
    "slug": "wheat-seed",
    "name": "Wheat Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/wheat-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 47,
    "energy": 1,
    "tags": [
      "seed",
      "crop",
      "farming"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Wheat Seed begins a cereal crop whose mature grain can support flour- and dough-based cooking. It is the planting stage behind one of Heartopia's most basic grain ingredients."
  },
  {
    "id": "white-calla-lily-seed",
    "slug": "white-calla-lily-seed",
    "name": "White Calla Lily Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/white-calla-lily-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 45,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/seed/white-calla-lily-seed.webp",
      "variant-of:calla-lily-seeds"
    ],
    "notes": null,
    "description": "White Calla Lily Seed starts that particular color directly. After the flower matures, any cross still follows the Calla Lily family rules, with parent star ranks controlling compatibility instead of the white appearance.",
    "flowerSpecies": "calla-lily-seeds",
    "flowerColor": "white",
    "variantOf": "calla-lily-seeds"
  },
  {
    "id": "white-carnation-seed",
    "slug": "white-carnation-seed",
    "name": "White Carnation Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/white-carnation-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 60,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/seed/white-carnation-seed.webp",
      "variant-of:carnation-seeds"
    ],
    "notes": null,
    "description": "White Carnation Seed provides a white member of the Carnation family as a planting item. Any later cross uses the normal Carnation star-compatibility rules, so the visible color does not dictate the pairing.",
    "flowerSpecies": "carnation-seeds",
    "flowerColor": "white",
    "variantOf": "carnation-seeds"
  },
  {
    "id": "white-corn-poppy-seed",
    "slug": "white-corn-poppy-seed",
    "name": "White Corn Poppy Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/white-corn-poppy-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 30,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/seed/white-corn-poppy-seed.webp",
      "variant-of:corn-poppy-seeds"
    ],
    "notes": null,
    "description": "White Corn Poppy Seed establishes the pale variant without changing the species' breeding logic. Mature Corn Poppies still cross according to family and suitable star ranks, not a formula based on white petals.",
    "flowerSpecies": "corn-poppy-seeds",
    "flowerColor": "white",
    "variantOf": "corn-poppy-seeds"
  },
  {
    "id": "white-daisy-seed",
    "slug": "white-daisy-seed",
    "name": "White Daisy Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/white-daisy-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 15,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/seed/white-daisy-seed.webp",
      "variant-of:daisy-seeds"
    ],
    "notes": null,
    "description": "White Daisy Seed gives the player that Daisy color at planting. The grown flower does not require another white parent later; Daisy crossbreeding continues to use star compatibility instead of color matching.",
    "flowerSpecies": "daisy-seeds",
    "flowerColor": "white",
    "variantOf": "daisy-seeds"
  },
  {
    "id": "white-highland-poppy-seed",
    "slug": "white-highland-poppy-seed",
    "name": "White Highland Poppy Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/white-highland-poppy-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 15,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/seed/white-highland-poppy-seed.webp",
      "variant-of:highland-poppy-seeds"
    ],
    "notes": null,
    "description": "White Highland Poppy Seed starts a white flower in the Highland Poppy family. Future breeding treats it like any other Highland Poppy, with parent star levels determining compatibility rather than hue.",
    "flowerSpecies": "highland-poppy-seeds",
    "flowerColor": "white",
    "variantOf": "highland-poppy-seeds"
  },
  {
    "id": "white-laceleaft-seed",
    "slug": "white-laceleaft-seed",
    "name": "White Laceleaf Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/white-laceleaft-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 30,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/seed/white-laceleaft-seed.webp",
      "variant-of:laceleaf-seeds"
    ],
    "notes": null,
    "description": "White Laceleaf Seed produces the white Laceleaf form directly. Once mature, it remains subject to the same Laceleaf breeding rules, where star rank matters and color does not drive the calculation.",
    "flowerSpecies": "laceleaf-seeds",
    "flowerColor": "white",
    "variantOf": "laceleaf-seeds"
  },
  {
    "id": "white-morning-glory-seed",
    "slug": "white-morning-glory-seed",
    "name": "White Morning Glory Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/white-morning-glory-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 45,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/seed/white-morning-glory-seed.webp",
      "variant-of:morning-glory-seeds"
    ],
    "notes": null,
    "description": "White Morning Glory Seed plants a white variant, but the shade is not inherited through a fixed color recipe. Later crosses stay within Morning Glory and depend on compatible parent star ratings.",
    "flowerSpecies": "morning-glory-seeds",
    "flowerColor": "white",
    "variantOf": "morning-glory-seeds"
  },
  {
    "id": "white-radish-seed",
    "slug": "white-radish-seed",
    "name": "White Radish Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/white-radish-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 5,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "supabase-lookup:scripts/_supabase-lookups/other-items.json"
    ],
    "notes": null,
    "description": "This seed was part of Winter Frost's temporary garden content. Growing it supplied White Radish for the seasonal menu, including the event's creamy radish soup."
  },
  {
    "id": "yellow-calla-lily-seed",
    "slug": "yellow-calla-lily-seed",
    "name": "Yellow Calla Lily Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/yellow-calla-lily-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 45,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/seed/yellow-calla-lily-seed.webp",
      "variant-of:calla-lily-seeds"
    ],
    "notes": null,
    "description": "Yellow Calla Lily Seed starts the yellow color form as a plant. If it is later used for crossbreeding, Heartopia still checks Calla Lily family and star compatibility rather than the yellow shade itself.",
    "flowerSpecies": "calla-lily-seeds",
    "flowerColor": "yellow",
    "variantOf": "calla-lily-seeds"
  },
  {
    "id": "yellow-carnation-seed",
    "slug": "yellow-carnation-seed",
    "name": "Yellow Carnation Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/yellow-carnation-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 60,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/seed/yellow-carnation-seed.webp",
      "variant-of:carnation-seeds"
    ],
    "notes": null,
    "description": "Yellow Carnation Seed provides a colored Carnation from the start, but its hue has no special power in the breeding system. Mature plants continue through compatible Carnation star levels.",
    "flowerSpecies": "carnation-seeds",
    "flowerColor": "yellow",
    "variantOf": "carnation-seeds"
  },
  {
    "id": "yellow-corn-poppy-seed",
    "slug": "yellow-corn-poppy-seed",
    "name": "Yellow Corn Poppy Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/yellow-corn-poppy-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 30,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/seed/yellow-corn-poppy-seed.webp",
      "variant-of:corn-poppy-seeds"
    ],
    "notes": null,
    "description": "Yellow Corn Poppy Seed establishes a yellow member of the Corn Poppy family. Subsequent crosses are governed by species and parent star rank, so yellow is a catalog appearance rather than a breeding formula.",
    "flowerSpecies": "corn-poppy-seeds",
    "flowerColor": "yellow",
    "variantOf": "corn-poppy-seeds"
  },
  {
    "id": "yellow-highland-poppy-seed",
    "slug": "yellow-highland-poppy-seed",
    "name": "Yellow Highland Poppy Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/yellow-highland-poppy-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 15,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/seed/yellow-highland-poppy-seed.webp",
      "variant-of:highland-poppy-seeds"
    ],
    "notes": null,
    "description": "Yellow Highland Poppy Seed plants that color directly while leaving normal Highland Poppy genetics unchanged. Compatible star ratings, not yellow petals, determine whether later crossbreeding can proceed.",
    "flowerSpecies": "highland-poppy-seeds",
    "flowerColor": "yellow",
    "variantOf": "highland-poppy-seeds"
  },
  {
    "id": "yellow-laceleaft-seed",
    "slug": "yellow-laceleaft-seed",
    "name": "Yellow Laceleaf Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/yellow-laceleaft-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 30,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/seed/yellow-laceleaft-seed.webp",
      "variant-of:laceleaf-seeds"
    ],
    "notes": null,
    "description": "Yellow Laceleaf Seed produces the yellow catalog variant. For any next generation, the flower is simply a Laceleaf whose star level must be compatible with the other parent; color is not part of the calculation.",
    "flowerSpecies": "laceleaf-seeds",
    "flowerColor": "yellow",
    "variantOf": "laceleaf-seeds"
  },
  {
    "id": "yellow-morning-glory-seed",
    "slug": "yellow-morning-glory-seed",
    "name": "Yellow Morning Glory Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/yellow-morning-glory-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 45,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/seed/yellow-morning-glory-seed.webp",
      "variant-of:morning-glory-seeds"
    ],
    "notes": null,
    "description": "Yellow Morning Glory Seed starts the yellow form without creating a separate breeding path. Once grown, it crosses under the same Morning Glory star-compatibility rules as every other color.",
    "flowerSpecies": "morning-glory-seeds",
    "flowerColor": "yellow",
    "variantOf": "morning-glory-seeds"
  },
  {
    "id": "yellow-pansy-seed",
    "slug": "yellow-pansy-seed",
    "name": "Yellow Pansy Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/yellow-pansy-seed.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "derived:local-asset:apps/web-vite/public/icons/seed/yellow-pansy-seed.webp",
      "variant-of:pansy-seeds"
    ],
    "notes": null,
    "description": "Yellow Pansy Seed supplies a yellow Pansy at planting, but later breeding does not ask for yellow-compatible colors. Heartopia only needs another Pansy with a suitable star rating.",
    "flowerSpecies": "pansy-seeds",
    "flowerColor": "yellow",
    "variantOf": "pansy-seeds"
  },
  {
    "id": "sugar",
    "slug": "sugar",
    "name": "Sugar",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": null,
    "imageStatus": "missing",
    "sellPrice": 10,
    "energy": 4,
    "tags": [
      "food",
      "ingredient",
      "sweetener"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Sugar is a basic sweetener made of soluble carbohydrates and used to add sweetness to food and drink. In Heartopia it fills the ordinary pantry role beneath the more specialized colored sugars."
  },
  {
    "id": "amazing-seasoning",
    "slug": "amazing-seasoning",
    "name": "Amazing Seasoning",
    "kind": "tool",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/tool/amazing-seasoning.webp",
    "imageStatus": "verified",
    "sellPrice": 1000,
    "energy": null,
    "tags": [
      "tool",
      "cooking"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Amazing Seasoning is a quality-control shortcut rather than a flavor variant. Turning it on before cooking guarantees that the finished dish reaches at least two-star quality, which is valuable when ingredients are costly."
  },
  {
    "id": "matcha-powder",
    "slug": "matcha-powder",
    "name": "Matcha Powder",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/matcha-powder.webp",
    "imageStatus": "verified",
    "sellPrice": 125,
    "energy": null,
    "tags": [
      "ingredient",
      "cooking"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Matcha Powder is finely ground green tea with a concentrated grassy, slightly bitter flavor and vivid green color. Heartopia uses it as a specialty cooking ingredient rather than as ordinary loose tea."
  },
  {
    "id": "red-bean",
    "slug": "red-bean",
    "name": "Red Bean",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/red-bean.webp",
    "imageStatus": "verified",
    "sellPrice": 25,
    "energy": null,
    "tags": [
      "ingredient",
      "cooking"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Red Bean is a small legume commonly associated with both savory cooking and sweet bean fillings in East Asian desserts. In Heartopia it functions as a specialty ingredient for several prepared foods."
  },
  {
    "id": "rice-flour",
    "slug": "rice-flour",
    "name": "Rice Flour",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/rice-flour.webp",
    "imageStatus": "verified",
    "sellPrice": 25,
    "energy": null,
    "tags": [
      "ingredient",
      "cooking"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Rice Flour is produced by grinding rice into a fine powder. Its starch-heavy texture makes it useful for batters, doughs and chewy sweets, giving Heartopia a grain ingredient distinct from wheat."
  },
  {
    "id": "tea-leaves",
    "slug": "tea-leaves",
    "name": "Tea Leaves",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/tea-leaves.webp",
    "imageStatus": "verified",
    "sellPrice": 125,
    "energy": null,
    "tags": [
      "ingredient",
      "cooking"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Tea Leaves are harvested leaves prepared for steeping in hot water to make tea. Their aromatic compounds supply the drink's flavor, making them the base ingredient behind tea-style beverages in Heartopia."
  },
  {
    "id": "universal-ingredient",
    "slug": "universal-ingredient",
    "name": "Universal Ingredient",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/universal-ingredient.webp",
    "imageStatus": "verified",
    "sellPrice": 2000,
    "energy": null,
    "tags": [
      "ingredient",
      "cooking"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Universal Ingredient is a flexible cooking component rather than a specific crop, fish or animal product. Its value comes from being usable where Heartopia accepts a general-purpose ingredient instead of demanding one named food."
  },
  {
    "id": "cat-food",
    "slug": "cat-food",
    "name": "Cat Food",
    "kind": "tool",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/tool/cat-food.webp",
    "imageStatus": "verified",
    "sellPrice": 75,
    "energy": 20,
    "tags": [
      "tool",
      "pet-food"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Cat Food is prepared feed intended specifically for pet cats. It provides a straightforward feeding option without requiring the player to use a fresh crop, fish or other individual ingredient."
  },
  {
    "id": "dog-food",
    "slug": "dog-food",
    "name": "Dog Food",
    "kind": "tool",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/tool/dog-food.webp",
    "imageStatus": "verified",
    "sellPrice": 1,
    "energy": 20,
    "tags": [
      "tool",
      "pet-food"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Dog Food is packaged feed made for pet dogs. It serves as a dedicated feeding item, giving players a simple alternative to offering separate raw or cooked ingredients."
  },
  {
    "id": "insect-net",
    "slug": "insect-net",
    "name": "Insect Net",
    "kind": "tool",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/tool/insect-net.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [
      "tool",
      "bug-catching"
    ],
    "sourceRefs": [
      "icon-asset:apps/web-vite/public/icons/tool/insect-net.webp"
    ],
    "notes": null,
    "description": "Net upgrades matter because bug catching is not purely cosmetic. Better nets reach farther and are more dependable against difficult insects, so progression directly improves how safely and consistently rare targets can be captured."
  },
  {
    "id": "master-repair-kit",
    "slug": "master-repair-kit",
    "name": "Master Repair Kit",
    "kind": "tool",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/tool/master-repair-kit.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [
      "tool",
      "repair"
    ],
    "sourceRefs": [
      "icon-asset:apps/web-vite/public/icons/tool/master-repair-kit.webp"
    ],
    "notes": null,
    "description": "At the top end of the shared repair items, the Master version keeps a recovery zone active long enough to restore durability repeatedly. Several nearby players can stand inside and benefit from the same use."
  },
  {
    "id": "mermaid-fish-attractor",
    "slug": "mermaid-fish-attractor",
    "name": "Mermaid Fish Attractor",
    "kind": "tool",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/tool/mermaid-fish-attractor.webp",
    "imageStatus": "verified",
    "sellPrice": 1000,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "gift-code-rewards:src/data/source/gift-codes.json",
      "icon-asset:apps/web-vite/public/icons/tool/mermaid-fish-attractor.webp"
    ],
    "notes": null,
    "description": "Some unusual fishing targets are tied directly to Mermaid Fish Attractor. The Edible Frog is one example: its special blue shadow belongs only to the player who deployed the attractor, making lure ownership part of the catch rule."
  },
  {
    "id": "mermaid-perfume",
    "slug": "mermaid-perfume",
    "name": "Mermaid Perfume",
    "kind": "tool",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/tool/mermaid-perfume.webp",
    "imageStatus": "verified",
    "sellPrice": 2000,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "gift-code-rewards:src/data/source/gift-codes.json",
      "icon-asset:apps/web-vite/public/icons/tool/mermaid-perfume.webp"
    ],
    "notes": null,
    "description": "Players commonly pair Mermaid Perfume with Mermaid Fish Attractors during longer fishing sessions. Community routes treat it as a support consumable, although a guaranteed boost to rare-catch rates has not been firmly documented."
  },
  {
    "id": "quality-fertilizer",
    "slug": "quality-fertilizer",
    "name": "Quality Fertilizer",
    "kind": "tool",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/tool/quality-fertilizer.webp",
    "imageStatus": "verified",
    "sellPrice": 1,
    "energy": null,
    "tags": [
      "tool",
      "gardening"
    ],
    "sourceRefs": [
      "icon-asset:apps/web-vite/public/icons/tool/quality-fertilizer.webp",
      "supabase-lookup:scripts/_supabase-lookups/other-items.json"
    ],
    "notes": null,
    "description": "Quality Fertilizer belongs to Gardening's harvest-quality side rather than its speed system. Stronger fertilizer tiers improve the chance of receiving better-star produce instead of simply making crops finish sooner."
  },
  {
    "id": "quality-growth-booster",
    "slug": "quality-growth-booster",
    "name": "Quality Growth Booster",
    "kind": "tool",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/tool/quality-growth-booster.webp",
    "imageStatus": "verified",
    "sellPrice": 1,
    "energy": null,
    "tags": [
      "tool",
      "gardening"
    ],
    "sourceRefs": [
      "icon-asset:apps/web-vite/public/icons/tool/quality-growth-booster.webp",
      "supabase-lookup:scripts/_supabase-lookups/other-items.json"
    ],
    "notes": null,
    "description": "Quality Growth Booster targets time, not crop stars. It is an upgraded speed item used to shorten the wait between planting and harvesting, while fertilizer remains the separate tool for improving produce quality."
  },
  {
    "id": "rainbow-bouquet",
    "slug": "rainbow-bouquet",
    "name": "Rainbow Bouquet",
    "kind": "tool",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/tool/rainbow-bouquet.webp",
    "imageStatus": "verified",
    "sellPrice": 1,
    "energy": null,
    "tags": [
      "tool",
      "gardening"
    ],
    "sourceRefs": [
      "icon-asset:apps/web-vite/public/icons/tool/rainbow-bouquet.webp"
    ],
    "notes": null,
    "description": "Activating this bouquet grants Rainbow Blessing for half an hour. During the buff, multiple hobbies can roll stronger star results, including activities from cooking to angling and item-making; nearby players may benefit as well."
  },
  {
    "id": "rainbow-breeding-powder",
    "slug": "rainbow-breeding-powder",
    "name": "Rainbow Breeding Powder",
    "kind": "tool",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/tool/rainbow-breeding-powder.webp",
    "imageStatus": "verified",
    "sellPrice": 2000,
    "energy": null,
    "tags": [
      "tool",
      "gardening"
    ],
    "sourceRefs": [
      "icon-asset:apps/web-vite/public/icons/tool/rainbow-breeding-powder.webp",
      "supabase-lookup:scripts/_supabase-lookups/other-items.json"
    ],
    "notes": null,
    "description": "Flower breeders use this powder as help for difficult crosses. Community documentation attributes stronger effects to it, but the precise guarantee and the conditions for obtaining it are still less certain than its basic breeding purpose."
  },
  {
    "id": "repair-kit",
    "slug": "repair-kit",
    "name": "Repair Kit",
    "kind": "tool",
    "eventKey": null,
    "status": "active",
    "aliases": [
      "repair-kits"
    ],
    "image": "/icons/tool/repair-kit.webp",
    "imageStatus": "verified",
    "sellPrice": 30,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "gift-code-rewards:src/data/source/gift-codes.json",
      "icon-asset:apps/web-vite/public/icons/tool/repair-kit.webp"
    ],
    "notes": null,
    "description": "Repair Kit creates an area where equipped tools regain durability over time. Because the zone can serve more than one person standing inside it, a single kit can be useful for a group instead of repairing only one tool instantly."
  },
  {
    "id": "scanner",
    "slug": "scanner",
    "name": "Scanner",
    "kind": "tool",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/tool/scanner.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [
      "tool"
    ],
    "sourceRefs": [
      "icon-asset:apps/web-vite/public/icons/tool/scanner.webp"
    ],
    "notes": null,
    "description": "Birdwatching revolves around the Scanner: it records birds and produces Info Cards from the moment captured. Pose and behavior affect card quality, so a well-timed scan can be more valuable than photographing the same species carelessly."
  },
  {
    "id": "tablet",
    "slug": "tablet",
    "name": "Tablet",
    "kind": "tool",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/tool/tablet.webp",
    "imageStatus": "verified",
    "sellPrice": 1,
    "energy": null,
    "tags": [
      "tool"
    ],
    "sourceRefs": [
      "icon-asset:apps/web-vite/public/icons/tool/tablet.webp"
    ],
    "notes": null,
    "description": "A tablet is a portable touchscreen computer designed for handheld use, sitting between a phone and a laptop in size. In Heartopia's catalog, the item is best understood as a personal electronic device rather than a resource or consumable."
  },
  {
    "id": "top-fertilizer",
    "slug": "top-fertilizer",
    "name": "Top Fertilizer",
    "kind": "tool",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/tool/top-fertilizer.webp",
    "imageStatus": "verified",
    "sellPrice": 1,
    "energy": null,
    "tags": [
      "tool",
      "gardening"
    ],
    "sourceRefs": [
      "icon-asset:apps/web-vite/public/icons/tool/top-fertilizer.webp",
      "supabase-lookup:scripts/_supabase-lookups/other-items.json"
    ],
    "notes": null,
    "description": "Top Fertilizer sits at the premium end of Gardening's quality boosters. Its purpose is to push harvests toward higher star ratings, separating it from Growth Booster items whose job is to reduce waiting time."
  },
  {
    "id": "top-growth-booster",
    "slug": "top-growth-booster",
    "name": "Top Growth Booster",
    "kind": "tool",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/tool/top-growth-booster.webp",
    "imageStatus": "verified",
    "sellPrice": 1,
    "energy": null,
    "tags": [
      "tool",
      "gardening"
    ],
    "sourceRefs": [
      "icon-asset:apps/web-vite/public/icons/tool/top-growth-booster.webp",
      "supabase-lookup:scripts/_supabase-lookups/other-items.json"
    ],
    "notes": null,
    "description": "Top Growth Booster is a high-tier Gardening speed aid. It works on the crop-timing side of the system, cutting down the growth wait rather than directly improving the star quality of the harvested produce."
  },
  {
    "id": "universal-animal-food",
    "slug": "universal-animal-food",
    "name": "Universal Animal Food",
    "kind": "tool",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/tool/universal-animal-food.webp",
    "imageStatus": "verified",
    "sellPrice": 1,
    "energy": 15,
    "tags": [
      "tool",
      "pet-food"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Universal Animal Food is general-purpose feed intended to work across animal-care situations instead of targeting one species. It is the flexible counterpart to dedicated foods such as Cat Food or Dog Food."
  },
  {
    "id": "inflatable-insect-attractor",
    "slug": "inflatable-insect-attractor",
    "name": "Inflatable Insect Attractor",
    "kind": "tool",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/tool/inflatable-insect-attractor.webp",
    "imageStatus": "verified",
    "sellPrice": 1,
    "energy": null,
    "tags": [
      "tool",
      "bug-catching"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "This single-use inflatable lure creates special bug-catching opportunities and is needed for some uncommon journal entries. Sulkowsky's Morpho is one documented example that depends on using the attractor."
  },
  {
    "id": "dreamlight-cinematics-popcorn-serving-cart",
    "slug": "dreamlight-cinematics-popcorn-serving-cart",
    "name": "Dreamlight Cinematics Popcorn Serving Cart",
    "kind": "furniture",
    "eventKey": "dreamlight-cinematics",
    "status": "event",
    "aliases": [],
    "image": "/icons/furniture/dreamlight-cinematics-popcorn-serving-cart.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [
      "furniture",
      "event"
    ],
    "sourceRefs": [
      "icon-asset:apps/web-vite/public/icons/furniture/dreamlight-cinematics-popcorn-serving-cart.webp"
    ],
    "notes": null,
    "description": "Dreamlight Cinematics assigned its popcorn cart a mechanical job, not just a decorative one: festival recipes were prepared at this special station instead of through the ordinary home-cooking setup."
  },
  {
    "id": "large-flower-bed",
    "slug": "large-flower-bed",
    "name": "Large Flower Bed",
    "kind": "furniture",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/furniture/large-flower-bed.webp",
    "imageStatus": "verified",
    "sellPrice": 625,
    "energy": null,
    "tags": [
      "furniture",
      "gardening"
    ],
    "sourceRefs": [
      "icon-asset:apps/web-vite/public/icons/furniture/large-flower-bed.webp",
      "supabase-lookup:scripts/_supabase-lookups/other-items.json"
    ],
    "notes": null,
    "description": "Large Flower Bed is a roomy planter-style furnishing intended to hold flowers in a defined decorative patch. Its main distinction from smaller beds is presentation space rather than a separate breeding mechanic."
  },
  {
    "id": "large-vivarium",
    "slug": "large-vivarium",
    "name": "Large Vivarium",
    "kind": "furniture",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/furniture/large-vivarium.webp",
    "imageStatus": "verified",
    "sellPrice": 136710,
    "energy": null,
    "tags": [
      "furniture",
      "bug-catching"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Large Vivarium lets caught insects become part of a home display instead of being immediately sold. It gives collectors a way to keep favorite specimens visible after recording them in the Insect Journal."
  },
  {
    "id": "medium-flower-bed",
    "slug": "medium-flower-bed",
    "name": "Medium Flower Bed",
    "kind": "furniture",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/furniture/medium-flower-bed.webp",
    "imageStatus": "verified",
    "sellPrice": 625,
    "energy": null,
    "tags": [
      "furniture",
      "gardening"
    ],
    "sourceRefs": [
      "icon-asset:apps/web-vite/public/icons/furniture/medium-flower-bed.webp",
      "supabase-lookup:scripts/_supabase-lookups/other-items.json"
    ],
    "notes": null,
    "description": "Medium Flower Bed provides a mid-sized decorative planting area for arranging flowers around a property. It changes how much display space is available without creating a separate flower species or breeding rule."
  },
  {
    "id": "medium-vivarium",
    "slug": "medium-vivarium",
    "name": "Medium Vivarium",
    "kind": "furniture",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/furniture/medium-vivarium.webp",
    "imageStatus": "verified",
    "sellPrice": 1715,
    "energy": null,
    "tags": [
      "furniture",
      "bug-catching"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Medium Vivarium is an indoor display option for insects already caught through Bug Catching. Rather than converting every specimen into currency, players can keep selected bugs as visible collection pieces at home."
  },
  {
    "id": "sense-booster",
    "slug": "sense-booster",
    "name": "Sense Booster",
    "kind": "tool",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/tool/sense-booster.webp",
    "imageStatus": "verified",
    "sellPrice": 1,
    "energy": null,
    "tags": [
      "tool",
      "bug-catching"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Sense Booster supports insect hunting by helping players notice nearby bugs during natural searches. It is most useful when sweeping an area for ordinary spawns, complementing rather than replacing attractor-based encounters."
  },
  {
    "id": "watering-can",
    "slug": "watering-can",
    "name": "Watering Can",
    "kind": "tool",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/tool/watering-can.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [
      "tool",
      "gardening"
    ],
    "sourceRefs": [
      "icon-asset:apps/web-vite/public/icons/tool/watering-can.webp"
    ],
    "notes": null,
    "description": "Watering has two separate benefits in Heartopia: crops gain better quality odds, while flowers receive improved crossbreeding chances. Gardening progression can also make the Watering Can cover tiles more efficiently."
  },
  {
    "id": "medium-wall-plant-frame",
    "slug": "medium-wall-plant-frame",
    "name": "Medium Wall Plant Frame",
    "kind": "furniture",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/furniture/medium-wall-plant-frame.webp",
    "imageStatus": "verified",
    "sellPrice": 1100,
    "energy": null,
    "tags": [
      "furniture",
      "gardening"
    ],
    "sourceRefs": [
      "icon-asset:apps/web-vite/public/icons/furniture/medium-wall-plant-frame.webp",
      "supabase-lookup:scripts/_supabase-lookups/other-items.json"
    ],
    "notes": null,
    "description": "Medium Wall Plant Frame is a wall-mounted decorative planter, letting greenery occupy vertical space instead of a floor or garden plot. Its role is presentation rather than a unique crop or breeding mechanic."
  },
  {
    "id": "planter",
    "slug": "planter",
    "name": "Planter",
    "kind": "furniture",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/furniture/planter.webp",
    "imageStatus": "verified",
    "sellPrice": 1,
    "energy": null,
    "tags": [
      "furniture",
      "gardening"
    ],
    "sourceRefs": [
      "icon-asset:apps/web-vite/public/icons/furniture/planter.webp",
      "supabase-lookup:scripts/_supabase-lookups/other-items.json"
    ],
    "notes": null,
    "description": "A planter is a container used to grow or display plants in a controlled spot rather than directly in open ground. In Heartopia furniture terms, it functions mainly as a compact decorative planting piece."
  },
  {
    "id": "small-flower-bed",
    "slug": "small-flower-bed",
    "name": "Small Flower Bed",
    "kind": "furniture",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/furniture/small-flower-bed.webp",
    "imageStatus": "verified",
    "sellPrice": 625,
    "energy": null,
    "tags": [
      "furniture",
      "gardening"
    ],
    "sourceRefs": [
      "icon-asset:apps/web-vite/public/icons/furniture/small-flower-bed.webp",
      "supabase-lookup:scripts/_supabase-lookups/other-items.json"
    ],
    "notes": null,
    "description": "Small Flower Bed is the compact version of Heartopia's flower-bed furnishings. It gives players a contained patch for decorative blooms when a larger planting area would take up more space than desired."
  },
  {
    "id": "small-vivarium",
    "slug": "small-vivarium",
    "name": "Small Vivarium",
    "kind": "furniture",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/furniture/small-vivarium.webp",
    "imageStatus": "verified",
    "sellPrice": 850,
    "energy": null,
    "tags": [
      "furniture",
      "bug-catching"
    ],
    "sourceRefs": [
      "legacy:src/data/generated/recipes.ts+shops.ts (referenced-only orphan)",
      "supabase:items"
    ],
    "notes": null,
    "description": "Small Vivarium turns captured insects into compact home decorations. It is useful for keeping favorite bugs on display after collection, offering an alternative to treating every catch only as something to sell."
  },
  {
    "id": "square-flower-bed",
    "slug": "square-flower-bed",
    "name": "Square Flower Bed",
    "kind": "furniture",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/furniture/square-flower-bed.webp",
    "imageStatus": "verified",
    "sellPrice": 1100,
    "energy": null,
    "tags": [
      "furniture",
      "gardening"
    ],
    "sourceRefs": [
      "icon-asset:apps/web-vite/public/icons/furniture/square-flower-bed.webp",
      "supabase-lookup:scripts/_supabase-lookups/other-items.json"
    ],
    "notes": null,
    "description": "Square Flower Bed organizes flowers inside a clean geometric planting area. Its defining feature is the square layout, making it useful when a build needs structured landscaping rather than a differently behaving plant system."
  },
  {
    "id": "apple-verbena-pie",
    "slug": "apple-verbena-pie",
    "name": "Apple Verbena Pie",
    "kind": "dish",
    "eventKey": "modular-streets",
    "status": "event",
    "aliases": [],
    "image": "/icons/dish/apple-verbena-pie.webp",
    "imageStatus": "verified",
    "sellPrice": 500,
    "energy": 65,
    "tags": [
      "recipe",
      "cooking",
      "event",
      "modular-streets"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Report gave energy range 60-70; stored midpoint 65 until detail validation.",
    "description": "This is a classic apple pie—no burnt bits, just pure goodness."
  },
  {
    "id": "blueberry-verbena-pie",
    "slug": "blueberry-verbena-pie",
    "name": "Blueberry Verbena Pie",
    "kind": "dish",
    "eventKey": "modular-streets",
    "status": "event",
    "aliases": [],
    "image": "/icons/dish/blueberry-verbena-pie.webp",
    "imageStatus": "verified",
    "sellPrice": 360,
    "energy": null,
    "tags": [
      "recipe",
      "cooking",
      "event",
      "modular-streets"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Making a blueberry pie... wait, how did the blueberries end up soaking in the cream first?"
  },
  {
    "id": "brick-black-truffle-patty-burger",
    "slug": "brick-black-truffle-patty-burger",
    "name": "Brick Black Truffle Patty Burger",
    "kind": "dish",
    "eventKey": "modular-streets",
    "status": "event",
    "aliases": [],
    "image": "/icons/dish/brick-black-truffle-patty-burger.webp",
    "imageStatus": "verified",
    "sellPrice": 780,
    "energy": null,
    "tags": [
      "recipe",
      "cooking",
      "event",
      "modular-streets"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Deep inside the dark truffle burger, a brick meat patty rests in quiet slumber."
  },
  {
    "id": "brick-bowl-apple-shaved-ice",
    "slug": "brick-bowl-apple-shaved-ice",
    "name": "Brick Bowl Apple Shaved Ice",
    "kind": "dish",
    "eventKey": "modular-streets",
    "status": "event",
    "aliases": [],
    "image": "/icons/dish/brick-bowl-apple-shaved-ice.webp",
    "imageStatus": "verified",
    "sellPrice": 260,
    "energy": null,
    "tags": [
      "recipe",
      "cooking",
      "event",
      "modular-streets"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "On the mountain of shaved ice built from countless tiny brick ice, three brave apple warriors have reached the summit."
  },
  {
    "id": "brick-bowl-blueberry-shaved-ice",
    "slug": "brick-bowl-blueberry-shaved-ice",
    "name": "Brick Bowl Blueberry Shaved Ice",
    "kind": "dish",
    "eventKey": "modular-streets",
    "status": "event",
    "aliases": [],
    "image": "/icons/dish/brick-bowl-blueberry-shaved-ice.webp",
    "imageStatus": "verified",
    "sellPrice": 220,
    "energy": null,
    "tags": [
      "recipe",
      "cooking",
      "event",
      "modular-streets"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "On the mountain of shaved ice built from countless tiny brick ice, a chase unfolds between rival blueberry clans."
  },
  {
    "id": "brick-bowl-fruit-shaved-ice",
    "slug": "brick-bowl-fruit-shaved-ice",
    "name": "Brick Bowl Fruit Shaved Ice",
    "kind": "dish",
    "eventKey": "modular-streets",
    "status": "event",
    "aliases": [],
    "image": "/icons/dish/brick-bowl-fruit-shaved-ice.webp",
    "imageStatus": "verified",
    "sellPrice": 210,
    "energy": null,
    "tags": [
      "recipe",
      "cooking",
      "event",
      "modular-streets"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Once a towering shaved ice peak, until the day a family of hefty fruits moved in—and things started to get wobbly."
  },
  {
    "id": "brick-bowl-grape-shaved-ice",
    "slug": "brick-bowl-grape-shaved-ice",
    "name": "Brick Bowl Grape Shaved Ice",
    "kind": "dish",
    "eventKey": "modular-streets",
    "status": "event",
    "aliases": [],
    "image": "/icons/dish/brick-bowl-grape-shaved-ice.webp",
    "imageStatus": "verified",
    "sellPrice": 1110,
    "energy": null,
    "tags": [
      "recipe",
      "cooking",
      "event",
      "modular-streets"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "At the foot of the mountain of shaved ice built from countless tiny brick ice, grapes join hands to praise the wonders of nature."
  },
  {
    "id": "brick-bowl-mandarin-shaved-ice",
    "slug": "brick-bowl-mandarin-shaved-ice",
    "name": "Brick Bowl Mandarin Shaved Ice",
    "kind": "dish",
    "eventKey": "modular-streets",
    "status": "event",
    "aliases": [],
    "image": "/icons/dish/brick-bowl-mandarin-shaved-ice.webp",
    "imageStatus": "verified",
    "sellPrice": 260,
    "energy": null,
    "tags": [
      "recipe",
      "cooking",
      "event",
      "modular-streets"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "On the mountain of shaved ice built from countless tiny brick ice, the relentless spirit of mandarin slices has painted the slopes gold."
  },
  {
    "id": "brick-bowl-pineapple-shaved-ice",
    "slug": "brick-bowl-pineapple-shaved-ice",
    "name": "Brick Bowl Pineapple Shaved Ice",
    "kind": "dish",
    "eventKey": "modular-streets",
    "status": "event",
    "aliases": [],
    "image": "/icons/dish/brick-bowl-pineapple-shaved-ice.webp",
    "imageStatus": "verified",
    "sellPrice": 260,
    "energy": null,
    "tags": [
      "recipe",
      "cooking",
      "event",
      "modular-streets"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "On the mountain of shaved ice built from countless tiny brick ice, pineapple chunks sit atop a cloud of condensed milk, taking in the view."
  },
  {
    "id": "brick-bowl-raspberry-shaved-ice",
    "slug": "brick-bowl-raspberry-shaved-ice",
    "name": "Brick Bowl Raspberry Shaved Ice",
    "kind": "dish",
    "eventKey": "modular-streets",
    "status": "event",
    "aliases": [],
    "image": "/icons/dish/brick-bowl-raspberry-shaved-ice.webp",
    "imageStatus": "verified",
    "sellPrice": 260,
    "energy": null,
    "tags": [
      "recipe",
      "cooking",
      "event",
      "modular-streets"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "On the mountain of shaved ice built from countless tiny brick ice, a pair of raspberries tie the knot."
  },
  {
    "id": "brick-bowl-strawberry-shaved-ice",
    "slug": "brick-bowl-strawberry-shaved-ice",
    "name": "Brick Bowl Strawberry Shaved Ice",
    "kind": "dish",
    "eventKey": "modular-streets",
    "status": "event",
    "aliases": [],
    "image": "/icons/dish/brick-bowl-strawberry-shaved-ice.webp",
    "imageStatus": "verified",
    "sellPrice": 900,
    "energy": null,
    "tags": [
      "recipe",
      "cooking",
      "event",
      "modular-streets"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "On the mountain of shaved ice built from countless tiny brick ice, a giant strawberry takes the crown!"
  },
  {
    "id": "brick-button-mushroom-patty-burger",
    "slug": "brick-button-mushroom-patty-burger",
    "name": "Brick Button Mushroom Patty Burger",
    "kind": "dish",
    "eventKey": "modular-streets",
    "status": "event",
    "aliases": [],
    "image": "/icons/dish/brick-button-mushroom-patty-burger.webp",
    "imageStatus": "verified",
    "sellPrice": 450,
    "energy": null,
    "tags": [
      "recipe",
      "cooking",
      "event",
      "modular-streets"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Plump little button mushrooms—unexpected heroes that give the patty a lift."
  },
  {
    "id": "brick-fun-combo-set",
    "slug": "brick-fun-combo-set",
    "name": "Brick Fun Combo Set",
    "kind": "dish",
    "eventKey": "modular-streets",
    "status": "event",
    "aliases": [],
    "image": "/icons/dish/brick-fun-combo-set.webp",
    "imageStatus": "verified",
    "sellPrice": 1070,
    "energy": null,
    "tags": [
      "recipe",
      "cooking",
      "event",
      "modular-streets"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "The Ultimate Brick Fun Combo Set—mix and match to your heart's content!"
  },
  {
    "id": "brick-mushroom-patty-burger",
    "slug": "brick-mushroom-patty-burger",
    "name": "Brick Mushroom Patty Burger",
    "kind": "dish",
    "eventKey": "modular-streets",
    "status": "event",
    "aliases": [],
    "image": "/icons/dish/brick-mushroom-patty-burger.webp",
    "imageStatus": "verified",
    "sellPrice": 450,
    "energy": null,
    "tags": [
      "recipe",
      "cooking",
      "event",
      "modular-streets"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "The hardest part of making a delicious mushroom patty burger? Getting all the lagers to stay perfectly stacked."
  },
  {
    "id": "brick-oyster-mushroom-patty-burger",
    "slug": "brick-oyster-mushroom-patty-burger",
    "name": "Brick Oyster Mushroom Patty Burger",
    "kind": "dish",
    "eventKey": "modular-streets",
    "status": "event",
    "aliases": [],
    "image": "/icons/dish/brick-oyster-mushroom-patty-burger.webp",
    "imageStatus": "verified",
    "sellPrice": 450,
    "energy": null,
    "tags": [
      "recipe",
      "cooking",
      "event",
      "modular-streets"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "On an ordinary day, nothing soothes the soul quite like a juicy, savory oyster mushroom patty burger."
  },
  {
    "id": "brick-penny-bun-patty-burger",
    "slug": "brick-penny-bun-patty-burger",
    "name": "Brick Penny Bun Patty Burger",
    "kind": "dish",
    "eventKey": "modular-streets",
    "status": "event",
    "aliases": [],
    "image": "/icons/dish/brick-penny-bun-patty-burger.webp",
    "imageStatus": "verified",
    "sellPrice": 450,
    "energy": null,
    "tags": [
      "recipe",
      "cooking",
      "event",
      "modular-streets"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "The finest ingredients need nothing more than a simple white bun to shine. Don't worry, the penny bun inside is perfectly cooked."
  },
  {
    "id": "brick-shiitake-patty-burger",
    "slug": "brick-shiitake-patty-burger",
    "name": "Brick Shiitake Patty Burger",
    "kind": "dish",
    "eventKey": "modular-streets",
    "status": "event",
    "aliases": [],
    "image": "/icons/dish/brick-shiitake-patty-burger.webp",
    "imageStatus": "verified",
    "sellPrice": 450,
    "energy": null,
    "tags": [
      "recipe",
      "cooking",
      "event",
      "modular-streets"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "That bun color looks a little... off. They didn't sneak ang weird shiitake in there, did they?"
  },
  {
    "id": "colorful-egg-feast",
    "slug": "colorful-egg-feast",
    "name": "Colorful Egg Feast",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/colorful-egg-feast.webp",
    "imageStatus": "verified",
    "sellPrice": 1650,
    "energy": null,
    "tags": [
      "recipe",
      "cooking"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Look at all these stunning colorful eggs! If we save them only for celebration days, our cholesterol won't skyrocket, right?"
  },
  {
    "id": "fruit-verbena-pie",
    "slug": "fruit-verbena-pie",
    "name": "Fruit Verbena Pie",
    "kind": "dish",
    "eventKey": "modular-streets",
    "status": "event",
    "aliases": [],
    "image": "/icons/dish/fruit-verbena-pie.webp",
    "imageStatus": "verified",
    "sellPrice": 360,
    "energy": null,
    "tags": [
      "recipe",
      "cooking",
      "event",
      "modular-streets"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "One bite of a fruit flavored pie, and deliciousness loops endlessly in gour mouth."
  },
  {
    "id": "grape-verbena-pie",
    "slug": "grape-verbena-pie",
    "name": "Grape Verbena Pie",
    "kind": "dish",
    "eventKey": "modular-streets",
    "status": "event",
    "aliases": [],
    "image": "/icons/dish/grape-verbena-pie.webp",
    "imageStatus": "verified",
    "sellPrice": 810,
    "energy": null,
    "tags": [
      "recipe",
      "cooking",
      "event",
      "modular-streets"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "How to slice it so the grapes on the crust are perfectly divided? Now that's a real question."
  },
  {
    "id": "grass-cake",
    "slug": "grass-cake",
    "name": "Grass Cake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/grass-cake.webp",
    "imageStatus": "verified",
    "sellPrice": 690,
    "energy": null,
    "tags": [
      "recipe",
      "cooking"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "A special treat from Green Green Grassland, sweet and delicious. It's What Paddi craves even in his dreams."
  },
  {
    "id": "green-egg",
    "slug": "green-egg",
    "name": "Green Egg",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/green-egg.webp",
    "imageStatus": "verified",
    "sellPrice": 570,
    "energy": null,
    "tags": [
      "recipe",
      "cooking"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "A fresh green egg—might just vanish if hidden in the grass."
  },
  {
    "id": "heart-puppies-con-panna",
    "slug": "heart-puppies-con-panna",
    "name": "Heart Puppies Con Panna",
    "kind": "dish",
    "eventKey": "maltese",
    "status": "event",
    "aliases": [],
    "image": "/icons/dish/heart-puppies-con-panna.webp",
    "imageStatus": "verified",
    "sellPrice": 1220,
    "energy": null,
    "tags": [
      "recipe",
      "cooking",
      "event",
      "maltese"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Aww, two little puppies snuggled together in a cup—if you look from afar, they almost form a heart."
  },
  {
    "id": "maltese-canele",
    "slug": "maltese-canele",
    "name": "Maltese Canelé",
    "kind": "dish",
    "eventKey": "maltese",
    "status": "event",
    "aliases": [],
    "image": "/icons/dish/maltese-canele.webp",
    "imageStatus": "verified",
    "sellPrice": 450,
    "energy": 50,
    "tags": [
      "recipe",
      "cooking",
      "event",
      "maltese"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "The maltese sitting atop the canelé makes this pastry even more adorable!"
  },
  {
    "id": "maltese-con-panna",
    "slug": "maltese-con-panna",
    "name": "Maltese Con Panna",
    "kind": "dish",
    "eventKey": "maltese",
    "status": "event",
    "aliases": [],
    "image": "/icons/dish/maltese-con-panna.webp",
    "imageStatus": "verified",
    "sellPrice": 520,
    "energy": null,
    "tags": [
      "recipe",
      "cooking",
      "event",
      "maltese"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Fresh cream shaped like a maltese floats gently on gour coffee. A nice combination, isn't it?"
  },
  {
    "id": "mandarin-verbena-pie",
    "slug": "mandarin-verbena-pie",
    "name": "Mandarin Verbena Pie",
    "kind": "dish",
    "eventKey": "modular-streets",
    "status": "event",
    "aliases": [],
    "image": "/icons/dish/mandarin-verbena-pie.webp",
    "imageStatus": "verified",
    "sellPrice": 360,
    "energy": null,
    "tags": [
      "recipe",
      "cooking",
      "event",
      "modular-streets"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "A mandarin pie wearing a \"pearl necklace\"—elegance never goes out of Style."
  },
  {
    "id": "orange-egg",
    "slug": "orange-egg",
    "name": "Orange Egg",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/orange-egg.webp",
    "imageStatus": "verified",
    "sellPrice": 190,
    "energy": null,
    "tags": [
      "recipe",
      "cooking"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "An egg bursting with passion. Wonder if gour fingers Will turn orange peeling it?"
  },
  {
    "id": "pillow-shaped-egg-yolk-and-pork-zongzi",
    "slug": "pillow-shaped-egg-yolk-and-pork-zongzi",
    "name": "Pillow-Shaped Egg Yolk & Pork Zongzi",
    "kind": "dish",
    "eventKey": "midsummer-rhyme",
    "status": "event",
    "aliases": [],
    "image": "/icons/dish/pillow-shaped-egg-yolk-and-pork-zongzi.webp",
    "imageStatus": "verified",
    "sellPrice": 400,
    "energy": 55,
    "tags": [
      "recipe",
      "cooking",
      "event",
      "midsummer-rhyme"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there."
  },
  {
    "id": "pillow-shaped-plain-rice-zongzi",
    "slug": "pillow-shaped-plain-rice-zongzi",
    "name": "Pillow-Shaped Plain Rice Zongzi",
    "kind": "dish",
    "eventKey": "midsummer-rhyme",
    "status": "event",
    "aliases": [],
    "image": "/icons/dish/pillow-shaped-plain-rice-zongzi.webp",
    "imageStatus": "verified",
    "sellPrice": 400,
    "energy": 55,
    "tags": [
      "recipe",
      "cooking",
      "event",
      "midsummer-rhyme"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "A soft, fragrant pillow-shaped Plain rice zongzi paired with savory sides—a classic choice for savory lovers."
  },
  {
    "id": "pillow-shaped-red-bean-zongzi",
    "slug": "pillow-shaped-red-bean-zongzi",
    "name": "Pillow-Shaped Red Bean Zongzi",
    "kind": "dish",
    "eventKey": "midsummer-rhyme",
    "status": "event",
    "aliases": [],
    "image": "/icons/dish/pillow-shaped-red-bean-zongzi.webp",
    "imageStatus": "verified",
    "sellPrice": 400,
    "energy": 55,
    "tags": [
      "recipe",
      "cooking",
      "event",
      "midsummer-rhyme"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "A smooth, creamy pillow-shaped red bean zongzi with a runny center—careful, it's hot!"
  },
  {
    "id": "pineapple-verbena-pie",
    "slug": "pineapple-verbena-pie",
    "name": "Pineapple Verbena Pie",
    "kind": "dish",
    "eventKey": "modular-streets",
    "status": "event",
    "aliases": [],
    "image": "/icons/dish/pineapple-verbena-pie.webp",
    "imageStatus": "verified",
    "sellPrice": 380,
    "energy": null,
    "tags": [
      "recipe",
      "cooking",
      "event",
      "modular-streets"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Dig a little hole in the crust, and out blooms a pineapple flower."
  },
  {
    "id": "purple-egg",
    "slug": "purple-egg",
    "name": "Purple Egg",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/purple-egg.webp",
    "imageStatus": "verified",
    "sellPrice": 620,
    "energy": null,
    "tags": [
      "recipe",
      "cooking"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "An egg draped in royal purple. Even if it's just food coloring, please savor it with a solemn heart."
  },
  {
    "id": "rainbow-heart",
    "slug": "rainbow-heart",
    "name": "Rainbow Heart",
    "kind": "dish",
    "eventKey": "rainbow-verse",
    "status": "event",
    "aliases": [],
    "image": "/icons/dish/rainbow-heart.webp",
    "imageStatus": "verified",
    "sellPrice": 600,
    "energy": 80,
    "tags": [
      "recipe",
      "cooking",
      "event",
      "rainbow-verse"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Embrace the rainbow, own the color!"
  },
  {
    "id": "rainbow-spark",
    "slug": "rainbow-spark",
    "name": "Rainbow Spark",
    "kind": "dish",
    "eventKey": "rainbow-verse",
    "status": "event",
    "aliases": [],
    "image": "/icons/dish/rainbow-spark.webp",
    "imageStatus": "verified",
    "sellPrice": 550,
    "energy": 75,
    "tags": [
      "recipe",
      "cooking",
      "event",
      "rainbow-verse"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Touch the rainbow, feel the spark!"
  },
  {
    "id": "raspberry-verbena-pie",
    "slug": "raspberry-verbena-pie",
    "name": "Raspberry Verbena Pie",
    "kind": "dish",
    "eventKey": "modular-streets",
    "status": "event",
    "aliases": [],
    "image": "/icons/dish/raspberry-verbena-pie.webp",
    "imageStatus": "verified",
    "sellPrice": 380,
    "energy": null,
    "tags": [
      "recipe",
      "cooking",
      "event",
      "modular-streets"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Visit Whale Island, wander through the fun Modular Streets, and savor the tangy sweetness of raspberry pie..."
  },
  {
    "id": "retriever-canele",
    "slug": "retriever-canele",
    "name": "Retriever Canelé",
    "kind": "dish",
    "eventKey": "maltese",
    "status": "event",
    "aliases": [],
    "image": "/icons/dish/retriever-canele.webp",
    "imageStatus": "verified",
    "sellPrice": 590,
    "energy": null,
    "tags": [
      "recipe",
      "cooking",
      "event",
      "maltese"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "The maltese sitting atop the canelé makes this pastry even more adorable!"
  },
  {
    "id": "retriever-con-panna",
    "slug": "retriever-con-panna",
    "name": "Retriever Con Panna",
    "kind": "dish",
    "eventKey": "maltese",
    "status": "event",
    "aliases": [],
    "image": "/icons/dish/retriever-con-panna.webp",
    "imageStatus": "verified",
    "sellPrice": 520,
    "energy": null,
    "tags": [
      "recipe",
      "cooking",
      "event",
      "maltese"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Fresh cream shaped like a maltese floats gently on your coffee. A nice combination, isn't it?"
  },
  {
    "id": "springdag-raspberry-black-tea",
    "slug": "springdag-raspberry-black-tea",
    "name": "Springdag Raspberry Black Tea",
    "kind": "dish",
    "eventKey": "dreamlight-cinematics",
    "status": "event",
    "aliases": [],
    "image": "/icons/dish/springdag-raspberry-black-tea.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [
      "recipe",
      "cooking",
      "event",
      "dreamlight-cinematics"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Pure black tea with fresh raspberries, each sip is a quirky springtime fantasy."
  },
  {
    "id": "springday-apple-black-tea",
    "slug": "springday-apple-black-tea",
    "name": "Springday Apple Black Tea",
    "kind": "dish",
    "eventKey": "dreamlight-cinematics",
    "status": "event",
    "aliases": [],
    "image": "/icons/dish/springday-apple-black-tea.webp",
    "imageStatus": "verified",
    "sellPrice": 480,
    "energy": null,
    "tags": [
      "recipe",
      "cooking",
      "event",
      "dreamlight-cinematics"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Pure black tea with fresh apple, pure and simple like a love story."
  },
  {
    "id": "springday-blueberry-black-tea",
    "slug": "springday-blueberry-black-tea",
    "name": "Springday Blueberry Black Tea",
    "kind": "dish",
    "eventKey": "dreamlight-cinematics",
    "status": "event",
    "aliases": [],
    "image": "/icons/dish/springday-blueberry-black-tea.webp",
    "imageStatus": "verified",
    "sellPrice": 460,
    "energy": null,
    "tags": [
      "recipe",
      "cooking",
      "event",
      "dreamlight-cinematics"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Pure black tea with fresh blueberries, a fantasy adventure into the deep sea and dreams."
  },
  {
    "id": "springday-fruit-black-tea",
    "slug": "springday-fruit-black-tea",
    "name": "Springday Fruit Black Tea",
    "kind": "dish",
    "eventKey": "dreamlight-cinematics",
    "status": "event",
    "aliases": [],
    "image": "/icons/dish/springday-fruit-black-tea.webp",
    "imageStatus": "verified",
    "sellPrice": 460,
    "energy": null,
    "tags": [
      "recipe",
      "cooking",
      "event",
      "dreamlight-cinematics"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Pure black tea with fresh fruits—stacked with stars, packed with nutrition."
  },
  {
    "id": "springday-grape-black-tea",
    "slug": "springday-grape-black-tea",
    "name": "Springday Grape Black Tea",
    "kind": "dish",
    "eventKey": "dreamlight-cinematics",
    "status": "event",
    "aliases": [],
    "image": "/icons/dish/springday-grape-black-tea.webp",
    "imageStatus": "verified",
    "sellPrice": 910,
    "energy": null,
    "tags": [
      "recipe",
      "cooking",
      "event",
      "dreamlight-cinematics"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Pure black tea with fresh grapes—softly murmuring, like a tale woven in mist."
  },
  {
    "id": "springday-mandarin-black-tea",
    "slug": "springday-mandarin-black-tea",
    "name": "Springday Mandarin Black Tea",
    "kind": "dish",
    "eventKey": "dreamlight-cinematics",
    "status": "event",
    "aliases": [],
    "image": "/icons/dish/springday-mandarin-black-tea.webp",
    "imageStatus": "verified",
    "sellPrice": 480,
    "energy": null,
    "tags": [
      "recipe",
      "cooking",
      "event",
      "dreamlight-cinematics"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Pure black tea with fresh orange—filled with the sweet-and-sour zest of a coming-of-age story."
  },
  {
    "id": "springday-pineapple-black-tea",
    "slug": "springday-pineapple-black-tea",
    "name": "Springday Pineapple Black Tea",
    "kind": "dish",
    "eventKey": "dreamlight-cinematics",
    "status": "event",
    "aliases": [],
    "image": "/icons/dish/springday-pineapple-black-tea.webp",
    "imageStatus": "verified",
    "sellPrice": 480,
    "energy": null,
    "tags": [
      "recipe",
      "cooking",
      "event",
      "dreamlight-cinematics"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Pure black tea with fresh pineapple—its refreshing taste barrels through like a race car in a road movie."
  },
  {
    "id": "springday-strawberry-black-tea",
    "slug": "springday-strawberry-black-tea",
    "name": "Springday Strawberry Black Tea",
    "kind": "dish",
    "eventKey": "dreamlight-cinematics",
    "status": "event",
    "aliases": [],
    "image": "/icons/dish/springday-strawberry-black-tea.webp",
    "imageStatus": "verified",
    "sellPrice": 800,
    "energy": null,
    "tags": [
      "recipe",
      "cooking",
      "event",
      "dreamlight-cinematics"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Pure black tea with fresh strawberries, a sweet encounter bubbling with Pink romance.\n"
  },
  {
    "id": "strawberry-jam",
    "slug": "strawberry-jam",
    "name": "Strawberry Jam",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/strawberry-jam.webp",
    "imageStatus": "verified",
    "sellPrice": 1580,
    "energy": null,
    "tags": [
      "recipe",
      "cooking"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Turn strawberries into jam to enjoy the sweet and tart taste anytime."
  },
  {
    "id": "strawberry-verbena-pie",
    "slug": "strawberry-verbena-pie",
    "name": "Strawberry Verbena Pie",
    "kind": "dish",
    "eventKey": "modular-streets",
    "status": "event",
    "aliases": [],
    "image": "/icons/dish/strawberry-verbena-pie.webp",
    "imageStatus": "verified",
    "sellPrice": 710,
    "energy": null,
    "tags": [
      "recipe",
      "cooking",
      "event",
      "modular-streets"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "What's the best flavor? Hard to say—bUt the strawberry pie sure looks stunning."
  },
  {
    "id": "supreme-movie-meal",
    "slug": "supreme-movie-meal",
    "name": "Supreme Movie Meal",
    "kind": "dish",
    "eventKey": "dreamlight-cinematics",
    "status": "event",
    "aliases": [],
    "image": "/icons/dish/supreme-movie-meal.webp",
    "imageStatus": "verified",
    "sellPrice": 2370,
    "energy": null,
    "tags": [
      "recipe",
      "cooking",
      "event",
      "dreamlight-cinematics"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Ultimate Flavor Combo Set—every bite treats you like the main character. Don't worrg, the on-screen stars won't reach out and steal gour food. Well, usually."
  },
  {
    "id": "triangle-egg-yolk-and-pork-zongzi",
    "slug": "triangle-egg-yolk-and-pork-zongzi",
    "name": "Triangle Egg Yolk & Pork Zongzi",
    "kind": "dish",
    "eventKey": "midsummer-rhyme",
    "status": "event",
    "aliases": [],
    "image": "/icons/dish/triangle-egg-yolk-and-pork-zongzi.webp",
    "imageStatus": "verified",
    "sellPrice": 400,
    "energy": 55,
    "tags": [
      "recipe",
      "cooking",
      "event",
      "midsummer-rhyme"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there."
  },
  {
    "id": "triangle-plain-rice-zongzi",
    "slug": "triangle-plain-rice-zongzi",
    "name": "Triangle Plain Rice Zongzi",
    "kind": "dish",
    "eventKey": "midsummer-rhyme",
    "status": "event",
    "aliases": [],
    "image": "/icons/dish/triangle-plain-rice-zongzi.webp",
    "imageStatus": "verified",
    "sellPrice": 400,
    "energy": 55,
    "tags": [
      "recipe",
      "cooking",
      "event",
      "midsummer-rhyme"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "The crystal-clear triangle Plain rice zongzi is best enjoyed hot, dipped in sugar."
  },
  {
    "id": "triangle-red-bean-zongzi",
    "slug": "triangle-red-bean-zongzi",
    "name": "Triangle Red Bean Zongzi",
    "kind": "dish",
    "eventKey": "midsummer-rhyme",
    "status": "event",
    "aliases": [],
    "image": "/icons/dish/triangle-red-bean-zongzi.webp",
    "imageStatus": "verified",
    "sellPrice": 400,
    "energy": 55,
    "tags": [
      "recipe",
      "cooking",
      "event",
      "midsummer-rhyme"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "A triangle red bean zongzi, packed with whole beans. Take your time chewing—don't just swallow it whole."
  },
  {
    "id": "blue-european-crayfish-sashimi",
    "slug": "blue-european-crayfish-sashimi",
    "name": "Blue European Crayfish Sashimi",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/blue-european-crayfish-sashimi.webp",
    "imageStatus": "verified",
    "sellPrice": 1310,
    "energy": null,
    "tags": [
      "recipe",
      "cooking"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "A rarer and more expensive version of the Crayfish Sashimi, offering the most elevating taste experience."
  },
  {
    "id": "steamed-golden-king-crab",
    "slug": "steamed-golden-king-crab",
    "name": "Steamed Golden King Crab",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/steamed-golden-king-crab.webp",
    "imageStatus": "verified",
    "sellPrice": 2980,
    "energy": null,
    "tags": [
      "recipe",
      "cooking"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "A prized ingredient like the Golden King Crab needs no complex preparation, its flavor speaks for itself."
  },
  {
    "id": "steamed-king-crab",
    "slug": "steamed-king-crab",
    "name": "Steamed King Crab",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/steamed-king-crab.webp",
    "imageStatus": "verified",
    "sellPrice": 1990,
    "energy": null,
    "tags": [
      "recipe",
      "cooking"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Even though it’s complicated to eat, many people still flock to this dish—that alone speaks for its deliciousness."
  },
  {
    "id": "apple-milkshake",
    "slug": "apple-milkshake",
    "name": "Apple Milkshake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/apple-milkshake.webp",
    "imageStatus": "verified",
    "sellPrice": 450,
    "energy": null,
    "tags": [
      "recipe",
      "cooking"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Chunks of fresh apple bring crunchiness to this milkshake."
  },
  {
    "id": "blueberry-milkshake",
    "slug": "blueberry-milkshake",
    "name": "Blueberry Milkshake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/blueberry-milkshake.webp",
    "imageStatus": "verified",
    "sellPrice": 400,
    "energy": null,
    "tags": [
      "recipe",
      "cooking"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Chunks of fresh blueberry bring freshness to this milkshake."
  },
  {
    "id": "cocoa-milk-tea",
    "slug": "cocoa-milk-tea",
    "name": "Cocoa Milk Tea",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/cocoa-milk-tea.webp",
    "imageStatus": "verified",
    "sellPrice": 1120,
    "energy": null,
    "tags": [
      "recipe",
      "cooking"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "A blend of cocoa powder and milk in the golden ratio, slightly sweeter than Mellow Milk Tea."
  },
  {
    "id": "cocoa-milkshake",
    "slug": "cocoa-milkshake",
    "name": "Cocoa Milkshake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/cocoa-milkshake.webp",
    "imageStatus": "verified",
    "sellPrice": 1000,
    "energy": null,
    "tags": [
      "recipe",
      "cooking"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "With just the right amount of cocoa powder, this classic combination rules the taste buds."
  },
  {
    "id": "grape-milkshake",
    "slug": "grape-milkshake",
    "name": "Grape Milkshake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/grape-milkshake.webp",
    "imageStatus": "verified",
    "sellPrice": 1300,
    "energy": null,
    "tags": [
      "recipe",
      "cooking"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Chunks of fresh grape bring a honey-like sweetness to this milkshake."
  },
  {
    "id": "mandarin-milkshake",
    "slug": "mandarin-milkshake",
    "name": "Mandarin Milkshake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/mandarin-milkshake.webp",
    "imageStatus": "verified",
    "sellPrice": 450,
    "energy": null,
    "tags": [
      "recipe",
      "cooking"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Chunks of fresh apple bring crunchiness to this milkshake."
  },
  {
    "id": "matcha-milkshake",
    "slug": "matcha-milkshake",
    "name": "Matcha Milkshake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/matcha-milkshake.webp",
    "imageStatus": "verified",
    "sellPrice": 840,
    "energy": null,
    "tags": [
      "recipe",
      "cooking"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "The right amount of matcha powder creates a deep, bittersweet and lingering flavor."
  },
  {
    "id": "mellow-black-tea",
    "slug": "mellow-black-tea",
    "name": "Mellow Black Tea",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/mellow-black-tea.webp",
    "imageStatus": "verified",
    "sellPrice": 840,
    "energy": null,
    "tags": [
      "recipe",
      "cooking"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Brewed from black tea leaves, featuring a bright red color and rich flavor with a slight hint of bitterness."
  },
  {
    "id": "mellow-milk-tea",
    "slug": "mellow-milk-tea",
    "name": "Mellow Milk Tea",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/mellow-milk-tea.webp",
    "imageStatus": "verified",
    "sellPrice": 840,
    "energy": null,
    "tags": [
      "recipe",
      "cooking"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "A blend of black tea and milk in the golden ratio, wrapped up in deliciousness."
  },
  {
    "id": "milkshake",
    "slug": "milkshake",
    "name": "Milkshake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/milkshake.webp",
    "imageStatus": "verified",
    "sellPrice": 400,
    "energy": null,
    "tags": [
      "recipe",
      "cooking"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "No water added, just four full boxes of milk blended into one pure milkshake."
  },
  {
    "id": "pineapple-milkshake",
    "slug": "pineapple-milkshake",
    "name": "Pineapple Milkshake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/pineapple-milkshake.webp",
    "imageStatus": "verified",
    "sellPrice": 440,
    "energy": null,
    "tags": [
      "recipe",
      "cooking"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Chunks of fresh pineapple bring tropical flavor to this milkshake."
  },
  {
    "id": "raspberry-milkshake",
    "slug": "raspberry-milkshake",
    "name": "Raspberry Milkshake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/raspberry-milkshake.webp",
    "imageStatus": "verified",
    "sellPrice": 440,
    "energy": null,
    "tags": [
      "recipe",
      "cooking"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Chunks of fresh raspberry bring tartness to this milkshake."
  },
  {
    "id": "strawberry-milkshake",
    "slug": "strawberry-milkshake",
    "name": "Strawberry Milkshake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/strawberry-milkshake.webp",
    "imageStatus": "verified",
    "sellPrice": 1090,
    "energy": null,
    "tags": [
      "recipe",
      "cooking"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Chunks of fresh strawberry bring sweetness to this milkshake."
  },
  {
    "id": "daisy-tea",
    "slug": "daisy-tea",
    "name": "Daisy Tea",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/daisy-tea.webp",
    "imageStatus": "verified",
    "sellPrice": 600,
    "energy": 30,
    "tags": [
      "recipe",
      "cooking"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "With a few daisies in the brew, this golden tea soothes fevers and brightens the eyes."
  },
  {
    "id": "exquisite-afternoon-tea",
    "slug": "exquisite-afternoon-tea",
    "name": "Exquisite Afternoon Tea",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/exquisite-afternoon-tea.webp",
    "imageStatus": "verified",
    "sellPrice": 2970,
    "energy": null,
    "tags": [
      "recipe",
      "cooking"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Bunny's so cute... How could angone bear to eat bunny's... afternoon tea?"
  },
  {
    "id": "green-milk-tea",
    "slug": "green-milk-tea",
    "name": "Green Milk Tea",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/green-milk-tea.webp",
    "imageStatus": "verified",
    "sellPrice": 500,
    "energy": null,
    "tags": [
      "recipe",
      "cooking"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "A blend of green tea and milk in the golden ratio, fragrant, refreshing, and an excellent palate cleanser."
  },
  {
    "id": "green-tea",
    "slug": "green-tea",
    "name": "Green Tea",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/green-tea.webp",
    "imageStatus": "verified",
    "sellPrice": 500,
    "energy": 35,
    "tags": [
      "recipe",
      "cooking"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Brewed from green tea leaves, featuring a vibrant green color and an invigorating effect."
  },
  {
    "id": "matcha-green-milk-tea",
    "slug": "matcha-green-milk-tea",
    "name": "Matcha Green Milk Tea",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/matcha-green-milk-tea.webp",
    "imageStatus": "verified",
    "sellPrice": 700,
    "energy": null,
    "tags": [
      "recipe",
      "cooking"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "A blend of matcha powder and milk in the golden ratio, slightly more bitter than the green milk tea."
  },
  {
    "id": "rose-tea",
    "slug": "rose-tea",
    "name": "Rose Tea",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/rose-tea.webp",
    "imageStatus": "verified",
    "sellPrice": 1930,
    "energy": 30,
    "tags": [
      "recipe",
      "cooking"
    ],
    "sourceRefs": [
      "heartodex:recipe"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "With a few rose buds in the brew, this bright rosy-pink tea has a sweet and fragrant aroma."
  },
  {
    "id": "blue-brick-sparrow",
    "slug": "blue-brick-sparrow",
    "name": "Blue Brick Sparrow",
    "kind": "bird",
    "eventKey": "modular-streets",
    "status": "event",
    "aliases": [],
    "image": "/icons/bird/blue-brick-sparrow.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [
      "birdwatching",
      "event",
      "modular-streets"
    ],
    "sourceRefs": [
      "heartodex:bird"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "The blue toy Sparrow borrows real habitat trivia for its Modular Streets joke. Heartopia connects sparrows with open woods and areas near water while presenting the bird itself as a block-built collectible."
  },
  {
    "id": "purple-brick-sparrow",
    "slug": "purple-brick-sparrow",
    "name": "Purple Brick Sparrow",
    "kind": "bird",
    "eventKey": "modular-streets",
    "status": "event",
    "aliases": [],
    "image": "/icons/bird/purple-brick-sparrow.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [
      "birdwatching",
      "event",
      "modular-streets"
    ],
    "sourceRefs": [
      "heartodex:bird"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Natural purple birds are uncommon, so the Modular Streets version turns scarcity into a joke: seeing a purple Sparrow is much easier when the bird is assembled from purple toy bricks instead of found in nature."
  },
  {
    "id": "colorful-brick-sparrow",
    "slug": "colorful-brick-sparrow",
    "name": "Colorful Brick Sparrow",
    "kind": "bird",
    "eventKey": "modular-streets",
    "status": "event",
    "aliases": [],
    "image": "/icons/bird/colorful-brick-sparrow.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [
      "birdwatching",
      "event",
      "modular-streets"
    ],
    "sourceRefs": [
      "heartodex:bird"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "This multicolored Sparrow leans fully into Modular Streets' educational-toy joke. Heartopia imagines brick-built birds making bird trivia fashionable enough that learning about sparrows becomes unexpectedly mainstream."
  },
  {
    "id": "pink-brick-sparrow",
    "slug": "pink-brick-sparrow",
    "name": "Pink Brick Sparrow",
    "kind": "bird",
    "eventKey": "modular-streets",
    "status": "event",
    "aliases": [],
    "image": "/icons/bird/pink-brick-sparrow.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [
      "birdwatching",
      "event",
      "modular-streets"
    ],
    "sourceRefs": [
      "heartodex:bird"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "The Pink Brick Sparrow gets its rosy appearance from construction pieces, not biology. Heartopia uses the toy version to joke that genuinely pink birds usually need some explanation beyond simply being born that way."
  },
  {
    "id": "green-brick-sparrow",
    "slug": "green-brick-sparrow",
    "name": "Green Brick Sparrow",
    "kind": "bird",
    "eventKey": "modular-streets",
    "status": "event",
    "aliases": [],
    "image": "/icons/bird/green-brick-sparrow.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [
      "birdwatching",
      "event",
      "modular-streets"
    ],
    "sourceRefs": [
      "heartodex:bird"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "A camouflage principle supplies the green toy Sparrow's trivia. Countershading uses a paler belly to reduce contrast against a bright sky when an animal is viewed from underneath by a predator."
  },
  {
    "id": "blue-suit-dove",
    "slug": "blue-suit-dove",
    "name": "Blue Suit Dove",
    "kind": "bird",
    "eventKey": "dreamlight-cinematics",
    "status": "event",
    "aliases": [],
    "image": "/icons/bird/blue-suit-dove.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [
      "birdwatching",
      "event",
      "dreamlight-cinematics"
    ],
    "sourceRefs": [
      "heartodex:bird"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Dreamlight Cinematics casts Blue Suit Dove in a corporate drama rather than giving it ordinary bird lore. Its role is the calculating mastermind behind the story, turning the suited dove into a film character with a clear archetype."
  },
  {
    "id": "gray-suit-dove",
    "slug": "gray-suit-dove",
    "name": "Gray Suit Dove",
    "kind": "bird",
    "eventKey": "dreamlight-cinematics",
    "status": "event",
    "aliases": [],
    "image": "/icons/bird/gray-suit-dove.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [
      "birdwatching",
      "event",
      "dreamlight-cinematics"
    ],
    "sourceRefs": [
      "heartodex:bird"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "In Dreamlight Cinematics, the gray-suited bird is an urban wanderer who cannot find the way through a colorless city. The costume supports a movie-character vignette rather than natural dove behavior."
  },
  {
    "id": "striped-suit-dove",
    "slug": "striped-suit-dove",
    "name": "Striped Suit Dove",
    "kind": "bird",
    "eventKey": "dreamlight-cinematics",
    "status": "event",
    "aliases": [],
    "image": "/icons/bird/striped-suit-dove.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [
      "birdwatching",
      "event",
      "dreamlight-cinematics"
    ],
    "sourceRefs": [
      "heartodex:bird"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Dreamlight Cinematics turns the striped-suited bird into a specialist in deliberately strange cinema. Its recurring niche is bizarre satire, making the costume part of an eccentric performer persona."
  },
  {
    "id": "red-suit-dove",
    "slug": "red-suit-dove",
    "name": "Red Suit Dove",
    "kind": "bird",
    "eventKey": "dreamlight-cinematics",
    "status": "event",
    "aliases": [],
    "image": "/icons/bird/red-suit-dove.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [
      "birdwatching",
      "event",
      "dreamlight-cinematics"
    ],
    "sourceRefs": [
      "heartodex:bird"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Red Suit Dove receives the antagonist slot in Dreamlight Cinematics. Its character is written as dangerously unstable, using the bright suit to reinforce a deliberately theatrical villain role."
  },
  {
    "id": "green-suit-dove",
    "slug": "green-suit-dove",
    "name": "Green Suit Dove",
    "kind": "bird",
    "eventKey": "dreamlight-cinematics",
    "status": "event",
    "aliases": [],
    "image": "/icons/bird/green-suit-dove.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [
      "birdwatching",
      "event",
      "dreamlight-cinematics"
    ],
    "sourceRefs": [
      "heartodex:bird"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "An arthouse role defines the green-suited bird: Heartopia casts it as a professor carrying hidden secrets. The event entry is therefore a film-character sketch rather than ordinary dove lore."
  },
  {
    "id": "green-peafowl",
    "slug": "green-peafowl",
    "name": "Green Peafowl",
    "kind": "bird",
    "eventKey": "nest-of-hundreds",
    "status": "event",
    "aliases": [],
    "image": "/icons/bird/green-peafowl.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [
      "birdwatching",
      "event",
      "nest-of-hundreds"
    ],
    "sourceRefs": [
      "heartodex:bird"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "This bird was reserved for the additional phase of Nest of Hundreds. Heartopia links its green-bronze feathers with status and good fortune, giving the limited encounter an auspicious, aristocratic tone."
  },
  {
    "id": "white-peafowl",
    "slug": "white-peafowl",
    "name": "White Peafowl",
    "kind": "bird",
    "eventKey": "nest-of-hundreds",
    "status": "event",
    "aliases": [],
    "image": "/icons/bird/white-peafowl.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [
      "birdwatching",
      "event",
      "nest-of-hundreds"
    ],
    "sourceRefs": [
      "heartodex:bird"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "White Peafowl was a limited Nest of Hundreds bonus-stage target rather than part of the ordinary permanent bird pool. That event restriction is the most important context separating the variant from standard peafowl sightings."
  },
  {
    "id": "black-peafowl",
    "slug": "black-peafowl",
    "name": "Black Peafowl",
    "kind": "bird",
    "eventKey": "nest-of-hundreds",
    "status": "event",
    "aliases": [],
    "image": "/icons/bird/black-peafowl.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [
      "birdwatching",
      "event",
      "nest-of-hundreds"
    ],
    "sourceRefs": [
      "heartodex:bird"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "The black variant was obtainable through Nest of Hundreds' additional event phase, not the normal permanent bird pool. Its main gameplay distinction is therefore limited-event availability."
  },
  {
    "id": "baikal-teal",
    "slug": "baikal-teal",
    "name": "Baikal Teal",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/baikal-teal.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [
      "birdwatching"
    ],
    "sourceRefs": [
      "heartodex:bird"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Baikal Teal is a small dabbling duck best known for the male's highly patterned head, where green, yellow, black and cream areas form a striking face design. Females are much more subdued and mottled."
  },
  {
    "id": "inca-tern",
    "slug": "inca-tern",
    "name": "Inca Tern",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/inca-tern.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [
      "birdwatching"
    ],
    "sourceRefs": [
      "heartodex:bird"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Inca Tern is a dark seabird with a bright red bill and unmistakable white feather plumes curling away from the face like a moustache. That facial ornament is one of the species' easiest real-world identifiers."
  },
  {
    "id": "chestnut-cheeked-starling",
    "slug": "chestnut-cheeked-starling",
    "name": "Chestnut-Cheeked Starling",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/chestnut-cheeked-starling.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [
      "birdwatching"
    ],
    "sourceRefs": [
      "heartodex:bird"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Chestnut-Cheeked Starling is a compact East Asian starling whose name comes from the warm brown coloring around the face. Darker wings and a lighter body create a noticeable contrast in its plumage."
  },
  {
    "id": "blue-headed-quail-dove",
    "slug": "blue-headed-quail-dove",
    "name": "Blue-Headed Quail-Dove",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/blue-headed-quail-dove.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [
      "birdwatching"
    ],
    "sourceRefs": [
      "heartodex:bird"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Blue-Headed Quail-Dove is a stocky ground-oriented dove recognized by the cool blue tone across its head. Like other quail-doves, it has a heavier, more terrestrial build than the typical city pigeon silhouette."
  },
  {
    "id": "snowy-owl",
    "slug": "snowy-owl",
    "name": "Snowy Owl",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/snowy-owl.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [
      "birdwatching"
    ],
    "sourceRefs": [
      "heartodex:bird"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "For this white owl, the useful Heartodex clue is vertical: search the upper branches. Looking through treetops is more effective than watching only paths or the ground when trying to record the bird."
  },
  {
    "id": "red-browed-finch",
    "slug": "red-browed-finch",
    "name": "Red-Browed Finch",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/red-browed-finch.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [
      "birdwatching"
    ],
    "sourceRefs": [
      "heartodex:bird"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Red-Browed Finch is a small Australian finch marked by a vivid red stripe above the eye and additional red coloring near the rump. Those accents stand out sharply against its otherwise olive-gray body."
  },
  {
    "id": "atlantic-puffin",
    "slug": "atlantic-puffin",
    "name": "Atlantic Puffin",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/atlantic-puffin.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [
      "birdwatching"
    ],
    "sourceRefs": [
      "heartodex:bird"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Atlantic Puffin is a compact seabird built for diving after fish. During the breeding season, its deep triangular bill becomes brightly colored, producing the familiar clown-like face that makes the species easy to recognize."
  },
  {
    "id": "blue-footed-booby",
    "slug": "blue-footed-booby",
    "name": "Blue-Footed Booby",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/blue-footed-booby.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [
      "birdwatching"
    ],
    "sourceRefs": [
      "heartodex:bird"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Blue-Footed Booby is famous for the intense blue skin on its feet. Those feet are not merely decorative: males emphasize them during courtship displays, making foot color part of how the bird advertises itself to a mate."
  },
  {
    "id": "whooper-swan",
    "slug": "whooper-swan",
    "name": "Whooper Swan",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/whooper-swan.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [
      "birdwatching"
    ],
    "sourceRefs": [
      "heartodex:bird"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Whooper Swan is a large white swan with a long neck and a yellow-and-black bill. It is also strongly migratory, traveling long distances between breeding and wintering areas rather than remaining in one place all year."
  },
  {
    "id": "black-swan",
    "slug": "black-swan",
    "name": "Black Swan",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/black-swan.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [
      "birdwatching"
    ],
    "sourceRefs": [
      "heartodex:bird"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Black Swan reverses the usual swan color scheme with mostly dark plumage, while the bright red bill provides a strong contrast. Adults also show white flight feathers that become especially visible when the wings open."
  },
  {
    "id": "black-stork",
    "slug": "black-stork",
    "name": "Black Stork",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/black-stork.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [
      "birdwatching"
    ],
    "sourceRefs": [
      "heartodex:bird"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Black Stork combines glossy dark upper plumage with a white underside and vivid red bill and legs. Compared with many familiar storks, it is notably shy and tends to favor quieter wetlands and forested waterways."
  },
  {
    "id": "spectacled-owl",
    "slug": "spectacled-owl",
    "name": "Spectacled Owl",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/spectacled-owl.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [
      "birdwatching"
    ],
    "sourceRefs": [
      "heartodex:bird"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "For Spectacled Owl, Heartopia again rewards looking above eye level. The observation tip directs players toward treetops, making canopy scanning the efficient approach for finding the bird."
  },
  {
    "id": "director-common-octopus-with-patterned-hat",
    "slug": "director-common-octopus-with-patterned-hat",
    "name": "Director Common Octopus w/ Patterned Hat",
    "kind": "fish",
    "eventKey": "dreamlight-cinematics",
    "status": "event",
    "aliases": [],
    "image": "/icons/fish/director-common-octopus-with-patterned-hat.webp",
    "imageStatus": "verified",
    "sellPrice": 320,
    "energy": null,
    "tags": [
      "fishing",
      "event",
      "dreamlight-cinematics"
    ],
    "sourceRefs": [
      "heartodex:fish"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "This patterned-hat Common Octopus is written as a director with unusually good control over lighting. Its sensitivity to light becomes a filmmaking advantage, helping the toy character tune illumination on set with precision."
  },
  {
    "id": "asian-arowana",
    "slug": "asian-arowana",
    "name": "Asian Arowana",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/asian-arowana.webp",
    "imageStatus": "verified",
    "sellPrice": 320,
    "energy": null,
    "tags": [
      "fishing"
    ],
    "sourceRefs": [
      "heartodex:fish"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Asian Arowana is a long-bodied freshwater fish with large scales and an upturned mouth adapted to feeding near the surface. Its sleek shape and metallic-looking scales are major reasons it is prized as an ornamental fish."
  },
  {
    "id": "blackspot-sergeant",
    "slug": "blackspot-sergeant",
    "name": "Blackspot Sergeant",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/blackspot-sergeant.webp",
    "imageStatus": "verified",
    "sellPrice": 610,
    "energy": null,
    "tags": [
      "fishing"
    ],
    "sourceRefs": [
      "heartodex:fish"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Blackspot Sergeant is a small tropical reef fish with dark vertical bars across a pale body and a conspicuous black mark near the tail. Those bold markings give the species its military-sounding common name."
  },
  {
    "id": "lionhead",
    "slug": "lionhead",
    "name": "Lionhead",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/lionhead.webp",
    "imageStatus": "verified",
    "sellPrice": 395,
    "energy": null,
    "tags": [
      "fishing"
    ],
    "sourceRefs": [
      "heartodex:fish"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Lionhead is an ornamental goldfish variety bred for a rounded body and a fleshy head growth known as a wen. Unlike many fancy goldfish, the traditional Lionhead also lacks a dorsal fin."
  },
  {
    "id": "whale-shark",
    "slug": "whale-shark",
    "name": "Whale Shark",
    "kind": "fish",
    "eventKey": "sea-fishing",
    "status": "event",
    "aliases": [],
    "image": "/icons/fish/whale-shark.webp",
    "imageStatus": "verified",
    "sellPrice": 850,
    "energy": null,
    "tags": [
      "fishing",
      "event",
      "sea-fishing"
    ],
    "sourceRefs": [
      "heartodex:fish"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Whale Shark is the world's largest living fish, yet it feeds by filtering tiny organisms from the water rather than hunting large prey. Its broad body is covered with a distinctive pattern of pale spots and stripes."
  },
  {
    "id": "mahi-mahi",
    "slug": "mahi-mahi",
    "name": "Mahi-Mahi",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/mahi-mahi.webp",
    "imageStatus": "verified",
    "sellPrice": 320,
    "energy": null,
    "tags": [
      "fishing"
    ],
    "sourceRefs": [
      "heartodex:fish"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Mahi-Mahi is a fast open-ocean fish known for electric blue, green and gold coloring that can change rapidly after capture. Its tall forehead and long dorsal fin give it a distinctive pelagic silhouette."
  },
  {
    "id": "moon-jelly",
    "slug": "moon-jelly",
    "name": "Moon Jelly",
    "kind": "fish",
    "eventKey": "sea-fishing",
    "status": "event",
    "aliases": [],
    "image": "/icons/fish/moon-jelly.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [
      "fishing",
      "event",
      "sea-fishing"
    ],
    "sourceRefs": [
      "heartodex:fish"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Moon Jelly is a translucent jellyfish whose internal reproductive organs often appear as four horseshoe-shaped forms visible through the bell. Its delicate body drifts with currents rather than swimming like a fish."
  },
  {
    "id": "angelfish",
    "slug": "angelfish",
    "name": "Angelfish",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/angelfish.webp",
    "imageStatus": "verified",
    "sellPrice": 150,
    "energy": null,
    "tags": [
      "fishing"
    ],
    "sourceRefs": [
      "heartodex:fish"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Angelfish is recognized by a laterally compressed body and prominent fins that create a tall, graceful profile. The name reflects that elegant silhouette, which has made angelfish popular as ornamental aquarium fish."
  },
  {
    "id": "pink-betta",
    "slug": "pink-betta",
    "name": "Pink Betta",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/pink-betta.webp",
    "imageStatus": "verified",
    "sellPrice": 250,
    "energy": null,
    "tags": [
      "fishing"
    ],
    "sourceRefs": [
      "heartodex:fish"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Pink Betta is a color form of the domesticated betta, a small labyrinth fish famous for elaborate fins and strong territorial behavior in males. Selective breeding can produce vivid pink tones not common in wild populations."
  },
  {
    "id": "green-sea-turtle",
    "slug": "green-sea-turtle",
    "name": "Green Sea Turtle",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/green-sea-turtle.webp",
    "imageStatus": "verified",
    "sellPrice": 610,
    "energy": null,
    "tags": [
      "fishing"
    ],
    "sourceRefs": [
      "heartodex:fish"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Green Sea Turtle is a large marine reptile rather than a fish. Adults are primarily herbivorous, and the species' common name comes from the greenish fat beneath the shell rather than from an entirely green outer body."
  },
  {
    "id": "white-faced-surgeonfish",
    "slug": "white-faced-surgeonfish",
    "name": "White-Faced Surgeonfish",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/white-faced-surgeonfish.webp",
    "imageStatus": "verified",
    "sellPrice": 230,
    "energy": null,
    "tags": [
      "fishing"
    ],
    "sourceRefs": [
      "heartodex:fish"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "White-Faced Surgeonfish belongs to the surgeonfish group, whose members carry sharp blade-like spines near the base of the tail. The pale facial area provides an extra visual cue beyond that defensive anatomy."
  },
  {
    "id": "lionfish",
    "slug": "lionfish",
    "name": "Lionfish",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/lionfish.webp",
    "imageStatus": "verified",
    "sellPrice": 320,
    "energy": null,
    "tags": [
      "fishing"
    ],
    "sourceRefs": [
      "heartodex:fish"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Lionfish combines ornate fan-like fins with a serious defense: the long dorsal spines are venomous. The fish is also an ambush predator, using its dramatic fins to help corner smaller prey before striking."
  },
  {
    "id": "blue-and-yellow-wrasse",
    "slug": "blue-and-yellow-wrasse",
    "name": "Blue-and-Yellow Wrasse",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/blue-and-yellow-wrasse.webp",
    "imageStatus": "verified",
    "sellPrice": 150,
    "energy": null,
    "tags": [
      "fishing"
    ],
    "sourceRefs": [
      "heartodex:fish"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Blue-and-Yellow Wrasse is a colorful reef fish whose contrasting blue and yellow markings make it stand out over coral habitat. Like other wrasses, it has a streamlined body suited to active swimming around reefs."
  },
  {
    "id": "azure-demoiselle",
    "slug": "azure-demoiselle",
    "name": "Azure Demoiselle",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/azure-demoiselle.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [
      "fishing"
    ],
    "sourceRefs": [
      "heartodex:fish"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Azure Demoiselle is a small damselfish defined by bright blue coloration. Demoiselles are reef-associated fish, so the vivid body is usually seen against coral and rocky marine habitat rather than open ocean."
  },
  {
    "id": "golden-script-supervisor-bumblebee",
    "slug": "golden-script-supervisor-bumblebee",
    "name": "Golden Script Supervisor Bumblebee",
    "kind": "insect",
    "eventKey": "dreamlight-cinematics",
    "status": "event",
    "aliases": [],
    "image": "/icons/insect/golden-script-supervisor-bumblebee.webp",
    "imageStatus": "verified",
    "sellPrice": 165,
    "energy": null,
    "tags": [
      "bug-catching",
      "event",
      "dreamlight-cinematics"
    ],
    "sourceRefs": [
      "heartodex:insect"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "The golden Dreamlight Cinematics supervisor arrives with a production credit already attached. Heartopia says this sharp-eyed crew member has just finished work on a movie titled “Gold Rush,” making the color part of the joke."
  },
  {
    "id": "yellow-brick-large-red-damselfly",
    "slug": "yellow-brick-large-red-damselfly",
    "name": "Yellow Brick Large Red Damselfly",
    "kind": "insect",
    "eventKey": "modular-streets",
    "status": "event",
    "aliases": [],
    "image": "/icons/insect/yellow-brick-large-red-damselfly.webp",
    "imageStatus": "verified",
    "sellPrice": 75,
    "energy": null,
    "tags": [
      "bug-catching",
      "event",
      "modular-streets"
    ],
    "sourceRefs": [
      "heartodex:insect"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "The yellow Modular Streets damselfly is rebuilt as a conspicuous toy insect. Heartopia jokes that making the model this bright might have the unintended effect of drawing even more tiny insects toward it."
  },
  {
    "id": "blue-brick-large-red-damselfly",
    "slug": "blue-brick-large-red-damselfly",
    "name": "Blue Brick Large Red Damselfly",
    "kind": "insect",
    "eventKey": "modular-streets",
    "status": "event",
    "aliases": [],
    "image": "/icons/insect/blue-brick-large-red-damselfly.webp",
    "imageStatus": "verified",
    "sellPrice": 75,
    "energy": null,
    "tags": [
      "bug-catching",
      "event",
      "modular-streets"
    ],
    "sourceRefs": [
      "heartodex:insect"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "This blue Modular Streets damselfly preserves the lively waterside mood associated with its real counterpart. The event text instead focuses on minute specks trailing behind the toy as it moves through the air."
  },
  {
    "id": "purple-brick-large-red-damselfly",
    "slug": "purple-brick-large-red-damselfly",
    "name": "Purple Brick Large Red Damselfly",
    "kind": "insect",
    "eventKey": "modular-streets",
    "status": "event",
    "aliases": [],
    "image": "/icons/insect/purple-brick-large-red-damselfly.webp",
    "imageStatus": "verified",
    "sellPrice": 75,
    "energy": null,
    "tags": [
      "bug-catching",
      "event",
      "modular-streets"
    ],
    "sourceRefs": [
      "heartodex:insect"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Purple bricks give this Large Red Damselfly a mock-armored appearance. Heartopia treats the toy build as unusually dignified, pushing the insect toward the image of a tiny noble knight."
  },
  {
    "id": "colorful-brick-large-red-damselfly",
    "slug": "colorful-brick-large-red-damselfly",
    "name": "Colorful Brick Large Red Damselfly",
    "kind": "insect",
    "eventKey": "modular-streets",
    "status": "event",
    "aliases": [],
    "image": "/icons/insect/colorful-brick-large-red-damselfly.webp",
    "imageStatus": "verified",
    "sellPrice": 110,
    "energy": null,
    "tags": [
      "bug-catching",
      "event",
      "modular-streets"
    ],
    "sourceRefs": [
      "heartodex:insect"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Colorful Brick Large Red Damselfly is the multicolored Modular Streets toy version of the insect. Because the current flavor text appears unreliable, the safe distinction is simply its bright mixed-brick construction."
  },
  {
    "id": "pink-brick-large-red-damselfly",
    "slug": "pink-brick-large-red-damselfly",
    "name": "Pink Brick Large Red Damselfly",
    "kind": "insect",
    "eventKey": "modular-streets",
    "status": "event",
    "aliases": [],
    "image": "/icons/insect/pink-brick-large-red-damselfly.webp",
    "imageStatus": "verified",
    "sellPrice": 75,
    "energy": null,
    "tags": [
      "bug-catching",
      "event",
      "modular-streets"
    ],
    "sourceRefs": [
      "heartodex:insect"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "The pink Modular Streets version deliberately softens the Large Red Damselfly's usual energetic image. Heartopia gives the toy build a gentler, more charming presentation rather than emphasizing toughness."
  },
  {
    "id": "atlas-beetle",
    "slug": "atlas-beetle",
    "name": "Atlas Beetle",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/atlas-beetle.webp",
    "imageStatus": "verified",
    "sellPrice": 390,
    "energy": null,
    "tags": [
      "bug-catching"
    ],
    "sourceRefs": [
      "heartodex:insect"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Finding Atlas Beetle is easier when the search stays on vertical surfaces. Heartodex specifically directs players to inspect tree trunks, so checking bark is more useful than sweeping open ground."
  },
  {
    "id": "orchid-mantis",
    "slug": "orchid-mantis",
    "name": "Orchid Mantis",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/orchid-mantis.webp",
    "imageStatus": "verified",
    "sellPrice": 515,
    "energy": null,
    "tags": [
      "bug-catching"
    ],
    "sourceRefs": [
      "heartodex:insect"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Orchid Mantis hides a predator inside a flower-like disguise. Its pale, petal-shaped body helps it blend among blossoms, where camouflage can bring unsuspecting insects close enough to attack."
  },
  {
    "id": "queen-alexandra-s-birdwing",
    "slug": "queen-alexandra-s-birdwing",
    "name": "Queen Alexandra's Birdwing",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/queen-alexandra-s-birdwing.webp",
    "imageStatus": "verified",
    "sellPrice": 150,
    "energy": null,
    "tags": [
      "bug-catching"
    ],
    "sourceRefs": [
      "heartodex:insect"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Queen Alexandra's Birdwing is the largest living butterfly by wingspan. Native to Papua New Guinea, the species shows strong sexual dimorphism, with females considerably larger than the more brightly colored males."
  },
  {
    "id": "greater-asian-lady-beetle",
    "slug": "greater-asian-lady-beetle",
    "name": "Greater Asian Lady Beetle",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/greater-asian-lady-beetle.webp",
    "imageStatus": "verified",
    "sellPrice": 440,
    "energy": null,
    "tags": [
      "bug-catching"
    ],
    "sourceRefs": [
      "heartodex:insect"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Greater Asian Lady Beetle is a ladybird-type beetle with rounded wing covers and contrasting spots. Like many lady beetles, members of this group are predators of small plant pests such as aphids."
  },
  {
    "id": "goliath-beetle",
    "slug": "goliath-beetle",
    "name": "Goliath Beetle",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/goliath-beetle.webp",
    "imageStatus": "verified",
    "sellPrice": 440,
    "energy": null,
    "tags": [
      "bug-catching"
    ],
    "sourceRefs": [
      "heartodex:insect"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Goliath Beetles rank among the heaviest and largest beetles in the world. Their powerful bodies and reinforced legs give them a formidable appearance, while males also carry prominent horn-like structures on the head."
  },
  {
    "id": "red-milkweed-locust",
    "slug": "red-milkweed-locust",
    "name": "Red Milkweed Locust",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/red-milkweed-locust.webp",
    "imageStatus": "verified",
    "sellPrice": 45,
    "energy": null,
    "tags": [
      "bug-catching"
    ],
    "sourceRefs": [
      "heartodex:insect"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Red Milkweed Locust advertises danger through bright warning colors. Feeding on toxic plants allows the insect to retain defensive chemicals, making its vivid red-and-black appearance useful as a signal to predators."
  },
  {
    "id": "flamer-skimmer",
    "slug": "flamer-skimmer",
    "name": "Flamer Skimmer",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/flamer-skimmer.webp",
    "imageStatus": "verified",
    "sellPrice": 185,
    "energy": null,
    "tags": [
      "bug-catching"
    ],
    "sourceRefs": [
      "heartodex:insect"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Flame Skimmer is a dragonfly whose mature males can become intensely orange-red across much of the body and wings. That fiery coloration explains the common name far more directly than any unusual behavior."
  },
  {
    "id": "purple-spotted-swallowtail",
    "slug": "purple-spotted-swallowtail",
    "name": "Purple Spotted Swallowtail",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/purple-spotted-swallowtail.webp",
    "imageStatus": "verified",
    "sellPrice": 240,
    "energy": null,
    "tags": [
      "bug-catching"
    ],
    "sourceRefs": [
      "heartodex:insect"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Purple Spotted Swallowtail is a dark butterfly accented by reflective purple-blue spotting. The colored patches interrupt the darker wings and provide the clearest visual clue behind the species' name."
  },
  {
    "id": "scarce-morpho",
    "slug": "scarce-morpho",
    "name": "Scarce Morpho",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/scarce-morpho.webp",
    "imageStatus": "verified",
    "sellPrice": 150,
    "energy": null,
    "tags": [
      "bug-catching"
    ],
    "sourceRefs": [
      "heartodex:insect"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Scarce Morpho belongs to the Morpho butterflies, a group famous for light-reflecting wing scales. Its blue tones can appear to shift with viewing angle as the wing surface catches and redirects light."
  },
  {
    "id": "green-metalwing",
    "slug": "green-metalwing",
    "name": "Green Metalwing",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/green-metalwing.webp",
    "imageStatus": "verified",
    "sellPrice": 590,
    "energy": null,
    "tags": [
      "bug-catching"
    ],
    "sourceRefs": [
      "heartodex:insect"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Green Metalwing is a damselfly-like insect whose identity centers on metallic green coloration. The reflective body and wings can look different as the viewing angle changes, giving the insect a polished sheen."
  },
  {
    "id": "green-snail",
    "slug": "green-snail",
    "name": "Green Snail",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/green-snail.webp",
    "imageStatus": "verified",
    "sellPrice": 590,
    "energy": null,
    "tags": [
      "bug-catching"
    ],
    "sourceRefs": [
      "heartodex:insect"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Green Snail is a gastropod with the typical soft body and coiled shell of a land or freshwater snail, distinguished here by green coloration. Its movement relies on a muscular foot rather than legs."
  },
  {
    "id": "glasswing-butterfly",
    "slug": "glasswing-butterfly",
    "name": "Glasswing Butterfly",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/glasswing-butterfly.webp",
    "imageStatus": "verified",
    "sellPrice": 480,
    "energy": null,
    "tags": [
      "bug-catching"
    ],
    "sourceRefs": [
      "heartodex:insect"
    ],
    "notes": "Generated from Heartodex list view; price/energy left null when not exposed there.",
    "description": "Glasswing Butterfly gets its name from large transparent sections of wing where normal colored scales are greatly reduced. The clear membrane, bordered by darker edges, lets the background remain visible through the wings."
  },
  {
    "id": "blue-brick-clownfish",
    "slug": "blue-brick-clownfish",
    "name": "Blue Brick Clownfish",
    "kind": "fish",
    "eventKey": "modular-streets",
    "status": "event",
    "aliases": [],
    "image": "/icons/fish/blue-brick-clownfish.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [
      "fish",
      "event",
      "modular-streets",
      "brick"
    ],
    "sourceRefs": [
      "heartodex:fish"
    ],
    "notes": "Confirmed on Heartodex fish list. Base market value set to 100 from Blue Brick Clownfish detail; verify variant-specific values if needed.",
    "description": "The blue toy Clownfish carries an age-reversal joke: Heartopia suggests the blocky design could seem too juvenile to children while becoming exactly the kind of collectible that appeals to adults."
  },
  {
    "id": "colorful-brick-clownfish",
    "slug": "colorful-brick-clownfish",
    "name": "Colorful Brick Clownfish",
    "kind": "fish",
    "eventKey": "modular-streets",
    "status": "event",
    "aliases": [],
    "image": "/icons/fish/colorful-brick-clownfish.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [
      "fish",
      "event",
      "modular-streets",
      "brick"
    ],
    "sourceRefs": [
      "heartodex:fish"
    ],
    "notes": "Confirmed on Heartodex fish list. Base market value set to 100 from Blue Brick Clownfish detail; verify variant-specific values if needed.",
    "description": "This Clownfish uses almost every bright brick color the Modular Streets theme can justify. The flavor text turns that excess into the joke, suggesting that simply looking at the finished toy can become visually exhausting."
  },
  {
    "id": "purple-brick-clownfish",
    "slug": "purple-brick-clownfish",
    "name": "Purple Brick Clownfish",
    "kind": "fish",
    "eventKey": "modular-streets",
    "status": "event",
    "aliases": [],
    "image": "/icons/fish/purple-brick-clownfish.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [
      "fish",
      "event",
      "modular-streets",
      "brick"
    ],
    "sourceRefs": [
      "heartodex:fish"
    ],
    "notes": "Confirmed on Heartodex fish list. Base market value set to 100 from Blue Brick Clownfish detail; verify variant-specific values if needed.",
    "description": "Purple Brick Clownfish abandons realistic color for a playful toy build. Instead of fish biology, its event flavor text centers on bubbles, keeping the item firmly in Modular Streets' whimsical collectible tone."
  },
  {
    "id": "red-brick-clownfish",
    "slug": "red-brick-clownfish",
    "name": "Red Brick Clownfish",
    "kind": "fish",
    "eventKey": "modular-streets",
    "status": "event",
    "aliases": [],
    "image": "/icons/fish/red-brick-clownfish.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [
      "fish",
      "event",
      "modular-streets",
      "brick"
    ],
    "sourceRefs": [
      "heartodex:fish"
    ],
    "notes": "Confirmed on Heartodex fish list. Base market value set to 100 from Blue Brick Clownfish detail; verify variant-specific values if needed.",
    "description": "Among the brick Clownfish set, the red version is presented as the closest to the familiar real-world star. Heartopia turns that recognizable color scheme into a sales joke, calling it a reliable favorite of the toy line."
  },
  {
    "id": "green-brick-clownfish",
    "slug": "green-brick-clownfish",
    "name": "Green Brick Clownfish",
    "kind": "fish",
    "eventKey": "modular-streets",
    "status": "event",
    "aliases": [],
    "image": "/icons/fish/green-brick-clownfish.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [
      "fish",
      "event",
      "modular-streets",
      "brick"
    ],
    "sourceRefs": [
      "heartodex:fish"
    ],
    "notes": "Confirmed on Heartodex fish list. Base market value set to 100 from Blue Brick Clownfish detail; verify variant-specific values if needed.",
    "description": "Green Brick Clownfish intentionally removes the familiar color palette associated with the species. Heartopia jokes that the unusual green build loses the original fish's reputation for being especially pleasant to look at."
  },
  {
    "id": "loam",
    "slug": "loam",
    "name": "Loam",
    "kind": "material",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/material/loam.webp",
    "imageStatus": "verified",
    "sellPrice": 1,
    "energy": null,
    "tags": [
      "material",
      "gardening"
    ],
    "sourceRefs": [
      "icon-asset:apps/web-vite/public/icons/material/loam.webp"
    ],
    "notes": null,
    "description": "Loam is a soil texture made from a balanced mixture of sand, silt and clay. That combination can hold moisture and nutrients while still draining better than heavy clay, which is why loamy soil is widely valued for growing plants."
  },
  {
    "id": "ore",
    "slug": "ore",
    "name": "Ore",
    "kind": "material",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/forageable/ore.webp",
    "imageStatus": "verified",
    "sellPrice": 14,
    "energy": null,
    "tags": [
      "material"
    ],
    "sourceRefs": [
      "icon-asset:apps/web-vite/public/icons/forageable/ore.webp",
      "supabase-lookup:scripts/_supabase-lookups/other-items.json"
    ],
    "notes": null,
    "description": "Mined Ore also feeds into equipment maintenance. One documented recipe uses three Ore together with Roaming Oak Timber to craft the mid-tier repair item known as Crafty Repair Kit."
  },
  {
    "id": "snowball",
    "slug": "snowball",
    "name": "Snowball",
    "kind": "material",
    "eventKey": "winter-frost-season",
    "status": "event",
    "aliases": [],
    "image": "/icons/material/snowball.webp",
    "imageStatus": "verified",
    "sellPrice": 1,
    "energy": null,
    "tags": [
      "material",
      "event",
      "winter-frost-season"
    ],
    "sourceRefs": [
      "icon-asset:apps/web-vite/public/icons/material/snowball.webp",
      "supabase-lookup:scripts/_supabase-lookups/other-items.json"
    ],
    "notes": null,
    "description": "A snowball is simply snow packed tightly enough to hold a rounded shape. It is associated with winter play and throwing games, making it a natural seasonal item even when no deeper crafting use is documented."
  },
  {
    "id": "starfall-shard",
    "slug": "starfall-shard",
    "name": "Starfall Shard",
    "kind": "material",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/forageable/starfall-shard.webp",
    "imageStatus": "verified",
    "sellPrice": 150,
    "energy": null,
    "tags": [
      "material"
    ],
    "sourceRefs": [
      "icon-asset:apps/web-vite/public/icons/forageable/starfall-shard.webp",
      "supabase-lookup:scripts/_supabase-lookups/other-items.json"
    ],
    "notes": null,
    "description": "Starfall Shard is gathered from meteorite activity during Meteor Shower conditions rather than ordinary mining nodes. Guides treat it as a limited advanced crafting material, separating it from everyday Ore."
  },
  {
    "id": "agrias-butterfly",
    "slug": "agrias-butterfly",
    "name": "Agrias Butterfly",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/agrias-butterfly.webp",
    "imageStatus": "verified",
    "sellPrice": 60,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51138"
    ],
    "notes": null
  },
  {
    "id": "alpaca-cupcake",
    "slug": "alpaca-cupcake",
    "name": "Alpaca Cupcake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/alpaca-cupcake.webp",
    "imageStatus": "verified",
    "sellPrice": 590,
    "energy": 35,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45318"
    ],
    "notes": null
  },
  {
    "id": "alpaca-paw-candy",
    "slug": "alpaca-paw-candy",
    "name": "Alpaca Paw Candy",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/alpaca-paw-candy.webp",
    "imageStatus": "verified",
    "sellPrice": 25,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#46132"
    ],
    "notes": null
  },
  {
    "id": "american-paddlefish",
    "slug": "american-paddlefish",
    "name": "American Paddlefish",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/american-paddlefish.webp",
    "imageStatus": "verified",
    "sellPrice": 155,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#10137"
    ],
    "notes": null
  },
  {
    "id": "amur-catfish",
    "slug": "amur-catfish",
    "name": "Amur Catfish",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/amur-catfish.webp",
    "imageStatus": "verified",
    "sellPrice": 105,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#10136"
    ],
    "notes": null
  },
  {
    "id": "apple-cake",
    "slug": "apple-cake",
    "name": "Apple Cake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/apple-cake.webp",
    "imageStatus": "verified",
    "sellPrice": 560,
    "energy": 50,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45185"
    ],
    "notes": null
  },
  {
    "id": "apple-cloud-candy",
    "slug": "apple-cloud-candy",
    "name": "Apple Cloud Candy",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/apple-cloud-candy.webp",
    "imageStatus": "verified",
    "sellPrice": 340,
    "energy": 30,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45288"
    ],
    "notes": null
  },
  {
    "id": "apple-frosted-pancake",
    "slug": "apple-frosted-pancake",
    "name": "Apple Frosted Pancake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/apple-frosted-pancake.webp",
    "imageStatus": "verified",
    "sellPrice": 360,
    "energy": 25,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45435"
    ],
    "notes": null
  },
  {
    "id": "apple-hermit-crab",
    "slug": "apple-hermit-crab",
    "name": "Apple Hermit Crab",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/apple-hermit-crab.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#10370",
      "variant-of:hermit-crab"
    ],
    "notes": null,
    "variantOf": "hermit-crab"
  },
  {
    "id": "apple-ice-cream",
    "slug": "apple-ice-cream",
    "name": "Apple Ice Cream",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/apple-ice-cream.webp",
    "imageStatus": "verified",
    "sellPrice": 810,
    "energy": 70,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45132"
    ],
    "notes": null
  },
  {
    "id": "apple-jam-meatball",
    "slug": "apple-jam-meatball",
    "name": "Apple Jam Meatball",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/apple-jam-meatball.webp",
    "imageStatus": "verified",
    "sellPrice": 450,
    "energy": 40,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45412"
    ],
    "notes": null
  },
  {
    "id": "apple-juice",
    "slug": "apple-juice",
    "name": "Apple Juice",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/apple-juice.webp",
    "imageStatus": "verified",
    "sellPrice": 310,
    "energy": 38,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45140"
    ],
    "notes": null
  },
  {
    "id": "apple-pearl-cake",
    "slug": "apple-pearl-cake",
    "name": "Apple Pearl Cake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/apple-pearl-cake.webp",
    "imageStatus": "verified",
    "sellPrice": 590,
    "energy": 45,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45536"
    ],
    "notes": null
  },
  {
    "id": "apple-princess-cake",
    "slug": "apple-princess-cake",
    "name": "Apple Princess Cake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/apple-princess-cake.webp",
    "imageStatus": "verified",
    "sellPrice": 360,
    "energy": 20,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45402"
    ],
    "notes": null
  },
  {
    "id": "apple-pudding",
    "slug": "apple-pudding",
    "name": "Apple Pudding",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/apple-pudding.webp",
    "imageStatus": "verified",
    "sellPrice": 560,
    "energy": 50,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45211"
    ],
    "notes": null
  },
  {
    "id": "audouin-s-gull",
    "slug": "audouin-s-gull",
    "name": "Audouin's Gull",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/audouin-s-gull.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#61504"
    ],
    "notes": null
  },
  {
    "id": "aurora-banquet",
    "slug": "aurora-banquet",
    "name": "Aurora Banquet",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/aurora-banquet.webp",
    "imageStatus": "verified",
    "sellPrice": 1630,
    "energy": 40,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45437"
    ],
    "notes": null
  },
  {
    "id": "baked-eggplant-w-meat-sauce",
    "slug": "baked-eggplant-w-meat-sauce",
    "name": "Baked Eggplant w/ Meat Sauce",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/baked-eggplant-w-meat-sauce.webp",
    "imageStatus": "verified",
    "sellPrice": 1230,
    "energy": 75,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45425"
    ],
    "notes": null
  },
  {
    "id": "balloon-morpho",
    "slug": "balloon-morpho",
    "name": "Balloon Morpho",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/balloon-morpho.webp",
    "imageStatus": "verified",
    "sellPrice": 60,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51129"
    ],
    "notes": null
  },
  {
    "id": "balloon-nymphalidae",
    "slug": "balloon-nymphalidae",
    "name": "Balloon Nymphalidae",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/balloon-nymphalidae.webp",
    "imageStatus": "verified",
    "sellPrice": 60,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51127"
    ],
    "notes": null
  },
  {
    "id": "balloon-swallowtail",
    "slug": "balloon-swallowtail",
    "name": "Balloon Swallowtail",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/balloon-swallowtail.webp",
    "imageStatus": "verified",
    "sellPrice": 60,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51128"
    ],
    "notes": null
  },
  {
    "id": "bamboo-tube-apple-juice",
    "slug": "bamboo-tube-apple-juice",
    "name": "Bamboo Tube Apple Juice",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/bamboo-tube-apple-juice.webp",
    "imageStatus": "verified",
    "sellPrice": 360,
    "energy": 38,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45324"
    ],
    "notes": null
  },
  {
    "id": "bamboo-tube-blueberry-juice",
    "slug": "bamboo-tube-blueberry-juice",
    "name": "Bamboo Tube Blueberry Juice",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/bamboo-tube-blueberry-juice.webp",
    "imageStatus": "verified",
    "sellPrice": 260,
    "energy": 25,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45323"
    ],
    "notes": null
  },
  {
    "id": "bamboo-tube-dragonfruit-juice",
    "slug": "bamboo-tube-dragonfruit-juice",
    "name": "Bamboo Tube Dragonfruit Juice",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/bamboo-tube-dragonfruit-juice.webp",
    "imageStatus": "verified",
    "sellPrice": 290,
    "energy": 20,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45321"
    ],
    "notes": null
  },
  {
    "id": "bamboo-tube-juice",
    "slug": "bamboo-tube-juice",
    "name": "Bamboo Tube Juice",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/bamboo-tube-juice.webp",
    "imageStatus": "verified",
    "sellPrice": 250,
    "energy": 20,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45320"
    ],
    "notes": null
  },
  {
    "id": "bamboo-tube-mandarin-juice",
    "slug": "bamboo-tube-mandarin-juice",
    "name": "Bamboo Tube Mandarin Juice",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/bamboo-tube-mandarin-juice.webp",
    "imageStatus": "verified",
    "sellPrice": 360,
    "energy": 38,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45322"
    ],
    "notes": null
  },
  {
    "id": "bamboo-tube-raspberry-juice",
    "slug": "bamboo-tube-raspberry-juice",
    "name": "Bamboo Tube Raspberry Juice",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/bamboo-tube-raspberry-juice.webp",
    "imageStatus": "verified",
    "sellPrice": 340,
    "energy": 30,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45325"
    ],
    "notes": null
  },
  {
    "id": "bandage-fish",
    "slug": "bandage-fish",
    "name": "Bandage Fish",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/bandage-fish.webp",
    "imageStatus": "verified",
    "sellPrice": 320,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#10360"
    ],
    "notes": null
  },
  {
    "id": "bath-towel-mako-shark",
    "slug": "bath-towel-mako-shark",
    "name": "Bath-Towel Mako Shark",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/yellow-bath-towel-mako-shark.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "variant-group:bath-towel-mako-shark"
    ],
    "notes": null,
    "isVariantGroup": true
  },
  {
    "id": "bean-paste-tangyuan",
    "slug": "bean-paste-tangyuan",
    "name": "Bean Paste Tangyuan",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/bean-paste-tangyuan.webp",
    "imageStatus": "verified",
    "sellPrice": 280,
    "energy": 20,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45253"
    ],
    "notes": null
  },
  {
    "id": "beet",
    "slug": "beet",
    "name": "Beet",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/beet.webp",
    "imageStatus": "verified",
    "sellPrice": 30,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#769007"
    ],
    "notes": null
  },
  {
    "id": "berry-cake",
    "slug": "berry-cake",
    "name": "Berry Cake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/berry-cake.webp",
    "imageStatus": "verified",
    "sellPrice": 560,
    "energy": 50,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45183"
    ],
    "notes": null
  },
  {
    "id": "berry-pie",
    "slug": "berry-pie",
    "name": "Berry Pie",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": null,
    "imageStatus": "missing",
    "sellPrice": 560,
    "energy": 50,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45187"
    ],
    "notes": null
  },
  {
    "id": "black-calla-lily-seed",
    "slug": "black-calla-lily-seed",
    "name": "Black Calla Lily Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/black-calla-lily-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 90,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#700506",
      "variant-of:calla-lily-seeds"
    ],
    "notes": null,
    "flowerSpecies": "calla-lily-seeds",
    "flowerColor": "black",
    "variantOf": "calla-lily-seeds"
  },
  {
    "id": "black-cranesbill",
    "slug": "black-cranesbill",
    "name": "Black Cranesbill",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/black-cranesbill.webp",
    "imageStatus": "verified",
    "sellPrice": 1650,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#732406",
      "variant-of:cranesbill"
    ],
    "notes": null,
    "flowerSpecies": "cranesbill",
    "flowerColor": "black",
    "variantOf": "cranesbill"
  },
  {
    "id": "black-cranesbill-seed",
    "slug": "black-cranesbill-seed",
    "name": "Black Cranesbill Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/black-cranesbill-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 300,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#702406",
      "variant-of:cranesbill-seeds"
    ],
    "notes": null,
    "flowerSpecies": "cranesbill-seeds",
    "flowerColor": "black",
    "variantOf": "cranesbill-seeds"
  },
  {
    "id": "black-dandelion",
    "slug": "black-dandelion",
    "name": "Black Dandelion",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/black-dandelion.webp",
    "imageStatus": "verified",
    "sellPrice": 250,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#732606",
      "variant-of:dandelion"
    ],
    "notes": null,
    "flowerSpecies": "dandelion",
    "flowerColor": "black",
    "variantOf": "dandelion"
  },
  {
    "id": "black-diamond-mussel",
    "slug": "black-diamond-mussel",
    "name": "Black Diamond Mussel",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/black-diamond-mussel.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#10234"
    ],
    "notes": null
  },
  {
    "id": "black-hyacinth",
    "slug": "black-hyacinth",
    "name": "Black Hyacinth",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/black-hyacinth.webp",
    "imageStatus": "verified",
    "sellPrice": 1570,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#731506",
      "variant-of:hyacinth"
    ],
    "notes": null,
    "flowerSpecies": "hyacinth",
    "flowerColor": "black",
    "variantOf": "hyacinth"
  },
  {
    "id": "black-moth-orchid",
    "slug": "black-moth-orchid",
    "name": "Black Moth Orchid",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/black-moth-orchid.webp",
    "imageStatus": "verified",
    "sellPrice": 1610,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#731606",
      "variant-of:moth-orchid"
    ],
    "notes": null,
    "flowerSpecies": "moth-orchid",
    "flowerColor": "black",
    "variantOf": "moth-orchid"
  },
  {
    "id": "black-rose-seed",
    "slug": "black-rose-seed",
    "name": "Black Rose Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/black-rose-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 300,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#700906",
      "variant-of:rose-seeds"
    ],
    "notes": null,
    "flowerSpecies": "rose-seeds",
    "flowerColor": "black",
    "variantOf": "rose-seeds"
  },
  {
    "id": "black-tulip-seed",
    "slug": "black-tulip-seed",
    "name": "Black Tulip Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/black-tulip-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 150,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#700706",
      "variant-of:tulip-seeds"
    ],
    "notes": null,
    "flowerSpecies": "tulip-seeds",
    "flowerColor": "black",
    "variantOf": "tulip-seeds"
  },
  {
    "id": "black-turkey",
    "slug": "black-turkey",
    "name": "Black Turkey",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/black-turkey.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#61220"
    ],
    "notes": null
  },
  {
    "id": "blue-camping-sparrow",
    "slug": "blue-camping-sparrow",
    "name": "Blue Camping Sparrow",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/blue-camping-sparrow.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#61130",
      "variant-of:camping-sparrow"
    ],
    "notes": null,
    "variantOf": "camping-sparrow"
  },
  {
    "id": "blue-clockwork-sparrow",
    "slug": "blue-clockwork-sparrow",
    "name": "Blue Clockwork Sparrow",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/blue-clockwork-sparrow.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#61134",
      "variant-of:clockwork-sparrow"
    ],
    "notes": null,
    "variantOf": "clockwork-sparrow"
  },
  {
    "id": "blue-coast",
    "slug": "blue-coast",
    "name": "Blue Coast",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/blue-coast.webp",
    "imageStatus": "verified",
    "sellPrice": 570,
    "energy": 70,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45151"
    ],
    "notes": null
  },
  {
    "id": "blue-cranesbill",
    "slug": "blue-cranesbill",
    "name": "Blue Cranesbill",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/blue-cranesbill.webp",
    "imageStatus": "verified",
    "sellPrice": 2065,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#732409",
      "variant-of:cranesbill"
    ],
    "notes": null,
    "flowerSpecies": "cranesbill",
    "flowerColor": "blue",
    "variantOf": "cranesbill"
  },
  {
    "id": "blue-cranesbill-seed",
    "slug": "blue-cranesbill-seed",
    "name": "Blue Cranesbill Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/blue-cranesbill-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 375,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#702409",
      "variant-of:cranesbill-seeds"
    ],
    "notes": null,
    "flowerSpecies": "cranesbill-seeds",
    "flowerColor": "blue",
    "variantOf": "cranesbill-seeds"
  },
  {
    "id": "blue-dandelion",
    "slug": "blue-dandelion",
    "name": "Blue Dandelion",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/blue-dandelion.webp",
    "imageStatus": "verified",
    "sellPrice": 315,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#732609",
      "variant-of:dandelion"
    ],
    "notes": null,
    "flowerSpecies": "dandelion",
    "flowerColor": "blue",
    "variantOf": "dandelion"
  },
  {
    "id": "blue-diamond-mussel",
    "slug": "blue-diamond-mussel",
    "name": "Blue Diamond Mussel",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/blue-diamond-mussel.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#10232"
    ],
    "notes": null
  },
  {
    "id": "blue-dung-beetle",
    "slug": "blue-dung-beetle",
    "name": "Blue Dung Beetle",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/blue-dung-beetle.webp",
    "imageStatus": "verified",
    "sellPrice": 110,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51228",
      "variant-of:dung-beetle"
    ],
    "notes": null,
    "variantOf": "dung-beetle"
  },
  {
    "id": "blue-floating-dust-bug",
    "slug": "blue-floating-dust-bug",
    "name": "Blue Floating Dust Bug",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/blue-floating-dust-bug.webp",
    "imageStatus": "verified",
    "sellPrice": 90,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51904",
      "variant-of:dust-bug"
    ],
    "notes": null,
    "variantOf": "dust-bug"
  },
  {
    "id": "blue-hat-stock-dove",
    "slug": "blue-hat-stock-dove",
    "name": "Blue Hat Stock Dove",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/blue-hat-stock-dove.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#61221",
      "variant-of:stock-dove"
    ],
    "notes": null,
    "variantOf": "stock-dove"
  },
  {
    "id": "blue-hyacinth",
    "slug": "blue-hyacinth",
    "name": "Blue Hyacinth",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/blue-hyacinth.webp",
    "imageStatus": "verified",
    "sellPrice": 1965,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#731509",
      "variant-of:hyacinth"
    ],
    "notes": null,
    "flowerSpecies": "hyacinth",
    "flowerColor": "blue",
    "variantOf": "hyacinth"
  },
  {
    "id": "blue-jello-fish",
    "slug": "blue-jello-fish",
    "name": "Blue Jello Fish",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/blue-jello-fish.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#10229",
      "variant-of:jello-fish"
    ],
    "notes": null,
    "variantOf": "jello-fish"
  },
  {
    "id": "blue-light-firefly",
    "slug": "blue-light-firefly",
    "name": "Blue Light Firefly",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/blue-light-firefly.webp",
    "imageStatus": "verified",
    "sellPrice": 110,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51222",
      "variant-of:light-firefly"
    ],
    "notes": null,
    "variantOf": "light-firefly"
  },
  {
    "id": "blue-light-jellyfish",
    "slug": "blue-light-jellyfish",
    "name": "Blue Light Jellyfish",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/blue-light-jellyfish.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#10376"
    ],
    "notes": null
  },
  {
    "id": "blue-milkweed-beetle",
    "slug": "blue-milkweed-beetle",
    "name": "Blue Milkweed Beetle",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/blue-milkweed-beetle.webp",
    "imageStatus": "verified",
    "sellPrice": 110,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51233"
    ],
    "notes": null
  },
  {
    "id": "blue-moth-orchid",
    "slug": "blue-moth-orchid",
    "name": "Blue Moth Orchid",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/blue-moth-orchid.webp",
    "imageStatus": "verified",
    "sellPrice": 2015,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#731609",
      "variant-of:moth-orchid"
    ],
    "notes": null,
    "flowerSpecies": "moth-orchid",
    "flowerColor": "blue",
    "variantOf": "moth-orchid"
  },
  {
    "id": "blue-red-betta",
    "slug": "blue-red-betta",
    "name": "Blue & Red Betta",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/blue-red-betta.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#10223"
    ],
    "notes": null
  },
  {
    "id": "blue-rose-seed",
    "slug": "blue-rose-seed",
    "name": "Blue Rose Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/blue-rose-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 375,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#700909",
      "variant-of:rose-seeds"
    ],
    "notes": null,
    "flowerSpecies": "rose-seeds",
    "flowerColor": "blue",
    "variantOf": "rose-seeds"
  },
  {
    "id": "blue-starry-stock-dove",
    "slug": "blue-starry-stock-dove",
    "name": "Blue Starry Stock Dove",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/blue-starry-stock-dove.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#61212",
      "variant-of:stock-dove"
    ],
    "notes": null,
    "variantOf": "stock-dove"
  },
  {
    "id": "blue-starry-swan",
    "slug": "blue-starry-swan",
    "name": "Blue Starry Swan",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/blue-starry-swan.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#61706",
      "variant-of:starry-swan"
    ],
    "notes": null,
    "variantOf": "starry-swan"
  },
  {
    "id": "blue-tulip-seed",
    "slug": "blue-tulip-seed",
    "name": "Blue Tulip Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/blue-tulip-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 190,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#700709",
      "variant-of:tulip-seeds"
    ],
    "notes": null,
    "flowerSpecies": "tulip-seeds",
    "flowerColor": "blue",
    "variantOf": "tulip-seeds"
  },
  {
    "id": "blueberry-cloud-candy",
    "slug": "blueberry-cloud-candy",
    "name": "Blueberry Cloud Candy",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/blueberry-cloud-candy.webp",
    "imageStatus": "verified",
    "sellPrice": 300,
    "energy": 30,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45291"
    ],
    "notes": null
  },
  {
    "id": "blueberry-frosted-pancake",
    "slug": "blueberry-frosted-pancake",
    "name": "Blueberry Frosted Pancake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/blueberry-frosted-pancake.webp",
    "imageStatus": "verified",
    "sellPrice": 330,
    "energy": 25,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45433"
    ],
    "notes": null
  },
  {
    "id": "blueberry-hermit-crab",
    "slug": "blueberry-hermit-crab",
    "name": "Blueberry Hermit Crab",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/blueberry-hermit-crab.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#10373",
      "variant-of:hermit-crab"
    ],
    "notes": null,
    "variantOf": "hermit-crab"
  },
  {
    "id": "blueberry-ice-cream",
    "slug": "blueberry-ice-cream",
    "name": "Blueberry Ice Cream",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/blueberry-ice-cream.webp",
    "imageStatus": "verified",
    "sellPrice": 610,
    "energy": 50,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45130"
    ],
    "notes": null
  },
  {
    "id": "blueberry-jam-meatball",
    "slug": "blueberry-jam-meatball",
    "name": "Blueberry Jam Meatball",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/blueberry-jam-meatball.webp",
    "imageStatus": "verified",
    "sellPrice": 350,
    "energy": 25,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45414"
    ],
    "notes": null
  },
  {
    "id": "blueberry-juice",
    "slug": "blueberry-juice",
    "name": "Blueberry Juice",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/blueberry-juice.webp",
    "imageStatus": "verified",
    "sellPrice": 210,
    "energy": 30,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45138"
    ],
    "notes": null
  },
  {
    "id": "blueberry-pearl-cake",
    "slug": "blueberry-pearl-cake",
    "name": "Blueberry Pearl Cake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/blueberry-pearl-cake.webp",
    "imageStatus": "verified",
    "sellPrice": 570,
    "energy": 45,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45538"
    ],
    "notes": null
  },
  {
    "id": "blueberry-princess-cake",
    "slug": "blueberry-princess-cake",
    "name": "Blueberry Princess Cake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/blueberry-princess-cake.webp",
    "imageStatus": "verified",
    "sellPrice": 330,
    "energy": 20,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45404"
    ],
    "notes": null
  },
  {
    "id": "blueberry-pudding",
    "slug": "blueberry-pudding",
    "name": "Blueberry Pudding",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/blueberry-pudding.webp",
    "imageStatus": "verified",
    "sellPrice": 560,
    "energy": 50,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45209"
    ],
    "notes": null
  },
  {
    "id": "blueberry-toast",
    "slug": "blueberry-toast",
    "name": "Blueberry Toast",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/blueberry-toast.webp",
    "imageStatus": "verified",
    "sellPrice": 560,
    "energy": 50,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45204"
    ],
    "notes": null
  },
  {
    "id": "bottled-apple-juice",
    "slug": "bottled-apple-juice",
    "name": "Bottled Apple Juice",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/bottled-apple-juice.webp",
    "imageStatus": "verified",
    "sellPrice": 470,
    "energy": 50,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45198"
    ],
    "notes": null
  },
  {
    "id": "bottled-blueberry-juice",
    "slug": "bottled-blueberry-juice",
    "name": "Bottled Blueberry Juice",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/bottled-blueberry-juice.webp",
    "imageStatus": "verified",
    "sellPrice": 470,
    "energy": 50,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45196"
    ],
    "notes": null
  },
  {
    "id": "bottled-iced-milk",
    "slug": "bottled-iced-milk",
    "name": "Bottled Iced Milk",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/bottled-iced-milk.webp",
    "imageStatus": "verified",
    "sellPrice": 470,
    "energy": 50,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45194"
    ],
    "notes": null
  },
  {
    "id": "bottled-mandarin-juice",
    "slug": "bottled-mandarin-juice",
    "name": "Bottled Mandarin Juice",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/bottled-mandarin-juice.webp",
    "imageStatus": "verified",
    "sellPrice": 470,
    "energy": 50,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45195"
    ],
    "notes": null
  },
  {
    "id": "bottled-raspberry-juice",
    "slug": "bottled-raspberry-juice",
    "name": "Bottled Raspberry Juice",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/bottled-raspberry-juice.webp",
    "imageStatus": "verified",
    "sellPrice": 470,
    "energy": 50,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45197"
    ],
    "notes": null
  },
  {
    "id": "bourbon-red-turkey",
    "slug": "bourbon-red-turkey",
    "name": "Bourbon Red Turkey",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/bourbon-red-turkey.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#61219"
    ],
    "notes": null
  },
  {
    "id": "brown-camping-sparrow",
    "slug": "brown-camping-sparrow",
    "name": "Brown Camping Sparrow",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/brown-camping-sparrow.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#61131",
      "variant-of:camping-sparrow"
    ],
    "notes": null,
    "variantOf": "camping-sparrow"
  },
  {
    "id": "brown-clockwork-sparrow",
    "slug": "brown-clockwork-sparrow",
    "name": "Brown Clockwork Sparrow",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/brown-clockwork-sparrow.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#61133",
      "variant-of:clockwork-sparrow"
    ],
    "notes": null,
    "variantOf": "clockwork-sparrow"
  },
  {
    "id": "brown-hat-stock-dove",
    "slug": "brown-hat-stock-dove",
    "name": "Brown Hat Stock Dove",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/brown-hat-stock-dove.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#61224",
      "variant-of:stock-dove"
    ],
    "notes": null,
    "variantOf": "stock-dove"
  },
  {
    "id": "brown-sauna-hat-sea-turtle",
    "slug": "brown-sauna-hat-sea-turtle",
    "name": "Brown Sauna Hat Sea Turtle",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/brown-sauna-hat-sea-turtle.webp",
    "imageStatus": "verified",
    "sellPrice": 230,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#10384",
      "variant-of:sauna-hat-sea-turtle"
    ],
    "notes": null,
    "variantOf": "sauna-hat-sea-turtle"
  },
  {
    "id": "bunny-cupcake",
    "slug": "bunny-cupcake",
    "name": "Bunny Cupcake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/bunny-cupcake.webp",
    "imageStatus": "verified",
    "sellPrice": 590,
    "energy": 35,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45314"
    ],
    "notes": null
  },
  {
    "id": "bunny-paw-candy",
    "slug": "bunny-paw-candy",
    "name": "Bunny Paw Candy",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/bunny-paw-candy.webp",
    "imageStatus": "verified",
    "sellPrice": 25,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#46128"
    ],
    "notes": null
  },
  {
    "id": "burdock-celtuce-taco",
    "slug": "burdock-celtuce-taco",
    "name": "Burdock Celtuce Taco",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/burdock-celtuce-taco.webp",
    "imageStatus": "verified",
    "sellPrice": 330,
    "energy": 35,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45447"
    ],
    "notes": null
  },
  {
    "id": "camping-sparrow",
    "slug": "camping-sparrow",
    "name": "Camping Sparrow",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/gray-camping-sparrow.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "variant-group:camping-sparrow"
    ],
    "notes": null,
    "isVariantGroup": true
  },
  {
    "id": "candy-corn-fish",
    "slug": "candy-corn-fish",
    "name": "Candy Corn Fish",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/candy-corn-fish.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#10361"
    ],
    "notes": null
  },
  {
    "id": "cappuccino",
    "slug": "cappuccino",
    "name": "Cappuccino",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/cappuccino.webp",
    "imageStatus": "verified",
    "sellPrice": 470,
    "energy": 50,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45200"
    ],
    "notes": null
  },
  {
    "id": "capybara-cupcake",
    "slug": "capybara-cupcake",
    "name": "Capybara Cupcake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/capybara-cupcake.webp",
    "imageStatus": "verified",
    "sellPrice": 590,
    "energy": 35,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45315"
    ],
    "notes": null
  },
  {
    "id": "capybara-paw-candy",
    "slug": "capybara-paw-candy",
    "name": "Capybara Paw Candy",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/capybara-paw-candy.webp",
    "imageStatus": "verified",
    "sellPrice": 25,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#46129"
    ],
    "notes": null
  },
  {
    "id": "carrot-juice",
    "slug": "carrot-juice",
    "name": "Carrot Juice",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/carrot-juice.webp",
    "imageStatus": "verified",
    "sellPrice": 700,
    "energy": 40,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45170"
    ],
    "notes": null
  },
  {
    "id": "cheese-crayfish-stuffed-crab-claws",
    "slug": "cheese-crayfish-stuffed-crab-claws",
    "name": "Cheese Crayfish Stuffed Crab Claws",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/cheese-crayfish-stuffed-crab-claws.webp",
    "imageStatus": "verified",
    "sellPrice": 1440,
    "energy": 80,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45427"
    ],
    "notes": null
  },
  {
    "id": "cheesy-baked-eggplants",
    "slug": "cheesy-baked-eggplants",
    "name": "Cheesy Baked Eggplants",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": null,
    "imageStatus": "missing",
    "sellPrice": 410,
    "energy": 80,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45179"
    ],
    "notes": null
  },
  {
    "id": "chocolate-mooncake",
    "slug": "chocolate-mooncake",
    "name": "Chocolate Mooncake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/chocolate-mooncake.webp",
    "imageStatus": "verified",
    "sellPrice": 1050,
    "energy": 75,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45391"
    ],
    "notes": null
  },
  {
    "id": "cinnamoroll-crepe",
    "slug": "cinnamoroll-crepe",
    "name": "Cinnamoroll Crepe",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/cinnamoroll-crepe.webp",
    "imageStatus": "verified",
    "sellPrice": 670,
    "energy": 80,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45553"
    ],
    "notes": null
  },
  {
    "id": "claypot-seafood-soup",
    "slug": "claypot-seafood-soup",
    "name": "Claypot Seafood Soup",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/claypot-seafood-soup.webp",
    "imageStatus": "verified",
    "sellPrice": 470,
    "energy": 40,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45252"
    ],
    "notes": null
  },
  {
    "id": "claypot-tomato-soup",
    "slug": "claypot-tomato-soup",
    "name": "Claypot Tomato Soup",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/claypot-tomato-soup.webp",
    "imageStatus": "verified",
    "sellPrice": 540,
    "energy": 60,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45251"
    ],
    "notes": null
  },
  {
    "id": "clockwork-frog",
    "slug": "clockwork-frog",
    "name": "Clockwork Frog",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/clockwork-frog.webp",
    "imageStatus": "verified",
    "sellPrice": 150,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#10230"
    ],
    "notes": null
  },
  {
    "id": "clockwork-ladybug",
    "slug": "clockwork-ladybug",
    "name": "Clockwork Ladybug",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/red-clockwork-ladybug.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "variant-group:clockwork-ladybug"
    ],
    "notes": null,
    "isVariantGroup": true
  },
  {
    "id": "clockwork-sparrow",
    "slug": "clockwork-sparrow",
    "name": "Clockwork Sparrow",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/gray-clockwork-sparrow.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "variant-group:clockwork-sparrow"
    ],
    "notes": null,
    "isVariantGroup": true
  },
  {
    "id": "coal-bug",
    "slug": "coal-bug",
    "name": "Coal Bug",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/coal-bug.webp",
    "imageStatus": "verified",
    "sellPrice": 110,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51931"
    ],
    "notes": null
  },
  {
    "id": "cocoa-bean",
    "slug": "cocoa-bean",
    "name": "Cocoa Bean",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/cocoa-bean.webp",
    "imageStatus": "verified",
    "sellPrice": 330,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#769405"
    ],
    "notes": null
  },
  {
    "id": "coconut",
    "slug": "coconut",
    "name": "Coconut",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/coconut.webp",
    "imageStatus": "verified",
    "sellPrice": 27,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#40301"
    ],
    "notes": null
  },
  {
    "id": "coconut-ice-cream",
    "slug": "coconut-ice-cream",
    "name": "Coconut Ice Cream",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/coconut-ice-cream.webp",
    "imageStatus": "verified",
    "sellPrice": 790,
    "energy": 70,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45136"
    ],
    "notes": null
  },
  {
    "id": "coconut-juice",
    "slug": "coconut-juice",
    "name": "Coconut Juice",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/coconut-juice.webp",
    "imageStatus": "verified",
    "sellPrice": 300,
    "energy": 38,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45144"
    ],
    "notes": null
  },
  {
    "id": "coconut-pudding",
    "slug": "coconut-pudding",
    "name": "Coconut Pudding",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/coconut-pudding.webp",
    "imageStatus": "verified",
    "sellPrice": 560,
    "energy": 50,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45212"
    ],
    "notes": null
  },
  {
    "id": "coffee-cupcake",
    "slug": "coffee-cupcake",
    "name": "Coffee Cupcake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/coffee-cupcake.webp",
    "imageStatus": "verified",
    "sellPrice": 850,
    "energy": 65,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45147"
    ],
    "notes": null
  },
  {
    "id": "coffee-ice-cream",
    "slug": "coffee-ice-cream",
    "name": "Coffee Ice Cream",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/coffee-ice-cream.webp",
    "imageStatus": "verified",
    "sellPrice": 770,
    "energy": 70,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45134"
    ],
    "notes": null
  },
  {
    "id": "coffee-pudding",
    "slug": "coffee-pudding",
    "name": "Coffee Pudding",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/coffee-pudding.webp",
    "imageStatus": "verified",
    "sellPrice": 560,
    "energy": 50,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45214"
    ],
    "notes": null
  },
  {
    "id": "coffee-toast",
    "slug": "coffee-toast",
    "name": "Coffee Toast",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/coffee-toast.webp",
    "imageStatus": "verified",
    "sellPrice": 560,
    "energy": 50,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45202"
    ],
    "notes": null
  },
  {
    "id": "colorful-movie-meal",
    "slug": "colorful-movie-meal",
    "name": "Colorful Movie Meal",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/colorful-movie-meal.webp",
    "imageStatus": "verified",
    "sellPrice": 1960,
    "energy": 60,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45460"
    ],
    "notes": null
  },
  {
    "id": "corn-juice",
    "slug": "corn-juice",
    "name": "Corn Juice",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/corn-juice.webp",
    "imageStatus": "verified",
    "sellPrice": 2170,
    "energy": 40,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45171"
    ],
    "notes": null
  },
  {
    "id": "cozy-afternoon-tea",
    "slug": "cozy-afternoon-tea",
    "name": "Cozy Afternoon Tea",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/cozy-afternoon-tea.webp",
    "imageStatus": "verified",
    "sellPrice": 1020,
    "energy": 30,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45419"
    ],
    "notes": null
  },
  {
    "id": "cozy-borscht",
    "slug": "cozy-borscht",
    "name": "Cozy Borscht",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/cozy-borscht.webp",
    "imageStatus": "verified",
    "sellPrice": 270,
    "energy": 20,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45393"
    ],
    "notes": null
  },
  {
    "id": "cozy-carrot-borscht",
    "slug": "cozy-carrot-borscht",
    "name": "Cozy Carrot Borscht",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/cozy-carrot-borscht.webp",
    "imageStatus": "verified",
    "sellPrice": 390,
    "energy": 25,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45398"
    ],
    "notes": null
  },
  {
    "id": "cozy-classic-meatball",
    "slug": "cozy-classic-meatball",
    "name": "Cozy Classic Meatball",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/cozy-classic-meatball.webp",
    "imageStatus": "verified",
    "sellPrice": 25,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#46139"
    ],
    "notes": null
  },
  {
    "id": "cozy-corn-borscht",
    "slug": "cozy-corn-borscht",
    "name": "Cozy Corn Borscht",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/cozy-corn-borscht.webp",
    "imageStatus": "verified",
    "sellPrice": 750,
    "energy": 40,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45395"
    ],
    "notes": null
  },
  {
    "id": "cozy-custard-sauce",
    "slug": "cozy-custard-sauce",
    "name": "Cozy Custard Sauce",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/cozy-custard-sauce.webp",
    "imageStatus": "verified",
    "sellPrice": 25,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#46138"
    ],
    "notes": null
  },
  {
    "id": "cozy-potato-borscht",
    "slug": "cozy-potato-borscht",
    "name": "Cozy Potato Borscht",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/cozy-potato-borscht.webp",
    "imageStatus": "verified",
    "sellPrice": 330,
    "energy": 20,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45394"
    ],
    "notes": null
  },
  {
    "id": "cozy-tomato-borscht",
    "slug": "cozy-tomato-borscht",
    "name": "Cozy Tomato Borscht",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/cozy-tomato-borscht.webp",
    "imageStatus": "verified",
    "sellPrice": 270,
    "energy": 20,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45396"
    ],
    "notes": null
  },
  {
    "id": "crawling-firecracker-bug",
    "slug": "crawling-firecracker-bug",
    "name": "Crawling Firecracker Bug",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/crawling-firecracker-bug.webp",
    "imageStatus": "verified",
    "sellPrice": 90,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51911",
      "variant-of:firecracker-bug"
    ],
    "notes": null,
    "variantOf": "firecracker-bug"
  },
  {
    "id": "crayfish-avocado-cup",
    "slug": "crayfish-avocado-cup",
    "name": "Crayfish Avocado Cup",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/crayfish-avocado-cup.webp",
    "imageStatus": "verified",
    "sellPrice": 1560,
    "energy": 80,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45426"
    ],
    "notes": null
  },
  {
    "id": "cream-cake",
    "slug": "cream-cake",
    "name": "Cream Cake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/cream-cake.webp",
    "imageStatus": "verified",
    "sellPrice": 560,
    "energy": 50,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45182"
    ],
    "notes": null
  },
  {
    "id": "creamy-white-radish-soup",
    "slug": "creamy-white-radish-soup",
    "name": "Creamy White Radish Soup",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/creamy-white-radish-soup.webp",
    "imageStatus": "verified",
    "sellPrice": 340,
    "energy": 25,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45431"
    ],
    "notes": null
  },
  {
    "id": "cupcake",
    "slug": "cupcake",
    "name": "Cupcake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/cupcake.webp",
    "imageStatus": "verified",
    "sellPrice": 590,
    "energy": 45,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45145"
    ],
    "notes": null
  },
  {
    "id": "deer-cupcake",
    "slug": "deer-cupcake",
    "name": "Deer Cupcake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/deer-cupcake.webp",
    "imageStatus": "verified",
    "sellPrice": 590,
    "energy": 35,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45316"
    ],
    "notes": null
  },
  {
    "id": "deer-paw-candy",
    "slug": "deer-paw-candy",
    "name": "Deer Paw Candy",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/deer-paw-candy.webp",
    "imageStatus": "verified",
    "sellPrice": 25,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#46130"
    ],
    "notes": null
  },
  {
    "id": "dragonfruit-hermit-crab",
    "slug": "dragonfruit-hermit-crab",
    "name": "Dragonfruit Hermit Crab",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/dragonfruit-hermit-crab.webp",
    "imageStatus": "verified",
    "sellPrice": 150,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#10369",
      "variant-of:hermit-crab"
    ],
    "notes": null,
    "variantOf": "hermit-crab"
  },
  {
    "id": "dragonfruit-jam",
    "slug": "dragonfruit-jam",
    "name": "Dragonfruit Jam",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/dragonfruit-jam.webp",
    "imageStatus": "verified",
    "sellPrice": 200,
    "energy": 20,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45326"
    ],
    "notes": null
  },
  {
    "id": "dung-beetle",
    "slug": "dung-beetle",
    "name": "Dung Beetle",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/red-dung-beetle.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "variant-group:dung-beetle"
    ],
    "notes": null,
    "isVariantGroup": true
  },
  {
    "id": "dust-bug",
    "slug": "dust-bug",
    "name": "Dust Bug",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/gray-bouncy-dust-insect.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "variant-group:dust-bug"
    ],
    "notes": null,
    "isVariantGroup": true
  },
  {
    "id": "eastern-lubber-grasshopper",
    "slug": "eastern-lubber-grasshopper",
    "name": "Eastern Lubber Grasshopper",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/eastern-lubber-grasshopper.webp",
    "imageStatus": "verified",
    "sellPrice": 90,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51305"
    ],
    "notes": null
  },
  {
    "id": "edible-star-powder",
    "slug": "edible-star-powder",
    "name": "Edible Star Powder",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/edible-star-powder.webp",
    "imageStatus": "verified",
    "sellPrice": 25,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#46134"
    ],
    "notes": null
  },
  {
    "id": "eerie-pumpkin-bowl",
    "slug": "eerie-pumpkin-bowl",
    "name": "Eerie Pumpkin Bowl",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/eerie-pumpkin-bowl.webp",
    "imageStatus": "verified",
    "sellPrice": 520,
    "energy": 30,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45220"
    ],
    "notes": null
  },
  {
    "id": "eerie-pumpkin-pie",
    "slug": "eerie-pumpkin-pie",
    "name": "Eerie Pumpkin Pie",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/eerie-pumpkin-pie.webp",
    "imageStatus": "verified",
    "sellPrice": 620,
    "energy": 35,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45218"
    ],
    "notes": null
  },
  {
    "id": "eerie-pumpkin-soup",
    "slug": "eerie-pumpkin-soup",
    "name": "Eerie Pumpkin Soup",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/eerie-pumpkin-soup.webp",
    "imageStatus": "verified",
    "sellPrice": 410,
    "energy": 20,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45216"
    ],
    "notes": null
  },
  {
    "id": "egg-dumpling",
    "slug": "egg-dumpling",
    "name": "Egg Dumpling",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/egg-dumpling.webp",
    "imageStatus": "verified",
    "sellPrice": 950,
    "energy": 50,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45245"
    ],
    "notes": null
  },
  {
    "id": "egg-pudding",
    "slug": "egg-pudding",
    "name": "Egg Pudding",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/egg-pudding.webp",
    "imageStatus": "verified",
    "sellPrice": 560,
    "energy": 50,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45213"
    ],
    "notes": null
  },
  {
    "id": "egg-rice-bowl-banchos-pick",
    "slug": "egg-rice-bowl-banchos-pick",
    "name": "Egg Rice Bowl (Bancho's Pick)",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/egg-rice-bowl-banchos-pick.webp",
    "imageStatus": "verified",
    "sellPrice": 310,
    "energy": 40,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45551"
    ],
    "notes": null
  },
  {
    "id": "eggplant-pasta",
    "slug": "eggplant-pasta",
    "name": "Eggplant Pasta",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": null,
    "imageStatus": "missing",
    "sellPrice": 550,
    "energy": 80,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45178"
    ],
    "notes": null
  },
  {
    "id": "fermented-dough",
    "slug": "fermented-dough",
    "name": "Fermented Dough",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/fermented-dough.webp",
    "imageStatus": "verified",
    "sellPrice": 25,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#46135"
    ],
    "notes": null
  },
  {
    "id": "ferret-cupcake",
    "slug": "ferret-cupcake",
    "name": "Ferret Cupcake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/ferret-cupcake.webp",
    "imageStatus": "verified",
    "sellPrice": 590,
    "energy": 35,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45319"
    ],
    "notes": null
  },
  {
    "id": "ferret-paw-candy",
    "slug": "ferret-paw-candy",
    "name": "Ferret Paw Candy",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/ferret-paw-candy.webp",
    "imageStatus": "verified",
    "sellPrice": 25,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#46133"
    ],
    "notes": null
  },
  {
    "id": "fiddlehead-celtuce-taco",
    "slug": "fiddlehead-celtuce-taco",
    "name": "Fiddlehead Celtuce Taco",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/fiddlehead-celtuce-taco.webp",
    "imageStatus": "verified",
    "sellPrice": 330,
    "energy": 35,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45445"
    ],
    "notes": null
  },
  {
    "id": "firecracker-bug",
    "slug": "firecracker-bug",
    "name": "Firecracker Bug",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/crawling-firecracker-bug.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "variant-group:firecracker-bug"
    ],
    "notes": null,
    "isVariantGroup": true
  },
  {
    "id": "firefly-squid",
    "slug": "firefly-squid",
    "name": "Firefly Squid",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/firefly-squid.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#10411"
    ],
    "notes": null
  },
  {
    "id": "fish-chips",
    "slug": "fish-chips",
    "name": "Fish & Chips",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/fish-chips.webp",
    "imageStatus": "verified",
    "sellPrice": 310,
    "energy": 40,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45111"
    ],
    "notes": null
  },
  {
    "id": "flame-skimmer",
    "slug": "flame-skimmer",
    "name": "Flame Skimmer",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/flame-skimmer.webp",
    "imageStatus": "verified",
    "sellPrice": 295,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51507"
    ],
    "notes": null
  },
  {
    "id": "flat-white",
    "slug": "flat-white",
    "name": "Flat White",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/flat-white.webp",
    "imageStatus": "verified",
    "sellPrice": 470,
    "energy": 50,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45199"
    ],
    "notes": null
  },
  {
    "id": "flatback-turtle",
    "slug": "flatback-turtle",
    "name": "Flatback Turtle",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/flatback-turtle.webp",
    "imageStatus": "verified",
    "sellPrice": 155,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#10412"
    ],
    "notes": null
  },
  {
    "id": "flower-cake",
    "slug": "flower-cake",
    "name": "Flower Cake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/flower-cake.webp",
    "imageStatus": "verified",
    "sellPrice": 560,
    "energy": 50,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45186"
    ],
    "notes": null
  },
  {
    "id": "flying-firecracker-bug",
    "slug": "flying-firecracker-bug",
    "name": "Flying Firecracker Bug",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/flying-firecracker-bug.webp",
    "imageStatus": "verified",
    "sellPrice": 90,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51913",
      "variant-of:firecracker-bug"
    ],
    "notes": null,
    "variantOf": "firecracker-bug"
  },
  {
    "id": "fox-cupcake",
    "slug": "fox-cupcake",
    "name": "Fox Cupcake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/fox-cupcake.webp",
    "imageStatus": "verified",
    "sellPrice": 590,
    "energy": 35,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45313"
    ],
    "notes": null
  },
  {
    "id": "fox-paw-candy",
    "slug": "fox-paw-candy",
    "name": "Fox Paw Candy",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/fox-paw-candy.webp",
    "imageStatus": "verified",
    "sellPrice": 25,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#46127"
    ],
    "notes": null
  },
  {
    "id": "fried-shrimp-sushi-banchos-pick",
    "slug": "fried-shrimp-sushi-banchos-pick",
    "name": "Fried Shrimp Sushi (Bancho's Pick)",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/fried-shrimp-sushi-banchos-pick.webp",
    "imageStatus": "verified",
    "sellPrice": 430,
    "energy": 45,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45550"
    ],
    "notes": null
  },
  {
    "id": "frozen-sausage",
    "slug": "frozen-sausage",
    "name": "Frozen Sausage",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/frozen-sausage.webp",
    "imageStatus": "verified",
    "sellPrice": 25,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#46124"
    ],
    "notes": null
  },
  {
    "id": "fruit-jam-meatball",
    "slug": "fruit-jam-meatball",
    "name": "Fruit Jam Meatball",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/fruit-jam-meatball.webp",
    "imageStatus": "verified",
    "sellPrice": 340,
    "energy": 20,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45411"
    ],
    "notes": null
  },
  {
    "id": "fruit-juice",
    "slug": "fruit-juice",
    "name": "Fruit Juice",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/fruit-juice.webp",
    "imageStatus": "verified",
    "sellPrice": 200,
    "energy": 25,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45137"
    ],
    "notes": null
  },
  {
    "id": "fruit-princess-cake",
    "slug": "fruit-princess-cake",
    "name": "Fruit Princess Cake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/fruit-princess-cake.webp",
    "imageStatus": "verified",
    "sellPrice": 330,
    "energy": 20,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45401"
    ],
    "notes": null
  },
  {
    "id": "ghost-frog",
    "slug": "ghost-frog",
    "name": "Ghost Frog",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/ghost-frog.webp",
    "imageStatus": "verified",
    "sellPrice": 230,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#10362"
    ],
    "notes": null
  },
  {
    "id": "ghost-lollipop",
    "slug": "ghost-lollipop",
    "name": "Ghost Lollipop",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/ghost-lollipop.webp",
    "imageStatus": "verified",
    "sellPrice": 50,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#46114"
    ],
    "notes": null
  },
  {
    "id": "gin-matsuba-koi",
    "slug": "gin-matsuba-koi",
    "name": "Gin Matsuba Koi",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/gin-matsuba-koi.webp",
    "imageStatus": "verified",
    "sellPrice": 155,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#10122",
      "variant-of:koi"
    ],
    "notes": null,
    "variantOf": "koi"
  },
  {
    "id": "glass-rose-seed",
    "slug": "glass-rose-seed",
    "name": "Glass Rose Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/glass-rose-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 600,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#700912",
      "variant-of:rose-seeds"
    ],
    "notes": null,
    "flowerSpecies": "rose-seeds",
    "flowerColor": "glass",
    "variantOf": "rose-seeds"
  },
  {
    "id": "glasswort",
    "slug": "glasswort",
    "name": "Glasswort",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/glasswort.webp",
    "imageStatus": "verified",
    "sellPrice": 10,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#40601"
    ],
    "notes": null
  },
  {
    "id": "glasswort-shrimp-fried-rice",
    "slug": "glasswort-shrimp-fried-rice",
    "name": "Glasswort & Shrimp Fried Rice",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/glasswort-shrimp-fried-rice.webp",
    "imageStatus": "verified",
    "sellPrice": 160,
    "energy": 25,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45549"
    ],
    "notes": null
  },
  {
    "id": "gold-bug",
    "slug": "gold-bug",
    "name": "Gold Bug",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/gold-bug.webp",
    "imageStatus": "verified",
    "sellPrice": 165,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51935"
    ],
    "notes": null
  },
  {
    "id": "golden-clockwork-ladybug",
    "slug": "golden-clockwork-ladybug",
    "name": "Golden Clockwork Ladybug",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/golden-clockwork-ladybug.webp",
    "imageStatus": "verified",
    "sellPrice": 165,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51412",
      "variant-of:clockwork-ladybug"
    ],
    "notes": null,
    "variantOf": "clockwork-ladybug"
  },
  {
    "id": "golden-dung-beetle",
    "slug": "golden-dung-beetle",
    "name": "Golden Dung Beetle",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/golden-dung-beetle.webp",
    "imageStatus": "verified",
    "sellPrice": 165,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51231",
      "variant-of:dung-beetle"
    ],
    "notes": null,
    "variantOf": "dung-beetle"
  },
  {
    "id": "golden-koi",
    "slug": "golden-koi",
    "name": "Golden Koi",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/golden-koi.webp",
    "imageStatus": "verified",
    "sellPrice": 155,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#10110",
      "variant-of:koi"
    ],
    "notes": null,
    "variantOf": "koi"
  },
  {
    "id": "golden-mussel",
    "slug": "golden-mussel",
    "name": "Golden Mussel",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/golden-mussel.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#10235"
    ],
    "notes": null
  },
  {
    "id": "golden-pheasant",
    "slug": "golden-pheasant",
    "name": "Golden Pheasant",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/golden-pheasant.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#61211"
    ],
    "notes": null
  },
  {
    "id": "grape-cloud-candy",
    "slug": "grape-cloud-candy",
    "name": "Grape Cloud Candy",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/grape-cloud-candy.webp",
    "imageStatus": "verified",
    "sellPrice": 1190,
    "energy": 80,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45286"
    ],
    "notes": null
  },
  {
    "id": "grape-ice-cream",
    "slug": "grape-ice-cream",
    "name": "Grape Ice Cream",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/grape-ice-cream.webp",
    "imageStatus": "verified",
    "sellPrice": 4280,
    "energy": 70,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45167"
    ],
    "notes": null
  },
  {
    "id": "grape-jam-meatball",
    "slug": "grape-jam-meatball",
    "name": "Grape Jam Meatball",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/grape-jam-meatball.webp",
    "imageStatus": "verified",
    "sellPrice": 2200,
    "energy": 100,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45417"
    ],
    "notes": null
  },
  {
    "id": "grape-juice",
    "slug": "grape-juice",
    "name": "Grape Juice",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/grape-juice.webp",
    "imageStatus": "verified",
    "sellPrice": 2030,
    "energy": 40,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45169"
    ],
    "notes": null
  },
  {
    "id": "grape-princess-cake",
    "slug": "grape-princess-cake",
    "name": "Grape Princess Cake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/grape-princess-cake.webp",
    "imageStatus": "verified",
    "sellPrice": 780,
    "energy": 40,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45407"
    ],
    "notes": null
  },
  {
    "id": "gray-bouncy-dust-insect",
    "slug": "gray-bouncy-dust-insect",
    "name": "Gray Bouncy Dust Insect",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/gray-bouncy-dust-insect.webp",
    "imageStatus": "verified",
    "sellPrice": 45,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51901",
      "variant-of:dust-bug"
    ],
    "notes": null,
    "variantOf": "dust-bug"
  },
  {
    "id": "gray-camping-sparrow",
    "slug": "gray-camping-sparrow",
    "name": "Gray Camping Sparrow",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/gray-camping-sparrow.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#61127",
      "variant-of:camping-sparrow"
    ],
    "notes": null,
    "variantOf": "camping-sparrow"
  },
  {
    "id": "gray-clockwork-sparrow",
    "slug": "gray-clockwork-sparrow",
    "name": "Gray Clockwork Sparrow",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/gray-clockwork-sparrow.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#61132",
      "variant-of:clockwork-sparrow"
    ],
    "notes": null,
    "variantOf": "clockwork-sparrow"
  },
  {
    "id": "great-black-firefly",
    "slug": "great-black-firefly",
    "name": "Great Black Firefly",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/great-black-firefly.webp",
    "imageStatus": "verified",
    "sellPrice": 110,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51217"
    ],
    "notes": null
  },
  {
    "id": "green-bath-towel-mako-shark",
    "slug": "green-bath-towel-mako-shark",
    "name": "Green Bath-Towel Mako Shark",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/green-bath-towel-mako-shark.webp",
    "imageStatus": "verified",
    "sellPrice": 215,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#10380",
      "variant-of:bath-towel-mako-shark"
    ],
    "notes": null,
    "variantOf": "bath-towel-mako-shark"
  },
  {
    "id": "green-bouncy-dust-bug",
    "slug": "green-bouncy-dust-bug",
    "name": "Green Bouncy Dust Bug",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/green-bouncy-dust-bug.webp",
    "imageStatus": "verified",
    "sellPrice": 45,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51902",
      "variant-of:dust-bug"
    ],
    "notes": null,
    "variantOf": "dust-bug"
  },
  {
    "id": "green-camping-sparrow",
    "slug": "green-camping-sparrow",
    "name": "Green Camping Sparrow",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/green-camping-sparrow.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#61129",
      "variant-of:camping-sparrow"
    ],
    "notes": null,
    "variantOf": "camping-sparrow"
  },
  {
    "id": "green-cranesbill",
    "slug": "green-cranesbill",
    "name": "Green Cranesbill",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/green-cranesbill.webp",
    "imageStatus": "verified",
    "sellPrice": 2065,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#732408",
      "variant-of:cranesbill"
    ],
    "notes": null,
    "flowerSpecies": "cranesbill",
    "flowerColor": "green",
    "variantOf": "cranesbill"
  },
  {
    "id": "green-cranesbill-seed",
    "slug": "green-cranesbill-seed",
    "name": "Green Cranesbill Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/green-cranesbill-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 375,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#702408",
      "variant-of:cranesbill-seeds"
    ],
    "notes": null,
    "flowerSpecies": "cranesbill-seeds",
    "flowerColor": "green",
    "variantOf": "cranesbill-seeds"
  },
  {
    "id": "green-dung-beetle",
    "slug": "green-dung-beetle",
    "name": "Green Dung Beetle",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/green-dung-beetle.webp",
    "imageStatus": "verified",
    "sellPrice": 110,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51229",
      "variant-of:dung-beetle"
    ],
    "notes": null,
    "variantOf": "dung-beetle"
  },
  {
    "id": "green-flower-chafer",
    "slug": "green-flower-chafer",
    "name": "Green Flower Chafer",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/green-flower-chafer.webp",
    "imageStatus": "verified",
    "sellPrice": 110,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51232"
    ],
    "notes": null
  },
  {
    "id": "green-hat-stock-dove",
    "slug": "green-hat-stock-dove",
    "name": "Green Hat Stock Dove",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/green-hat-stock-dove.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#61223",
      "variant-of:stock-dove"
    ],
    "notes": null,
    "variantOf": "stock-dove"
  },
  {
    "id": "green-jello-fish",
    "slug": "green-jello-fish",
    "name": "Green Jello Fish",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/green-jello-fish.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#10226",
      "variant-of:jello-fish"
    ],
    "notes": null,
    "variantOf": "jello-fish"
  },
  {
    "id": "green-light-firefly",
    "slug": "green-light-firefly",
    "name": "Green Light Firefly",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/green-light-firefly.webp",
    "imageStatus": "verified",
    "sellPrice": 110,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51223",
      "variant-of:light-firefly"
    ],
    "notes": null,
    "variantOf": "light-firefly"
  },
  {
    "id": "green-light-jellyfish",
    "slug": "green-light-jellyfish",
    "name": "Green Light Jellyfish",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/green-light-jellyfish.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#10375"
    ],
    "notes": null
  },
  {
    "id": "green-light-sea-star",
    "slug": "green-light-sea-star",
    "name": "Green Light Sea Star",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/green-light-sea-star.webp",
    "imageStatus": "verified",
    "sellPrice": 230,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#10377",
      "variant-of:light-sea-star"
    ],
    "notes": null,
    "variantOf": "light-sea-star"
  },
  {
    "id": "green-starry-stock-dove",
    "slug": "green-starry-stock-dove",
    "name": "Green Starry Stock Dove",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/green-starry-stock-dove.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#61213",
      "variant-of:stock-dove"
    ],
    "notes": null,
    "variantOf": "stock-dove"
  },
  {
    "id": "green-starry-swan",
    "slug": "green-starry-swan",
    "name": "Green Starry Swan",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/green-starry-swan.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#61707",
      "variant-of:starry-swan"
    ],
    "notes": null,
    "variantOf": "starry-swan"
  },
  {
    "id": "grey-mantled-albatross",
    "slug": "grey-mantled-albatross",
    "name": "Grey-mantled Albatross",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/grey-mantled-albatross.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#61512"
    ],
    "notes": null
  },
  {
    "id": "grilled-mushroom",
    "slug": "grilled-mushroom",
    "name": "Grilled Mushroom",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/grilled-mushroom.webp",
    "imageStatus": "verified",
    "sellPrice": 180,
    "energy": 15,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45358"
    ],
    "notes": null
  },
  {
    "id": "grilled-shiitake",
    "slug": "grilled-shiitake",
    "name": "Grilled Shiitake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/grilled-shiitake.webp",
    "imageStatus": "verified",
    "sellPrice": 180,
    "energy": 15,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45360"
    ],
    "notes": null
  },
  {
    "id": "grilled-squid-w-apple-jam",
    "slug": "grilled-squid-w-apple-jam",
    "name": "Grilled Squid w/ Apple Jam",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/grilled-squid-w-apple-jam.webp",
    "imageStatus": "verified",
    "sellPrice": 550,
    "energy": 45,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45541"
    ],
    "notes": null
  },
  {
    "id": "grilled-squid-w-blueberry-jam",
    "slug": "grilled-squid-w-blueberry-jam",
    "name": "Grilled Squid w/ Blueberry Jam",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/grilled-squid-w-blueberry-jam.webp",
    "imageStatus": "verified",
    "sellPrice": 450,
    "energy": 40,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45542"
    ],
    "notes": null
  },
  {
    "id": "grilled-squid-w-fruit-jam",
    "slug": "grilled-squid-w-fruit-jam",
    "name": "Grilled Squid w/ Fruit Jam",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/grilled-squid-w-fruit-jam.webp",
    "imageStatus": "verified",
    "sellPrice": 440,
    "energy": 40,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45540"
    ],
    "notes": null
  },
  {
    "id": "grilled-squid-w-pineapple-jam",
    "slug": "grilled-squid-w-pineapple-jam",
    "name": "Grilled Squid w/ Pineapple Jam",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/grilled-squid-w-pineapple-jam.webp",
    "imageStatus": "verified",
    "sellPrice": 560,
    "energy": 45,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45544"
    ],
    "notes": null
  },
  {
    "id": "grilled-squid-w-starfruit-jam",
    "slug": "grilled-squid-w-starfruit-jam",
    "name": "Grilled Squid w/ Starfruit Jam",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/grilled-squid-w-starfruit-jam.webp",
    "imageStatus": "verified",
    "sellPrice": 480,
    "energy": 40,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45543"
    ],
    "notes": null
  },
  {
    "id": "grilled-squid-w-strawberry-jam",
    "slug": "grilled-squid-w-strawberry-jam",
    "name": "Grilled Squid w/ Strawberry Jam",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/grilled-squid-w-strawberry-jam.webp",
    "imageStatus": "verified",
    "sellPrice": 1860,
    "energy": 100,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45545"
    ],
    "notes": null
  },
  {
    "id": "grimkin-pumpkin-bowl",
    "slug": "grimkin-pumpkin-bowl",
    "name": "Grimkin Pumpkin Bowl",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/grimkin-pumpkin-bowl.webp",
    "imageStatus": "verified",
    "sellPrice": 590,
    "energy": 35,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45221"
    ],
    "notes": null
  },
  {
    "id": "grimkin-pumpkin-pie",
    "slug": "grimkin-pumpkin-pie",
    "name": "Grimkin Pumpkin Pie",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/grimkin-pumpkin-pie.webp",
    "imageStatus": "verified",
    "sellPrice": 690,
    "energy": 40,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45219"
    ],
    "notes": null
  },
  {
    "id": "grimkin-pumpkin-soup",
    "slug": "grimkin-pumpkin-soup",
    "name": "Grimkin Pumpkin Soup",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/grimkin-pumpkin-soup.webp",
    "imageStatus": "verified",
    "sellPrice": 480,
    "energy": 25,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45217"
    ],
    "notes": null
  },
  {
    "id": "hanging-firecracker-bug",
    "slug": "hanging-firecracker-bug",
    "name": "Hanging Firecracker Bug",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/hanging-firecracker-bug.webp",
    "imageStatus": "verified",
    "sellPrice": 90,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51914",
      "variant-of:firecracker-bug"
    ],
    "notes": null,
    "variantOf": "firecracker-bug"
  },
  {
    "id": "harvest-apple-yogurt-bowl",
    "slug": "harvest-apple-yogurt-bowl",
    "name": "Harvest Apple Yogurt Bowl",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/harvest-apple-yogurt-bowl.webp",
    "imageStatus": "verified",
    "sellPrice": 300,
    "energy": 20,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45372"
    ],
    "notes": null
  },
  {
    "id": "harvest-black-diamond-mussel",
    "slug": "harvest-black-diamond-mussel",
    "name": "Harvest Black Diamond Mussel",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/harvest-black-diamond-mussel.webp",
    "imageStatus": "verified",
    "sellPrice": 440,
    "energy": 30,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45385"
    ],
    "notes": null
  },
  {
    "id": "harvest-blue-diamond-mussel",
    "slug": "harvest-blue-diamond-mussel",
    "name": "Harvest Blue Diamond Mussel",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/harvest-blue-diamond-mussel.webp",
    "imageStatus": "verified",
    "sellPrice": 440,
    "energy": 30,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45383"
    ],
    "notes": null
  },
  {
    "id": "harvest-blueberry-yogurt-bowl",
    "slug": "harvest-blueberry-yogurt-bowl",
    "name": "Harvest Blueberry Yogurt Bowl",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/harvest-blueberry-yogurt-bowl.webp",
    "imageStatus": "verified",
    "sellPrice": 250,
    "energy": 20,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45374"
    ],
    "notes": null
  },
  {
    "id": "harvest-corn-toast",
    "slug": "harvest-corn-toast",
    "name": "Harvest Corn Toast",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/harvest-corn-toast.webp",
    "imageStatus": "verified",
    "sellPrice": 1470,
    "energy": 80,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45365"
    ],
    "notes": null
  },
  {
    "id": "harvest-golden-mussel",
    "slug": "harvest-golden-mussel",
    "name": "Harvest Golden Mussel",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/harvest-golden-mussel.webp",
    "imageStatus": "verified",
    "sellPrice": 440,
    "energy": 30,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45386"
    ],
    "notes": null
  },
  {
    "id": "harvest-grape-yogurt-bowl",
    "slug": "harvest-grape-yogurt-bowl",
    "name": "Harvest Grape Yogurt Bowl",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/harvest-grape-yogurt-bowl.webp",
    "imageStatus": "verified",
    "sellPrice": 1150,
    "energy": 80,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45377"
    ],
    "notes": null
  },
  {
    "id": "harvest-jade-mussel",
    "slug": "harvest-jade-mussel",
    "name": "Harvest Jade Mussel",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/harvest-jade-mussel.webp",
    "imageStatus": "verified",
    "sellPrice": 440,
    "energy": 30,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45382"
    ],
    "notes": null
  },
  {
    "id": "harvest-lettuce-toast",
    "slug": "harvest-lettuce-toast",
    "name": "Harvest Lettuce Toast",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/harvest-lettuce-toast.webp",
    "imageStatus": "verified",
    "sellPrice": 500,
    "energy": 30,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45364"
    ],
    "notes": null
  },
  {
    "id": "harvest-mandarin-yogurt-bowl",
    "slug": "harvest-mandarin-yogurt-bowl",
    "name": "Harvest Mandarin Yogurt Bowl",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/harvest-mandarin-yogurt-bowl.webp",
    "imageStatus": "verified",
    "sellPrice": 300,
    "energy": 20,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45373"
    ],
    "notes": null
  },
  {
    "id": "harvest-matsutake-soup",
    "slug": "harvest-matsutake-soup",
    "name": "Harvest Matsutake Soup",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/harvest-matsutake-soup.webp",
    "imageStatus": "verified",
    "sellPrice": 350,
    "energy": 25,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45387"
    ],
    "notes": null
  },
  {
    "id": "harvest-meal",
    "slug": "harvest-meal",
    "name": "Harvest Meal",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/harvest-meal.webp",
    "imageStatus": "verified",
    "sellPrice": 1600,
    "energy": 30,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45388"
    ],
    "notes": null
  },
  {
    "id": "harvest-mussel",
    "slug": "harvest-mussel",
    "name": "Harvest Mussel",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/harvest-mussel.webp",
    "imageStatus": "verified",
    "sellPrice": 440,
    "energy": 30,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45381"
    ],
    "notes": null
  },
  {
    "id": "harvest-nut-yogurt-bowl",
    "slug": "harvest-nut-yogurt-bowl",
    "name": "Harvest Nut Yogurt Bowl",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/harvest-nut-yogurt-bowl.webp",
    "imageStatus": "verified",
    "sellPrice": 250,
    "energy": 20,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45371"
    ],
    "notes": null
  },
  {
    "id": "harvest-nuts",
    "slug": "harvest-nuts",
    "name": "Harvest Nuts",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/harvest-nuts.webp",
    "imageStatus": "verified",
    "sellPrice": 25,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#46137"
    ],
    "notes": null
  },
  {
    "id": "harvest-pineapple-yogurt-bowl",
    "slug": "harvest-pineapple-yogurt-bowl",
    "name": "Harvest Pineapple Yogurt Bowl",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/harvest-pineapple-yogurt-bowl.webp",
    "imageStatus": "verified",
    "sellPrice": 290,
    "energy": 20,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45378"
    ],
    "notes": null
  },
  {
    "id": "harvest-purple-diamond-mussel",
    "slug": "harvest-purple-diamond-mussel",
    "name": "Harvest Purple Diamond Mussel",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/harvest-purple-diamond-mussel.webp",
    "imageStatus": "verified",
    "sellPrice": 440,
    "energy": 30,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45384"
    ],
    "notes": null
  },
  {
    "id": "harvest-raspberry-yogurt-bowl",
    "slug": "harvest-raspberry-yogurt-bowl",
    "name": "Harvest Raspberry Yogurt Bowl",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/harvest-raspberry-yogurt-bowl.webp",
    "imageStatus": "verified",
    "sellPrice": 290,
    "energy": 20,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45375"
    ],
    "notes": null
  },
  {
    "id": "harvest-strawberry-yogurt-bowl",
    "slug": "harvest-strawberry-yogurt-bowl",
    "name": "Harvest Strawberry Yogurt Bowl",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/harvest-strawberry-yogurt-bowl.webp",
    "imageStatus": "verified",
    "sellPrice": 940,
    "energy": 80,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45376"
    ],
    "notes": null
  },
  {
    "id": "harvest-tomato-toast",
    "slug": "harvest-tomato-toast",
    "name": "Harvest Tomato Toast",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/harvest-tomato-toast.webp",
    "imageStatus": "verified",
    "sellPrice": 500,
    "energy": 30,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45366"
    ],
    "notes": null
  },
  {
    "id": "harvest-yogurt",
    "slug": "harvest-yogurt",
    "name": "Harvest Yogurt",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/harvest-yogurt.webp",
    "imageStatus": "verified",
    "sellPrice": 25,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#46136"
    ],
    "notes": null
  },
  {
    "id": "ice-bug",
    "slug": "ice-bug",
    "name": "Ice Bug",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/ice-bug.webp",
    "imageStatus": "verified",
    "sellPrice": 110,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51934"
    ],
    "notes": null
  },
  {
    "id": "ice-cream",
    "slug": "ice-cream",
    "name": "Ice Cream",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/ice-cream.webp",
    "imageStatus": "verified",
    "sellPrice": 280,
    "energy": 30,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45129"
    ],
    "notes": null
  },
  {
    "id": "iced-cup-coffee",
    "slug": "iced-cup-coffee",
    "name": "Iced-Cup Coffee",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/iced-cup-coffee.webp",
    "imageStatus": "verified",
    "sellPrice": 280,
    "energy": 20,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45428"
    ],
    "notes": null
  },
  {
    "id": "iced-cup-latte",
    "slug": "iced-cup-latte",
    "name": "Iced-Cup Latte",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/iced-cup-latte.webp",
    "imageStatus": "verified",
    "sellPrice": 280,
    "energy": 20,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45429"
    ],
    "notes": null
  },
  {
    "id": "indigo-hanging-dust-bug",
    "slug": "indigo-hanging-dust-bug",
    "name": "Indigo Hanging Dust Bug",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/indigo-hanging-dust-bug.webp",
    "imageStatus": "verified",
    "sellPrice": 140,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51905",
      "variant-of:dust-bug"
    ],
    "notes": null,
    "variantOf": "dust-bug"
  },
  {
    "id": "indigo-jello-fish",
    "slug": "indigo-jello-fish",
    "name": "Indigo Jello Fish",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/indigo-jello-fish.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#10225",
      "variant-of:jello-fish"
    ],
    "notes": null,
    "variantOf": "jello-fish"
  },
  {
    "id": "inflatable-mallard",
    "slug": "inflatable-mallard",
    "name": "Inflatable Mallard",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/inflatable-mallard.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#61409",
      "variant-of:mallard"
    ],
    "notes": null,
    "variantOf": "mallard"
  },
  {
    "id": "inflatable-ruddy-shelduck",
    "slug": "inflatable-ruddy-shelduck",
    "name": "Inflatable Ruddy Shelduck",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/inflatable-ruddy-shelduck.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#61412",
      "variant-of:ruddy-shelduck"
    ],
    "notes": null,
    "variantOf": "ruddy-shelduck"
  },
  {
    "id": "inflatable-smew",
    "slug": "inflatable-smew",
    "name": "Inflatable Smew",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/inflatable-smew.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#61410",
      "variant-of:smew"
    ],
    "notes": null,
    "variantOf": "smew"
  },
  {
    "id": "inflatable-wigeon",
    "slug": "inflatable-wigeon",
    "name": "Inflatable Wigeon",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/inflatable-wigeon.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#61411"
    ],
    "notes": null
  },
  {
    "id": "jade-mussel",
    "slug": "jade-mussel",
    "name": "Jade Mussel",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/jade-mussel.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#10231"
    ],
    "notes": null
  },
  {
    "id": "jady-blue-jellyfish-tartare",
    "slug": "jady-blue-jellyfish-tartare",
    "name": "Jady Blue Jellyfish Tartare",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/jady-blue-jellyfish-tartare.webp",
    "imageStatus": "verified",
    "sellPrice": 430,
    "energy": 30,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45349"
    ],
    "notes": null
  },
  {
    "id": "jady-green-jellyfish-tartare",
    "slug": "jady-green-jellyfish-tartare",
    "name": "Jady Green Jellyfish Tartare",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/jady-green-jellyfish-tartare.webp",
    "imageStatus": "verified",
    "sellPrice": 430,
    "energy": 30,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45350"
    ],
    "notes": null
  },
  {
    "id": "jady-jellyfish-tartare",
    "slug": "jady-jellyfish-tartare",
    "name": "Jady Jellyfish Tartare",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/jady-jellyfish-tartare.webp",
    "imageStatus": "verified",
    "sellPrice": 430,
    "energy": 30,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45347"
    ],
    "notes": null
  },
  {
    "id": "jady-purple-jellyfish-tartare",
    "slug": "jady-purple-jellyfish-tartare",
    "name": "Jady Purple Jellyfish Tartare",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/jady-purple-jellyfish-tartare.webp",
    "imageStatus": "verified",
    "sellPrice": 430,
    "energy": 30,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45348"
    ],
    "notes": null
  },
  {
    "id": "japanese-flying-squid",
    "slug": "japanese-flying-squid",
    "name": "Japanese Flying Squid",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/japanese-flying-squid.webp",
    "imageStatus": "verified",
    "sellPrice": 155,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#10410"
    ],
    "notes": null
  },
  {
    "id": "jello-fish",
    "slug": "jello-fish",
    "name": "Jello Fish",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/red-jello-fish.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "variant-group:jello-fish"
    ],
    "notes": null,
    "isVariantGroup": true
  },
  {
    "id": "jelly-treatsure-firefly",
    "slug": "jelly-treatsure-firefly",
    "name": "Jelly Treatsure Firefly",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/jelly-treatsure-firefly.webp",
    "imageStatus": "verified",
    "sellPrice": 110,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51923"
    ],
    "notes": null
  },
  {
    "id": "jellybean-treatsure-butterfly",
    "slug": "jellybean-treatsure-butterfly",
    "name": "Jellybean Treatsure Butterfly",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/jellybean-treatsure-butterfly.webp",
    "imageStatus": "verified",
    "sellPrice": 60,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51925"
    ],
    "notes": null
  },
  {
    "id": "jumping-firecracker-bug",
    "slug": "jumping-firecracker-bug",
    "name": "Jumping Firecracker Bug",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/jumping-firecracker-bug.webp",
    "imageStatus": "verified",
    "sellPrice": 90,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51912",
      "variant-of:firecracker-bug"
    ],
    "notes": null,
    "variantOf": "firecracker-bug"
  },
  {
    "id": "kissing-fish",
    "slug": "kissing-fish",
    "name": "Kissing Fish",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/kissing-fish.webp",
    "imageStatus": "verified",
    "sellPrice": 150,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#10222"
    ],
    "notes": null
  },
  {
    "id": "koi",
    "slug": "koi",
    "name": "Koi",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/koi.webp",
    "imageStatus": "verified",
    "sellPrice": 155,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#10105"
    ],
    "notes": null
  },
  {
    "id": "kuromi-crepe",
    "slug": "kuromi-crepe",
    "name": "Kuromi Crepe",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/kuromi-crepe.webp",
    "imageStatus": "verified",
    "sellPrice": 670,
    "energy": 80,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45554"
    ],
    "notes": null
  },
  {
    "id": "lady-amherst-s-pheasant",
    "slug": "lady-amherst-s-pheasant",
    "name": "Lady Amherst's Pheasant",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/lady-amherst-s-pheasant.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#61226"
    ],
    "notes": null
  },
  {
    "id": "large-chocolate-mooncake",
    "slug": "large-chocolate-mooncake",
    "name": "Large Chocolate Mooncake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/large-chocolate-mooncake.webp",
    "imageStatus": "verified",
    "sellPrice": 3300,
    "energy": 80,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45392"
    ],
    "notes": null
  },
  {
    "id": "large-egg-yolk-mooncake",
    "slug": "large-egg-yolk-mooncake",
    "name": "Large Egg Yolk Mooncake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/large-egg-yolk-mooncake.webp",
    "imageStatus": "verified",
    "sellPrice": 2610,
    "energy": 55,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45181"
    ],
    "notes": null
  },
  {
    "id": "large-moon-rabbit-snow-skin-mooncake",
    "slug": "large-moon-rabbit-snow-skin-mooncake",
    "name": "Large Moon Rabbit Snow Skin Mooncake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/large-moon-rabbit-snow-skin-mooncake.webp",
    "imageStatus": "verified",
    "sellPrice": 1100,
    "energy": 25,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45390"
    ],
    "notes": null
  },
  {
    "id": "light-firefly",
    "slug": "light-firefly",
    "name": "Light Firefly",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/blue-light-firefly.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "variant-group:light-firefly"
    ],
    "notes": null,
    "isVariantGroup": true
  },
  {
    "id": "light-sea-star",
    "slug": "light-sea-star",
    "name": "Light Sea Star",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/green-light-sea-star.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "variant-group:light-sea-star"
    ],
    "notes": null,
    "isVariantGroup": true
  },
  {
    "id": "little-egret",
    "slug": "little-egret",
    "name": "Little Egret",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/little-egret.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#61305"
    ],
    "notes": null
  },
  {
    "id": "lollipop-treatsure-dragonfly",
    "slug": "lollipop-treatsure-dragonfly",
    "name": "Lollipop Treatsure Dragonfly",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/lollipop-treatsure-dragonfly.webp",
    "imageStatus": "verified",
    "sellPrice": 75,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51921"
    ],
    "notes": null
  },
  {
    "id": "lychee-shieldbug",
    "slug": "lychee-shieldbug",
    "name": "Lychee Shieldbug",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/lychee-shieldbug.webp",
    "imageStatus": "verified",
    "sellPrice": 35,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51406"
    ],
    "notes": null
  },
  {
    "id": "mandarin-cake",
    "slug": "mandarin-cake",
    "name": "Mandarin Cake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/mandarin-cake.webp",
    "imageStatus": "verified",
    "sellPrice": 560,
    "energy": 50,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45184"
    ],
    "notes": null
  },
  {
    "id": "mandarin-cloud-candy",
    "slug": "mandarin-cloud-candy",
    "name": "Mandarin Cloud Candy",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/mandarin-cloud-candy.webp",
    "imageStatus": "verified",
    "sellPrice": 340,
    "energy": 30,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45290"
    ],
    "notes": null
  },
  {
    "id": "mandarin-cupcake",
    "slug": "mandarin-cupcake",
    "name": "Mandarin Cupcake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/mandarin-cupcake.webp",
    "imageStatus": "verified",
    "sellPrice": 820,
    "energy": 65,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45148"
    ],
    "notes": null
  },
  {
    "id": "mandarin-duck",
    "slug": "mandarin-duck",
    "name": "Mandarin Duck",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/mandarin-duck.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#61408"
    ],
    "notes": null
  },
  {
    "id": "mandarin-fish",
    "slug": "mandarin-fish",
    "name": "Mandarin Fish",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/mandarin-fish.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#10408"
    ],
    "notes": null
  },
  {
    "id": "mandarin-frosted-pancake",
    "slug": "mandarin-frosted-pancake",
    "name": "Mandarin Frosted Pancake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/mandarin-frosted-pancake.webp",
    "imageStatus": "verified",
    "sellPrice": 360,
    "energy": 25,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45436"
    ],
    "notes": null
  },
  {
    "id": "mandarin-hermit-crab",
    "slug": "mandarin-hermit-crab",
    "name": "Mandarin Hermit Crab",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/mandarin-hermit-crab.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#10372",
      "variant-of:hermit-crab"
    ],
    "notes": null,
    "variantOf": "hermit-crab"
  },
  {
    "id": "mandarin-ice-cream",
    "slug": "mandarin-ice-cream",
    "name": "Mandarin Ice Cream",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/mandarin-ice-cream.webp",
    "imageStatus": "verified",
    "sellPrice": 810,
    "energy": 70,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45133"
    ],
    "notes": null
  },
  {
    "id": "mandarin-jam-meatball",
    "slug": "mandarin-jam-meatball",
    "name": "Mandarin Jam Meatball",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/mandarin-jam-meatball.webp",
    "imageStatus": "verified",
    "sellPrice": 450,
    "energy": 40,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45413"
    ],
    "notes": null
  },
  {
    "id": "mandarin-juice",
    "slug": "mandarin-juice",
    "name": "Mandarin Juice",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/mandarin-juice.webp",
    "imageStatus": "verified",
    "sellPrice": 310,
    "energy": 38,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45141"
    ],
    "notes": null
  },
  {
    "id": "mandarin-pearl-cake",
    "slug": "mandarin-pearl-cake",
    "name": "Mandarin Pearl Cake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/mandarin-pearl-cake.webp",
    "imageStatus": "verified",
    "sellPrice": 590,
    "energy": 45,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45537"
    ],
    "notes": null
  },
  {
    "id": "mandarin-princess-cake",
    "slug": "mandarin-princess-cake",
    "name": "Mandarin Princess Cake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/mandarin-princess-cake.webp",
    "imageStatus": "verified",
    "sellPrice": 360,
    "energy": 20,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45403"
    ],
    "notes": null
  },
  {
    "id": "mandarin-pudding",
    "slug": "mandarin-pudding",
    "name": "Mandarin Pudding",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/mandarin-pudding.webp",
    "imageStatus": "verified",
    "sellPrice": 560,
    "energy": 50,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45210"
    ],
    "notes": null
  },
  {
    "id": "marinade-powder",
    "slug": "marinade-powder",
    "name": "Marinade Powder",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/marinade-powder.webp",
    "imageStatus": "verified",
    "sellPrice": 25,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#46123"
    ],
    "notes": null
  },
  {
    "id": "marinated-catfish-fillets",
    "slug": "marinated-catfish-fillets",
    "name": "Marinated Catfish Fillets",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/marinated-catfish-fillets.webp",
    "imageStatus": "verified",
    "sellPrice": 390,
    "energy": 35,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45266"
    ],
    "notes": null
  },
  {
    "id": "marinated-fillets",
    "slug": "marinated-fillets",
    "name": "Marinated Fillets",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/marinated-fillets.webp",
    "imageStatus": "verified",
    "sellPrice": 280,
    "energy": 25,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45263"
    ],
    "notes": null
  },
  {
    "id": "marinated-paddlefish-fillets",
    "slug": "marinated-paddlefish-fillets",
    "name": "Marinated Paddlefish Fillets",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/marinated-paddlefish-fillets.webp",
    "imageStatus": "verified",
    "sellPrice": 490,
    "energy": 30,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45265"
    ],
    "notes": null
  },
  {
    "id": "marinated-pufferfish-fillets",
    "slug": "marinated-pufferfish-fillets",
    "name": "Marinated Pufferfish Fillets",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/marinated-pufferfish-fillets.webp",
    "imageStatus": "verified",
    "sellPrice": 610,
    "energy": 35,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45264"
    ],
    "notes": null
  },
  {
    "id": "marshmallow",
    "slug": "marshmallow",
    "name": "Marshmallow",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/marshmallow.webp",
    "imageStatus": "verified",
    "sellPrice": 25,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#46122"
    ],
    "notes": null
  },
  {
    "id": "mashed-potato",
    "slug": "mashed-potato",
    "name": "Mashed Potato",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": null,
    "imageStatus": "missing",
    "sellPrice": 450,
    "energy": 48,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45173"
    ],
    "notes": null
  },
  {
    "id": "meat-dumpling",
    "slug": "meat-dumpling",
    "name": "Meat Dumpling",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/meat-dumpling.webp",
    "imageStatus": "verified",
    "sellPrice": 950,
    "energy": 50,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45244"
    ],
    "notes": null
  },
  {
    "id": "milk-cupcake",
    "slug": "milk-cupcake",
    "name": "Milk Cupcake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/milk-cupcake.webp",
    "imageStatus": "verified",
    "sellPrice": 590,
    "energy": 50,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45149"
    ],
    "notes": null
  },
  {
    "id": "milk-toast",
    "slug": "milk-toast",
    "name": "Milk Toast",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/milk-toast.webp",
    "imageStatus": "verified",
    "sellPrice": 560,
    "energy": 50,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45206"
    ],
    "notes": null
  },
  {
    "id": "mint",
    "slug": "mint",
    "name": "Mint",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/mint.webp",
    "imageStatus": "verified",
    "sellPrice": 30,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#769005"
    ],
    "notes": null
  },
  {
    "id": "mixed-vegetable-puree",
    "slug": "mixed-vegetable-puree",
    "name": "Mixed Vegetable Puree",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": null,
    "imageStatus": "missing",
    "sellPrice": 200,
    "energy": 25,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45172"
    ],
    "notes": null
  },
  {
    "id": "mixed-vegetable-soup",
    "slug": "mixed-vegetable-soup",
    "name": "Mixed Vegetable Soup",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": null,
    "imageStatus": "missing",
    "sellPrice": 430,
    "energy": 30,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45175"
    ],
    "notes": null
  },
  {
    "id": "moon-rabbit-snow-skin-mooncake",
    "slug": "moon-rabbit-snow-skin-mooncake",
    "name": "Moon Rabbit Snow Skin Mooncake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/moon-rabbit-snow-skin-mooncake.webp",
    "imageStatus": "verified",
    "sellPrice": 250,
    "energy": 20,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45389"
    ],
    "notes": null
  },
  {
    "id": "mooncake",
    "slug": "mooncake",
    "name": "Mooncake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/mooncake.webp",
    "imageStatus": "verified",
    "sellPrice": 820,
    "energy": 45,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45180"
    ],
    "notes": null
  },
  {
    "id": "morpho-luna",
    "slug": "morpho-luna",
    "name": "Morpho Luna",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/morpho-luna.webp",
    "imageStatus": "verified",
    "sellPrice": 90,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51137"
    ],
    "notes": null
  },
  {
    "id": "mummy-cat-drink",
    "slug": "mummy-cat-drink",
    "name": "Mummy Cat Drink",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/mummy-cat-drink.webp",
    "imageStatus": "verified",
    "sellPrice": 330,
    "energy": 26,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45423"
    ],
    "notes": null
  },
  {
    "id": "mustard-greens-celtuce-taco",
    "slug": "mustard-greens-celtuce-taco",
    "name": "Mustard Greens Celtuce Taco",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/mustard-greens-celtuce-taco.webp",
    "imageStatus": "verified",
    "sellPrice": 330,
    "energy": 35,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45448"
    ],
    "notes": null
  },
  {
    "id": "my-melody-crepe",
    "slug": "my-melody-crepe",
    "name": "My Melody Crepe",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/my-melody-crepe.webp",
    "imageStatus": "verified",
    "sellPrice": 670,
    "energy": 80,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45555"
    ],
    "notes": null
  },
  {
    "id": "new-year-fortune-fish",
    "slug": "new-year-fortune-fish",
    "name": "New Year Fortune Fish",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/new-year-fortune-fish.webp",
    "imageStatus": "verified",
    "sellPrice": 150,
    "energy": 20,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45248"
    ],
    "notes": null
  },
  {
    "id": "ocean-feast",
    "slug": "ocean-feast",
    "name": "Ocean Feast",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/ocean-feast.webp",
    "imageStatus": "verified",
    "sellPrice": 1700,
    "energy": 45,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45546"
    ],
    "notes": null
  },
  {
    "id": "ocean-iced-drink",
    "slug": "ocean-iced-drink",
    "name": "Ocean Iced Drink",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/ocean-iced-drink.webp",
    "imageStatus": "verified",
    "sellPrice": 190,
    "energy": 20,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45532"
    ],
    "notes": null
  },
  {
    "id": "ocellated-turkey",
    "slug": "ocellated-turkey",
    "name": "Ocellated Turkey",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/ocellated-turkey.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#61218"
    ],
    "notes": null
  },
  {
    "id": "olive-ridley-turtle",
    "slug": "olive-ridley-turtle",
    "name": "Olive Ridley Turtle",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/olive-ridley-turtle.webp",
    "imageStatus": "verified",
    "sellPrice": 155,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#10413"
    ],
    "notes": null
  },
  {
    "id": "orange-calla-lily-seed",
    "slug": "orange-calla-lily-seed",
    "name": "Orange Calla Lily Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/orange-calla-lily-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 70,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#700504",
      "variant-of:calla-lily-seeds"
    ],
    "notes": null,
    "flowerSpecies": "calla-lily-seeds",
    "flowerColor": "orange",
    "variantOf": "calla-lily-seeds"
  },
  {
    "id": "orange-camping-sparrow",
    "slug": "orange-camping-sparrow",
    "name": "Orange Camping Sparrow",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/orange-camping-sparrow.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#61128",
      "variant-of:camping-sparrow"
    ],
    "notes": null,
    "variantOf": "camping-sparrow"
  },
  {
    "id": "orange-cranesbill",
    "slug": "orange-cranesbill",
    "name": "Orange Cranesbill",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/orange-cranesbill.webp",
    "imageStatus": "verified",
    "sellPrice": 1240,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#732404",
      "variant-of:cranesbill"
    ],
    "notes": null,
    "flowerSpecies": "cranesbill",
    "flowerColor": "orange",
    "variantOf": "cranesbill"
  },
  {
    "id": "orange-cranesbill-seed",
    "slug": "orange-cranesbill-seed",
    "name": "Orange Cranesbill Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/orange-cranesbill-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 225,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#702404",
      "variant-of:cranesbill-seeds"
    ],
    "notes": null,
    "flowerSpecies": "cranesbill-seeds",
    "flowerColor": "orange",
    "variantOf": "cranesbill-seeds"
  },
  {
    "id": "orange-dandelion",
    "slug": "orange-dandelion",
    "name": "Orange Dandelion",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/orange-dandelion.webp",
    "imageStatus": "verified",
    "sellPrice": 190,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#732604",
      "variant-of:dandelion"
    ],
    "notes": null,
    "flowerSpecies": "dandelion",
    "flowerColor": "orange",
    "variantOf": "dandelion"
  },
  {
    "id": "orange-hyacinth",
    "slug": "orange-hyacinth",
    "name": "Orange Hyacinth",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/orange-hyacinth.webp",
    "imageStatus": "verified",
    "sellPrice": 1180,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#731504",
      "variant-of:hyacinth"
    ],
    "notes": null,
    "flowerSpecies": "hyacinth",
    "flowerColor": "orange",
    "variantOf": "hyacinth"
  },
  {
    "id": "orange-jello-fish",
    "slug": "orange-jello-fish",
    "name": "Orange Jello Fish",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/orange-jello-fish.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#10227",
      "variant-of:jello-fish"
    ],
    "notes": null,
    "variantOf": "jello-fish"
  },
  {
    "id": "orange-moth-orchid",
    "slug": "orange-moth-orchid",
    "name": "Orange Moth Orchid",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/orange-moth-orchid.webp",
    "imageStatus": "verified",
    "sellPrice": 1210,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#731604",
      "variant-of:moth-orchid"
    ],
    "notes": null,
    "flowerSpecies": "moth-orchid",
    "flowerColor": "orange",
    "variantOf": "moth-orchid"
  },
  {
    "id": "orange-rose-seed",
    "slug": "orange-rose-seed",
    "name": "Orange Rose Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/orange-rose-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 225,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#700904",
      "variant-of:rose-seeds"
    ],
    "notes": null,
    "flowerSpecies": "rose-seeds",
    "flowerColor": "orange",
    "variantOf": "rose-seeds"
  },
  {
    "id": "orange-tulip-seed",
    "slug": "orange-tulip-seed",
    "name": "Orange Tulip Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/orange-tulip-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 115,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#700704",
      "variant-of:tulip-seeds"
    ],
    "notes": null,
    "flowerSpecies": "tulip-seeds",
    "flowerColor": "orange",
    "variantOf": "tulip-seeds"
  },
  {
    "id": "oriental-magpie",
    "slug": "oriental-magpie",
    "name": "Oriental Magpie",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/oriental-magpie.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#61126"
    ],
    "notes": null
  },
  {
    "id": "original-cloud-candy",
    "slug": "original-cloud-candy",
    "name": "Original Cloud Candy",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/original-cloud-candy.webp",
    "imageStatus": "verified",
    "sellPrice": 300,
    "energy": 30,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45284"
    ],
    "notes": null
  },
  {
    "id": "original-frosted-pancake",
    "slug": "original-frosted-pancake",
    "name": "Original Frosted Pancake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/original-frosted-pancake.webp",
    "imageStatus": "verified",
    "sellPrice": 330,
    "energy": 25,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45432"
    ],
    "notes": null
  },
  {
    "id": "palmier-treatsure-butterfly",
    "slug": "palmier-treatsure-butterfly",
    "name": "Palmier Treatsure Butterfly",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/palmier-treatsure-butterfly.webp",
    "imageStatus": "verified",
    "sellPrice": 60,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51922"
    ],
    "notes": null
  },
  {
    "id": "panda-cupcake",
    "slug": "panda-cupcake",
    "name": "Panda Cupcake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/panda-cupcake.webp",
    "imageStatus": "verified",
    "sellPrice": 590,
    "energy": 35,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45317"
    ],
    "notes": null
  },
  {
    "id": "panda-paw-candy",
    "slug": "panda-paw-candy",
    "name": "Panda Paw Candy",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/panda-paw-candy.webp",
    "imageStatus": "verified",
    "sellPrice": 25,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#46131"
    ],
    "notes": null
  },
  {
    "id": "parsley",
    "slug": "parsley",
    "name": "Parsley",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/parsley.webp",
    "imageStatus": "verified",
    "sellPrice": 30,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#769006"
    ],
    "notes": null
  },
  {
    "id": "pasta",
    "slug": "pasta",
    "name": "Pasta",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": null,
    "imageStatus": "missing",
    "sellPrice": 590,
    "energy": 70,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45177"
    ],
    "notes": null
  },
  {
    "id": "pea",
    "slug": "pea",
    "name": "Pea",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/pea.webp",
    "imageStatus": "verified",
    "sellPrice": 75,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#769303"
    ],
    "notes": null
  },
  {
    "id": "pea-puree",
    "slug": "pea-puree",
    "name": "Pea Puree",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": null,
    "imageStatus": "missing",
    "sellPrice": 90,
    "energy": 40,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45174"
    ],
    "notes": null
  },
  {
    "id": "pea-soup",
    "slug": "pea-soup",
    "name": "Pea Soup",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": null,
    "imageStatus": "missing",
    "sellPrice": 390,
    "energy": 40,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45176"
    ],
    "notes": null
  },
  {
    "id": "peach-calla-lily-seed",
    "slug": "peach-calla-lily-seed",
    "name": "Peach Calla Lily Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/peach-calla-lily-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 90,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#700507",
      "variant-of:calla-lily-seeds"
    ],
    "notes": null,
    "flowerSpecies": "calla-lily-seeds",
    "flowerColor": "peach",
    "variantOf": "calla-lily-seeds"
  },
  {
    "id": "peach-cranesbill",
    "slug": "peach-cranesbill",
    "name": "Peach Cranesbill",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/peach-cranesbill.webp",
    "imageStatus": "verified",
    "sellPrice": 1650,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#732407",
      "variant-of:cranesbill"
    ],
    "notes": null,
    "flowerSpecies": "cranesbill",
    "flowerColor": "peach",
    "variantOf": "cranesbill"
  },
  {
    "id": "peach-cranesbill-seed",
    "slug": "peach-cranesbill-seed",
    "name": "Peach Cranesbill Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/peach-cranesbill-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 300,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#702407",
      "variant-of:cranesbill-seeds"
    ],
    "notes": null,
    "flowerSpecies": "cranesbill-seeds",
    "flowerColor": "peach",
    "variantOf": "cranesbill-seeds"
  },
  {
    "id": "peach-dandelion",
    "slug": "peach-dandelion",
    "name": "Peach Dandelion",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/peach-dandelion.webp",
    "imageStatus": "verified",
    "sellPrice": 250,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#732607",
      "variant-of:dandelion"
    ],
    "notes": null,
    "flowerSpecies": "dandelion",
    "flowerColor": "peach",
    "variantOf": "dandelion"
  },
  {
    "id": "peach-hyacinth",
    "slug": "peach-hyacinth",
    "name": "Peach Hyacinth",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/peach-hyacinth.webp",
    "imageStatus": "verified",
    "sellPrice": 1570,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#731507",
      "variant-of:hyacinth"
    ],
    "notes": null,
    "flowerSpecies": "hyacinth",
    "flowerColor": "peach",
    "variantOf": "hyacinth"
  },
  {
    "id": "peach-moth-orchid",
    "slug": "peach-moth-orchid",
    "name": "Peach Moth Orchid",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/peach-moth-orchid.webp",
    "imageStatus": "verified",
    "sellPrice": 1610,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#731607",
      "variant-of:moth-orchid"
    ],
    "notes": null,
    "flowerSpecies": "moth-orchid",
    "flowerColor": "peach",
    "variantOf": "moth-orchid"
  },
  {
    "id": "peach-rose-seed",
    "slug": "peach-rose-seed",
    "name": "Peach Rose Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/peach-rose-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 300,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#700907",
      "variant-of:rose-seeds"
    ],
    "notes": null,
    "flowerSpecies": "rose-seeds",
    "flowerColor": "peach",
    "variantOf": "rose-seeds"
  },
  {
    "id": "peach-tulip-seed",
    "slug": "peach-tulip-seed",
    "name": "Peach Tulip Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/peach-tulip-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 150,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#700707",
      "variant-of:tulip-seeds"
    ],
    "notes": null,
    "flowerSpecies": "tulip-seeds",
    "flowerColor": "peach",
    "variantOf": "tulip-seeds"
  },
  {
    "id": "permit",
    "slug": "permit",
    "name": "Permit",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/permit.webp",
    "imageStatus": "verified",
    "sellPrice": 850,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#10357"
    ],
    "notes": null
  },
  {
    "id": "persimmon",
    "slug": "persimmon",
    "name": "Persimmon",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/persimmon.webp",
    "imageStatus": "verified",
    "sellPrice": 30,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#769002"
    ],
    "notes": null
  },
  {
    "id": "persimmon-ruyi-cake",
    "slug": "persimmon-ruyi-cake",
    "name": "Persimmon Ruyi Cake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/persimmon-ruyi-cake.webp",
    "imageStatus": "verified",
    "sellPrice": 190,
    "energy": 15,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45249"
    ],
    "notes": null
  },
  {
    "id": "pied-falconet",
    "slug": "pied-falconet",
    "name": "Pied Falconet",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/pied-falconet.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#61804"
    ],
    "notes": null
  },
  {
    "id": "pied-kingfisher",
    "slug": "pied-kingfisher",
    "name": "Pied Kingfisher",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/pied-kingfisher.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#61135"
    ],
    "notes": null
  },
  {
    "id": "pineapple-cloud-candy",
    "slug": "pineapple-cloud-candy",
    "name": "Pineapple Cloud Candy",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/pineapple-cloud-candy.webp",
    "imageStatus": "verified",
    "sellPrice": 340,
    "energy": 30,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45289"
    ],
    "notes": null
  },
  {
    "id": "pineapple-ice-cream",
    "slug": "pineapple-ice-cream",
    "name": "Pineapple Ice Cream",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/pineapple-ice-cream.webp",
    "imageStatus": "verified",
    "sellPrice": 770,
    "energy": 70,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45135"
    ],
    "notes": null
  },
  {
    "id": "pineapple-jam-meatball",
    "slug": "pineapple-jam-meatball",
    "name": "Pineapple Jam Meatball",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/pineapple-jam-meatball.webp",
    "imageStatus": "verified",
    "sellPrice": 460,
    "energy": 45,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45418"
    ],
    "notes": null
  },
  {
    "id": "pineapple-juice",
    "slug": "pineapple-juice",
    "name": "Pineapple Juice",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/pineapple-juice.webp",
    "imageStatus": "verified",
    "sellPrice": 290,
    "energy": 38,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45143"
    ],
    "notes": null
  },
  {
    "id": "pineapple-princess-cake",
    "slug": "pineapple-princess-cake",
    "name": "Pineapple Princess Cake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/pineapple-princess-cake.webp",
    "imageStatus": "verified",
    "sellPrice": 350,
    "energy": 20,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45408"
    ],
    "notes": null
  },
  {
    "id": "pineapple-pudding",
    "slug": "pineapple-pudding",
    "name": "Pineapple Pudding",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/pineapple-pudding.webp",
    "imageStatus": "verified",
    "sellPrice": 560,
    "energy": 50,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45215"
    ],
    "notes": null
  },
  {
    "id": "pink-atlantic-salmon",
    "slug": "pink-atlantic-salmon",
    "name": "Pink Atlantic Salmon",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/pink-atlantic-salmon.webp",
    "imageStatus": "verified",
    "sellPrice": 155,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#10345",
      "variant-of:atlantic-salmon"
    ],
    "notes": null,
    "variantOf": "atlantic-salmon"
  },
  {
    "id": "pink-calla-lily-seed",
    "slug": "pink-calla-lily-seed",
    "name": "Pink Calla Lily Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/pink-calla-lily-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 70,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#700505",
      "variant-of:calla-lily-seeds"
    ],
    "notes": null,
    "flowerSpecies": "calla-lily-seeds",
    "flowerColor": "pink",
    "variantOf": "calla-lily-seeds"
  },
  {
    "id": "pink-cranesbill",
    "slug": "pink-cranesbill",
    "name": "Pink Cranesbill",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/pink-cranesbill.webp",
    "imageStatus": "verified",
    "sellPrice": 1240,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#732405",
      "variant-of:cranesbill"
    ],
    "notes": null,
    "flowerSpecies": "cranesbill",
    "flowerColor": "pink",
    "variantOf": "cranesbill"
  },
  {
    "id": "pink-cranesbill-seed",
    "slug": "pink-cranesbill-seed",
    "name": "Pink Cranesbill Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/pink-cranesbill-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 225,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#702405",
      "variant-of:cranesbill-seeds"
    ],
    "notes": null,
    "flowerSpecies": "cranesbill-seeds",
    "flowerColor": "pink",
    "variantOf": "cranesbill-seeds"
  },
  {
    "id": "pink-dandelion",
    "slug": "pink-dandelion",
    "name": "Pink Dandelion",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/pink-dandelion.webp",
    "imageStatus": "verified",
    "sellPrice": 190,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#732605",
      "variant-of:dandelion"
    ],
    "notes": null,
    "flowerSpecies": "dandelion",
    "flowerColor": "pink",
    "variantOf": "dandelion"
  },
  {
    "id": "pink-hanging-dust-bug",
    "slug": "pink-hanging-dust-bug",
    "name": "Pink Hanging Dust Bug",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/pink-hanging-dust-bug.webp",
    "imageStatus": "verified",
    "sellPrice": 140,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51906",
      "variant-of:dust-bug"
    ],
    "notes": null,
    "variantOf": "dust-bug"
  },
  {
    "id": "pink-hat-stock-dove",
    "slug": "pink-hat-stock-dove",
    "name": "Pink Hat Stock Dove",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/pink-hat-stock-dove.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#61222",
      "variant-of:stock-dove"
    ],
    "notes": null,
    "variantOf": "stock-dove"
  },
  {
    "id": "pink-hyacinth",
    "slug": "pink-hyacinth",
    "name": "Pink Hyacinth",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/pink-hyacinth.webp",
    "imageStatus": "verified",
    "sellPrice": 1180,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#731505",
      "variant-of:hyacinth"
    ],
    "notes": null,
    "flowerSpecies": "hyacinth",
    "flowerColor": "pink",
    "variantOf": "hyacinth"
  },
  {
    "id": "pink-king-crab",
    "slug": "pink-king-crab",
    "name": "Pink King Crab",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/pink-king-crab.webp",
    "imageStatus": "verified",
    "sellPrice": 215,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#10347",
      "variant-of:king-crab"
    ],
    "notes": null,
    "variantOf": "king-crab"
  },
  {
    "id": "pink-light-firefly",
    "slug": "pink-light-firefly",
    "name": "Pink Light Firefly",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/pink-light-firefly.webp",
    "imageStatus": "verified",
    "sellPrice": 110,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51225",
      "variant-of:light-firefly"
    ],
    "notes": null,
    "variantOf": "light-firefly"
  },
  {
    "id": "pink-memory",
    "slug": "pink-memory",
    "name": "Pink Memory",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/pink-memory.webp",
    "imageStatus": "verified",
    "sellPrice": 730,
    "energy": 82,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45152"
    ],
    "notes": null
  },
  {
    "id": "pink-moth-orchid",
    "slug": "pink-moth-orchid",
    "name": "Pink Moth Orchid",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/pink-moth-orchid.webp",
    "imageStatus": "verified",
    "sellPrice": 1210,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#731605",
      "variant-of:moth-orchid"
    ],
    "notes": null,
    "flowerSpecies": "moth-orchid",
    "flowerColor": "pink",
    "variantOf": "moth-orchid"
  },
  {
    "id": "pink-necked-firefly",
    "slug": "pink-necked-firefly",
    "name": "Pink-Necked Firefly",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/pink-necked-firefly.webp",
    "imageStatus": "verified",
    "sellPrice": 110,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51218"
    ],
    "notes": null
  },
  {
    "id": "pink-rose-seed",
    "slug": "pink-rose-seed",
    "name": "Pink Rose Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/pink-rose-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 225,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#700905",
      "variant-of:rose-seeds"
    ],
    "notes": null,
    "flowerSpecies": "rose-seeds",
    "flowerColor": "pink",
    "variantOf": "rose-seeds"
  },
  {
    "id": "pink-seahorse",
    "slug": "pink-seahorse",
    "name": "Pink Seahorse",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/pink-seahorse.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#10346",
      "variant-of:seahorse"
    ],
    "notes": null,
    "variantOf": "seahorse"
  },
  {
    "id": "pink-shortfin-mako-shark",
    "slug": "pink-shortfin-mako-shark",
    "name": "Pink Shortfin Mako Shark",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/pink-shortfin-mako-shark.webp",
    "imageStatus": "verified",
    "sellPrice": 215,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#10348",
      "variant-of:shortfin-mako-shark"
    ],
    "notes": null,
    "variantOf": "shortfin-mako-shark"
  },
  {
    "id": "pink-swordfish",
    "slug": "pink-swordfish",
    "name": "Pink Swordfish",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/pink-swordfish.webp",
    "imageStatus": "verified",
    "sellPrice": 215,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#10344",
      "variant-of:swordfish"
    ],
    "notes": null,
    "variantOf": "swordfish"
  },
  {
    "id": "pink-tulip-seed",
    "slug": "pink-tulip-seed",
    "name": "Pink Tulip Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/pink-tulip-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 115,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#700705",
      "variant-of:tulip-seeds"
    ],
    "notes": null,
    "flowerSpecies": "tulip-seeds",
    "flowerColor": "pink",
    "variantOf": "tulip-seeds"
  },
  {
    "id": "pomarine-skua",
    "slug": "pomarine-skua",
    "name": "Pomarine Skua",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/pomarine-skua.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#61508"
    ],
    "notes": null
  },
  {
    "id": "potato",
    "slug": "potato",
    "name": "Potato",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/potato.webp",
    "imageStatus": "verified",
    "sellPrice": 90,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#769102"
    ],
    "notes": null
  },
  {
    "id": "psionic-indian-fritillary",
    "slug": "psionic-indian-fritillary",
    "name": "Psionic Indian Fritillary",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/psionic-indian-fritillary.webp",
    "imageStatus": "verified",
    "sellPrice": 60,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51930"
    ],
    "notes": null
  },
  {
    "id": "psionic-luna-moth",
    "slug": "psionic-luna-moth",
    "name": "Psionic Luna Moth",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/psionic-luna-moth.webp",
    "imageStatus": "verified",
    "sellPrice": 60,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51929"
    ],
    "notes": null
  },
  {
    "id": "psionic-queen-alexandra-s-birdwing",
    "slug": "psionic-queen-alexandra-s-birdwing",
    "name": "Psionic Queen Alexandra's Birdwing",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/psionic-queen-alexandra-s-birdwing.webp",
    "imageStatus": "verified",
    "sellPrice": 90,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51928",
      "variant-of:queen-alexandra-s-birdwing"
    ],
    "notes": null,
    "variantOf": "queen-alexandra-s-birdwing"
  },
  {
    "id": "psionic-rimmed-window-firefly",
    "slug": "psionic-rimmed-window-firefly",
    "name": "Psionic Rimmed Window Firefly",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/psionic-rimmed-window-firefly.webp",
    "imageStatus": "verified",
    "sellPrice": 110,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51927",
      "variant-of:rimmed-window-firefly"
    ],
    "notes": null,
    "variantOf": "rimmed-window-firefly"
  },
  {
    "id": "pudding",
    "slug": "pudding",
    "name": "Pudding",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/pudding.webp",
    "imageStatus": "verified",
    "sellPrice": 560,
    "energy": 50,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45207"
    ],
    "notes": null
  },
  {
    "id": "puff-treatsure-ladybug",
    "slug": "puff-treatsure-ladybug",
    "name": "Puff Treatsure Ladybug",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/puff-treatsure-ladybug.webp",
    "imageStatus": "verified",
    "sellPrice": 110,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51924"
    ],
    "notes": null
  },
  {
    "id": "pumpkin",
    "slug": "pumpkin",
    "name": "Pumpkin",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/pumpkin.webp",
    "imageStatus": "verified",
    "sellPrice": 30,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#769001"
    ],
    "notes": null
  },
  {
    "id": "pumpkin-lollipop",
    "slug": "pumpkin-lollipop",
    "name": "Pumpkin Lollipop",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/pumpkin-lollipop.webp",
    "imageStatus": "verified",
    "sellPrice": 50,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#46115"
    ],
    "notes": null
  },
  {
    "id": "purple-calla-lily-seed",
    "slug": "purple-calla-lily-seed",
    "name": "Purple Calla Lily Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/purple-calla-lily-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 115,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#700508",
      "variant-of:calla-lily-seeds"
    ],
    "notes": null,
    "flowerSpecies": "calla-lily-seeds",
    "flowerColor": "purple",
    "variantOf": "calla-lily-seeds"
  },
  {
    "id": "purple-dandelion",
    "slug": "purple-dandelion",
    "name": "Purple Dandelion",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/purple-dandelion.webp",
    "imageStatus": "verified",
    "sellPrice": 315,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#732608",
      "variant-of:dandelion"
    ],
    "notes": null,
    "flowerSpecies": "dandelion",
    "flowerColor": "purple",
    "variantOf": "dandelion"
  },
  {
    "id": "purple-diamond-mussel",
    "slug": "purple-diamond-mussel",
    "name": "Purple Diamond Mussel",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/purple-diamond-mussel.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#10233"
    ],
    "notes": null
  },
  {
    "id": "purple-dung-beetle",
    "slug": "purple-dung-beetle",
    "name": "Purple Dung Beetle",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/purple-dung-beetle.webp",
    "imageStatus": "verified",
    "sellPrice": 110,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51230",
      "variant-of:dung-beetle"
    ],
    "notes": null,
    "variantOf": "dung-beetle"
  },
  {
    "id": "purple-floating-dust-bug",
    "slug": "purple-floating-dust-bug",
    "name": "Purple Floating Dust Bug",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/purple-floating-dust-bug.webp",
    "imageStatus": "verified",
    "sellPrice": 90,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51903",
      "variant-of:dust-bug"
    ],
    "notes": null,
    "variantOf": "dust-bug"
  },
  {
    "id": "purple-hyacinth",
    "slug": "purple-hyacinth",
    "name": "Purple Hyacinth",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/purple-hyacinth.webp",
    "imageStatus": "verified",
    "sellPrice": 1965,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#731508",
      "variant-of:hyacinth"
    ],
    "notes": null,
    "flowerSpecies": "hyacinth",
    "flowerColor": "purple",
    "variantOf": "hyacinth"
  },
  {
    "id": "purple-jello-fish",
    "slug": "purple-jello-fish",
    "name": "Purple Jello Fish",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/purple-jello-fish.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#10228",
      "variant-of:jello-fish"
    ],
    "notes": null,
    "variantOf": "jello-fish"
  },
  {
    "id": "purple-light-firefly",
    "slug": "purple-light-firefly",
    "name": "Purple Light Firefly",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/purple-light-firefly.webp",
    "imageStatus": "verified",
    "sellPrice": 110,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51224",
      "variant-of:light-firefly"
    ],
    "notes": null,
    "variantOf": "light-firefly"
  },
  {
    "id": "purple-light-jellyfish",
    "slug": "purple-light-jellyfish",
    "name": "Purple Light Jellyfish",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/purple-light-jellyfish.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#10374"
    ],
    "notes": null
  },
  {
    "id": "purple-light-sea-star",
    "slug": "purple-light-sea-star",
    "name": "Purple Light Sea Star",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/purple-light-sea-star.webp",
    "imageStatus": "verified",
    "sellPrice": 230,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#10378",
      "variant-of:light-sea-star"
    ],
    "notes": null,
    "variantOf": "light-sea-star"
  },
  {
    "id": "purple-moth-orchid",
    "slug": "purple-moth-orchid",
    "name": "Purple Moth Orchid",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/purple-moth-orchid.webp",
    "imageStatus": "verified",
    "sellPrice": 2015,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#731608",
      "variant-of:moth-orchid"
    ],
    "notes": null,
    "flowerSpecies": "moth-orchid",
    "flowerColor": "purple",
    "variantOf": "moth-orchid"
  },
  {
    "id": "purple-rose-seed",
    "slug": "purple-rose-seed",
    "name": "Purple Rose Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/purple-rose-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 375,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#700908",
      "variant-of:rose-seeds"
    ],
    "notes": null,
    "flowerSpecies": "rose-seeds",
    "flowerColor": "purple",
    "variantOf": "rose-seeds"
  },
  {
    "id": "purple-starry-stock-dove",
    "slug": "purple-starry-stock-dove",
    "name": "Purple Starry Stock Dove",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/purple-starry-stock-dove.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#61214",
      "variant-of:stock-dove"
    ],
    "notes": null,
    "variantOf": "stock-dove"
  },
  {
    "id": "purple-starry-swan",
    "slug": "purple-starry-swan",
    "name": "Purple Starry Swan",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/purple-starry-swan.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#61708",
      "variant-of:starry-swan"
    ],
    "notes": null,
    "variantOf": "starry-swan"
  },
  {
    "id": "purple-tulip-seed",
    "slug": "purple-tulip-seed",
    "name": "Purple Tulip Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/purple-tulip-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 190,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#700708",
      "variant-of:tulip-seeds"
    ],
    "notes": null,
    "flowerSpecies": "tulip-seeds",
    "flowerColor": "purple",
    "variantOf": "tulip-seeds"
  },
  {
    "id": "qiaoguo",
    "slug": "qiaoguo",
    "name": "Qiaoguo",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/qiaoguo.webp",
    "imageStatus": "verified",
    "sellPrice": 830,
    "energy": 100,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45552"
    ],
    "notes": null
  },
  {
    "id": "rajah-brooke-s-birdwing",
    "slug": "rajah-brooke-s-birdwing",
    "name": "Rajah Brooke's Birdwing",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/rajah-brooke-s-birdwing.webp",
    "imageStatus": "verified",
    "sellPrice": 90,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51117"
    ],
    "notes": null
  },
  {
    "id": "raspberry-cloud-candy",
    "slug": "raspberry-cloud-candy",
    "name": "Raspberry Cloud Candy",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/raspberry-cloud-candy.webp",
    "imageStatus": "verified",
    "sellPrice": 340,
    "energy": 30,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45292"
    ],
    "notes": null
  },
  {
    "id": "raspberry-cupcake",
    "slug": "raspberry-cupcake",
    "name": "Raspberry Cupcake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/raspberry-cupcake.webp",
    "imageStatus": "verified",
    "sellPrice": 790,
    "energy": 60,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45146"
    ],
    "notes": null
  },
  {
    "id": "raspberry-frosted-pancake",
    "slug": "raspberry-frosted-pancake",
    "name": "Raspberry Frosted Pancake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/raspberry-frosted-pancake.webp",
    "imageStatus": "verified",
    "sellPrice": 350,
    "energy": 25,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45434"
    ],
    "notes": null
  },
  {
    "id": "raspberry-hermit-crab",
    "slug": "raspberry-hermit-crab",
    "name": "Raspberry Hermit Crab",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/raspberry-hermit-crab.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#10371",
      "variant-of:hermit-crab"
    ],
    "notes": null,
    "variantOf": "hermit-crab"
  },
  {
    "id": "raspberry-ice-cream",
    "slug": "raspberry-ice-cream",
    "name": "Raspberry Ice Cream",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/raspberry-ice-cream.webp",
    "imageStatus": "verified",
    "sellPrice": 770,
    "energy": 65,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45131"
    ],
    "notes": null
  },
  {
    "id": "raspberry-jam-meatball",
    "slug": "raspberry-jam-meatball",
    "name": "Raspberry Jam Meatball",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/raspberry-jam-meatball.webp",
    "imageStatus": "verified",
    "sellPrice": 430,
    "energy": 30,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45415"
    ],
    "notes": null
  },
  {
    "id": "raspberry-juice",
    "slug": "raspberry-juice",
    "name": "Raspberry Juice",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/raspberry-juice.webp",
    "imageStatus": "verified",
    "sellPrice": 290,
    "energy": 34,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45139"
    ],
    "notes": null
  },
  {
    "id": "raspberry-pearl-cake",
    "slug": "raspberry-pearl-cake",
    "name": "Raspberry Pearl Cake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/raspberry-pearl-cake.webp",
    "imageStatus": "verified",
    "sellPrice": 590,
    "energy": 45,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45539"
    ],
    "notes": null
  },
  {
    "id": "raspberry-princess-cake",
    "slug": "raspberry-princess-cake",
    "name": "Raspberry Princess Cake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/raspberry-princess-cake.webp",
    "imageStatus": "verified",
    "sellPrice": 350,
    "energy": 20,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45405"
    ],
    "notes": null
  },
  {
    "id": "raspberry-pudding",
    "slug": "raspberry-pudding",
    "name": "Raspberry Pudding",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/raspberry-pudding.webp",
    "imageStatus": "verified",
    "sellPrice": 560,
    "energy": 50,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45208"
    ],
    "notes": null
  },
  {
    "id": "raspberry-toast",
    "slug": "raspberry-toast",
    "name": "Raspberry Toast",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/raspberry-toast.webp",
    "imageStatus": "verified",
    "sellPrice": 560,
    "energy": 50,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45205"
    ],
    "notes": null
  },
  {
    "id": "red-clockwork-ladybug",
    "slug": "red-clockwork-ladybug",
    "name": "Red Clockwork Ladybug",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/red-clockwork-ladybug.webp",
    "imageStatus": "verified",
    "sellPrice": 110,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51409",
      "variant-of:clockwork-ladybug"
    ],
    "notes": null,
    "variantOf": "clockwork-ladybug"
  },
  {
    "id": "red-cranesbill",
    "slug": "red-cranesbill",
    "name": "Red Cranesbill",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/red-cranesbill.webp",
    "imageStatus": "verified",
    "sellPrice": 825,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#732401",
      "variant-of:cranesbill"
    ],
    "notes": null,
    "flowerSpecies": "cranesbill",
    "flowerColor": "red",
    "variantOf": "cranesbill"
  },
  {
    "id": "red-cranesbill-seed",
    "slug": "red-cranesbill-seed",
    "name": "Red Cranesbill Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/red-cranesbill-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 150,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#702401",
      "variant-of:cranesbill-seeds"
    ],
    "notes": null,
    "flowerSpecies": "cranesbill-seeds",
    "flowerColor": "red",
    "variantOf": "cranesbill-seeds"
  },
  {
    "id": "red-crowned-crane",
    "slug": "red-crowned-crane",
    "name": "Red-Crowned Crane",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/red-crowned-crane.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#61304"
    ],
    "notes": null
  },
  {
    "id": "red-dandelion",
    "slug": "red-dandelion",
    "name": "Red Dandelion",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/red-dandelion.webp",
    "imageStatus": "verified",
    "sellPrice": 125,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#732601",
      "variant-of:dandelion"
    ],
    "notes": null,
    "flowerSpecies": "dandelion",
    "flowerColor": "red",
    "variantOf": "dandelion"
  },
  {
    "id": "red-dung-beetle",
    "slug": "red-dung-beetle",
    "name": "Red Dung Beetle",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/red-dung-beetle.webp",
    "imageStatus": "verified",
    "sellPrice": 110,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51227",
      "variant-of:dung-beetle"
    ],
    "notes": null,
    "variantOf": "dung-beetle"
  },
  {
    "id": "red-hyacinth",
    "slug": "red-hyacinth",
    "name": "Red Hyacinth",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/red-hyacinth.webp",
    "imageStatus": "verified",
    "sellPrice": 785,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#731501",
      "variant-of:hyacinth"
    ],
    "notes": null,
    "flowerSpecies": "hyacinth",
    "flowerColor": "red",
    "variantOf": "hyacinth"
  },
  {
    "id": "red-jello-fish",
    "slug": "red-jello-fish",
    "name": "Red Jello Fish",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/red-jello-fish.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#10224",
      "variant-of:jello-fish"
    ],
    "notes": null,
    "variantOf": "jello-fish"
  },
  {
    "id": "red-koi",
    "slug": "red-koi",
    "name": "Red Koi",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/red-koi.webp",
    "imageStatus": "verified",
    "sellPrice": 155,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#10108",
      "variant-of:koi"
    ],
    "notes": null,
    "variantOf": "koi"
  },
  {
    "id": "red-moth-orchid",
    "slug": "red-moth-orchid",
    "name": "Red Moth Orchid",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/red-moth-orchid.webp",
    "imageStatus": "verified",
    "sellPrice": 805,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#731601",
      "variant-of:moth-orchid"
    ],
    "notes": null,
    "flowerSpecies": "moth-orchid",
    "flowerColor": "red",
    "variantOf": "moth-orchid"
  },
  {
    "id": "red-rose-seed",
    "slug": "red-rose-seed",
    "name": "Red Rose Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/red-rose-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 150,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#700901",
      "variant-of:rose-seeds"
    ],
    "notes": null,
    "flowerSpecies": "rose-seeds",
    "flowerColor": "red",
    "variantOf": "rose-seeds"
  },
  {
    "id": "red-tulip-seed",
    "slug": "red-tulip-seed",
    "name": "Red Tulip Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/red-tulip-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 75,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#700701",
      "variant-of:tulip-seeds"
    ],
    "notes": null,
    "flowerSpecies": "tulip-seeds",
    "flowerColor": "red",
    "variantOf": "tulip-seeds"
  },
  {
    "id": "rimmed-window-firefly",
    "slug": "rimmed-window-firefly",
    "name": "Rimmed Window Firefly",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/rimmed-window-firefly.webp",
    "imageStatus": "verified",
    "sellPrice": 110,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51207"
    ],
    "notes": null
  },
  {
    "id": "rock-bug",
    "slug": "rock-bug",
    "name": "Rock Bug",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/rock-bug.webp",
    "imageStatus": "verified",
    "sellPrice": 110,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51933"
    ],
    "notes": null
  },
  {
    "id": "roll-cake-treatsure-snail",
    "slug": "roll-cake-treatsure-snail",
    "name": "Roll Cake Treatsure Snail",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/roll-cake-treatsure-snail.webp",
    "imageStatus": "verified",
    "sellPrice": 35,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51926"
    ],
    "notes": null
  },
  {
    "id": "roseate-spoonbill",
    "slug": "roseate-spoonbill",
    "name": "Roseate Spoonbill",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/roseate-spoonbill.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#61509"
    ],
    "notes": null
  },
  {
    "id": "royal-palm-turkey",
    "slug": "royal-palm-turkey",
    "name": "Royal Palm Turkey",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/royal-palm-turkey.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#61217"
    ],
    "notes": null
  },
  {
    "id": "salsa",
    "slug": "salsa",
    "name": "Salsa",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/salsa.webp",
    "imageStatus": "verified",
    "sellPrice": 25,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#46144"
    ],
    "notes": null
  },
  {
    "id": "salsa-rippled-potato-chips",
    "slug": "salsa-rippled-potato-chips",
    "name": "Salsa Rippled Potato Chips",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/salsa-rippled-potato-chips.webp",
    "imageStatus": "verified",
    "sellPrice": 280,
    "energy": 26,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45440"
    ],
    "notes": null
  },
  {
    "id": "sauna-hat-sea-turtle",
    "slug": "sauna-hat-sea-turtle",
    "name": "Sauna Hat Sea Turtle",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/white-sauna-hat-sea-turtle.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "variant-group:sauna-hat-sea-turtle"
    ],
    "notes": null,
    "isVariantGroup": true
  },
  {
    "id": "savory-duo-bucket",
    "slug": "savory-duo-bucket",
    "name": "Savory Duo Bucket",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/savory-duo-bucket.webp",
    "imageStatus": "verified",
    "sellPrice": 1230,
    "energy": 95,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45441"
    ],
    "notes": null
  },
  {
    "id": "scallop",
    "slug": "scallop",
    "name": "Scallop",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/scallop.webp",
    "imageStatus": "verified",
    "sellPrice": 100,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#10407"
    ],
    "notes": null
  },
  {
    "id": "sea-grape",
    "slug": "sea-grape",
    "name": "Sea Grape",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/sea-grape.webp",
    "imageStatus": "verified",
    "sellPrice": 10,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#40602"
    ],
    "notes": null
  },
  {
    "id": "sea-grape-shiitake-chawanmushi",
    "slug": "sea-grape-shiitake-chawanmushi",
    "name": "Sea Grape & Shiitake Chawanmushi",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/sea-grape-shiitake-chawanmushi.webp",
    "imageStatus": "verified",
    "sellPrice": 230,
    "energy": 35,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45547"
    ],
    "notes": null
  },
  {
    "id": "sea-otter-cupcake",
    "slug": "sea-otter-cupcake",
    "name": "Sea Otter Cupcake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/sea-otter-cupcake.webp",
    "imageStatus": "verified",
    "sellPrice": 590,
    "energy": 35,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45312"
    ],
    "notes": null
  },
  {
    "id": "sea-otter-paw-candy",
    "slug": "sea-otter-paw-candy",
    "name": "Sea Otter Paw Candy",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/sea-otter-paw-candy.webp",
    "imageStatus": "verified",
    "sellPrice": 25,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#46126"
    ],
    "notes": null
  },
  {
    "id": "sea-slug",
    "slug": "sea-slug",
    "name": "Sea Slug",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/sea-slug.webp",
    "imageStatus": "verified",
    "sellPrice": 150,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#10409"
    ],
    "notes": null
  },
  {
    "id": "seashell-pearl-cake",
    "slug": "seashell-pearl-cake",
    "name": "Seashell Pearl Cake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/seashell-pearl-cake.webp",
    "imageStatus": "verified",
    "sellPrice": 570,
    "energy": 45,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45534"
    ],
    "notes": null
  },
  {
    "id": "selene-cranesbill",
    "slug": "selene-cranesbill",
    "name": "Selene Cranesbill",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/selene-cranesbill.webp",
    "imageStatus": "verified",
    "sellPrice": 3300,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#732411",
      "variant-of:cranesbill"
    ],
    "notes": null,
    "flowerSpecies": "cranesbill",
    "flowerColor": "selene",
    "variantOf": "cranesbill"
  },
  {
    "id": "selene-cranesbill-seed",
    "slug": "selene-cranesbill-seed",
    "name": "Selene Cranesbill Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/selene-cranesbill-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 600,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#702411",
      "variant-of:cranesbill-seeds"
    ],
    "notes": null,
    "flowerSpecies": "cranesbill-seeds",
    "flowerColor": "selene",
    "variantOf": "cranesbill-seeds"
  },
  {
    "id": "selene-dandelion",
    "slug": "selene-dandelion",
    "name": "Selene Dandelion",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/selene-dandelion.webp",
    "imageStatus": "verified",
    "sellPrice": 500,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#732610",
      "variant-of:dandelion"
    ],
    "notes": null,
    "flowerSpecies": "dandelion",
    "flowerColor": "selene",
    "variantOf": "dandelion"
  },
  {
    "id": "selene-moth-orchid",
    "slug": "selene-moth-orchid",
    "name": "Selene Moth Orchid",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/selene-moth-orchid.webp",
    "imageStatus": "verified",
    "sellPrice": 3220,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#731610",
      "variant-of:moth-orchid"
    ],
    "notes": null,
    "flowerSpecies": "moth-orchid",
    "flowerColor": "selene",
    "variantOf": "moth-orchid"
  },
  {
    "id": "selene-rose-seed",
    "slug": "selene-rose-seed",
    "name": "Selene Rose Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/selene-rose-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 600,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#700911",
      "variant-of:rose-seeds"
    ],
    "notes": null,
    "flowerSpecies": "rose-seeds",
    "flowerColor": "selene",
    "variantOf": "rose-seeds"
  },
  {
    "id": "simmered-claypot-soup",
    "slug": "simmered-claypot-soup",
    "name": "Simmered Claypot Soup",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/simmered-claypot-soup.webp",
    "imageStatus": "verified",
    "sellPrice": 370,
    "energy": 35,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45250"
    ],
    "notes": null
  },
  {
    "id": "small-xmas-cake",
    "slug": "small-xmas-cake",
    "name": "Small Xmas Cake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/small-xmas-cake.webp",
    "imageStatus": "verified",
    "sellPrice": 910,
    "energy": 45,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45229"
    ],
    "notes": null
  },
  {
    "id": "snow-bug",
    "slug": "snow-bug",
    "name": "Snow Bug",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/snow-bug.webp",
    "imageStatus": "verified",
    "sellPrice": 110,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51932"
    ],
    "notes": null
  },
  {
    "id": "snowy-window-firefly",
    "slug": "snowy-window-firefly",
    "name": "Snowy Window Firefly",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/snowy-window-firefly.webp",
    "imageStatus": "verified",
    "sellPrice": 165,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51219"
    ],
    "notes": null
  },
  {
    "id": "spectral-octopus",
    "slug": "spectral-octopus",
    "name": "Spectral Octopus",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/spectral-octopus.webp",
    "imageStatus": "verified",
    "sellPrice": 155,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#10359"
    ],
    "notes": null
  },
  {
    "id": "spirulina-powder",
    "slug": "spirulina-powder",
    "name": "Spirulina Powder",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/spirulina-powder.webp",
    "imageStatus": "verified",
    "sellPrice": 25,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#46151"
    ],
    "notes": null
  },
  {
    "id": "springday-picnic-set",
    "slug": "springday-picnic-set",
    "name": "Springday Picnic Set",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/springday-picnic-set.webp",
    "imageStatus": "verified",
    "sellPrice": 1140,
    "energy": 30,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45273"
    ],
    "notes": null
  },
  {
    "id": "springday-raspberry-black-tea",
    "slug": "springday-raspberry-black-tea",
    "name": "Springday Raspberry Black Tea",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/springday-raspberry-black-tea.webp",
    "imageStatus": "verified",
    "sellPrice": 480,
    "energy": 45,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45453"
    ],
    "notes": null
  },
  {
    "id": "starfruit",
    "slug": "starfruit",
    "name": "Starfruit",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/starfruit.webp",
    "imageStatus": "verified",
    "sellPrice": 30,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#769012"
    ],
    "notes": null
  },
  {
    "id": "starfruit-jam",
    "slug": "starfruit-jam",
    "name": "Starfruit Jam",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/starfruit-jam.webp",
    "imageStatus": "verified",
    "sellPrice": 200,
    "energy": 20,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45531"
    ],
    "notes": null
  },
  {
    "id": "starfruit-pearl-cake",
    "slug": "starfruit-pearl-cake",
    "name": "Starfruit Pearl Cake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/starfruit-pearl-cake.webp",
    "imageStatus": "verified",
    "sellPrice": 570,
    "energy": 45,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45535"
    ],
    "notes": null
  },
  {
    "id": "starry-apple-donut",
    "slug": "starry-apple-donut",
    "name": "Starry Apple Donut",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/starry-apple-donut.webp",
    "imageStatus": "verified",
    "sellPrice": 310,
    "energy": 20,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45338"
    ],
    "notes": null
  },
  {
    "id": "starry-apple-mint-milk",
    "slug": "starry-apple-mint-milk",
    "name": "Starry Apple Mint Milk",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/starry-apple-mint-milk.webp",
    "imageStatus": "verified",
    "sellPrice": 260,
    "energy": 20,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45328"
    ],
    "notes": null
  },
  {
    "id": "starry-blueberry-donut",
    "slug": "starry-blueberry-donut",
    "name": "Starry Blueberry Donut",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/starry-blueberry-donut.webp",
    "imageStatus": "verified",
    "sellPrice": 270,
    "energy": 20,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45340"
    ],
    "notes": null
  },
  {
    "id": "starry-blueberry-mint-milk",
    "slug": "starry-blueberry-mint-milk",
    "name": "Starry Blueberry Mint Milk",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/starry-blueberry-mint-milk.webp",
    "imageStatus": "verified",
    "sellPrice": 240,
    "energy": 20,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45330"
    ],
    "notes": null
  },
  {
    "id": "starry-fruit-donut",
    "slug": "starry-fruit-donut",
    "name": "Starry Fruit Donut",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/starry-fruit-donut.webp",
    "imageStatus": "verified",
    "sellPrice": 260,
    "energy": 20,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45337"
    ],
    "notes": null
  },
  {
    "id": "starry-fruit-mint-milk",
    "slug": "starry-fruit-mint-milk",
    "name": "Starry Fruit Mint Milk",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/starry-fruit-mint-milk.webp",
    "imageStatus": "verified",
    "sellPrice": 240,
    "energy": 20,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45327"
    ],
    "notes": null
  },
  {
    "id": "starry-grape-donut",
    "slug": "starry-grape-donut",
    "name": "Starry Grape Donut",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/starry-grape-donut.webp",
    "imageStatus": "verified",
    "sellPrice": 1160,
    "energy": 80,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45343"
    ],
    "notes": null
  },
  {
    "id": "starry-grape-mint-milk",
    "slug": "starry-grape-mint-milk",
    "name": "Starry Grape Mint Milk",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/starry-grape-mint-milk.webp",
    "imageStatus": "verified",
    "sellPrice": 690,
    "energy": 35,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45333"
    ],
    "notes": null
  },
  {
    "id": "starry-mandarin-donut",
    "slug": "starry-mandarin-donut",
    "name": "Starry Mandarin Donut",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/starry-mandarin-donut.webp",
    "imageStatus": "verified",
    "sellPrice": 310,
    "energy": 20,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45339"
    ],
    "notes": null
  },
  {
    "id": "starry-mandarin-mint-milk",
    "slug": "starry-mandarin-mint-milk",
    "name": "Starry Mandarin Mint Milk",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/starry-mandarin-mint-milk.webp",
    "imageStatus": "verified",
    "sellPrice": 260,
    "energy": 20,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45329"
    ],
    "notes": null
  },
  {
    "id": "starry-meal",
    "slug": "starry-meal",
    "name": "Starry Meal",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/starry-meal.webp",
    "imageStatus": "verified",
    "sellPrice": 1290,
    "energy": 25,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45351"
    ],
    "notes": null
  },
  {
    "id": "starry-pineapple-donut",
    "slug": "starry-pineapple-donut",
    "name": "Starry Pineapple Donut",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/starry-pineapple-donut.webp",
    "imageStatus": "verified",
    "sellPrice": 310,
    "energy": 20,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45345"
    ],
    "notes": null
  },
  {
    "id": "starry-pineapple-mint-milk",
    "slug": "starry-pineapple-mint-milk",
    "name": "Starry Pineapple Mint Milk",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/starry-pineapple-mint-milk.webp",
    "imageStatus": "verified",
    "sellPrice": 260,
    "energy": 20,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45335"
    ],
    "notes": null
  },
  {
    "id": "starry-raspberry-donut",
    "slug": "starry-raspberry-donut",
    "name": "Starry Raspberry Donut",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/starry-raspberry-donut.webp",
    "imageStatus": "verified",
    "sellPrice": 310,
    "energy": 20,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45341"
    ],
    "notes": null
  },
  {
    "id": "starry-raspberry-mint-milk",
    "slug": "starry-raspberry-mint-milk",
    "name": "Starry Raspberry Mint Milk",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/starry-raspberry-mint-milk.webp",
    "imageStatus": "verified",
    "sellPrice": 260,
    "energy": 20,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45331"
    ],
    "notes": null
  },
  {
    "id": "starry-strawberry-donut",
    "slug": "starry-strawberry-donut",
    "name": "Starry Strawberry Donut",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/starry-strawberry-donut.webp",
    "imageStatus": "verified",
    "sellPrice": 950,
    "energy": 80,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45342"
    ],
    "notes": null
  },
  {
    "id": "starry-strawberry-mint-milk",
    "slug": "starry-strawberry-mint-milk",
    "name": "Starry Strawberry Mint Milk",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/starry-strawberry-mint-milk.webp",
    "imageStatus": "verified",
    "sellPrice": 580,
    "energy": 35,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45332"
    ],
    "notes": null
  },
  {
    "id": "starry-swan",
    "slug": "starry-swan",
    "name": "Starry Swan",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/blue-starry-swan.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "variant-group:starry-swan"
    ],
    "notes": null,
    "isVariantGroup": true
  },
  {
    "id": "steak-w-mashed-white-radish",
    "slug": "steak-w-mashed-white-radish",
    "name": "Steak w/ Mashed White Radish",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/steak-w-mashed-white-radish.webp",
    "imageStatus": "verified",
    "sellPrice": 630,
    "energy": 40,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45430"
    ],
    "notes": null
  },
  {
    "id": "steamed-cured-meat",
    "slug": "steamed-cured-meat",
    "name": "Steamed Cured Meat",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/steamed-cured-meat.webp",
    "imageStatus": "verified",
    "sellPrice": 480,
    "energy": 20,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45246"
    ],
    "notes": null
  },
  {
    "id": "steamed-ribs-w-rice-powder",
    "slug": "steamed-ribs-w-rice-powder",
    "name": "Steamed Ribs w/ Rice Powder",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/steamed-ribs-w-rice-powder.webp",
    "imageStatus": "verified",
    "sellPrice": 580,
    "energy": 30,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45247"
    ],
    "notes": null
  },
  {
    "id": "strawberry-cloud-candy",
    "slug": "strawberry-cloud-candy",
    "name": "Strawberry Cloud Candy",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/strawberry-cloud-candy.webp",
    "imageStatus": "verified",
    "sellPrice": 980,
    "energy": 80,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45285"
    ],
    "notes": null
  },
  {
    "id": "strawberry-ice-cream",
    "slug": "strawberry-ice-cream",
    "name": "Strawberry Ice Cream",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/strawberry-ice-cream.webp",
    "imageStatus": "verified",
    "sellPrice": 3410,
    "energy": 70,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45166"
    ],
    "notes": null
  },
  {
    "id": "strawberry-jam-meatball",
    "slug": "strawberry-jam-meatball",
    "name": "Strawberry Jam Meatball",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/strawberry-jam-meatball.webp",
    "imageStatus": "verified",
    "sellPrice": 1760,
    "energy": 100,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45416"
    ],
    "notes": null
  },
  {
    "id": "strawberry-juice",
    "slug": "strawberry-juice",
    "name": "Strawberry Juice",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/strawberry-juice.webp",
    "imageStatus": "verified",
    "sellPrice": 1600,
    "energy": 40,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45168"
    ],
    "notes": null
  },
  {
    "id": "strawberry-princess-cake",
    "slug": "strawberry-princess-cake",
    "name": "Strawberry Princess Cake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/strawberry-princess-cake.webp",
    "imageStatus": "verified",
    "sellPrice": 680,
    "energy": 35,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45406"
    ],
    "notes": null
  },
  {
    "id": "striped-bath-towel-mako-shark",
    "slug": "striped-bath-towel-mako-shark",
    "name": "Striped Bath-Towel Mako Shark",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/striped-bath-towel-mako-shark.webp",
    "imageStatus": "verified",
    "sellPrice": 320,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#10381",
      "variant-of:bath-towel-mako-shark"
    ],
    "notes": null,
    "variantOf": "bath-towel-mako-shark"
  },
  {
    "id": "striped-sauna-hat-sea-turtle",
    "slug": "striped-sauna-hat-sea-turtle",
    "name": "Striped Sauna Hat Sea Turtle",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/striped-sauna-hat-sea-turtle.webp",
    "imageStatus": "verified",
    "sellPrice": 155,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#10383",
      "variant-of:sauna-hat-sea-turtle"
    ],
    "notes": null,
    "variantOf": "sauna-hat-sea-turtle"
  },
  {
    "id": "sulkowsky-s-morpho",
    "slug": "sulkowsky-s-morpho",
    "name": "Sulkowsky's Morpho",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/sulkowsky-s-morpho.webp",
    "imageStatus": "verified",
    "sellPrice": 90,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51126"
    ],
    "notes": null
  },
  {
    "id": "sunglow-calla-lily-seed",
    "slug": "sunglow-calla-lily-seed",
    "name": "Sunglow Calla Lily Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/sunglow-calla-lily-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 180,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#700509",
      "variant-of:calla-lily-seeds"
    ],
    "notes": null,
    "flowerSpecies": "calla-lily-seeds",
    "flowerColor": "sunglow",
    "variantOf": "calla-lily-seeds"
  },
  {
    "id": "sunglow-cranesbill",
    "slug": "sunglow-cranesbill",
    "name": "Sunglow Cranesbill",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/sunglow-cranesbill.webp",
    "imageStatus": "verified",
    "sellPrice": 3300,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#732410",
      "variant-of:cranesbill"
    ],
    "notes": null,
    "flowerSpecies": "cranesbill",
    "flowerColor": "sunglow",
    "variantOf": "cranesbill"
  },
  {
    "id": "sunglow-cranesbill-seed",
    "slug": "sunglow-cranesbill-seed",
    "name": "Sunglow Cranesbill Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/sunglow-cranesbill-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 600,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#702410",
      "variant-of:cranesbill-seeds"
    ],
    "notes": null,
    "flowerSpecies": "cranesbill-seeds",
    "flowerColor": "sunglow",
    "variantOf": "cranesbill-seeds"
  },
  {
    "id": "sunglow-hyacinth",
    "slug": "sunglow-hyacinth",
    "name": "Sunglow Hyacinth",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/sunglow-hyacinth.webp",
    "imageStatus": "verified",
    "sellPrice": 3140,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#731510",
      "variant-of:hyacinth"
    ],
    "notes": null,
    "flowerSpecies": "hyacinth",
    "flowerColor": "sunglow",
    "variantOf": "hyacinth"
  },
  {
    "id": "sunglow-moth-orchid",
    "slug": "sunglow-moth-orchid",
    "name": "Sunglow Moth Orchid",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/sunglow-moth-orchid.webp",
    "imageStatus": "verified",
    "sellPrice": 3220,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#731611",
      "variant-of:moth-orchid"
    ],
    "notes": null,
    "flowerSpecies": "moth-orchid",
    "flowerColor": "sunglow",
    "variantOf": "moth-orchid"
  },
  {
    "id": "sunglow-rose-seed",
    "slug": "sunglow-rose-seed",
    "name": "Sunglow Rose Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/sunglow-rose-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 600,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#700910",
      "variant-of:rose-seeds"
    ],
    "notes": null,
    "flowerSpecies": "rose-seeds",
    "flowerColor": "sunglow",
    "variantOf": "rose-seeds"
  },
  {
    "id": "sunglow-tulip-seed",
    "slug": "sunglow-tulip-seed",
    "name": "Sunglow Tulip Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/sunglow-tulip-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 300,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#700710",
      "variant-of:tulip-seeds"
    ],
    "notes": null,
    "flowerSpecies": "tulip-seeds",
    "flowerColor": "sunglow",
    "variantOf": "tulip-seeds"
  },
  {
    "id": "tall-mustard-celtuce-taco",
    "slug": "tall-mustard-celtuce-taco",
    "name": "Tall Mustard Celtuce Taco",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/tall-mustard-celtuce-taco.webp",
    "imageStatus": "verified",
    "sellPrice": 330,
    "energy": 35,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45446"
    ],
    "notes": null
  },
  {
    "id": "tiger-puffer",
    "slug": "tiger-puffer",
    "name": "Tiger Puffer",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/tiger-puffer.webp",
    "imageStatus": "verified",
    "sellPrice": 215,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#10138"
    ],
    "notes": null
  },
  {
    "id": "toast",
    "slug": "toast",
    "name": "Toast",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/toast.webp",
    "imageStatus": "verified",
    "sellPrice": 560,
    "energy": 50,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45201"
    ],
    "notes": null
  },
  {
    "id": "toasted-apple-marshmallow",
    "slug": "toasted-apple-marshmallow",
    "name": "Toasted Apple Marshmallow",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/toasted-apple-marshmallow.webp",
    "imageStatus": "verified",
    "sellPrice": 310,
    "energy": 25,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45258"
    ],
    "notes": null
  },
  {
    "id": "toasted-blueberry-marshmallow",
    "slug": "toasted-blueberry-marshmallow",
    "name": "Toasted Blueberry Marshmallow",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/toasted-blueberry-marshmallow.webp",
    "imageStatus": "verified",
    "sellPrice": 270,
    "energy": 25,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45261"
    ],
    "notes": null
  },
  {
    "id": "toasted-mandarin-marshmallow",
    "slug": "toasted-mandarin-marshmallow",
    "name": "Toasted Mandarin Marshmallow",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/toasted-mandarin-marshmallow.webp",
    "imageStatus": "verified",
    "sellPrice": 310,
    "energy": 30,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45260"
    ],
    "notes": null
  },
  {
    "id": "toasted-marshmallow",
    "slug": "toasted-marshmallow",
    "name": "Toasted Marshmallow",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/toasted-marshmallow.webp",
    "imageStatus": "verified",
    "sellPrice": 270,
    "energy": 25,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45254"
    ],
    "notes": null
  },
  {
    "id": "toasted-pineapple-marshmallow",
    "slug": "toasted-pineapple-marshmallow",
    "name": "Toasted Pineapple Marshmallow",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/toasted-pineapple-marshmallow.webp",
    "imageStatus": "verified",
    "sellPrice": 310,
    "energy": 25,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45259"
    ],
    "notes": null
  },
  {
    "id": "toasted-raspberry-marshmallow",
    "slug": "toasted-raspberry-marshmallow",
    "name": "Toasted Raspberry Marshmallow",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/toasted-raspberry-marshmallow.webp",
    "imageStatus": "verified",
    "sellPrice": 310,
    "energy": 30,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45262"
    ],
    "notes": null
  },
  {
    "id": "toasted-strawberry-marshmallow",
    "slug": "toasted-strawberry-marshmallow",
    "name": "Toasted Strawberry Marshmallow",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/toasted-strawberry-marshmallow.webp",
    "imageStatus": "verified",
    "sellPrice": 950,
    "energy": 50,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45255"
    ],
    "notes": null
  },
  {
    "id": "tomato-juice",
    "slug": "tomato-juice",
    "name": "Tomato Juice",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/tomato-juice.webp",
    "imageStatus": "verified",
    "sellPrice": 200,
    "energy": 38,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45142"
    ],
    "notes": null
  },
  {
    "id": "tomato-seafood-soup",
    "slug": "tomato-seafood-soup",
    "name": "Tomato Seafood Soup",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/tomato-seafood-soup.webp",
    "imageStatus": "verified",
    "sellPrice": 450,
    "energy": 40,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45533"
    ],
    "notes": null
  },
  {
    "id": "treatsure-candy-roll-cake",
    "slug": "treatsure-candy-roll-cake",
    "name": "Treatsure Candy Roll Cake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/treatsure-candy-roll-cake.webp",
    "imageStatus": "verified",
    "sellPrice": 290,
    "energy": 25,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45268"
    ],
    "notes": null
  },
  {
    "id": "treatsure-crispy-roll-cake",
    "slug": "treatsure-crispy-roll-cake",
    "name": "Treatsure Crispy Roll Cake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/treatsure-crispy-roll-cake.webp",
    "imageStatus": "verified",
    "sellPrice": 260,
    "energy": 25,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45269"
    ],
    "notes": null
  },
  {
    "id": "treatsure-jelly-roll-cake",
    "slug": "treatsure-jelly-roll-cake",
    "name": "Treatsure Jelly Roll Cake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/treatsure-jelly-roll-cake.webp",
    "imageStatus": "verified",
    "sellPrice": 360,
    "energy": 30,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45270"
    ],
    "notes": null
  },
  {
    "id": "treatsure-jellybean-roll-cake",
    "slug": "treatsure-jellybean-roll-cake",
    "name": "Treatsure Jellybean Roll Cake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/treatsure-jellybean-roll-cake.webp",
    "imageStatus": "verified",
    "sellPrice": 260,
    "energy": 25,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45272"
    ],
    "notes": null
  },
  {
    "id": "treatsure-puff-roll-cake",
    "slug": "treatsure-puff-roll-cake",
    "name": "Treatsure Puff Roll Cake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/treatsure-puff-roll-cake.webp",
    "imageStatus": "verified",
    "sellPrice": 360,
    "energy": 30,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45271"
    ],
    "notes": null
  },
  {
    "id": "treatsure-roll-cake",
    "slug": "treatsure-roll-cake",
    "name": "Treatsure Roll Cake",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/treatsure-roll-cake.webp",
    "imageStatus": "verified",
    "sellPrice": 210,
    "energy": 20,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45267"
    ],
    "notes": null
  },
  {
    "id": "turkey",
    "slug": "turkey",
    "name": "Turkey",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/turkey.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#61216"
    ],
    "notes": null
  },
  {
    "id": "utopia-meal",
    "slug": "utopia-meal",
    "name": "Utopia Meal",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/utopia-meal.webp",
    "imageStatus": "verified",
    "sellPrice": 1970,
    "energy": 50,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45302"
    ],
    "notes": null
  },
  {
    "id": "utopian-corn-hotdog",
    "slug": "utopian-corn-hotdog",
    "name": "Utopian Corn Hotdog",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/utopian-corn-hotdog.webp",
    "imageStatus": "verified",
    "sellPrice": 1720,
    "energy": 90,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45296"
    ],
    "notes": null
  },
  {
    "id": "utopian-grilled-sausage",
    "slug": "utopian-grilled-sausage",
    "name": "Utopian Grilled Sausage",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/utopian-grilled-sausage.webp",
    "imageStatus": "verified",
    "sellPrice": 440,
    "energy": 30,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45293"
    ],
    "notes": null
  },
  {
    "id": "utopian-lettuce-hotdog",
    "slug": "utopian-lettuce-hotdog",
    "name": "Utopian Lettuce Hotdog",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/utopian-lettuce-hotdog.webp",
    "imageStatus": "verified",
    "sellPrice": 750,
    "energy": 50,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45295"
    ],
    "notes": null
  },
  {
    "id": "utopian-original-hotdog",
    "slug": "utopian-original-hotdog",
    "name": "Utopian Original Hotdog",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/utopian-original-hotdog.webp",
    "imageStatus": "verified",
    "sellPrice": 590,
    "energy": 35,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45294"
    ],
    "notes": null
  },
  {
    "id": "utopian-tomato-hotdog",
    "slug": "utopian-tomato-hotdog",
    "name": "Utopian Tomato Hotdog",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/utopian-tomato-hotdog.webp",
    "imageStatus": "verified",
    "sellPrice": 750,
    "energy": 50,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45298"
    ],
    "notes": null
  },
  {
    "id": "vanilla",
    "slug": "vanilla",
    "name": "Vanilla",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/vanilla.webp",
    "imageStatus": "verified",
    "sellPrice": 30,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#769003"
    ],
    "notes": null
  },
  {
    "id": "waffle-apple-ice-cream",
    "slug": "waffle-apple-ice-cream",
    "name": "Waffle & Apple Ice Cream",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/waffle-apple-ice-cream.webp",
    "imageStatus": "verified",
    "sellPrice": 410,
    "energy": 30,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45278"
    ],
    "notes": null
  },
  {
    "id": "waffle-blueberry-ice-cream",
    "slug": "waffle-blueberry-ice-cream",
    "name": "Waffle & Blueberry Ice Cream",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/waffle-blueberry-ice-cream.webp",
    "imageStatus": "verified",
    "sellPrice": 390,
    "energy": 30,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45281"
    ],
    "notes": null
  },
  {
    "id": "waffle-grape-ice-cream",
    "slug": "waffle-grape-ice-cream",
    "name": "Waffle & Grape Ice Cream",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/waffle-grape-ice-cream.webp",
    "imageStatus": "verified",
    "sellPrice": 840,
    "energy": 60,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45276"
    ],
    "notes": null
  },
  {
    "id": "waffle-mandarin-ice-cream",
    "slug": "waffle-mandarin-ice-cream",
    "name": "Waffle & Mandarin Ice Cream",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/waffle-mandarin-ice-cream.webp",
    "imageStatus": "verified",
    "sellPrice": 410,
    "energy": 30,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45280"
    ],
    "notes": null
  },
  {
    "id": "waffle-pineapple-ice-cream",
    "slug": "waffle-pineapple-ice-cream",
    "name": "Waffle & Pineapple Ice Cream",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/waffle-pineapple-ice-cream.webp",
    "imageStatus": "verified",
    "sellPrice": 410,
    "energy": 30,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45279"
    ],
    "notes": null
  },
  {
    "id": "waffle-raspberry-ice-cream",
    "slug": "waffle-raspberry-ice-cream",
    "name": "Waffle & Raspberry Ice Cream",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/waffle-raspberry-ice-cream.webp",
    "imageStatus": "verified",
    "sellPrice": 410,
    "energy": 30,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45282"
    ],
    "notes": null
  },
  {
    "id": "waffle-strawberry-ice-cream",
    "slug": "waffle-strawberry-ice-cream",
    "name": "Waffle & Strawberry Ice Cream",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/waffle-strawberry-ice-cream.webp",
    "imageStatus": "verified",
    "sellPrice": 730,
    "energy": 55,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45275"
    ],
    "notes": null
  },
  {
    "id": "waffle-vanilla-ice-cream",
    "slug": "waffle-vanilla-ice-cream",
    "name": "Waffle & Vanilla Ice Cream",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/waffle-vanilla-ice-cream.webp",
    "imageStatus": "verified",
    "sellPrice": 390,
    "energy": 35,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45274"
    ],
    "notes": null
  },
  {
    "id": "wakame",
    "slug": "wakame",
    "name": "Wakame",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/wakame.webp",
    "imageStatus": "verified",
    "sellPrice": 10,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#40603"
    ],
    "notes": null
  },
  {
    "id": "wakame-meatball-soup",
    "slug": "wakame-meatball-soup",
    "name": "Wakame Meatball Soup",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/wakame-meatball-soup.webp",
    "imageStatus": "verified",
    "sellPrice": 500,
    "energy": 55,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45548"
    ],
    "notes": null
  },
  {
    "id": "wandering-albatross",
    "slug": "wandering-albatross",
    "name": "Wandering Albatross",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/wandering-albatross.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#61511"
    ],
    "notes": null
  },
  {
    "id": "white-banded-erebus-moth",
    "slug": "white-banded-erebus-moth",
    "name": "White-banded Erebus Moth",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/white-banded-erebus-moth.webp",
    "imageStatus": "verified",
    "sellPrice": 60,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51139"
    ],
    "notes": null
  },
  {
    "id": "white-clockwork-ladybug",
    "slug": "white-clockwork-ladybug",
    "name": "White Clockwork Ladybug",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/white-clockwork-ladybug.webp",
    "imageStatus": "verified",
    "sellPrice": 110,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51411",
      "variant-of:clockwork-ladybug"
    ],
    "notes": null,
    "variantOf": "clockwork-ladybug"
  },
  {
    "id": "white-cranesbill",
    "slug": "white-cranesbill",
    "name": "White Cranesbill",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/white-cranesbill.webp",
    "imageStatus": "verified",
    "sellPrice": 825,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#732403",
      "variant-of:cranesbill"
    ],
    "notes": null,
    "flowerSpecies": "cranesbill",
    "flowerColor": "white",
    "variantOf": "cranesbill"
  },
  {
    "id": "white-cranesbill-seed",
    "slug": "white-cranesbill-seed",
    "name": "White Cranesbill Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/white-cranesbill-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 150,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#702403",
      "variant-of:cranesbill-seeds"
    ],
    "notes": null,
    "flowerSpecies": "cranesbill-seeds",
    "flowerColor": "white",
    "variantOf": "cranesbill-seeds"
  },
  {
    "id": "white-dandelion",
    "slug": "white-dandelion",
    "name": "White Dandelion",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/white-dandelion.webp",
    "imageStatus": "verified",
    "sellPrice": 125,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#732603",
      "variant-of:dandelion"
    ],
    "notes": null,
    "flowerSpecies": "dandelion",
    "flowerColor": "white",
    "variantOf": "dandelion"
  },
  {
    "id": "white-dragonfruit",
    "slug": "white-dragonfruit",
    "name": "White Dragonfruit",
    "kind": "ingredient",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/ingredient/white-dragonfruit.webp",
    "imageStatus": "verified",
    "sellPrice": 30,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#769004"
    ],
    "notes": null
  },
  {
    "id": "white-faced-storm-petrel",
    "slug": "white-faced-storm-petrel",
    "name": "White-Faced Storm Petrel",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/white-faced-storm-petrel.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#61705"
    ],
    "notes": null
  },
  {
    "id": "white-hat-stock-dove",
    "slug": "white-hat-stock-dove",
    "name": "White Hat Stock Dove",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/white-hat-stock-dove.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#61225",
      "variant-of:stock-dove"
    ],
    "notes": null,
    "variantOf": "stock-dove"
  },
  {
    "id": "white-hyacinth",
    "slug": "white-hyacinth",
    "name": "White Hyacinth",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/white-hyacinth.webp",
    "imageStatus": "verified",
    "sellPrice": 785,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#731503",
      "variant-of:hyacinth"
    ],
    "notes": null,
    "flowerSpecies": "hyacinth",
    "flowerColor": "white",
    "variantOf": "hyacinth"
  },
  {
    "id": "white-moth-orchid",
    "slug": "white-moth-orchid",
    "name": "White Moth Orchid",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/white-moth-orchid.webp",
    "imageStatus": "verified",
    "sellPrice": 805,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#731603",
      "variant-of:moth-orchid"
    ],
    "notes": null,
    "flowerSpecies": "moth-orchid",
    "flowerColor": "white",
    "variantOf": "moth-orchid"
  },
  {
    "id": "white-rose-seed",
    "slug": "white-rose-seed",
    "name": "White Rose Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/white-rose-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 150,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#700903",
      "variant-of:rose-seeds"
    ],
    "notes": null,
    "flowerSpecies": "rose-seeds",
    "flowerColor": "white",
    "variantOf": "rose-seeds"
  },
  {
    "id": "white-sauna-hat-sea-turtle",
    "slug": "white-sauna-hat-sea-turtle",
    "name": "White Sauna Hat Sea Turtle",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/white-sauna-hat-sea-turtle.webp",
    "imageStatus": "verified",
    "sellPrice": 155,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#10382",
      "variant-of:sauna-hat-sea-turtle"
    ],
    "notes": null,
    "variantOf": "sauna-hat-sea-turtle"
  },
  {
    "id": "white-spoonbill",
    "slug": "white-spoonbill",
    "name": "White Spoonbill",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/white-spoonbill.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#61510"
    ],
    "notes": null
  },
  {
    "id": "white-tulip-seed",
    "slug": "white-tulip-seed",
    "name": "White Tulip Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/white-tulip-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 75,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#700703",
      "variant-of:tulip-seeds"
    ],
    "notes": null,
    "flowerSpecies": "tulip-seeds",
    "flowerColor": "white",
    "variantOf": "tulip-seeds"
  },
  {
    "id": "white-winged-tern",
    "slug": "white-winged-tern",
    "name": "White-Winged Tern",
    "kind": "bird",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/bird/white-winged-tern.webp",
    "imageStatus": "verified",
    "sellPrice": null,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#61507"
    ],
    "notes": null
  },
  {
    "id": "whole-wheat-toast",
    "slug": "whole-wheat-toast",
    "name": "Whole Wheat Toast",
    "kind": "dish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/dish/whole-wheat-toast.webp",
    "imageStatus": "verified",
    "sellPrice": 560,
    "energy": 50,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#45203"
    ],
    "notes": null
  },
  {
    "id": "yellow-bath-towel-mako-shark",
    "slug": "yellow-bath-towel-mako-shark",
    "name": "Yellow Bath-Towel Mako Shark",
    "kind": "fish",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/fish/yellow-bath-towel-mako-shark.webp",
    "imageStatus": "verified",
    "sellPrice": 215,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#10379",
      "variant-of:bath-towel-mako-shark"
    ],
    "notes": null,
    "variantOf": "bath-towel-mako-shark"
  },
  {
    "id": "yellow-clockwork-ladybug",
    "slug": "yellow-clockwork-ladybug",
    "name": "Yellow Clockwork Ladybug",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/yellow-clockwork-ladybug.webp",
    "imageStatus": "verified",
    "sellPrice": 110,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51410",
      "variant-of:clockwork-ladybug"
    ],
    "notes": null,
    "variantOf": "clockwork-ladybug"
  },
  {
    "id": "yellow-cranesbill",
    "slug": "yellow-cranesbill",
    "name": "Yellow Cranesbill",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/yellow-cranesbill.webp",
    "imageStatus": "verified",
    "sellPrice": 825,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#732402",
      "variant-of:cranesbill"
    ],
    "notes": null,
    "flowerSpecies": "cranesbill",
    "flowerColor": "yellow",
    "variantOf": "cranesbill"
  },
  {
    "id": "yellow-cranesbill-seed",
    "slug": "yellow-cranesbill-seed",
    "name": "Yellow Cranesbill Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/yellow-cranesbill-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 150,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#702402",
      "variant-of:cranesbill-seeds"
    ],
    "notes": null,
    "flowerSpecies": "cranesbill-seeds",
    "flowerColor": "yellow",
    "variantOf": "cranesbill-seeds"
  },
  {
    "id": "yellow-dandelion",
    "slug": "yellow-dandelion",
    "name": "Yellow Dandelion",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/yellow-dandelion.webp",
    "imageStatus": "verified",
    "sellPrice": 125,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#732602",
      "variant-of:dandelion"
    ],
    "notes": null,
    "flowerSpecies": "dandelion",
    "flowerColor": "yellow",
    "variantOf": "dandelion"
  },
  {
    "id": "yellow-hyacinth",
    "slug": "yellow-hyacinth",
    "name": "Yellow Hyacinth",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/yellow-hyacinth.webp",
    "imageStatus": "verified",
    "sellPrice": 785,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#731502",
      "variant-of:hyacinth"
    ],
    "notes": null,
    "flowerSpecies": "hyacinth",
    "flowerColor": "yellow",
    "variantOf": "hyacinth"
  },
  {
    "id": "yellow-light-firefly",
    "slug": "yellow-light-firefly",
    "name": "Yellow Light Firefly",
    "kind": "insect",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/insect/yellow-light-firefly.webp",
    "imageStatus": "verified",
    "sellPrice": 110,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#51226",
      "variant-of:light-firefly"
    ],
    "notes": null,
    "variantOf": "light-firefly"
  },
  {
    "id": "yellow-moth-orchid",
    "slug": "yellow-moth-orchid",
    "name": "Yellow Moth Orchid",
    "kind": "flower",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/flower/yellow-moth-orchid.webp",
    "imageStatus": "verified",
    "sellPrice": 805,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#731602",
      "variant-of:moth-orchid"
    ],
    "notes": null,
    "flowerSpecies": "moth-orchid",
    "flowerColor": "yellow",
    "variantOf": "moth-orchid"
  },
  {
    "id": "yellow-rose-seed",
    "slug": "yellow-rose-seed",
    "name": "Yellow Rose Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/yellow-rose-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 150,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#700902",
      "variant-of:rose-seeds"
    ],
    "notes": null,
    "flowerSpecies": "rose-seeds",
    "flowerColor": "yellow",
    "variantOf": "rose-seeds"
  },
  {
    "id": "yellow-tulip-seed",
    "slug": "yellow-tulip-seed",
    "name": "Yellow Tulip Seed",
    "kind": "seed",
    "eventKey": null,
    "status": "active",
    "aliases": [],
    "image": "/icons/seed/yellow-tulip-seed.webp",
    "imageStatus": "verified",
    "sellPrice": 75,
    "energy": null,
    "tags": [],
    "sourceRefs": [
      "client:TableEntity#700702",
      "variant-of:tulip-seeds"
    ],
    "notes": null,
    "flowerSpecies": "tulip-seeds",
    "flowerColor": "yellow",
    "variantOf": "tulip-seeds"
  }
];
